
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3R0hq", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteIntegration", () => $77d88afa89f7f1c5$export$eb6ccee20cc51d7b);

var $eJOHy = parcelRequire("eJOHy");

var $gRw8I = parcelRequire("gRw8I");

var $jp3Bb = parcelRequire("jp3Bb");

var $4tw0m = parcelRequire("4tw0m");

var $eu8sK = parcelRequire("eu8sK");

var $hJ5Q8 = parcelRequire("hJ5Q8");

var $g51Bg = parcelRequire("g51Bg");

var $I0FBf = parcelRequire("I0FBf");

var $4B7rn = parcelRequire("4B7rn");

var $9pTd3 = parcelRequire("9pTd3");

var $dY8y3 = parcelRequire("dY8y3");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");


var $66hHa = parcelRequire("66hHa");

var $hkBEU = parcelRequire("hkBEU");

var $hXYvb = parcelRequire("hXYvb");

var $9QSBF = parcelRequire("9QSBF");

var $i1QV6 = parcelRequire("i1QV6");

var $6E71U = parcelRequire("6E71U");

var $1CYyD = parcelRequire("1CYyD");

var $1LqFT = parcelRequire("1LqFT");

var $2M8GM = parcelRequire("2M8GM");
const $77d88afa89f7f1c5$export$eb6ccee20cc51d7b = (props)=>{
    // eslint-disable-next-line jira/react-magnetic-di/no-unneeded
    (0, $gRw8I.di)((0, $4B7rn.default));
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ isOpen: isOpen }] = (0, $g51Bg.useCommandPaletteIsOpen)();
    const { quickSearchCommand: quickSearchCommand } = (0, $4tw0m.useQuickSearchCommand)({
        keepSearch: true
    });
    // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    const askRovoCommand = (0, $4cTDP.fg)('jjj_ask_rovo_compal_v1') ? (0, $eu8sK.useAskRovoCommand)() : null;
    (0, $hJ5Q8.useCommandPaletteRegistry)();
    const onErrorAnalytics = (0, $eJOHy.useCallback)((attribution, error, id, attributes)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            error: error,
            meta: {
                id: `jira.commandPalette.${id}`,
                packageName: 'jiraCommandPaletteIntegration',
                teamName: attribution || 'deliveroo'
            },
            attributes: attributes
        });
    }, []);
    (0, $i1QV6.useRegisterSections)();
    (0, $9QSBF.useRegisterDismissCommand)();
    (0, $66hHa.useCloseDotMenu)();
    (0, $hXYvb.useDisableCompalIfEmbed)();
    (0, $1CYyD.useRegisterInitialCommands)();
    (0, $hkBEU.useCompalBridge)();
    const Wrapper = isOpen ? (0, $4B7rn.default) : (0, $eJOHy.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f29e7b1e3120b887$export$70d2130cb02f61fa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $I0FBf.CommandPaletteModal), {
        defaultFooterContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6E71U.FooterFeedbackContent), null),
        onAnalytics: (0, $jp3Bb.handleAnalytics),
        onErrorAnalytics: onErrorAnalytics,
        defaultAriaLabel: formatMessage((0, $1LqFT.messages).defaultSearchInputAriaLabel),
        defaultPlaceholder: formatMessage((0, $1LqFT.messages).defaultPlaceholder),
        defaultFallback: {
            onError: {
                label: formatMessage((0, $1LqFT.messages).onErrorFallback)
            },
            onNoResults: {
                label: formatMessage((0, $1LqFT.messages).noResultsFound)
            }
        },
        rootFallback: {
            label: formatMessage((0, $1LqFT.messages).noResultsFound),
            ...(0, $4cTDP.fg)('jjj_ask_rovo_compal_v1') ? {
                fallbackCommands: [
                    quickSearchCommand,
                    askRovoCommand
                ].filter(Boolean)
            } : // when cleaning up jjj_ask_rovo_compal_v1 remove fallbackCommand and just leave fallbackCommands
            {
                fallbackCommand: quickSearchCommand
            },
            fallbackSection: {
                name: formatMessage((0, $1LqFT.messages).recommendedSection)
            }
        },
        ...props
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2M8GM.RegisterDynamicCommands), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dY8y3.ForgeCommandPaletteCommandsWithFF), null));
};

});
parcelRegister("jp3Bb", function(module, exports) {
$parcel$export(module.exports, "handleAnalytics", () => $bf3a07eef661cffb$export$51232d58b72ca41a);

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");
const $bf3a07eef661cffb$var$packageName = 'jiraCommandPaletteIntegration';
const $bf3a07eef661cffb$export$51232d58b72ca41a = (event, eventType, args)=>{
    const eventFunctions = {
        [(0, $aa42ce8e355d58fa$export$a1562d08625f5d7e)]: (0, $kRgKj.fireUIAnalytics),
        [(0, $aa42ce8e355d58fa$export$947dac6c72b26f81)]: (0, $kRgKj.fireTrackAnalytics),
        [(0, $aa42ce8e355d58fa$export$12346a674644c156)]: (0, $kRgKj.fireOperationalAnalytics)
    };
    if (args?.actionSubject && args?.action || event.payload.actionSubject && event.payload.action) {
        const eventActionAndSubject = args?.actionSubject && args?.action ? `${args?.actionSubject} ${args?.action}` : `${event.payload.actionSubject} ${event.payload.action}`;
        if (args?.actionSubjectId) {
            eventFunctions[eventType]?.(event, eventActionAndSubject, args?.actionSubjectId, args?.attributes ? args?.attributes : {});
            return;
        }
        if (!args?.actionSubjectId) eventFunctions[eventType]?.(event, eventActionAndSubject, args?.attributes ? args?.attributes : {});
    } else (0, $9pTd3.fireErrorAnalytics)({
        error: new Error('Action or ActionSubject not provided'),
        meta: {
            id: 'jira.commandPalette.analytics',
            packageName: $bf3a07eef661cffb$var$packageName,
            teamName: 'deliveroo'
        }
    });
};

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("4tw0m", function(module, exports) {
$parcel$export(module.exports, "useQuickSearchCommand", () => $ff54e389f5e960fd$export$e5359a76eb8e8480);

var $eJOHy = parcelRequire("eJOHy");

var $dt3aG = parcelRequire("dt3aG");

var $1Zcfy = parcelRequire("1Zcfy");

var $hf4h9 = parcelRequire("hf4h9");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");


var $2AvTe = parcelRequire("2AvTe");

var $8melo = parcelRequire("8melo");

var $b9Lqb = parcelRequire("b9Lqb");

var $12IQN = parcelRequire("12IQN");
const $ff54e389f5e960fd$export$e5359a76eb8e8480 = (props)=>{
    const keepSearch = props?.keepSearch;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const searchCommandNameIssueTermRefreshGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $2AvTe.messages).searchCommandNameIssueTermRefreshGalaxia : (0, $2AvTe.messages).searchCommandNameIssueTermRefresh;
    const searchInputPlaceHolderIssueTermRefreshGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $2AvTe.messages).searchInputPlaceHolderIssueTermRefreshGalaxia : (0, $2AvTe.messages).searchInputPlaceHolderIssueTermRefresh;
    (0, $8melo.useFireQuickSearchAnalyticsOnClose)();
    const quickSearchCommand = (0, $eJOHy.useMemo)(()=>({
            id: (0, $d9877891f0cb1001$export$2c1eb650fb9787f),
            name: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? searchCommandNameIssueTermRefreshGalaxia : (0, $2AvTe.messages).searchCommandName),
            placeholder: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? searchInputPlaceHolderIssueTermRefreshGalaxia : (0, $2AvTe.messages).searchInputPlaceHolder),
            keywords: formatMessage((0, $2AvTe.messages).searchYourIssuesSynonyms),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
                        spacing: "spacious",
                        label: "",
                        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                    })
            },
            mode: '/',
            section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickSearch,
            priority: 1,
            analytics: {
                action: 'quickSearchMode',
                actionCategory: 'quick-search'
            },
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).COMMAND_LIST,
                components: {
                    Body: (0, $b9Lqb.QuickSearchChildren),
                    Wrapper: (0, $12IQN.QuickSearchChildWrapper)
                },
                keepSearch: keepSearch
            }
        }), [
        formatMessage,
        keepSearch,
        searchCommandNameIssueTermRefreshGalaxia,
        searchInputPlaceHolderIssueTermRefreshGalaxia
    ]);
    return {
        quickSearchCommand: quickSearchCommand
    };
};

});
const $d9877891f0cb1001$export$2c1eb650fb9787f = 'quick-search';

parcelRegister("2AvTe", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f3fef263732d22ac$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f3fef263732d22ac$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    searchCommandName: {
        "id": "command-palette-quick-search.use-quick-search-command.search-command-name",
        "defaultMessage": "Search issues, projects, and more"
    },
    searchInputPlaceHolder: {
        "id": "command-palette-quick-search.use-quick-search-command.search-input-place-holder",
        "defaultMessage": "Search for issues, projects, boards, filters and plans"
    },
    searchYourIssuesSynonyms: {
        "id": "command-palette-quick-search.use-quick-search-command.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    searchCommandNameIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.search-command-name-issue-term-refresh",
        "defaultMessage": "Search work items, projects, and more"
    },
    searchInputPlaceHolderIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.search-input-place-holder-issue-term-refresh",
        "defaultMessage": "Search for work items, projects, boards, filters, and plans"
    },
    searchCommandNameIssueTermRefreshGalaxia: {
        "id": "command-palette-quick-search.use-quick-search-command.search-command-name-issue-term-refresh-galaxia",
        "defaultMessage": "Search work items, spaces, and more"
    },
    searchInputPlaceHolderIssueTermRefreshGalaxia: {
        "id": "command-palette-quick-search.use-quick-search-command.search-input-place-holder-issue-term-refresh-galaxia",
        "defaultMessage": "Search for work items, spaces, boards, filters, and plans"
    }
});

});

parcelRegister("8melo", function(module, exports) {
$parcel$export(module.exports, "useFireQuickSearchAnalyticsOnClose", () => $f0ebd2ae2f490b1b$export$5bb3a88a6bd57afb);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $6d9QY = parcelRequire("6d9QY");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $djaLS = parcelRequire("djaLS");
const $f0ebd2ae2f490b1b$export$5bb3a88a6bd57afb = ()=>{
    const [{ isOpen: isOpen }] = (0, $g51Bg.useCommandPaletteIsOpen)();
    const previousIsOpen = (0, $6d9QY.usePrevious)(isOpen);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ hasModalWrapperMounted: hasModalWrapperMounted }] = (0, $djaLS.useQuickSearchAnalytics)();
    // Need to get the previousAttributes since they will change after closing compal
    const [attributes] = (0, $g51Bg.useCommandPaletteAnalyticsAttributes)();
    const previousAttributes = (0, $6d9QY.usePrevious)(attributes);
    const [compalAttributes] = (0, $djaLS.useQuickSearchAnalyticsAttributes)();
    const previousCompalAttributes = (0, $6d9QY.usePrevious)(compalAttributes);
    (0, $eJOHy.useEffect)(()=>{
        if (hasModalWrapperMounted && previousIsOpen && !isOpen) (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'close commandPaletteSearch', {
            ...previousCompalAttributes,
            ...previousAttributes
        });
    }, [
        createAnalyticsEvent,
        isOpen,
        previousIsOpen,
        hasModalWrapperMounted,
        previousCompalAttributes,
        previousAttributes
    ]);
};

});
parcelRegister("djaLS", function(module, exports) {
$parcel$export(module.exports, "useQuickSearchAnalytics", () => $0c62485291c46675$export$4717a2168cba99f2);
$parcel$export(module.exports, "useQuickSearchAnalyticsAttributes", () => $0c62485291c46675$export$c5622799de43dc3a);

var $aXKmr = parcelRequire("aXKmr");

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gpyau = parcelRequire("gpyau");
const $0c62485291c46675$var$initialState = {
    queryVersion: -1,
    query: '',
    searchSessionId: (0, $aXKmr.v4)(),
    hasModalWrapperMounted: false,
    screenName: undefined,
    isCachedResult: false
};
const $0c62485291c46675$var$actions = {
    setQuery: (query)=>({ setState: setState, getState: getState })=>{
            setState({
                queryVersion: getState().queryVersion + 1,
                query: query
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                ...$0c62485291c46675$var$initialState,
                searchSessionId: (0, $aXKmr.v4)()
            });
        },
    setHasModalWrapperMounted: (hasModalWrapperMounted)=>({ setState: setState })=>{
            setState({
                hasModalWrapperMounted: hasModalWrapperMounted
            });
        },
    setScreenName: (screenName)=>({ setState: setState })=>{
            setState({
                screenName: screenName
            });
        },
    setIsCachedResult: (isCachedResult)=>({ setState: setState })=>{
            setState({
                isCachedResult: isCachedResult
            });
        }
};
const $0c62485291c46675$var$store = (0, $GtRbT.createStore)({
    initialState: $0c62485291c46675$var$initialState,
    actions: $0c62485291c46675$var$actions,
    name: 'quickSearchAnalytics'
});
const $0c62485291c46675$export$4717a2168cba99f2 = (0, $iJq0l.createHook)($0c62485291c46675$var$store);
const $0c62485291c46675$export$770c0b647b46c688 = (0, $iJq0l.createActionsHook)($0c62485291c46675$var$store);
const $0c62485291c46675$export$c5622799de43dc3a = (0, $iJq0l.createHook)($0c62485291c46675$var$store, {
    selector: ({ query: query, queryVersion: queryVersion, searchSessionId: searchSessionId, screenName: screenName, isCachedResult: isCachedResult })=>({
            wordCount: (0, $gpyau.getWordCount)(query),
            queryLength: query.length,
            queryHash: (0, $gpyau.getQueryHash)(query),
            queryVersion: queryVersion,
            searchSessionId: searchSessionId,
            activeProduct: 'jira',
            isMultiProduct: false,
            screenName: screenName,
            isCachedResult: isCachedResult
        })
});

});
parcelRegister("gpyau", function(module, exports) {
$parcel$export(module.exports, "getQueryHash", () => $5249857f4a2c09cb$export$fa1c95a5ffa92036);
$parcel$export(module.exports, "getWordCount", () => $5249857f4a2c09cb$export$dba3e2bcdbd49da4);
$parcel$export(module.exports, "transformResultsForAnalytics", () => $5249857f4a2c09cb$export$902530edac79328);

var $jhs3c = parcelRequire("jhs3c");
const $5249857f4a2c09cb$export$fa1c95a5ffa92036 = (str)=>(0, $jhs3c.createHash)().update(str).digest('hex');
const $5249857f4a2c09cb$export$dba3e2bcdbd49da4 = (str)=>str.length > 0 ? str.split(/\s+/).length : 0;
const $5249857f4a2c09cb$export$902530edac79328 = (data, isRecentResult)=>{
    const results = data?.scopes?.map((scope)=>({
            sectionId: scope.id,
            results: scope.results.map((result)=>({
                    containerId: result?.attributes && 'containerId' in result?.attributes ? result?.attributes?.containerId || 'UNAVAILABLE' : 'UNAVAILABLE',
                    isRecentResult: isRecentResult,
                    resultContentId: result.id,
                    resultType: scope.id
                }))
        }));
    const resultCount = data?.scopes?.reduce((acc, scope)=>acc + scope.size, 0);
    return {
        results: results,
        sectionCount: data?.scopes?.length || 0,
        resultCount: resultCount,
        noResultsFetched: !results?.find((scope)=>scope.results.length > 0)
    };
};

});



parcelRegister("b9Lqb", function(module, exports) {
$parcel$export(module.exports, "QuickSearchChildren", () => $a697da50dae91258$export$a68383740408995a);

var $eJOHy = parcelRequire("eJOHy");

var $jmeeg = parcelRequire("jmeeg");

var $QKs2x = parcelRequire("QKs2x");

var $djaLS = parcelRequire("djaLS");

var $fVMQ6 = parcelRequire("fVMQ6");

var $iIIpn = parcelRequire("iIIpn");

var $iDJqM = parcelRequire("iDJqM");
const $a697da50dae91258$export$4630ed09821f1a78 = ()=>{
    const { fetch: fetch } = (0, $fVMQ6.useQuickSearchWithRecentCache)();
    const getRecentResults = (0, $iIIpn.useGetRecentResults)();
    const getSearchResults = (0, $iDJqM.useGetSearchResults)();
    const [{ searchSessionId: searchSessionId }, { setQuery: setQuery, setIsCachedResult: setIsCachedResult, setScreenName: setScreenName }] = (0, $djaLS.useQuickSearchAnalytics)();
    const controllerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>()=>controllerRef.current?.abort(), []);
    const isMountedRef = (0, $eJOHy.useRef)(false);
    (0, $eJOHy.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const loadChildren = (0, $eJOHy.useCallback)(async ({ search: search })=>{
        controllerRef.current?.abort();
        controllerRef.current = new AbortController();
        let response;
        let error;
        try {
            setQuery(search);
            response = await fetch(search, searchSessionId, controllerRef.current?.signal);
        } catch (e) {
            error = e instanceof Error ? e : new Error('Error not identified');
        }
        setIsCachedResult(response?.isCache || false);
        if (search && search.length > 0) {
            setScreenName('postQuerySearchResults');
            return {
                ...getSearchResults({
                    search: search,
                    quickSearchResponseData: response?.result,
                    error: error
                })
            };
        }
        setScreenName('preQuerySearchResults');
        return {
            ...getRecentResults({
                search: search,
                quickSearchResponseData: response?.result,
                error: error
            })
        };
    }, [
        setIsCachedResult,
        setScreenName,
        getRecentResults,
        setQuery,
        fetch,
        searchSessionId,
        getSearchResults
    ]);
    return {
        loadChildren: loadChildren
    };
};
const $a697da50dae91258$export$a68383740408995a = ({ setChildResult: setChildResult, setLoading: setLoading, ...rest })=>{
    const { loadChildren: loadChildren } = $a697da50dae91258$export$4630ed09821f1a78();
    const loadChildCommands = (0, $eJOHy.useCallback)((searchTerm, obj)=>loadChildren({
            search: searchTerm
        }).then((result)=>{
            if (!obj.isMounted) return;
            setChildResult?.(result);
        }), [
        loadChildren,
        setChildResult
    ]);
    (0, $QKs2x.useDebouncedLoadChildren)(loadChildCommands);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmeeg.components).Body, {
        setChildResult: setChildResult,
        setLoading: setLoading,
        ...rest
    });
};

});
parcelRegister("jmeeg", function(module, exports) {
$parcel$export(module.exports, "components", () => $0452758bc49e816e$export$9b5ac10f59f76296);

var $eJOHy = parcelRequire("eJOHy");

var $dUOwK = parcelRequire("dUOwK");

var $2Nn1q = parcelRequire("2Nn1q");

var $lKFw0 = parcelRequire("lKFw0");

var $b4bRO = parcelRequire("b4bRO");
const $0452758bc49e816e$var$NameComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
};
const $0452758bc49e816e$export$9b5ac10f59f76296 = {
    CommandRow: // @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
    $2Nn1q.CommandRow,
    Name: $0452758bc49e816e$var$NameComponent,
    LeftIcon: (0, $eJOHy.Fragment),
    Wrapper: (0, $eJOHy.Fragment),
    Footer: $lKFw0.Footer,
    Body: (0, $dUOwK.CommandPaletteBody),
    Header: $b4bRO.Header
};

});
parcelRegister("dUOwK", function(module, exports) {
$parcel$export(module.exports, "NoResultsContainer", () => $3a17c57ac1b263a3$export$2ab569a6937cb4e4);
$parcel$export(module.exports, "CommandPaletteBody", () => $3a17c57ac1b263a3$export$b1023de69a8756e6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $58ssj = parcelRequire("58ssj");

var $ftN6c = parcelRequire("ftN6c");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $g51Bg = parcelRequire("g51Bg");

var $2OtIa = parcelRequire("2OtIa");

var $5Ywg0 = parcelRequire("5Ywg0");

var $g8Pqh = parcelRequire("g8Pqh");

var $iG2Hi = parcelRequire("iG2Hi");


var $aNkQT = parcelRequire("aNkQT");

var $OZurT = parcelRequire("OZurT");

var $6b4EO = parcelRequire("6b4EO");

var $5IbG4 = parcelRequire("5IbG4");
const $3a17c57ac1b263a3$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, $g51Bg.useCommandPalette)();
    const onHoverCommand = (0, $eJOHy.useCallback)((index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    }, [
        setActiveIndex
    ]);
    const onMouseDownCommand = (0, $eJOHy.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onClickCommand = (0, $eJOHy.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $2OtIa.getAnalyticsAttributesFromResult)(result),
                ...(0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $2OtIa.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const onClickKeyboardCommand = (0, $eJOHy.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'keyboard',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $2OtIa.getAnalyticsAttributesFromResult)(result),
                ...(0, $2OtIa.getRegistryData)(registry, activeRegistry, result.command.id)
            }
        }, (0, $58ssj.isMacOs)() ? event.metaKey : event.ctrlKey);
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    if ((0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility')) // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    (0, $eJOHy.useEffect)(()=>{
        const handleEnterKey = (event)=>{
            if (event.key === 'Enter') {
                const focusedElement = typeof document !== 'undefined' ? document.activeElement : null;
                let targetElement = focusedElement;
                while(targetElement && targetElement !== (0, $fceQU.getDocument)()?.body){
                    if (targetElement.getAttribute('data-testid') === (0, $6b4EO.COMMAND_CONTAINER_ROW_TEST_ID)) {
                        event.preventDefault();
                        const focusedId = targetElement.id?.replace(`${(0, $19c39496d342d719$export$b28d6b416aaf953a)}-`, '');
                        if (focusedId) {
                            const selectedCommand = results.find((result)=>!result.isGroup && 'command' in result && result.command.id === focusedId);
                            if (selectedCommand) onClickKeyboardCommand(event, selectedCommand);
                        }
                        break;
                    }
                    targetElement = targetElement.parentElement;
                }
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleEnterKey);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleEnterKey);
        };
    }, [
        onClickKeyboardCommand,
        results
    ]);
    const localResultRefs = resultsRefs.current;
    const commandItem = (0, $eJOHy.useCallback)((result, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNkQT.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g8Pqh.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $OZurT.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        }))), [
        activeRegistry,
        isSearchFieldFocused,
        localResultRefs,
        onClickCommand,
        onHoverCommand,
        onMouseDownCommand,
        registry,
        removeCommandsById
    ]);
    const renderGroupedResults = (0, $eJOHy.useCallback)(()=>{
        const resultList = [];
        let groupList = [];
        const wrappedGroup = (group, groupIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
                role: "group",
                "aria-labelledby": `group-heading-${groupIndex}`,
                key: `group-${groupIndex}`
            }, group);
        results.forEach((result, i)=>{
            if (result.isGroup) {
                if (groupList.length !== 0) {
                    resultList.push(wrappedGroup(groupList, resultList.length));
                    groupList = [];
                }
                groupList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ywg0.CommandPaletteSearchResultGroupItem), {
                    ref: (commandRef)=>{
                        if (commandRef) localResultRefs[i] = commandRef;
                    },
                    group: result.group,
                    key: i
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$GroupContainerComponent, {
                    as: "h2",
                    role: "presentation",
                    "data-testid": (0, $6b4EO.GROUP_TEST_ID),
                    isFirstResult: i === 0,
                    id: `group-heading-${resultList.length}`
                }, result.renderGroup ? result.renderGroup() : result.group)));
            } else groupList.push(commandItem(result, i));
        });
        if (groupList.length !== 0) resultList.push(wrappedGroup(groupList, resultList.length));
        return resultList;
    }, [
        commandItem,
        localResultRefs,
        results
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$export$2ab569a6937cb4e4, {
        "data-testid": (0, $6b4EO.NO_RESULTS_TEST_ID)
    }, noResultsFallback), (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') && renderGroupedResults(), !(0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') && results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ywg0.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            group: result.group,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$GroupContainerComponent, {
            as: "h2",
            role: "presentation",
            "data-testid": (0, $6b4EO.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aNkQT.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $2OtIa.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g8Pqh.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $OZurT.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
const $3a17c57ac1b263a3$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, $g51Bg.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eJOHy.useState)(activeIndex);
    const resultsRefs = (0, $eJOHy.useRef)([]);
    const modalBodyRef = (0, $eJOHy.useRef)(null);
    const onArrowScroll = (0, $eJOHy.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-reset-all-state-on-prop-change
    (0, $eJOHy.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $6b4EO.SCROLL_DIRECTION).END : (0, $6b4EO.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $5IbG4.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $5IbG4.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $5IbG4.scrollResultIntoView)({
                target: scrolledToResult,
                direction: scrollTo,
                scrollContainer: modalBodyRef.current
            });
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eJOHy.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iG2Hi.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        noResultsFallback: noResultsFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3a17c57ac1b263a3$var$CommandPaletteChildren, {
        results: results,
        noResultsFallback: noResultsFallback,
        renderAfterCommands: renderAfterCommands,
        resultsRefs: resultsRefs
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a17c57ac1b263a3$var$GroupContainerComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $awdRS.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _1yt41f6d _syaz131l",
            __cmplp.className
        ])
    });
});
const $3a17c57ac1b263a3$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _syaz131l _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Ywg0", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $2dc004120872e887$export$591c26128e5fd757);

var $eJOHy = parcelRequire("eJOHy");

const $2dc004120872e887$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        "data-testid": (0, $19c39496d342d719$export$617744f059bfc3ba),
        id: group ? `${0, $19c39496d342d719$export$9ed1834ff36a8f29}-${group}` : undefined,
        ...rest
    }));

});
const $19c39496d342d719$export$9ffb4923f81813d9 = 'compal-menu';
const $19c39496d342d719$export$b28d6b416aaf953a = `${$19c39496d342d719$export$9ffb4923f81813d9}-item`;
const $19c39496d342d719$export$9ed1834ff36a8f29 = `${$19c39496d342d719$export$9ffb4923f81813d9}-group`;
const $19c39496d342d719$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $19c39496d342d719$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $19c39496d342d719$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $19c39496d342d719$export$9e40a0642460a944 = 'compal-menu-screen-reader';


parcelRegister("g8Pqh", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $1fa300fadfc2263f$export$1f8fa9d1eef77b32);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");


var $bZFaG = parcelRequire("bZFaG");
const $1fa300fadfc2263f$var$styles = {
    root: "_bozg1b66 _y4ti1b66"
};
const $1fa300fadfc2263f$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ id: id, active: active, selected: selected, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        ref: ref,
        "data-testid": (0, $19c39496d342d719$export$617744f059bfc3ba),
        "aria-current": (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') ? undefined : active,
        role: (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') ? 'option' : 'menuitem',
        "aria-selected": selected,
        id: `${(0, $19c39496d342d719$export$b28d6b416aaf953a)}-${id}`,
        "aria-label": formatMessage((0, $bZFaG.messages).resultListItemAriaLabel),
        ...(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility') && {
            css: $1fa300fadfc2263f$var$styles.root
        },
        ...rest
    });
});

});
parcelRegister("bZFaG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1a66dcc5b190c609$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1a66dcc5b190c609$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    resultListItemAriaLabel: {
        "id": "command-palette.common.command-palette-search-result-list-item",
        "defaultMessage": "Command palette action item"
    }
});

});


parcelRegister("iG2Hi", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $6725cef9016fe1d5$export$95554f6fb39a83c2);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");


var $1XCAD = parcelRequire("1XCAD");

var $2pUb3 = parcelRequire("2pUb3");
const $6725cef9016fe1d5$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const resizerRef = (0, $eJOHy.useRef)(null);
    const height = (0, $2pUb3.useSmoothExpand)(resizerRef);
    (0, $eJOHy.useEffect)(()=>{
        if (ref && 'current' in ref && ref.current) {
            const currentRef = ref.current;
            currentRef.style.height = `${height}px`;
        }
    }, [
        height,
        ref
    ]);
    const resultsRole = (0, $4cTDP.fg)('dee-8682-cmd-palette-search-items-listbox-fix') ? 'listbox' : 'menu';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6725cef9016fe1d5$var$wrapperStyles,
        testId: (0, $19c39496d342d719$export$85eefac753ab5bdb),
        id: (0, $19c39496d342d719$export$9ffb4923f81813d9),
        role: noResultsFallback ? 'group' : resultsRole,
        ref: ref,
        "aria-label": formatMessage((0, $1XCAD.messages).commandPaletteSearchResultListBoxLabel),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        ref: resizerRef,
        direction: "column",
        gap: "space.050"
    }, children));
});
const $6725cef9016fe1d5$var$wrapperStyles = (0, $1DXK0.xcss)({
    padding: '0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    transition: 'height 0.15s ease-out',
    overflowY: 'auto',
    maxHeight: '376px'
});

});
parcelRegister("1XCAD", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5f9181ddee7f41b1$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5f9181ddee7f41b1$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});

parcelRegister("2pUb3", function(module, exports) {
$parcel$export(module.exports, "useSmoothExpand", () => $535f9e4bd6cd6e9a$export$674ba8b02d2bfe86);

var $eJOHy = parcelRequire("eJOHy");
const $535f9e4bd6cd6e9a$var$MAX_HEIGHT = 376;
const $535f9e4bd6cd6e9a$var$STARTING_HEIGHT = 56;
const $535f9e4bd6cd6e9a$var$ADDITIONAL_HEIGHT = 16;
const $535f9e4bd6cd6e9a$export$674ba8b02d2bfe86 = (content)=>{
    const [height, setHeight] = (0, $eJOHy.useState)($535f9e4bd6cd6e9a$var$STARTING_HEIGHT);
    const callback = (0, $eJOHy.useCallback)(()=>{
        const contentClientHeight = content.current?.clientHeight;
        if (!contentClientHeight) return;
        if (contentClientHeight > $535f9e4bd6cd6e9a$var$MAX_HEIGHT) setHeight($535f9e4bd6cd6e9a$var$MAX_HEIGHT);
        else setHeight(contentClientHeight + $535f9e4bd6cd6e9a$var$ADDITIONAL_HEIGHT);
    }, [
        content
    ]);
    (0, $eJOHy.useEffect)(()=>{
        let resizeObserver;
        if (content.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(content.current);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        callback,
        content
    ]);
    return height;
};

});


parcelRegister("aNkQT", function(module, exports) {
$parcel$export(module.exports, "CommandRowErrorBoundary", () => $396c9e18c0709720$export$223f3c3c93a14a83);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");
const $396c9e18c0709720$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("OZurT", function(module, exports) {
$parcel$export(module.exports, "CommandRow", () => $7150d313297e5fc3$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $2OtIa = parcelRequire("2OtIa");

var $2Nn1q = parcelRequire("2Nn1q");
const $7150d313297e5fc3$var$styles = {
    rowWrapper: "_bozg1b66 _y4ti1b66"
};
const $7150d313297e5fc3$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        ...(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility') && {
            isLinkFocused: !!command.components?.CommandRow
        },
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $2OtIa.getAnalyticsAttributesFromResult)(result)
    };
    if ((0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $7150d313297e5fc3$var$styles.rowWrapper
        ])
    }, command.components?.CommandRow ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.CommandRow, rowProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Nn1q.CommandRow), rowProps));
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Nn1q.CommandRow), rowProps);
};

});
parcelRegister("2Nn1q", function(module, exports) {
$parcel$export(module.exports, "CommandRow", () => $23485c420ee6846d$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $46R8N = parcelRequire("46R8N");

var $6XJko = parcelRequire("6XJko");

var $4cTDP = parcelRequire("4cTDP");

var $1k1Uh = parcelRequire("1k1Uh");


var $cSwEo = parcelRequire("cSwEo");

var $gXsfJ = parcelRequire("gXsfJ");
const $23485c420ee6846d$var$activeStyles = null;
const $23485c420ee6846d$var$leftIconAndNameContainerStyles = null;
const $23485c420ee6846d$var$outlinedLozengeStyles = null;
const $23485c420ee6846d$var$styles = {
    root: "_1bsb1osq",
    commandContainer: "_11c82smr _syaz1gjq _1q511b66 _85i51b66 _bozg1b66 _y4ti1b66 _ahbqr5cr _12l2r5cr",
    innerContainer: "_1q511b66 _85i51b66 _bozgpxbi _y4tipxbi _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
    iconsContainer: "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
    buttonWrapper: "_bozg1b66 _y4ti1b66",
    button: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _bfhk18uv _y3gn1e5h"
};
const $23485c420ee6846d$export$3ef5d254c3c573e3 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, ...rest }, ref)=>{
    const InnerContainer = $23485c420ee6846d$var$CommandContainerInner;
    if (!(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $f844ecf9ba7020db$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(InnerContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$47c379a40b00a339),
        ref: ref,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandIconsContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        testId: (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $23485c420ee6846d$var$iconStyles,
            isActive && $23485c420ee6846d$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1k1Uh.OutlinedLozenge), {
        "data-testid": (0, $f844ecf9ba7020db$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSwEo.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gXsfJ.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": command.id,
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-active": isActive,
        "data-testid": (0, $f844ecf9ba7020db$export$b0017db5728101cc),
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.commandContainer,
            isActive && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f844ecf9ba7020db$export$47c379a40b00a339),
        ref: ref,
        ...rest,
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.innerContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f844ecf9ba7020db$export$d6dd1cf63aae711c),
        className: (0, $hcewu.default)([
            $23485c420ee6846d$var$styles.iconsContainer
        ])
    }, command.components?.LeftIcon && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        testId: (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $23485c420ee6846d$var$iconStyles,
            isActive && $23485c420ee6846d$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($23485c420ee6846d$var$CommandLeftIconContainer, {
        "data-testid": (0, $f844ecf9ba7020db$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testid": (0, $f844ecf9ba7020db$export$72c5368f559dd523),
        className: (0, $hcewu.default)([
            "_2rko12b0 _11c81u0j _19it3ju0 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _k48p1pd9 _bfhk1j9a _syaz131l _vchhusvi"
        ])
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cSwEo.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gXsfJ.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
    if (command.components?.CommandRow) return content;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46R8N.default), {
        xcss: $23485c420ee6846d$var$styles.button,
        "aria-label": command.name
    }, content);
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23485c420ee6846d$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _syaz1gjq _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            !!__cmplp.active && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandContainerInner = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandIconsContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$iconStyles = (0, $1DXK0.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $23485c420ee6846d$var$iconActiveStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23485c420ee6846d$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syazwdcn" : "_syaz1oju",
            __cmplp.className
        ])
    });
});
const $23485c420ee6846d$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1k1Uh", function(module, exports) {
$parcel$export(module.exports, "OutlinedLozenge", () => $34fe5e771f897e84$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $34fe5e771f897e84$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $34fe5e771f897e84$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $34fe5e771f897e84$var$Lozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rkofajl _11c8dcr7 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3igktf _1bsbgktf _vwz41crf _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81u0j _19it3ju0 _k48p1pd9 _1p1dangw _bfhk1j9a _syaz131l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81u0j _kqswh2mm _1p1dangw _1pbykb7n _1s6krwve _rfx3fajl _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $34fe5e771f897e84$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $34fe5e771f897e84$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1bsb1ris _bfhkm7j4",
            __cmplp.className
        ])
    });
});

});

const $f844ecf9ba7020db$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $f844ecf9ba7020db$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $f844ecf9ba7020db$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $f844ecf9ba7020db$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $f844ecf9ba7020db$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("cSwEo", function(module, exports) {
$parcel$export(module.exports, "RenderCommandName", () => $d68023b12b2300be$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $cQxBL = parcelRequire("cQxBL");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");

var $eZyz9 = parcelRequire("eZyz9");

const $d68023b12b2300be$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eJOHy.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eZyz9.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandNameContainer, {
        "data-testid": (0, $726ded7d34812919$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $726ded7d34812919$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $726ded7d34812919$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && ((0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            justifyContent: "center",
            xcss: $d68023b12b2300be$var$iconWrapperStyles,
            alignItems: "center",
            testId: (0, $726ded7d34812919$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d68023b12b2300be$var$CommandChevronContainer, {
            "data-testid": (0, $726ded7d34812919$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
            color: "currentColor",
            label: "separator",
            size: "small"
        })))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d68023b12b2300be$var$CommandNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_dm2rwo": (0, $awdRS.default)(__cmplp.active ? "var(--ds-text-subtle, #44546F)" : "var(--ds-text-subtlest, #626F86)")
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !!__cmplp.isParent && "_syazalb7",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$CommandChevronContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4kb7n _syaz1oju",
            __cmplp.className
        ])
    });
});
const $d68023b12b2300be$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    height: '24px',
    width: '24px'
});

});
parcelRegister("eZyz9", function(module, exports) {
$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $0485cf2ed2b26536$export$4495aca3d261add0);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $IW7jS = parcelRequire("IW7jS");

var $8nMzv = parcelRequire("8nMzv");

var $i92Id = parcelRequire("i92Id");


var $fu9LY = parcelRequire("fu9LY");
const $0485cf2ed2b26536$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        messageId: "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.popup",
        messageType: "transactional",
        popupComponent: (0, $i92Id.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i92Id.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $IW7jS.layers).tooltip()
    });
const $0485cf2ed2b26536$export$70f47de153e915ed = ()=>(0, $eJOHy.useRef)(null);
const $0485cf2ed2b26536$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $0485cf2ed2b26536$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $fu9LY.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $4c1f11f798b8ffde$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        ref: containerRef,
        xcss: [
            $0485cf2ed2b26536$var$tooltipContainerStyles,
            !preventTruncate && $0485cf2ed2b26536$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0485cf2ed2b26536$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $0485cf2ed2b26536$var$tooltipContainerStyles = (0, $1DXK0.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $0485cf2ed2b26536$var$truncateTooltipStyles = (0, $1DXK0.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("i92Id", function(module, exports) {
$parcel$export(module.exports, "TooltipComponent", () => $849f6edf3f22b0d2$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $849f6edf3f22b0d2$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $849f6edf3f22b0d2$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $849f6edf3f22b0d2$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $849f6edf3f22b0d2$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $849f6edf3f22b0d2$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $7AseU = parcelRequire("7AseU");

var $lRq8t = parcelRequire("lRq8t");

var $ccaPK = parcelRequire("ccaPK");
const $849f6edf3f22b0d2$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $849f6edf3f22b0d2$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $ccaPK.messages).tooltipTriggerAriaLabel)
    });
});
const $849f6edf3f22b0d2$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($849f6edf3f22b0d2$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $849f6edf3f22b0d2$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $7AseU.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $849f6edf3f22b0d2$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswh2mm _o5721q9c _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $849f6edf3f22b0d2$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ccaPK", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c726bd5d325f45ec$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c726bd5d325f45ec$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $4c1f11f798b8ffde$export$f9e3e7ede9ba929d = 400;

parcelRegister("fu9LY", function(module, exports) {
$parcel$export(module.exports, "useTruncatedTooltip", () => $696d52b07491914e$export$94b118b3187f12c);

var $eJOHy = parcelRequire("eJOHy");

var $2OtIa = parcelRequire("2OtIa");
const $696d52b07491914e$export$22c0312879c61300 = ()=>(0, $eJOHy.useState)(false);
const $696d52b07491914e$export$1ac6e474a0163418 = ()=>(0, $eJOHy.useState)(false);
const $696d52b07491914e$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $696d52b07491914e$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $696d52b07491914e$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $2OtIa.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eJOHy.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $726ded7d34812919$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $726ded7d34812919$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $726ded7d34812919$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $726ded7d34812919$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("gXsfJ", function(module, exports) {
$parcel$export(module.exports, "RightContent", () => $36c01c052dc4602a$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cQxBL = parcelRequire("cQxBL");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $2OtIa = parcelRequire("2OtIa");


var $xZyb9 = parcelRequire("xZyb9");

var $ivvUQ = parcelRequire("ivvUQ");

var $d6dCH = parcelRequire("d6dCH");

var $i7euV = parcelRequire("i7euV");
const $36c01c052dc4602a$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const transitionStep = (0, $i7euV.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eJOHy.useMemo)(()=>(0, $2OtIa.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$CommandRightChevronContainer, {
        "data-testid": (0, $f29cb9aaec65a024$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQxBL))), {
        spacing: "spacious",
        label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $xZyb9.messages).rightChevronLabel),
        size: "small",
        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($36c01c052dc4602a$var$ShortcutContainer, {
        "data-testid": (0, $f29cb9aaec65a024$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ivvUQ.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $36c01c052dc4602a$var$animationFadeIn = null;
const $36c01c052dc4602a$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$RightContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syaz1oju",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $36c01c052dc4602a$var$ShortcutContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
const $f29cb9aaec65a024$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $f29cb9aaec65a024$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';

parcelRegister("xZyb9", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8f4e2b0de24497ce$export$defe85febe8b728c);
// Delete file when cleaning up deliveroo_compal_a11y_fixes

var $7qGN1 = parcelRequire("7qGN1");
const $8f4e2b0de24497ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("ivvUQ", function(module, exports) {
$parcel$export(module.exports, "Shortcuts", () => $2bdae852387b780f$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $cMTOh = parcelRequire("cMTOh");

var $2OtIa = parcelRequire("2OtIa");


var $ey2FZ = parcelRequire("ey2FZ");
const $2bdae852387b780f$var$KeyElement = ({ shortcut: shortcut })=>{
    const isLongText = shortcut && shortcut.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $2bdae852387b780f$var$styles.shortcutKeyWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "data-testid": (0, $09f953b7673081a6$export$cd62afa4691c297),
        className: (0, $hcewu.default)([
            $2bdae852387b780f$var$styles.lozenge,
            isLongText && $2bdae852387b780f$var$styles.longLozenge
        ])
    }, shortcut));
};
const $2bdae852387b780f$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$ShortcutDivider, {
        "data-testid": (0, $09f953b7673081a6$export$e06ad7c09a29974b)
    }, divisor);
const $2bdae852387b780f$var$SHIFT_CHAR_MAP = {
    '?': 'shift /',
    '!': 'shift 1',
    '@': 'shift 2',
    '#': 'shift 3',
    $: 'shift 4',
    '%': 'shift 5',
    '^': 'shift 6',
    '&': 'shift 7',
    '*': 'shift 8',
    '(': 'shift 9',
    ')': 'shift 0',
    _: 'shift -',
    '+': 'shift =',
    '{': 'shift [',
    '}': 'shift ]',
    ':': 'shift ;',
    '"': "shift '",
    '<': 'shift ,',
    '>': 'shift .',
    '|': 'shift \\',
    '~': 'shift `'
};
const $2bdae852387b780f$var$shiftModifierCheck = (shortcut)=>{
    if (shortcut.length === 1) {
        if (/[A-Z]/.test(shortcut)) return `shift ${shortcut.toLowerCase()}`;
        return $2bdae852387b780f$var$SHIFT_CHAR_MAP[shortcut] || shortcut;
    }
    return shortcut;
};
const $2bdae852387b780f$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        $2bdae852387b780f$var$shiftModifierCheck(shortcut).split(' ').forEach((key, index, array)=>{
            acc.push({
                type: (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY,
                key: key
            });
            types.push((0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY);
            if (index < array.length - 1) {
                const separatorType = (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS;
                acc.push({
                    type: separatorType
                });
                types.push(separatorType);
            }
        });
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $2bdae852387b780f$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $2bdae852387b780f$export$cfaeb054b183bb20 = ()=>(0, $lRq8t.default)();
const $2bdae852387b780f$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $2bdae852387b780f$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eJOHy.useMemo)(()=>$2bdae852387b780f$var$parseShortcut(shortcut, (0, $2OtIa.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eJOHy.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ey2FZ.messages).shortcutThen;
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ey2FZ.messages).shortcutOr;
                if (types[1] === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ey2FZ.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eJOHy.useCallback)((type)=>{
        switch(type){
            case (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ey2FZ.messages).divisorThen);
            case (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ey2FZ.messages).divisorOr);
            default:
                return formatMessage((0, $ey2FZ.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$ShortcutContainer, {
        "data-testid": (0, $09f953b7673081a6$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $cMTOh.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bdae852387b780f$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bdae852387b780f$var$ShortcutDivider = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bdae852387b780f$var$ShortcutContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $2bdae852387b780f$var$styles = {
    lozenge: "_2rko12b0 _11c81u0j _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3i1tcg _syaz1fxt _1ul91tcg _1bsb1ris _kqswh2mm _1p1d1dk0 _1pbykb7n _1s6krwve _rfx312b0 _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
    longLozenge: "_18zr12x7",
    shortcutKeyWrapper: "_ca0qidpf _u5f31y44 _n3tdidpf _19bv1y44 _1ul91tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
};

});
const $09f953b7673081a6$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $09f953b7673081a6$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $09f953b7673081a6$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ey2FZ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e4fcfaa38e4e2d0e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e4fcfaa38e4e2d0e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("d6dCH", function(module, exports) {
$parcel$export(module.exports, "TRANSITION_STEP", () => $b2e6d0fa9dbab6a6$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $b2e6d0fa9dbab6a6$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $b2e6d0fa9dbab6a6$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $b2e6d0fa9dbab6a6$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $b2e6d0fa9dbab6a6$export$42d8d7c94c5a11e9 = /*#__PURE__*/ function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    return TRANSITION_STEP;
}({});
const $b2e6d0fa9dbab6a6$export$82cfc253a6c33f59 = 600;
const $b2e6d0fa9dbab6a6$export$e092796a9af3633b = 300;
const $b2e6d0fa9dbab6a6$export$1cad4f611a1c0229 = 350;

});

parcelRegister("i7euV", function(module, exports) {
$parcel$export(module.exports, "useHoverTransitionStep", () => $f0a4c8d4492da351$export$eefd045a02bab4c6);

var $eJOHy = parcelRequire("eJOHy");

var $kk5YU = parcelRequire("kk5YU");

var $9pTd3 = parcelRequire("9pTd3");

var $2OtIa = parcelRequire("2OtIa");

var $d6dCH = parcelRequire("d6dCH");
const $f0a4c8d4492da351$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eJOHy.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eJOHy.useState)((0, $d6dCH.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eJOHy.useRef)(null);
    const isReducedMotion = (0, $kk5YU.useIsReducedMotion)();
    const commandHasChildren = (0, $2OtIa.hasChildren)(command);
    (0, $eJOHy.useEffect)(()=>{
        setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eJOHy.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $d6dCH.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eJOHy.useCallback)(()=>{
        switch(transitionStep){
            case (0, $d6dCH.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $d6dCH.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $d6dCH.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $d6dCH.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $d6dCH.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).FINISHED, (0, $d6dCH.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $d6dCH.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $d6dCH.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $d6dCH.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $d6dCH.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $d6dCH.TRANSITION_STEP).INITIAL, (0, $d6dCH.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $9pTd3.fireErrorAnalytics)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!isFirstCommand) // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
        setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});




parcelRegister("6b4EO", function(module, exports) {
$parcel$export(module.exports, "COMMAND_CONTAINER_ROW_TEST_ID", () => $354f8ec6615134bc$export$617744f059bfc3ba);
$parcel$export(module.exports, "GROUP_TEST_ID", () => $354f8ec6615134bc$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $354f8ec6615134bc$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $354f8ec6615134bc$export$a6d65a8fb7b912d6);
const $354f8ec6615134bc$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $354f8ec6615134bc$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $354f8ec6615134bc$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $354f8ec6615134bc$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $354f8ec6615134bc$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $354f8ec6615134bc$export$a6d65a8fb7b912d6 = /*#__PURE__*/ function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
    return SCROLL_DIRECTION;
}({});

});

parcelRegister("5IbG4", function(module, exports) {
$parcel$export(module.exports, "isElementVisibleInContainer", () => $a1ee1680b73743ba$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $a1ee1680b73743ba$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $a1ee1680b73743ba$export$6be8a7238febd54f);

var $2OtIa = parcelRequire("2OtIa");

var $6b4EO = parcelRequire("6b4EO");
const $a1ee1680b73743ba$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $a1ee1680b73743ba$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $6b4EO.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $2OtIa.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $6b4EO.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $2OtIa.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $a1ee1680b73743ba$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
    const targetRect = target.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const gapScroll = 4;
    if (direction === (0, $6b4EO.SCROLL_DIRECTION).END) {
        const commandPosition = targetRect.bottom - containerRect.top;
        const amountToScroll = commandPosition - containerRect.height;
        const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
        scrollContainer.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = containerRect.top - targetRect.top;
        const amountToScroll = scrollContainer.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollContainer.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("lKFw0", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $0deb62bf7e6b3b6e$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");

var $4cTDP = parcelRequire("4cTDP");

const $0deb62bf7e6b3b6e$var$styles = {
    root: "_1e0c1txw _4cvr1h6o _mrkb1kw7 _1o0z1kw7 _1i53muej _uwhke4h9 _15a5nqa1 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi _4t3ickbl"
};
const $0deb62bf7e6b3b6e$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    if ((0, $4cTDP.fg)('compal_jifjam_navigation_new_filters')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $0deb62bf7e6b3b6e$var$styles.root,
        testId: (0, $19b63b11e263f76d$export$aca3e1b45b29f2bb)
    }, footerChildren);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0deb62bf7e6b3b6e$var$ModalFooterOld, {
        "data-testid": (0, $19b63b11e263f76d$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0deb62bf7e6b3b6e$var$ModalFooterOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_x3dozgxb _mrkb1kw7 _1o0z1kw7 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
const $19b63b11e263f76d$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("b4bRO", function(module, exports) {
$parcel$export(module.exports, "Header", () => $6a7be27086db7192$export$8b251419efc915eb);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

const $6a7be27086db7192$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $6a7be27086db7192$var$headerStyles,
        testId: (0, $dea6840b8c2241ed$export$bf5b960a2e79e6cf)
    }, children);
const $6a7be27086db7192$var$headerStyles = (0, $1DXK0.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    borderBottom: `solid 1px ${"var(--ds-border, #091E4224)"}`
});

});
const $dea6840b8c2241ed$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("QKs2x", function(module, exports) {
$parcel$export(module.exports, "useDebouncedLoadChildren", () => $434359018ede72c2$export$d38ddfbd8b9028f);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $cMTOh = parcelRequire("cMTOh");

var $g51Bg = parcelRequire("g51Bg");
const $434359018ede72c2$export$d38ddfbd8b9028f = (callback)=>{
    const [{ search: search }, { setLoadingList: setLoadingList }] = (0, $g51Bg.useCommandPaletteSearch)();
    const loadChildCommands = (0, $eJOHy.useCallback)(async (searchTerm, obj)=>{
        await callback(searchTerm, obj);
        if (!obj.isMounted) return;
        setLoadingList(false);
    }, [
        callback,
        setLoadingList
    ]);
    const executeDebouncer = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(loadChildCommands, (0, $cMTOh.COMMAND_PALETTE_DEBOUNCE_DEFAULT)), [
        loadChildCommands
    ]);
    (0, $eJOHy.useEffect)(()=>()=>executeDebouncer?.cancel?.(), [
        executeDebouncer
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const obj = {
            isMounted: true
        };
        setLoadingList(true);
        executeDebouncer(search, obj);
        return ()=>{
            obj.isMounted = false;
        };
    }, [
        search,
        executeDebouncer,
        setLoadingList
    ]);
};

});

parcelRegister("fVMQ6", function(module, exports) {
$parcel$export(module.exports, "useQuickSearchWithRecentCache", () => $fc94d7b9765673a1$export$7eb3d4d963c0f46c);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $416CA = parcelRequire("416CA");
const $fc94d7b9765673a1$export$ca7c3b177540050a = ()=>{
    const recentCacheRef = (0, $eJOHy.useRef)();
    const setRecentCache = (0, $eJOHy.useCallback)((cache)=>{
        recentCacheRef.current = cache;
    }, [
        recentCacheRef
    ]);
    return [
        recentCacheRef,
        setRecentCache
    ];
};
const $fc94d7b9765673a1$export$7eb3d4d963c0f46c = ()=>{
    const [{ isOpen: isOpen }] = (0, $g51Bg.useCommandPaletteIsOpen)();
    const [recentCache, setRecentCache] = $fc94d7b9765673a1$export$ca7c3b177540050a();
    const { fetch: fetch } = (0, $416CA.useQuickSearch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Reset cache when compal closes
    (0, $eJOHy.useEffect)(()=>{
        if (Boolean(recentCache.current) && !isOpen) setRecentCache(undefined);
    }, [
        isOpen,
        recentCache,
        setRecentCache
    ]);
    const fetchData = (0, $eJOHy.useCallback)(async (searchString, sessionId, signal)=>{
        const start = new Date();
        const apiCall = fetch(searchString, sessionId, signal);
        const result = await apiCall;
        const end = new Date();
        const duration = end.getTime() - start.getTime();
        if (searchString?.length) (0, $kRgKj.fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'searchRequest completed', {
            postQueryRequestDurationMs: duration
        });
        else {
            (0, $kRgKj.fireTrackAnalyticsDeferred)(createAnalyticsEvent({}), 'recentRequest completed', {
                preQueryRequestDurationMs: duration
            });
            setRecentCache(apiCall);
        }
        return result;
    }, [
        createAnalyticsEvent,
        fetch,
        setRecentCache
    ]);
    const getResponse = (0, $eJOHy.useCallback)(async (searchString, sessionId, signal)=>{
        if (searchString && searchString.length > 0) {
            const result = await fetchData(searchString, sessionId, signal);
            return {
                result: result,
                isCache: false
            };
        }
        if (recentCache.current) // refetch if existing cache is in error state
        try {
            await recentCache.current;
        } catch (err) {
            const apiCall = fetchData(searchString, sessionId, signal);
            return {
                result: await apiCall,
                isCache: false
            };
        }
        else {
            const apiCall = fetchData(searchString, sessionId, signal);
            return {
                result: await apiCall,
                isCache: false
            };
        }
        return {
            result: await recentCache.current,
            isCache: true
        };
    }, [
        recentCache,
        fetchData
    ]);
    return {
        fetch: getResponse
    };
};

});
parcelRegister("416CA", function(module, exports) {
$parcel$export(module.exports, "useQuickSearch", () => $bf15365b1a6535ce$export$8ad8ebb2d2ffa47);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $koAZ4 = parcelRequire("koAZ4");

var $9V8uj = parcelRequire("9V8uj");
const $bf15365b1a6535ce$var$EXPERIENCE = 'command-palette-jira-integration';
// limit of results per scope (can only choose 1 limit, so we are using the max limit)
// we are also adding 1 to this so we know if there are more items than the limit (vs there is exactly the limit)
const $bf15365b1a6535ce$var$LIMIT = Math.max((0, $9V8uj.ISSUE_LIMIT), (0, $9V8uj.PROJECT_LIMIT), (0, $9V8uj.BOARD_LIMIT), (0, $9V8uj.FILTER_LIMIT), (0, $9V8uj.PLAN_LIMIT)) + 1;
const $bf15365b1a6535ce$export$8ad8ebb2d2ffa47 = ()=>{
    const { cloudId: cloudId } = (0, $koAZ4.useTenantContext)();
    const fetch = (0, $eJOHy.useCallback)(async (query, sessionId, signal)=>{
        try {
            const data = await (0, $3ugTQ.performPostRequest)('/gateway/api/xpsearch-aggregator/quicksearch/v1', {
                body: JSON.stringify({
                    cloudId: cloudId,
                    scopes: [
                        'jira.issue',
                        'jira.board',
                        'jira.project',
                        'jira.filter',
                        'jira.plan'
                    ],
                    query: query,
                    experience: $bf15365b1a6535ce$var$EXPERIENCE,
                    searchSession: {
                        sessionId: sessionId,
                        referrerId: null
                    },
                    limit: $bf15365b1a6535ce$var$LIMIT
                }),
                signal: signal
            });
            return data;
        } catch (error) {
            (0, $9pTd3.fireErrorAnalytics)({
                error: error instanceof Error ? error : new Error('Error not identified'),
                meta: {
                    id: 'fetchRecentlyViewedIssuesService',
                    packageName: 'jiraCommandPaletteQuickSearch',
                    teamName: 'deliveroo'
                }
            });
            throw error;
        }
    }, [
        cloudId
    ]);
    return {
        fetch: fetch
    };
};

});
parcelRegister("9V8uj", function(module, exports) {
$parcel$export(module.exports, "QUICK_SEARCH_PRIORITY", () => $cb75b00b31e9ea33$export$ce7c8c2e20fb73ca);
$parcel$export(module.exports, "ISSUE_LIMIT", () => $cb75b00b31e9ea33$export$dcc4c3a6f9b2e0aa);
$parcel$export(module.exports, "PROJECT_LIMIT", () => $cb75b00b31e9ea33$export$8000560255015036);
$parcel$export(module.exports, "BOARD_LIMIT", () => $cb75b00b31e9ea33$export$2987f3ac7bc1c1c3);
$parcel$export(module.exports, "FILTER_LIMIT", () => $cb75b00b31e9ea33$export$14ceffb568197d5a);
$parcel$export(module.exports, "PLAN_LIMIT", () => $cb75b00b31e9ea33$export$654fbdaf884d026c);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $cb75b00b31e9ea33$export$ce7c8c2e20fb73ca = /*#__PURE__*/ function(QUICK_SEARCH_PRIORITY) {
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["ISSUES"] = 0] = "ISSUES";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["PROJECTS"] = 1] = "PROJECTS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["BOARDS"] = 2] = "BOARDS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["FILTERS"] = 3] = "FILTERS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["PLANS"] = 4] = "PLANS";
    QUICK_SEARCH_PRIORITY[QUICK_SEARCH_PRIORITY["RECOMMENDED"] = 5] = "RECOMMENDED";
    return QUICK_SEARCH_PRIORITY;
}({});
const $cb75b00b31e9ea33$export$dcc4c3a6f9b2e0aa = 5;
const $cb75b00b31e9ea33$export$8000560255015036 = 3;
const $cb75b00b31e9ea33$export$2987f3ac7bc1c1c3 = 3;
const $cb75b00b31e9ea33$export$14ceffb568197d5a = 3;
const $cb75b00b31e9ea33$export$654fbdaf884d026c = 3;

});



parcelRegister("iIIpn", function(module, exports) {
$parcel$export(module.exports, "useGetRecentResults", () => $6a95ae5187aa083c$export$232194057b4317a2);

var $eJOHy = parcelRequire("eJOHy");

var $2OtIa = parcelRequire("2OtIa");

var $SPYRa = parcelRequire("SPYRa");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $bDJNS = parcelRequire("bDJNS");

var $5opHR = parcelRequire("5opHR");

var $623Vg = parcelRequire("623Vg");

var $gpyau = parcelRequire("gpyau");

var $4xW0u = parcelRequire("4xW0u");

var $kNyOe = parcelRequire("kNyOe");

var $RQobE = parcelRequire("RQobE");

var $27NG5 = parcelRequire("27NG5");

var $8XegI = parcelRequire("8XegI");
const $6a95ae5187aa083c$export$232194057b4317a2 = ()=>{
    const { getChildResult: getRecentBoardsChildResult } = (0, $4xW0u.useGetRecentBoardsChildResult)();
    const { getChildResult: getRecentIssuesChildResult } = (0, $RQobE.useGetRecentIssuesChildResult)();
    const { getChildResult: getRecentProjectsChildResult } = (0, $8XegI.useGetRecentProjectsChildResult)();
    const { getChildResult: getRecentFiltersChildResult } = (0, $kNyOe.useGetRecentFiltersChildResult)();
    const { getChildResult: getRecentPlansChildResult } = (0, $27NG5.useGetRecentPlansChildResult)();
    const { getChildResult: getErrorChildResult } = (0, $bDJNS.useGetErrorChildResult)();
    const { getChildResult: getRecommendedChildResult } = (0, $5opHR.useGetRecommendedChildResult)();
    const [hasEditOrViewPermissions] = (0, $SPYRa.useNavigationViewPlansPermission)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $623Vg.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    const getRecentResults = (0, $eJOHy.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        setTimeoutFunc(()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'searchResults shown', 'preQuerySearchResults', {
                ...(0, $gpyau.transformResultsForAnalytics)(quickSearchResponseData, true)
            });
        }, 0);
        return (0, $2OtIa.mergeChildResults)([
            getErrorChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecommendedChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentIssuesChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentProjectsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentBoardsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecentFiltersChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            ...hasEditOrViewPermissions ? [
                getRecentPlansChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                })
            ] : []
        ]);
    }, [
        createAnalyticsEvent,
        getErrorChildResult,
        getRecommendedChildResult,
        getRecentIssuesChildResult,
        getRecentProjectsChildResult,
        getRecentBoardsChildResult,
        getRecentFiltersChildResult,
        hasEditOrViewPermissions,
        getRecentPlansChildResult,
        setTimeoutFunc
    ]);
    return getRecentResults;
};

});
parcelRegister("SPYRa", function(module, exports) {
$parcel$export(module.exports, "navigationPlansVisibilityResource", () => $fdcc63ef33fd0b8d$export$fa475a9581133779);
$parcel$export(module.exports, "useNavigationPlansVisibility", () => $fdcc63ef33fd0b8d$export$4524245d4e74edb2);
$parcel$export(module.exports, "useNavigationViewPlansPermission", () => $fdcc63ef33fd0b8d$export$98eef08fd4586a4);
$parcel$export(module.exports, "useNavigationEditPlansPermission", () => $fdcc63ef33fd0b8d$export$525db876ed776e0d);
$parcel$export(module.exports, "useIsAdvancedRoadmapsTrial", () => $fdcc63ef33fd0b8d$export$54805a2120a31ad0);

var $eSnSE = parcelRequire("eSnSE");

var $hgi0g = parcelRequire("hgi0g");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

const $fdcc63ef33fd0b8d$export$fa475a9581133779 = (0, $l1VxS.createResource)({
    type: (0, $19cf35753fa41a8f$export$9260ddb6dfeafd7b),
    getKey: ()=>'state',
    getData: async (_, { tenantContext: tenantContext })=>{
        try {
            if (tenantContext.isAnonymous) return false;
            const response = await (0, $hgi0g.default)('/rest/jpo/1.0/navigation/simple');
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData((0, $19cf35753fa41a8f$export$87d0ca22edb7493a), 'Error while fetching plans visibility', error);
        }
        return false;
    },
    maxAge: Infinity,
    isCritical: true
});
const $fdcc63ef33fd0b8d$export$4524245d4e74edb2 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let isVisible = false;
    if (!error && !loading && data !== null && typeof data === 'object') isVisible = data.isVisible;
    return [
        isVisible
    ];
};
const $fdcc63ef33fd0b8d$export$98eef08fd4586a4 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let hasEditOrViewPermissions = false;
    if (!error && !loading && data !== null && typeof data === 'object') hasEditOrViewPermissions = data.hasEditOrViewPermissions;
    return [
        hasEditOrViewPermissions
    ];
};
const $fdcc63ef33fd0b8d$export$525db876ed776e0d = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let canEditPlans = false;
    if (!error && !loading && data !== null && typeof data === 'object') canEditPlans = data.hasEditPermissions || false;
    return canEditPlans;
};
const $fdcc63ef33fd0b8d$export$54805a2120a31ad0 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)($fdcc63ef33fd0b8d$export$fa475a9581133779);
    let isAdvancedRoadmapsTrial = false;
    if (!error && !loading && data !== null && typeof data === 'object') isAdvancedRoadmapsTrial = data.isAdvancedRoadmapsTrial || false;
    return isAdvancedRoadmapsTrial;
};

});
const $19cf35753fa41a8f$export$9260ddb6dfeafd7b = 'NAVIGATION_PLANS_VISIBILITY';
const $19cf35753fa41a8f$export$87d0ca22edb7493a = 'portfolio.services.plan-item-visibility';


parcelRegister("bDJNS", function(module, exports) {
$parcel$export(module.exports, "useGetErrorChildResult", () => $1b7c8472568f4013$export$3aefd3a8866c4c01);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $g656q = parcelRequire("g656q");

var $1VhB7 = parcelRequire("1VhB7");


var $10HxG = parcelRequire("10HxG");

var $6tnwH = parcelRequire("6tnwH");
const $1b7c8472568f4013$export$3aefd3a8866c4c01 = ()=>{
    const { formatMessage: formatMessage, formatList: formatList } = (0, $lRq8t.default)();
    const getChildResult = (0, $eJOHy.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const projectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $10HxG.messages).projectsGalaxia : (0, $10HxG.messages).projects;
        const commands = [];
        const sections = {};
        const isSearching = Boolean(search);
        const issueScope = (0, $1VhB7.getQuickSearchIssueScope)(quickSearchResponseData);
        const projectScope = (0, $1VhB7.getQuickSearchProjectScope)(quickSearchResponseData);
        const boardScope = (0, $1VhB7.getQuickSearchBoardScope)(quickSearchResponseData);
        const filterScope = (0, $1VhB7.getQuickSearchFilterScope)(quickSearchResponseData);
        const planScope = (0, $1VhB7.getQuickSearchPlanScope)(quickSearchResponseData);
        const errorScopes = [
            issueScope?.error ? formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $10HxG.messages).issuesIssueTermRefresh : (0, $10HxG.messages).issues) : undefined,
            projectScope?.error ? formatMessage(projectsGalaxia) : undefined,
            boardScope?.error ? formatMessage((0, $10HxG.messages).boards) : undefined,
            filterScope?.error ? formatMessage((0, $10HxG.messages).filters) : undefined,
            planScope?.error ? formatMessage((0, $10HxG.messages).plans) : undefined
        ];
        const errors = errorScopes.filter(Boolean); // If there is an api error or the api scopes are all errors
        if (error || errorScopes.length === errors.length) {
            const getMessage = ()=>{
                if (isSearching) return (0, $10HxG.messages).searchFullError;
                return (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $10HxG.messages).recentFullErrorIssueTermRefresh : (0, $10HxG.messages).recentFullError;
            };
            const message = formatMessage(getMessage());
            commands.push({
                id: 'full-error',
                name: message,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1b7c8472568f4013$var$CommandErrorWrapper, {
                            "data-testid": (0, $ca6ade0d73b3de16$export$1a00547d03f724bf)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g656q.FullWidthText), null, message))
                },
                keywords: search
            });
            return {
                sections: sections,
                commands: commands
            };
        } // If the api scopes are partially errored
        if (errors.length) {
            const formattedErrors = formatList(errors, {
                style: 'long',
                type: 'conjunction'
            });
            const message = isSearching ? formatMessage((0, $10HxG.messages).searchPartialError, {
                errorList: formattedErrors
            }) : formatMessage((0, $10HxG.messages).recentPartialError, {
                errorList: formattedErrors
            });
            commands.push({
                id: 'partial-error',
                name: formatMessage((0, $10HxG.messages).searchFullError),
                // todo fix this
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1b7c8472568f4013$var$CommandErrorWrapper, {
                            "data-testid": (0, $ca6ade0d73b3de16$export$18ff005171e98b96)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g656q.FullWidthText), null, message))
                },
                keywords: search
            });
            return {
                sections: sections,
                commands: commands
            };
        }
        const noSearchResults = !issueScope?.results?.length && !projectScope?.results?.length && !boardScope?.results?.length && !filterScope?.results?.length && !planScope?.results?.length;
        if (noSearchResults) {
            if (isSearching) commands.push({
                id: 'no-search-results',
                name: formatMessage((0, $10HxG.messages).searchFullError),
                keywords: search,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1b7c8472568f4013$var$CommandErrorWrapper, {
                            "data-testid": (0, $ca6ade0d73b3de16$export$92b3b15780115417)
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g656q.FullWidthText), null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $10HxG.messages).searchNoResultsIssueTermRefresh : (0, $10HxG.messages).searchNoResults)))
                }
            });
            else {
                const message = formatMessage((0, $10HxG.messages).noRecentResults);
                commands.push({
                    id: 'no-recent-results',
                    name: message,
                    keywords: search,
                    components: {
                        Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1b7c8472568f4013$var$CommandErrorWrapper, {
                                "data-testid": (0, $ca6ade0d73b3de16$export$b42da4a04bacaf8c)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6tnwH.NoRecentResults), {
                                message: message
                            }))
                    }
                });
            }
            return {
                sections: sections,
                commands: commands
            };
        }
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatList,
        formatMessage
    ]);
    return {
        getChildResult: getChildResult
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b7c8472568f4013$var$CommandErrorWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qpxbi _n3tdu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g656q", function(module, exports) {
$parcel$export(module.exports, "FullWidthText", () => $e3296e960da53a2a$export$379b1877ecebef1d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $e3296e960da53a2a$export$379b1877ecebef1d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1osq _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1VhB7", function(module, exports) {
$parcel$export(module.exports, "transformQuickSearchIssueResultToIssue", () => $f31b9813c84d0166$export$58562759d0785ec6);
$parcel$export(module.exports, "getQuickSearchIssueScope", () => $f31b9813c84d0166$export$d7d3d79bf2e09f24);
$parcel$export(module.exports, "transformQuickSearchBoardResultToBoard", () => $f31b9813c84d0166$export$b8b15ec40fa1a48c);
$parcel$export(module.exports, "getQuickSearchBoardScope", () => $f31b9813c84d0166$export$53119668e12df12a);
$parcel$export(module.exports, "getQuickSearchProjectScope", () => $f31b9813c84d0166$export$a63a1be38234a3e5);
$parcel$export(module.exports, "transformQuickSearchProjectResultToProject", () => $f31b9813c84d0166$export$f2d81fcd7b29a3fa);
$parcel$export(module.exports, "getQuickSearchFilterScope", () => $f31b9813c84d0166$export$9fa79248b92c9eb7);
$parcel$export(module.exports, "transformQuickSearchFilterResultToFilter", () => $f31b9813c84d0166$export$ff1365615bf8816a);
$parcel$export(module.exports, "getQuickSearchPlanScope", () => $f31b9813c84d0166$export$ee6c69e884c0330);
$parcel$export(module.exports, "transformQuickSearchPlanResultToPlan", () => $f31b9813c84d0166$export$8033b8f463ee000a);
const $f31b9813c84d0166$export$58562759d0785ec6 = (issue)=>({
        issueId: issue.id,
        summary: issue.name,
        url: issue.url,
        issueKey: issue.attributes.key,
        avatar: issue.attributes.avatar,
        projectName: issue.attributes.container.title,
        projectId: issue.attributes.containerId,
        issueTypeName: issue.attributes.issueTypeName
    });
const $f31b9813c84d0166$export$d7d3d79bf2e09f24 = (results)=>{
    const issueResults = results?.scopes?.find((scope)=>scope.id === 'jira.issue');
    if (issueResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return issueResults;
    return undefined;
};
const $f31b9813c84d0166$export$b8b15ec40fa1a48c = (board)=>({
        id: board.id,
        url: board.url,
        name: board.name,
        containerId: board.attributes.containerId,
        containerName: board.attributes.containerName,
        isFavourite: board.attributes.isFavourite
    });
const $f31b9813c84d0166$export$53119668e12df12a = (results)=>{
    const boardResults = results?.scopes?.find((scope)=>scope.id === 'jira.board');
    if (boardResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return boardResults;
    return undefined;
};
const $f31b9813c84d0166$export$a63a1be38234a3e5 = (results)=>{
    const issueResults = results?.scopes?.find((scope)=>scope.id === 'jira.project');
    if (issueResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return issueResults;
    return undefined;
};
const $f31b9813c84d0166$export$f2d81fcd7b29a3fa = (project)=>({
        projectId: project.id,
        name: project.name,
        url: project.url,
        avatar: project.attributes.avatar,
        canView: project.attributes.canView,
        isFavourite: project.attributes.isFavourite,
        projectKey: project.attributes.projectKey,
        projectType: project.attributes.projectType,
        simplified: project.attributes.simplified
    });
const $f31b9813c84d0166$export$9fa79248b92c9eb7 = (results)=>{
    const filterResults = results?.scopes?.find((scope)=>scope.id === 'jira.filter');
    if (filterResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return filterResults;
    return undefined;
};
const $f31b9813c84d0166$export$ff1365615bf8816a = (filter)=>({
        id: filter.id,
        name: filter.name,
        url: filter.url
    });
const $f31b9813c84d0166$export$ee6c69e884c0330 = (results)=>{
    const planResults = results?.scopes?.find((scope)=>scope.id === 'jira.plan');
    if (planResults) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return planResults;
    return undefined;
};
const $f31b9813c84d0166$export$8033b8f463ee000a = (plan)=>({
        id: plan.id,
        name: plan.name,
        url: plan.url
    });

});

const $ca6ade0d73b3de16$export$1a00547d03f724bf = 'command-palette.ui.modal.modal-dialog';
const $ca6ade0d73b3de16$export$18ff005171e98b96 = 'command-palette.ui.modal.modal-dialog';
const $ca6ade0d73b3de16$export$92b3b15780115417 = 'command-palette.ui.modal.modal-dialog';
const $ca6ade0d73b3de16$export$b42da4a04bacaf8c = 'no-recent-results';

parcelRegister("10HxG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ee833d49092fe307$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ee833d49092fe307$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    noRecentResults: {
        "id": "command-palette-quick-search.common.error.no-recent-results",
        "defaultMessage": "Things in Jira that you\u2019ve recently viewed will appear here."
    },
    recentFullError: {
        "id": "command-palette-quick-search.common.error.recent-full-error",
        "defaultMessage": "We\u2019re having trouble loading recently viewed issues. Try again in a few moments."
    },
    searchFullError: {
        "id": "command-palette-quick-search.common.error.search-full-error",
        "defaultMessage": "We\u2019re not sure what went wrong. Try again in a few moments."
    },
    searchNoResults: {
        "id": "command-palette-quick-search.common.error.search-no-results",
        "defaultMessage": "No issue, project, board, plan, or filter matches your search"
    },
    searchIssueError: {
        "id": "command-palette-quick-search.common.error.search-issue-error",
        "defaultMessage": "We\u2019re having trouble searching issues. You can try again in a few moments."
    },
    recentPartialError: {
        "id": "command-palette-quick-search.common.error.recent-partial-error",
        "defaultMessage": "We are having trouble loading {errorList} from your recently viewed items. Try again in a few moments."
    },
    searchPartialError: {
        "id": "command-palette-quick-search.common.error.search-partial-error",
        "defaultMessage": "We are having trouble searching {errorList}. Try again in a few moments."
    },
    issues: {
        "id": "command-palette-quick-search.common.error.issues",
        "defaultMessage": "issues"
    },
    projects: {
        "id": "command-palette-quick-search.common.error.projects",
        "defaultMessage": "projects"
    },
    boards: {
        "id": "command-palette-quick-search.common.error.boards",
        "defaultMessage": "boards"
    },
    filters: {
        "id": "command-palette-quick-search.common.error.filters",
        "defaultMessage": "filters"
    },
    plans: {
        "id": "command-palette-quick-search.common.error.plans",
        "defaultMessage": "plans"
    },
    recentFullErrorIssueTermRefresh: {
        "id": "command-palette-quick-search.common.error.recent-full-error-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble loading recently viewed work items. Try again in a few moments."
    },
    searchNoResultsIssueTermRefresh: {
        "id": "command-palette-quick-search.common.error.search-no-results-issue-term-refresh",
        "defaultMessage": "No work item, project, board, plan, or filter matches your search"
    },
    searchIssueErrorIssueTermRefresh: {
        "id": "command-palette-quick-search.common.error.search-issue-error-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble searching for work items. You can try again in a few moments."
    },
    issuesIssueTermRefresh: {
        "id": "command-palette-quick-search.common.error.issues-issue-term-refresh",
        "defaultMessage": "work items"
    },
    projectsGalaxia: {
        "id": "command-palette-quick-search.common.error.projects-galaxia",
        "defaultMessage": "spaces"
    },
    searchNoResultsIssueTermRefreshGalaxia: {
        "id": "command-palette-quick-search.common.error.search-no-results-issue-term-refresh-galaxia",
        "defaultMessage": "No work item, space, board, plan, or filter matches your search"
    }
});

});

parcelRegister("6tnwH", function(module, exports) {
$parcel$export(module.exports, "NoRecentResults", () => $daa4572dc26884a4$export$6a5306d6ad19b06d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8IeH1 = parcelRequire("8IeH1");
var $78OnL = parcelRequire("78OnL");

var $adVJq = parcelRequire("adVJq");

var $g656q = parcelRequire("g656q");
const $daa4572dc26884a4$export$6a5306d6ad19b06d = ({ message: message })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g656q.FullWidthText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($daa4572dc26884a4$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $adVJq.default), {
        alt: "",
        fill: true
    })), message)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $daa4572dc26884a4$var$ImageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3ioahv _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("adVJq", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c56b1f234f7d4ec$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("2JjKy")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("2JjKy")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = nj3nrg7zrmxwrhh9fn9ftw5m
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/nj3nrg7zrmxwrhh9fn9ftw5m

var $c4huj = parcelRequire("c4huj");

var $2JjKy = parcelRequire("2JjKy");
const $3c56b1f234f7d4ec$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2JjKy)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2JjKy))
});
var $3c56b1f234f7d4ec$export$2e2bcd8739ae039 = $3c56b1f234f7d4ec$var$Illustration;
// for advanced use only
const $3c56b1f234f7d4ec$export$a179c88182cb9d56 = [
    0,
    0,
    95,
    89
];

});
parcelRegister("2JjKy", function(module, exports) {
module.exports = new URL("magic-search.dbdce574.svg", import.meta.url).toString();

});




parcelRegister("5opHR", function(module, exports) {
$parcel$export(module.exports, "useGetRecommendedChildResult", () => $323fa09b8712b859$export$d7d3564e5e2691ad);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $1VhB7 = parcelRequire("1VhB7");

var $hJZsd = parcelRequire("hJZsd");

var $flCp3 = parcelRequire("flCp3");

var $8e0TE = parcelRequire("8e0TE");
const $323fa09b8712b859$var$SECTION_ID = 'recommended';
const $323fa09b8712b859$export$d7d3564e5e2691ad = ()=>{
    const { getViewAllCommand: getViewAllCommand } = (0, $hJZsd.useGetViewAllCommand)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getChildResult = (0, $eJOHy.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const viewAllProjectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8e0TE.messages).viewAllProjectsGalaxia : (0, $8e0TE.messages).viewAllProjects;
        const isSearching = Boolean(search);
        const sections = {
            [$323fa09b8712b859$var$SECTION_ID]: {
                name: formatMessage((0, $8e0TE.messages).recommendedSection),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).RECOMMENDED
            }
        };
        const commands = [];
        const issueScope = (0, $1VhB7.getQuickSearchIssueScope)(quickSearchResponseData);
        const projectScope = (0, $1VhB7.getQuickSearchProjectScope)(quickSearchResponseData);
        const boardScope = (0, $1VhB7.getQuickSearchBoardScope)(quickSearchResponseData);
        const filterScope = (0, $1VhB7.getQuickSearchFilterScope)(quickSearchResponseData);
        const planScope = (0, $1VhB7.getQuickSearchPlanScope)(quickSearchResponseData);
        const showRecommended = (scope)=>!scope || scope.error || error || isSearching && !scope?.results?.length;
        if (showRecommended(issueScope)) {
            commands.push(getViewAllCommand({
                id: 'recommended-issues',
                section: $323fa09b8712b859$var$SECTION_ID,
                name: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $8e0TE.messages).viewAllIssuesIssueTermRefresh : (0, $8e0TE.messages).viewAllIssues),
                keywords: search,
                isRecommended: true,
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).ISSUE),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).ISSUES,
                analyticsPayload: {
                    action: 'viewAllIssues'
                }
            }));
            if ((0, $4cTDP.fg)('compal_jifjam_navigation_new_filters')) {
                commands.push(getViewAllCommand({
                    id: 'recommended-my-open-issues',
                    section: $323fa09b8712b859$var$SECTION_ID,
                    name: formatMessage((0, $8e0TE.messages).viewMyOpenIssues),
                    keywords: search,
                    isRecommended: true,
                    url: '/issues?filter=-1',
                    priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).ISSUES,
                    analyticsPayload: {
                        action: 'viewMyOpenIssues'
                    }
                }));
                commands.push(getViewAllCommand({
                    id: 'recommended-issues-reported-by-me',
                    section: $323fa09b8712b859$var$SECTION_ID,
                    name: formatMessage((0, $8e0TE.messages).viewIssuesReportedByMe),
                    keywords: search,
                    isRecommended: true,
                    url: '/issues?filter=-2',
                    priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).ISSUES,
                    analyticsPayload: {
                        action: 'viewIssuesReportedByMe'
                    }
                }));
            }
        }
        if (showRecommended(boardScope)) commands.push(getViewAllCommand({
            id: 'recommended-boards',
            section: $323fa09b8712b859$var$SECTION_ID,
            name: formatMessage((0, $8e0TE.messages).viewAllBoards),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).BOARD),
            priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).BOARDS,
            analyticsPayload: {
                action: 'viewAllBoards'
            }
        }));
        if (showRecommended(projectScope)) commands.push(getViewAllCommand({
            id: 'recommended-projects',
            section: $323fa09b8712b859$var$SECTION_ID,
            name: formatMessage(viewAllProjectsGalaxia),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).PROJECT),
            priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).PROJECTS,
            analyticsPayload: {
                action: 'viewAllProjects'
            }
        }));
        if (showRecommended(filterScope)) commands.push(getViewAllCommand({
            id: 'recommended-filters',
            section: $323fa09b8712b859$var$SECTION_ID,
            name: formatMessage((0, $8e0TE.messages).viewAllFilters),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).FILTER),
            priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).FILTERS,
            analyticsPayload: {
                action: 'viewAllFilters'
            }
        }));
        if (showRecommended(planScope)) commands.push(getViewAllCommand({
            id: 'recommended-plans',
            section: $323fa09b8712b859$var$SECTION_ID,
            name: formatMessage((0, $8e0TE.messages).viewAllPlans),
            keywords: search,
            isRecommended: true,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).PLAN),
            priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).PLANS,
            analyticsPayload: {
                action: 'viewAllPlans'
            }
        }));
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getViewAllCommand
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("hJZsd", function(module, exports) {
$parcel$export(module.exports, "useGetViewAllCommand", () => $d80859c89b79595b$export$fc2d112e790e7f2a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $ePxSL = parcelRequire("ePxSL");

var $4cTDP = parcelRequire("4cTDP");

var $kQy7N = parcelRequire("kQy7N");
const $d80859c89b79595b$export$fc2d112e790e7f2a = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $kQy7N.useTransformNavigationCommands)();
    const getViewAllCommand = (0, $eJOHy.useCallback)(({ name: name, url: url, isRecommended: isRecommended = false, analyticsPayload: analyticsPayload = {}, ...rest })=>transformNavigationCommand({
            name: name,
            components: {
                Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d80859c89b79595b$var$RenderNameWrapper, {
                        "data-testid": "command-palette-quick-search.common.ui.view-all.render-name-wrapper",
                        isRecommended: isRecommended
                    }, name),
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                        color: "currentColor",
                        size: "small",
                        label: "",
                        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                    })
            },
            analytics: {
                action: 'quickSearchViewAll',
                ...analyticsPayload
            },
            ...rest
        }, {
            path: url
        }), [
        transformNavigationCommand
    ]);
    return {
        getViewAllCommand: getViewAllCommand
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d80859c89b79595b$var$RenderNameWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isRecommended: isRecommended, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            !__cmplp.isRecommended && "_syaz1e6v",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ePxSL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc01c6bd1fc51c7$var$_react = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $acc01c6bd1fc51c7$var$_baseNew = $acc01c6bd1fc51c7$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $acc01c6bd1fc51c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc01c6bd1fc51c7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $acc01c6bd1fc51c7$var$_react.default.createElement($acc01c6bd1fc51c7$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$acc01c6bd1fc51c7$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $acc01c6bd1fc51c7$var$_default = module.exports.default = $acc01c6bd1fc51c7$var$ArrowRightIcon;

});

parcelRegister("kQy7N", function(module, exports) {
$parcel$export(module.exports, "useTransformNavigationCommands", () => $ae31bfa49fe3c190$export$5b108cd54c923a60);

var $eJOHy = parcelRequire("eJOHy");

var $58ssj = parcelRequire("58ssj");

var $ftN6c = parcelRequire("ftN6c");

var $9itkV = parcelRequire("9itkV");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $hf4h9 = parcelRequire("hf4h9");

var $jmeeg = parcelRequire("jmeeg");

var $2OtIa = parcelRequire("2OtIa");

var $g51Bg = parcelRequire("g51Bg");

var $kRgKj = parcelRequire("kRgKj");

var $6XJko = parcelRequire("6XJko");

var $gCY1z = parcelRequire("gCY1z");

var $4cTDP = parcelRequire("4cTDP");

var $7rOkc = parcelRequire("7rOkc");

var $cZPxL = parcelRequire("cZPxL");

var $9LFHG = parcelRequire("9LFHG");

var $aUXni = parcelRequire("aUXni");

const $ae31bfa49fe3c190$export$5b108cd54c923a60 = ()=>{
    const [{ location: { pathname: pathname } }, { push: push, pushTo: pushTo }] = (0, $gCY1z.useRouter)();
    const { getAnalyticsAttributes: getAnalyticsAttributes } = (0, $g51Bg.useActionsCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const openNewTab = (0, $eJOHy.useCallback)((link, openBackground)=>{
        const url = typeof link === 'string' ? link : link.path;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const newTab = window.open(url, '_blank');
        if (openBackground) {
            newTab?.blur();
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.focus();
        }
        return newTab;
    }, []);
    const openSameTab = (0, $eJOHy.useCallback)((link)=>{
        if (typeof link === 'string') return push(link);
        return pushTo(link);
    }, [
        push,
        pushTo
    ]);
    const renderCommand = (0, $eJOHy.useCallback)((props, path, shouldAlwaysOpenNewTab)=>{
        const { onClick: onClick, ...rest } = props;
        const { command: command } = rest;
        const handleClick = (event)=>{
            const wasSecondaryTriggered = (0, $2OtIa.isSecondaryTrigger)(event);
            if (!wasSecondaryTriggered) {
                onClick?.(event); // Run main action as it will close the modal too
                event.preventDefault();
                return;
            }
            const analytics = getAnalyticsAttributes(command, 'mouse', wasSecondaryTriggered, props?.analyticsAttributes);
            const eventAnalytics = createAnalyticsEvent({});
            (0, $kRgKj.fireTrackAnalytics)(eventAnalytics, 'commandPalette navigation', analytics);
            (0, $kRgKj.fireTrackAnalytics)(eventAnalytics, 'commandPalette secondaryAction', {
                ...analytics,
                keyPressed: (0, $58ssj.isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                secondaryAction: 'openNewTab'
            });
            (0, $kRgKj.fireTrackAnalytics)(eventAnalytics, 'commandPalette taskSucceeded', analytics);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZPxL.NavigationLink), {
            to: path,
            onClick: handleClick,
            ...shouldAlwaysOpenNewTab && {
                target: '_blank'
            },
            "data-testid": (0, $5c6484dc0a85adf4$export$8db96ea7b6a4cbab),
            ...props.isLinkFocused && (0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility') && {
                isLinkFocused: props.isLinkFocused
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmeeg.components).CommandRow, rest));
    }, [
        createAnalyticsEvent,
        getAnalyticsAttributes
    ]);
    const transformNavigationCommand = (0, $eJOHy.useCallback)((command, { path: path, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab })=>({
            ...command,
            components: {
                ...command.components,
                Name: (base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rOkc.NameContainer), null, command.components?.Name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(command.components.Name, base) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, command.name), !!shouldAlwaysOpenNewTab && (0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
                        testId: (0, $5c6484dc0a85adf4$export$99957d8f5f113509),
                        justifyContent: "center",
                        alignItems: "center",
                        xcss: $ae31bfa49fe3c190$var$iconWrapperStyles
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                        label: "",
                        color: "currentColor"
                    })), !!shouldAlwaysOpenNewTab && !(0, $6XJko.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rOkc.IconContainer), {
                        "data-testid": (0, $5c6484dc0a85adf4$export$99957d8f5f113509)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9itkV))), {
                        label: "",
                        color: "currentColor"
                    }))),
                CommandRow: (base)=>renderCommand(base, path, shouldAlwaysOpenNewTab),
                Footer: (0, $9LFHG.NewTabHintMessage)
            },
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>shouldAlwaysOpenNewTab ? openNewTab(path) : openSameTab(path)
            },
            secondaryAction: {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>openNewTab(path, true),
                preventModalClose: true,
                analyticsArgs: {
                    secondaryAction: 'openNewTab'
                }
            }
        }), [
        openNewTab,
        openSameTab,
        renderCommand
    ]);
    const shouldShowCommand = (0, $eJOHy.useCallback)((hideCommandPath)=>!(0, $aUXni.isCurrentPage)(hideCommandPath, pathname), [
        pathname
    ]);
    const hideAndTransformNavigationCommand = (0, $eJOHy.useCallback)((commandToTransform)=>{
        const { path: path, hideCommandPath: hideCommandPath, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab, command: command } = commandToTransform;
        let hidePath = typeof path === 'string' ? path : path.path;
        if (hideCommandPath) hidePath = hideCommandPath;
        if (!shouldShowCommand(hidePath)) return undefined;
        return transformNavigationCommand(command, {
            path: path,
            shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab
        });
    }, [
        shouldShowCommand,
        transformNavigationCommand
    ]);
    const hideAndTransformNavigationCommands = (0, $eJOHy.useCallback)((commands)=>{
        const filteredCommands = [];
        commands.forEach((commandToTransform)=>{
            const transformedCommand = hideAndTransformNavigationCommand(commandToTransform);
            if (transformedCommand) filteredCommands.push(transformedCommand);
        });
        return filteredCommands;
    }, [
        hideAndTransformNavigationCommand
    ]);
    return {
        shouldShowCommand: shouldShowCommand,
        hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
        hideAndTransformNavigationCommands: hideAndTransformNavigationCommands,
        transformNavigationCommand: transformNavigationCommand
    };
};
const $ae31bfa49fe3c190$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    height: '24px',
    width: '24px',
    marginLeft: 'space.075'
});

});
parcelRegister("7rOkc", function(module, exports) {
$parcel$export(module.exports, "NameContainer", () => $cbc9be426e5acea2$export$817b6bdd5f45c94b);
$parcel$export(module.exports, "IconContainer", () => $cbc9be426e5acea2$export$8f314e512d92575f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $cbc9be426e5acea2$export$817b6bdd5f45c94b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc _1nmz1hna _slp31hna",
            __cmplp.className
        ])
    });
});
const $cbc9be426e5acea2$export$8f314e512d92575f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _18u012x7 _1bsb1tcg _4t3i1tcg _vwz41tcg _1f027vkz _nbgx7vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cZPxL", function(module, exports) {
$parcel$export(module.exports, "NavigationLink", () => $9a70486e486be526$export$721ee963a67379f1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $c9uTK = parcelRequire("c9uTK");

var $4cTDP = parcelRequire("4cTDP");

var $f2JN3 = parcelRequire("f2JN3");
const $9a70486e486be526$var$styles = {
    link: "_4bfu18uv _1hmsglyw _ajmmnqa1 _1e0c1ule _9oik18uv _1bnxglyw _jf4cnqa1",
    linkFocused: "_y2mvugt7 _1bg4v77o _jomr18uv"
};
const $9a70486e486be526$export$81dde5c31917bf6 = ({ isLinkFocused: isLinkFocused, children: children, ...props })=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $c9uTK.Link), {
        ...props,
        className: (0, $hcewu.default)([
            $9a70486e486be526$var$styles.link,
            isLinkFocused && $9a70486e486be526$var$styles.linkFocused
        ])
    }, children);
};
const $9a70486e486be526$export$a52a4e5f5bc2fe3f = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $c9uTK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $9a70486e486be526$export$721ee963a67379f1 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('dee-8683-compal-a11y-button-keyboard-accessibility'), $9a70486e486be526$export$81dde5c31917bf6, $9a70486e486be526$export$a52a4e5f5bc2fe3f);

});

parcelRegister("9LFHG", function(module, exports) {
$parcel$export(module.exports, "NewTabHintMessage", () => $06af5dadddd8ab87$export$54561b2030abf061);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $58ssj = parcelRequire("58ssj");

var $8IeH1 = parcelRequire("8IeH1");

var $jmeeg = parcelRequire("jmeeg");

var $1k1Uh = parcelRequire("1k1Uh");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $i2qT7 = parcelRequire("i2qT7");
const $06af5dadddd8ab87$var$styles = {
    footerContentContainer: "_1e0c1txw _1bah1yb4 _4cvr1h6o _1bsb1osq"
};
const $06af5dadddd8ab87$export$54561b2030abf061 = ({ defaultFooterContent: defaultFooterContent })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const footerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, defaultFooterContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$HintMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$MessageWrapper, null, formatMessage((0, $i2qT7.messages).openInANewTab)), (0, $58ssj.isMacOs)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$MacLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$MacTextOffset, null, "\u2318")) : // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$WindowsLozenge, null, "Ctrl"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$EnterLozenge, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$EnterIconSVG, null))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jmeeg.components).Footer, null, (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $06af5dadddd8ab87$var$styles.footerContentContainer,
        testId: "command-palette-common.common.ui.new-tab-hint-message"
    }, footerContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($06af5dadddd8ab87$var$FooterContentContainerOld, {
        "data-testid": "command-palette-common.common.ui.new-tab-hint-message"
    }, footerContent));
};
const $06af5dadddd8ab87$var$EnterIconSVG = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "13",
        height: "8",
        viewBox: "0 0 13 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M11.055 1.055V3.055H2.275L4.195 1.135C4.455 0.875 4.455 0.455 4.195 0.195C3.935 -0.065 3.515 -0.065 3.255 0.195L0.195 3.255C-0.065 3.515 -0.065 3.935 0.195 4.195L3.255 7.255C3.515 7.515 3.935 7.515 4.195 7.255C4.455 6.995 4.455 6.575 4.195 6.315L2.275 4.38833H11.7217C12.0883 4.38833 12.3883 4.08833 12.3883 3.72167V1.055C12.3883 0.688333 12.0883 0.388333 11.7217 0.388333C11.355 0.388333 11.055 0.688333 11.055 1.055Z",
        fill: "var(--ds-text-subtle, #44546F)"
    })); // Delete when cleaning up compal_jifjam_navigation_new_filters
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$FooterContentContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$HintMessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m _syaz1gjq _u5f312x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$MacLozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $1k1Uh.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81ixg _18u0v77o _vwz47vkz _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$MacTextOffset = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_t9ec170z",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$WindowsLozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $1k1Uh.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1qjk _k48pi7a9 _1p1d1dk0 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06af5dadddd8ab87$var$EnterLozenge = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $1k1Uh.OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
});
const $06af5dadddd8ab87$var$MessageWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i2qT7", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fa31b2a866287d43$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $fa31b2a866287d43$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    openInANewTab: {
        "id": "command-palette-common.common.new-tab-hint-message.open-in-a-new-tab",
        "defaultMessage": "Open in a new tab"
    }
});

});


parcelRegister("aUXni", function(module, exports) {
$parcel$export(module.exports, "isCurrentPage", () => $9787bcf805f7e6d3$export$d4781f4a7d66b55c);
const $9787bcf805f7e6d3$export$d4781f4a7d66b55c = (hideCommandPath, pathname)=>{
    const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');
    const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');
    return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
};

});

const $5c6484dc0a85adf4$export$99957d8f5f113509 = 'command-palette-common.controllers.transform-navigation-commands.icon-container';
const $5c6484dc0a85adf4$export$8db96ea7b6a4cbab = 'command-palette-common.controllers.transform-navigation-commands.navigation-link';



parcelRegister("flCp3", function(module, exports) {
$parcel$export(module.exports, "ViewAllType", () => $a051cae2bf36aa20$export$701f40362530db8b);
$parcel$export(module.exports, "getViewAllUrl", () => $a051cae2bf36aa20$export$96e8b39eed587a1e);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $a051cae2bf36aa20$export$701f40362530db8b = /*#__PURE__*/ function(ViewAllType) {
    ViewAllType["PROJECT"] = "project";
    ViewAllType["ISSUE"] = "issue";
    ViewAllType["BOARD"] = "board";
    ViewAllType["FILTER"] = "filter";
    ViewAllType["PLAN"] = "plan";
    return ViewAllType;
}({});
const $a051cae2bf36aa20$export$96e8b39eed587a1e = (type, search)=>{
    switch(type){
        case "issue":
            return `/jira/search${search ? `?searchString=${search}` : ''}`;
        case "board":
            return `/jira/boards${search ? `?contains=${search}` : ''}`;
        case "project":
            return `/jira/projects${search ? `?keyword=${search}` : ''}`;
        case "filter":
            return `/jira/filters${search ? `?name=${search}` : ''}`;
        case "plan":
            return `/jira/plans${search ? `?name=${search}` : ''}`;
        default:
            return undefined;
    }
};

});

parcelRegister("8e0TE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $2da7c1f93284b60f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $2da7c1f93284b60f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    recommendedSection: {
        "id": "command-palette-quick-search.common.recommended.recommended-section",
        "defaultMessage": "Recommended"
    },
    viewAllIssues: {
        "id": "command-palette-quick-search.common.recommended.view-all-issues",
        "defaultMessage": "View all issues"
    },
    viewAllProjects: {
        "id": "command-palette-quick-search.common.recommended.view-all-projects",
        "defaultMessage": "View all projects"
    },
    viewAllBoards: {
        "id": "command-palette-quick-search.common.recommended.view-all-boards",
        "defaultMessage": "View all boards"
    },
    viewAllFilters: {
        "id": "command-palette-quick-search.common.recommended.view-all-filters",
        "defaultMessage": "View all filters"
    },
    viewAllPlans: {
        "id": "command-palette-quick-search.common.recommended.view-all-plans",
        "defaultMessage": "View all plans"
    },
    viewAllIssuesIssueTermRefresh: {
        "id": "command-palette-quick-search.common.recommended.view-all-issues-issue-term-refresh",
        "defaultMessage": "View all work items"
    },
    viewAllProjectsGalaxia: {
        "id": "command-palette-quick-search.common.recommended.view-all-projects-galaxia",
        "defaultMessage": "View all spaces"
    },
    viewMyOpenIssues: {
        "id": "command-palette-quick-search.common.recommended.view-my-open-issues",
        "defaultMessage": "View my open work items"
    },
    viewIssuesReportedByMe: {
        "id": "command-palette-quick-search.common.recommended.view-issues-reported-by-me",
        "defaultMessage": "View work items reported by me"
    }
});

});


parcelRegister("623Vg", function(module, exports) {
$parcel$export(module.exports, "useSetTimeoutAutoClear", () => $956fd60cece6a73c$export$c3d20e8c1e93a572);

var $eJOHy = parcelRequire("eJOHy");
const $956fd60cece6a73c$export$c3d20e8c1e93a572 = ()=>{
    const timeoutRef = (0, $eJOHy.useRef)();
    (0, $eJOHy.useEffect)(()=>()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
    const setTimeoutAutoClear = (0, $eJOHy.useCallback)((...args)=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(...args);
    }, []);
    return {
        setTimeoutAutoClear: setTimeoutAutoClear
    };
};

});

parcelRegister("4xW0u", function(module, exports) {
$parcel$export(module.exports, "useGetRecentBoardsChildResult", () => $9e819b7bfdc5cb6b$export$67be4cf74634869c);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5FwSV = parcelRequire("5FwSV");

var $9V8uj = parcelRequire("9V8uj");


var $6Ioay = parcelRequire("6Ioay");
const $9e819b7bfdc5cb6b$export$67be4cf74634869c = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchBoardCommands: getQuickSearchBoardCommands } = (0, $5FwSV.useGetQuickSearchBoardCommands)({
        section: (0, $2bfe2c815fb005bd$export$501955bd67991a25),
        showViewAll: false
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const sections = {
            [(0, $2bfe2c815fb005bd$export$501955bd67991a25)]: {
                id: (0, $2bfe2c815fb005bd$export$501955bd67991a25),
                name: formatMessage((0, $6Ioay.messages).recentlyViewedBoards),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).BOARDS
            }
        };
        const commands = getQuickSearchBoardCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchBoardCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("5FwSV", function(module, exports) {
$parcel$export(module.exports, "useGetQuickSearchBoardCommands", () => $e264b03906577f5e$export$3036f58f7b6b3d11);

var $eJOHy = parcelRequire("eJOHy");

var $azuQI = parcelRequire("azuQI");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $lABLf = parcelRequire("lABLf");

var $1VhB7 = parcelRequire("1VhB7");

var $hJZsd = parcelRequire("hJZsd");

var $flCp3 = parcelRequire("flCp3");
const $e264b03906577f5e$export$3036f58f7b6b3d11 = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getBoardCommand: getBoardCommand } = (0, $azuQI.useGetBoardCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $hJZsd.useGetViewAllCommand)();
    const getQuickSearchBoardCommands = (0, $eJOHy.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const boardScope = (0, $1VhB7.getQuickSearchBoardScope)(quickSearchResponseData);
        // No results
        if (!boardScope || error || boardScope?.error || boardScope?.results?.length === 0) return [];
        const commands = boardScope.results.slice(0, (0, $9V8uj.BOARD_LIMIT)).map((board)=>getBoardCommand({
                board: (0, $1VhB7.transformQuickSearchBoardResultToBoard)(board),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            }));
        if (!showViewAll || boardScope.results.length <= (0, $9V8uj.BOARD_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-boards',
            keywords: search,
            section: section,
            name: formatMessage((0, $lABLf.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).BOARD, search),
            analyticsPayload: {
                action: 'viewAllBoards',
                size: boardScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getBoardCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchBoardCommands: getQuickSearchBoardCommands
    };
};

});
parcelRegister("azuQI", function(module, exports) {
$parcel$export(module.exports, "useGetBoardCommand", () => $9181f14a1241a259$export$a607cbe1c4fa60ee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $Wdhjx = parcelRequire("Wdhjx");

var $4cTDP = parcelRequire("4cTDP");

var $kQy7N = parcelRequire("kQy7N");
const $9181f14a1241a259$export$a607cbe1c4fa60ee = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $kQy7N.useTransformNavigationCommands)();
    const renderBoardName = (0, $eJOHy.useCallback)((name, containerName, isActive)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9181f14a1241a259$var$BoardNameContainer, {
            "data-testid": "command-palette-common.common.ui.command.board.board-name-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9181f14a1241a259$var$BoardNameText, null, name), containerName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9181f14a1241a259$export$17e73069b4d98f65, {
            active: isActive
        }, containerName)), []);
    const getBoardCommand = (0, $eJOHy.useCallback)(({ board: board, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
        const { id: id, url: url, name: name, containerId: containerId = 'UNAVAILABLE', containerName: containerName } = board;
        return transformNavigationCommand({
            id: `board-${id}`,
            section: section,
            name: name,
            keywords: keywords,
            components: {
                Name: ({ isActive: isActive })=>renderBoardName(name, containerName, isActive),
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))), {
                        color: "currentColor",
                        label: "",
                        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                    })
            },
            analytics: {
                action: 'boardViewed',
                boardId: id,
                boardContainerId: containerId || '',
                metadata: {
                    contentId: id,
                    containerId: containerId,
                    contentType: 'board'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        renderBoardName,
        transformNavigationCommand
    ]);
    return {
        getBoardCommand: getBoardCommand
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9181f14a1241a259$var$BoardNameContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp12x7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $9181f14a1241a259$var$BoardNameText = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c82smr _vwz41kw7",
            __cmplp.className
        ])
    });
});
const $9181f14a1241a259$export$17e73069b4d98f65 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c81o8v _vwz41kw7",
            __cmplp.active ? "_syaz1gjq" : "_syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("Wdhjx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::411fb0e87ff78661e4fe4f98c48af3ed>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0aefb7ae3bc1328f$var$_react = $0aefb7ae3bc1328f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0aefb7ae3bc1328f$var$_baseNew = $0aefb7ae3bc1328f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $0aefb7ae3bc1328f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0aefb7ae3bc1328f$var$BoardIcon = (props)=>/*#__PURE__*/ $0aefb7ae3bc1328f$var$_react.default.createElement($0aefb7ae3bc1328f$var$_baseNew.default, Object.assign({
        name: "BoardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$0aefb7ae3bc1328f$var$BoardIcon.displayName = 'BoardIcon';
var $0aefb7ae3bc1328f$var$_default = module.exports.default = $0aefb7ae3bc1328f$var$BoardIcon;

});


parcelRegister("lABLf", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1824dd5a0f904b87$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1824dd5a0f904b87$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    viewAllResults: {
        "id": "command-palette-quick-search.common.view-all-results",
        "defaultMessage": "View all results"
    }
});

});


const $2bfe2c815fb005bd$export$501955bd67991a25 = 'jira.board';

parcelRegister("6Ioay", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ab055c22f5271070$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ab055c22f5271070$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    recentlyViewedBoards: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.boards.recently-viewed-boards",
        "defaultMessage": "Recently Viewed Boards"
    }
});

});


parcelRegister("kNyOe", function(module, exports) {
$parcel$export(module.exports, "useGetRecentFiltersChildResult", () => $da7b172ac8790d73$export$abc1122ece543f47);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $f6acb = parcelRequire("f6acb");


var $Qf9sk = parcelRequire("Qf9sk");
const $da7b172ac8790d73$export$abc1122ece543f47 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchFilterCommands: getQuickSearchFilterCommands } = (0, $f6acb.useGetQuickSearchFilterCommands)({
        section: (0, $23c5b6c26b5bce6a$export$501955bd67991a25),
        showViewAll: false
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const sections = {
            [(0, $23c5b6c26b5bce6a$export$501955bd67991a25)]: {
                id: (0, $23c5b6c26b5bce6a$export$501955bd67991a25),
                name: formatMessage((0, $Qf9sk.messages).recentlyViewedFilters),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).FILTERS
            }
        };
        const commands = getQuickSearchFilterCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchFilterCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("f6acb", function(module, exports) {
$parcel$export(module.exports, "useGetQuickSearchFilterCommands", () => $21453ca5247a9688$export$b31b2989a89c872e);

var $eJOHy = parcelRequire("eJOHy");

var $ijuU1 = parcelRequire("ijuU1");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $lABLf = parcelRequire("lABLf");

var $1VhB7 = parcelRequire("1VhB7");

var $hJZsd = parcelRequire("hJZsd");

var $flCp3 = parcelRequire("flCp3");
const $21453ca5247a9688$export$b31b2989a89c872e = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getFilterCommand: getFilterCommand } = (0, $ijuU1.useGetFilterCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $hJZsd.useGetViewAllCommand)();
    const getQuickSearchFilterCommands = (0, $eJOHy.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const filterScope = (0, $1VhB7.getQuickSearchFilterScope)(quickSearchResponseData);
        // No results
        if (!filterScope || error || filterScope?.error || filterScope?.results?.length === 0) return [];
        const commands = filterScope.results.slice(0, (0, $9V8uj.FILTER_LIMIT)).map((filter)=>getFilterCommand({
                filter: (0, $1VhB7.transformQuickSearchFilterResultToFilter)(filter),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            }));
        if (!showViewAll || filterScope.results.length <= (0, $9V8uj.FILTER_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-filters',
            keywords: search,
            section: section,
            name: formatMessage((0, $lABLf.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).FILTER, search),
            analyticsPayload: {
                action: 'viewAllFilters',
                size: filterScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getFilterCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchFilterCommands: getQuickSearchFilterCommands
    };
};

});
parcelRegister("ijuU1", function(module, exports) {
$parcel$export(module.exports, "useGetFilterCommand", () => $631c853de3fe5d7c$export$c074d91a3a335ecb);

var $eJOHy = parcelRequire("eJOHy");

var $KDB2z = parcelRequire("KDB2z");

var $4cTDP = parcelRequire("4cTDP");

var $kQy7N = parcelRequire("kQy7N");
const $631c853de3fe5d7c$export$c074d91a3a335ecb = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $kQy7N.useTransformNavigationCommands)();
    const getFilterCommand = (0, $eJOHy.useCallback)(({ filter: filter, section: section, analytics: analytics, ...rest })=>{
        const { id: id, url: url, name: name } = filter;
        return transformNavigationCommand({
            id: `filter-${id}`,
            section: section,
            name: name,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($KDB2z))), {
                        color: "currentColor",
                        label: "",
                        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                    })
            },
            analytics: {
                action: 'filterViewed',
                filterId: id,
                metadata: {
                    contentId: id,
                    containerId: 'UNAVAILABLE',
                    contentType: 'filter'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getFilterCommand: getFilterCommand
    };
};

});


const $23c5b6c26b5bce6a$export$501955bd67991a25 = 'jira.filter';

parcelRegister("Qf9sk", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6a478b23428a521f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6a478b23428a521f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    recentlyViewedFilters: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.filters.recently-viewed-filters",
        "defaultMessage": "Recently Viewed Filters"
    }
});

});


parcelRegister("RQobE", function(module, exports) {
$parcel$export(module.exports, "useGetRecentIssuesChildResult", () => $1a735986e2602542$export$e5366d4438f3f848);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $fgA0y = parcelRequire("fgA0y");

var $5k3KU = parcelRequire("5k3KU");
const $1a735986e2602542$var$SECTION_ID = 'jira.issue';
const $1a735986e2602542$export$e5366d4438f3f848 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchIssueCommands: getQuickSearchIssueCommands } = (0, $fgA0y.useGetQuickSearchIssueCommands)({
        section: $1a735986e2602542$var$SECTION_ID,
        errorMessage: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $5k3KU.messages).issueErrorIssueTermRefresh : (0, $5k3KU.messages).issueError),
        showViewAll: false
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const sections = {
            [$1a735986e2602542$var$SECTION_ID]: {
                id: $1a735986e2602542$var$SECTION_ID,
                name: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $5k3KU.messages).recentlyViewedIssuesIssueTermRefresh : (0, $5k3KU.messages).recentlyViewedIssues),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).ISSUES
            }
        };
        const commands = getQuickSearchIssueCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchIssueCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("fgA0y", function(module, exports) {
$parcel$export(module.exports, "useGetQuickSearchIssueCommands", () => $c15c5c4abd323a03$export$e3611b615ec843dc);

var $eJOHy = parcelRequire("eJOHy");

var $d1CCU = parcelRequire("d1CCU");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $lABLf = parcelRequire("lABLf");

var $1VhB7 = parcelRequire("1VhB7");

var $hJZsd = parcelRequire("hJZsd");

var $flCp3 = parcelRequire("flCp3");
const $c15c5c4abd323a03$export$e3611b615ec843dc = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getIssueCommand: getIssueCommand } = (0, $d1CCU.useGetIssueCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $hJZsd.useGetViewAllCommand)();
    const getQuickSearchIssueCommands = (0, $eJOHy.useCallback)(({ error: error, search: search, quickSearchResponseData: quickSearchResponseData })=>{
        const issueScope = (0, $1VhB7.getQuickSearchIssueScope)(quickSearchResponseData);
        // No results
        if (!issueScope || error || issueScope?.error || issueScope?.results?.length === 0) return [];
        // There are results!
        const commands = issueScope.results.slice(0, (0, $9V8uj.ISSUE_LIMIT)).map((issue)=>{
            const command = getIssueCommand({
                issue: (0, $1VhB7.transformQuickSearchIssueResultToIssue)(issue),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            });
            return command;
        });
        if (!showViewAll || issueScope.results.length <= (0, $9V8uj.ISSUE_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-issues',
            keywords: search,
            section: section,
            name: formatMessage((0, $lABLf.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).ISSUE, search),
            analyticsPayload: {
                action: 'viewAllIssues',
                size: issueScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getIssueCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchIssueCommands: getQuickSearchIssueCommands
    };
};

});
parcelRegister("d1CCU", function(module, exports) {
$parcel$export(module.exports, "useGetIssueCommand", () => $1d4776ff49acd442$export$98868e4240dcd14d);

var $eJOHy = parcelRequire("eJOHy");

var $kQy7N = parcelRequire("kQy7N");

var $6QZlQ = parcelRequire("6QZlQ");

var $fpj7g = parcelRequire("fpj7g");
const $1d4776ff49acd442$export$98868e4240dcd14d = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $kQy7N.useTransformNavigationCommands)();
    const getIssueCommand = (0, $eJOHy.useCallback)(({ issue: issue, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
        const { issueId: issueId, summary: summary, issueKey: issueKey, projectId: projectId = 'UNAVAILABLE' } = issue;
        return transformNavigationCommand({
            id: `issue-${issueId}`,
            section: section,
            keywords: keywords,
            name: `${issueKey} ${summary}`,
            components: {
                Name: ({ isActive: isActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fpj7g.IssueView), {
                        issue: issue,
                        isActive: isActive
                    }),
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6QZlQ.IssueLeftIcon), {
                        iconUrl: issue.avatar?.url,
                        issueTypeName: issue.issueTypeName
                    })
            },
            analytics: {
                action: 'issueViewed',
                issueId: issueId,
                metadata: {
                    contentId: issueId,
                    containerId: projectId,
                    contentType: 'issue'
                },
                ...analytics
            },
            ...rest
        }, {
            path: `/browse/${issueKey}`
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getIssueCommand: getIssueCommand
    };
};

});
parcelRegister("6QZlQ", function(module, exports) {
$parcel$export(module.exports, "IssueLeftIcon", () => $7c8046d8cc67e0c4$export$b1b562672a76ad84);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $egRFv = parcelRequire("egRFv");
const $7c8046d8cc67e0c4$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        src: iconUrl,
        alt: !issueTypeName && (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage(// eslint-disable-next-line no-nested-ternary
        (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? (0, $egRFv.messages).workTypeIconAltText : (0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $egRFv.messages).issueIconAltTextIssueTermRefresh : (0, $egRFv.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("egRFv", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d752c1cd111ca5da$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d752c1cd111ca5da$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    // Delete when cleaning up deliveroo_compal_a11y_fixes
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    },
    // Delete when cleaning up deliveroo_compal_a11y_fixes
    issueIconAltTextIssueTermRefresh: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text-issue-term-refresh",
        "defaultMessage": "Icon for the work type {issueTypeName}"
    },
    workTypeIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.work-type-icon-alt-text",
        "defaultMessage": "Work type {issueTypeName}"
    }
});

});


parcelRegister("fpj7g", function(module, exports) {
$parcel$export(module.exports, "IssueView", () => $efb57a3f9309f473$export$5aebed4b5cba826a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $eZyz9 = parcelRequire("eZyz9");
const $efb57a3f9309f473$export$995d7ae0c0293bac = {
    1: 'default',
    2: 'default',
    3: 'success',
    4: 'inprogress'
};
const $efb57a3f9309f473$export$5aebed4b5cba826a = ({ issue: { issueKey: issueKey, summary: summary, projectName: projectName, status: status }, isActive: isActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $efb57a3f9309f473$var$searchResultContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efb57a3f9309f473$var$TopContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eZyz9.TruncateWithTooltipOnActive), {
        isActive: !!isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efb57a3f9309f473$var$IssueKey, null, issueKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efb57a3f9309f473$var$IssueSummary, {
        active: isActive
    }, summary))), (status || projectName) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efb57a3f9309f473$var$BottomContainer, null, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $efb57a3f9309f473$var$statusStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: $efb57a3f9309f473$export$995d7ae0c0293bac[status.statusCategoryId],
        maxWidth: 236
    }, status.statusName)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($efb57a3f9309f473$var$ProjectName, {
        active: isActive
    }, projectName)));
const $efb57a3f9309f473$var$searchResultContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efb57a3f9309f473$var$TopContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz41tcg _slp31hna _1nmz1hna",
            __cmplp.className
        ])
    });
});
const $efb57a3f9309f473$var$IssueKey = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_syaz1gjq _2hwx12x7 _1e0c1nu9",
            __cmplp.className
        ])
    });
});
const $efb57a3f9309f473$var$IssueSummary = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1nu9",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $efb57a3f9309f473$var$BottomContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1txw _19pkv77o _syaz1gjq _vwz41kw7",
            __cmplp.className
        ])
    });
});
const $efb57a3f9309f473$var$statusStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.150'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efb57a3f9309f473$var$ProjectName = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _p12fuuw1 _vwz4gktf",
            __cmplp.active ? "_syaz1gjq" : "_syaz131l",
            __cmplp.className
        ])
    });
});

});



parcelRegister("5k3KU", function(module, exports) {
$parcel$export(module.exports, "messages", () => $3c1f1ad727f76d60$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $3c1f1ad727f76d60$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    recentlyViewedIssues: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.recently-viewed-issues",
        "defaultMessage": "Recently Viewed Issues"
    },
    issueError: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.issue-error",
        "defaultMessage": "We're having trouble loading recently viewed issues. Try again in a few moments."
    },
    recentlyViewedIssuesIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.recently-viewed-issues-issue-term-refresh",
        "defaultMessage": "Recently viewed work items"
    },
    issueErrorIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.issues.issue-error-issue-term-refresh",
        "defaultMessage": "We're having trouble loading recently viewed work items. Try again in a few moments."
    }
});

});


parcelRegister("27NG5", function(module, exports) {
$parcel$export(module.exports, "useGetRecentPlansChildResult", () => $bbe02ba51756a2eb$export$ec02659dcd249bd6);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $9GhHk = parcelRequire("9GhHk");


var $2DSLG = parcelRequire("2DSLG");
const $bbe02ba51756a2eb$export$ec02659dcd249bd6 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchPlanCommands: getQuickSearchPlanCommands } = (0, $9GhHk.useGetQuickSearchPlanCommands)({
        section: (0, $8a71071b878ea4d0$export$501955bd67991a25),
        showViewAll: false
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const sections = {
            [(0, $8a71071b878ea4d0$export$501955bd67991a25)]: {
                id: (0, $8a71071b878ea4d0$export$501955bd67991a25),
                name: formatMessage((0, $2DSLG.messages).recentlyViewedPlans),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).PLANS
            }
        };
        const commands = getQuickSearchPlanCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchPlanCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("9GhHk", function(module, exports) {
$parcel$export(module.exports, "useGetQuickSearchPlanCommands", () => $ad3847c42500c022$export$668213efda00d797);

var $eJOHy = parcelRequire("eJOHy");

var $8vHPp = parcelRequire("8vHPp");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $lABLf = parcelRequire("lABLf");

var $1VhB7 = parcelRequire("1VhB7");

var $hJZsd = parcelRequire("hJZsd");

var $flCp3 = parcelRequire("flCp3");
const $ad3847c42500c022$export$668213efda00d797 = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getPlanCommand: getPlanCommand } = (0, $8vHPp.useGetPlanCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $hJZsd.useGetViewAllCommand)();
    const getQuickSearchPlanCommands = (0, $eJOHy.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const planScope = (0, $1VhB7.getQuickSearchPlanScope)(quickSearchResponseData);
        // No results
        if (!planScope || error || planScope?.error || planScope?.results?.length === 0) return [];
        const commands = planScope.results.slice(0, (0, $9V8uj.PLAN_LIMIT)).map((plan)=>getPlanCommand({
                plan: (0, $1VhB7.transformQuickSearchPlanResultToPlan)(plan),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            }));
        if (!showViewAll || planScope.results.length <= (0, $9V8uj.PLAN_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-plans',
            keywords: search,
            section: section,
            name: formatMessage((0, $lABLf.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).PLAN, search),
            analyticsPayload: {
                action: 'viewAllPlans',
                size: planScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getPlanCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchPlanCommands: getQuickSearchPlanCommands
    };
};

});
parcelRegister("8vHPp", function(module, exports) {
$parcel$export(module.exports, "useGetPlanCommand", () => $977bac8ba57da853$export$69408f6c87099775);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4cTDP = parcelRequire("4cTDP");

var $kQy7N = parcelRequire("kQy7N");
const $977bac8ba57da853$export$69408f6c87099775 = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $kQy7N.useTransformNavigationCommands)();
    const getPlanCommand = (0, $eJOHy.useCallback)(({ plan: plan, section: section, analytics: analytics, ...rest })=>{
        const { id: id, url: url, name: name } = plan;
        return transformNavigationCommand({
            id: `plan-${id}`,
            section: section,
            name: name,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($977bac8ba57da853$export$3eeaa2f0a53409a2, null)
            },
            analytics: {
                action: 'planViewed',
                planId: id,
                metadata: {
                    contentId: id,
                    containerId: 'UNAVAILABLE',
                    contentType: 'plan'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getPlanCommand: getPlanCommand
    };
};
const $977bac8ba57da853$export$3eeaa2f0a53409a2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($977bac8ba57da853$var$PlanLeftIconContainer, {
        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.44455 5.66667C6.015 5.66667 5.66677 6.01489 5.66677 6.44444C5.66677 6.874 6.015 7.22222 6.44455 7.22222H9.55566C9.98522 7.22222 10.3334 6.874 10.3334 6.44444C10.3334 6.01489 9.98522 5.66667 9.55566 5.66667H6.44455Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.44455 8.77778C6.44455 8.34822 6.79278 8 7.22233 8H10.3334C10.763 8 11.1112 8.34822 11.1112 8.77778C11.1112 9.20733 10.763 9.55556 10.3334 9.55556H7.22233C6.79278 9.55556 6.44455 9.20733 6.44455 8.77778Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        d: "M6.44455 10.3333C6.015 10.3333 5.66677 10.6816 5.66677 11.1111C5.66677 11.5407 6.015 11.8889 6.44455 11.8889H8.00011C8.42966 11.8889 8.77789 11.5407 8.77789 11.1111C8.77789 10.6816 8.42966 10.3333 8.00011 10.3333H6.44455Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.889 2.55556C4.889 1.69645 5.58544 1 6.44455 1H9.55566C10.4148 1 11.1112 1.69645 11.1112 2.55556H11.889C12.7481 2.55556 13.4446 3.252 13.4446 4.11111V13.4444C13.4446 14.3036 12.7481 15 11.889 15H4.11122C3.25211 15 2.55566 14.3036 2.55566 13.4444V4.11111C2.55566 3.252 3.25211 2.55556 4.11122 2.55556H4.889ZM9.55566 4.88889C10.1314 4.88889 10.6342 4.57607 10.9031 4.11111H11.889V13.4444H4.11122L4.11122 4.11111H5.0971C5.36607 4.57607 5.86878 4.88889 6.44455 4.88889H9.55566ZM9.55566 2.55556H6.44455V3.33333H9.55566V2.55556Z"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $977bac8ba57da853$var$PlanLeftIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_vwz4kb7n _13ti15vq _15jv15vq _n0baglyw _1m8i1osq _1azq1osq _11d61r31 _11ssyfq0",
            __cmplp.className
        ])
    });
});

});


const $8a71071b878ea4d0$export$501955bd67991a25 = 'jira.plan';

parcelRegister("2DSLG", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b335ad1fb23d8c99$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b335ad1fb23d8c99$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    recentlyViewedPlans: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.plans.recently-viewed-plans",
        "defaultMessage": "Recently Viewed Plans"
    }
});

});


parcelRegister("8XegI", function(module, exports) {
$parcel$export(module.exports, "useGetRecentProjectsChildResult", () => $b99e846a34519f40$export$1f6a5212707c0c74);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $7fQun = parcelRequire("7fQun");

var $eH2xq = parcelRequire("eH2xq");
const $b99e846a34519f40$var$SECTION_ID = 'jira.project';
const $b99e846a34519f40$export$1f6a5212707c0c74 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchProjectCommands: getQuickSearchProjectCommands } = (0, $7fQun.useGetQuickSearchProjectCommands)({
        section: $b99e846a34519f40$var$SECTION_ID,
        showViewAll: false
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const recentlyViewedProjectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $eH2xq.messages).recentlyViewedProjectsGalaxia : (0, $eH2xq.messages).recentlyViewedProjects;
        const sections = {
            [$b99e846a34519f40$var$SECTION_ID]: {
                id: $b99e846a34519f40$var$SECTION_ID,
                name: formatMessage(recentlyViewedProjectsGalaxia),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).PROJECTS
            }
        };
        const commands = getQuickSearchProjectCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchProjectCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("7fQun", function(module, exports) {
$parcel$export(module.exports, "useGetQuickSearchProjectCommands", () => $0882b85588a211b5$export$d434736854ef42ec);

var $eJOHy = parcelRequire("eJOHy");

var $4vVVA = parcelRequire("4vVVA");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $lABLf = parcelRequire("lABLf");

var $1VhB7 = parcelRequire("1VhB7");

var $hJZsd = parcelRequire("hJZsd");

var $flCp3 = parcelRequire("flCp3");
const $0882b85588a211b5$export$d434736854ef42ec = ({ section: section, showViewAll: showViewAll })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getProjectCommand: getProjectCommand } = (0, $4vVVA.useGetProjectCommand)();
    const { getViewAllCommand: getViewAllCommand } = (0, $hJZsd.useGetViewAllCommand)();
    const getQuickSearchProjectCommands = (0, $eJOHy.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        const projectScope = (0, $1VhB7.getQuickSearchProjectScope)(quickSearchResponseData);
        // No results
        if (!projectScope || error || projectScope?.error || projectScope?.results?.length === 0) return [];
        // There are results!
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const commands = projectScope.results.slice(0, (0, $9V8uj.PROJECT_LIMIT)).map((project)=>getProjectCommand({
                project: (0, $1VhB7.transformQuickSearchProjectResultToProject)(project),
                keywords: search,
                section: section,
                analytics: {
                    isSearchResult: true
                }
            })).filter((project)=>project);
        if (!showViewAll || projectScope.results.length <= (0, $9V8uj.PROJECT_LIMIT)) return commands;
        const viewAllCommand = getViewAllCommand({
            id: 'view-all-projects',
            keywords: search,
            section: section,
            name: formatMessage((0, $lABLf.messages).viewAllResults),
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            url: (0, $flCp3.getViewAllUrl)((0, $flCp3.ViewAllType).PROJECT, search),
            analyticsPayload: {
                action: 'viewAllProjects',
                size: projectScope.size
            }
        });
        return commands.concat([
            viewAllCommand
        ]);
    }, [
        formatMessage,
        getProjectCommand,
        getViewAllCommand,
        section,
        showViewAll
    ]);
    return {
        getQuickSearchProjectCommands: getQuickSearchProjectCommands
    };
};

});
parcelRegister("4vVVA", function(module, exports) {
$parcel$export(module.exports, "useGetProjectCommand", () => $9af85ccbc487367e$export$ea003d923e77b495);

var $eJOHy = parcelRequire("eJOHy");

var $kQy7N = parcelRequire("kQy7N");

var $14Npl = parcelRequire("14Npl");
const $9af85ccbc487367e$export$ea003d923e77b495 = ()=>{
    const { transformNavigationCommand: transformNavigationCommand } = (0, $kQy7N.useTransformNavigationCommands)();
    const getProjectCommand = (0, $eJOHy.useCallback)(({ project: project, keywords: keywords, section: section, analytics: analytics, ...rest })=>{
        const { projectId: projectId, name: name, url: url, avatar: avatar, canView: canView } = project;
        if (!canView) return null;
        return transformNavigationCommand({
            id: `project-${projectId}`,
            section: section,
            keywords: keywords,
            name: name,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $14Npl.ProjectLeftIcon), {
                        url: avatar.url,
                        name: name
                    })
            },
            analytics: {
                action: 'projectViewed',
                projectId: projectId,
                metadata: {
                    contentId: projectId,
                    containerId: 'UNAVAILABLE',
                    contentType: 'project'
                },
                ...analytics
            },
            ...rest
        }, {
            path: url
        });
    }, [
        transformNavigationCommand
    ]);
    return {
        getProjectCommand: getProjectCommand
    };
};

});
parcelRegister("14Npl", function(module, exports) {
$parcel$export(module.exports, "ProjectLeftIcon", () => $bbce9c97239f4ac6$export$423e89389ac007b0);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $kMnRO = parcelRequire("kMnRO");
const $bbce9c97239f4ac6$export$7da4b9ffac538b50 = 'command-palette-common.common.ui.command.project.project-left-icon.img';
const $bbce9c97239f4ac6$export$423e89389ac007b0 = ({ url: url, name: name })=>{
    const issueIconAltTextGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $kMnRO.messages).issueIconAltTextGalaxia : (0, $kMnRO.messages).issueIconAltText;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        "data-testid": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? $bbce9c97239f4ac6$export$7da4b9ffac538b50 : undefined,
        src: url,
        alt: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage(issueIconAltTextGalaxia, {
            name: name
        }),
        height: "16",
        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
    });
};

});
parcelRegister("kMnRO", function(module, exports) {
$parcel$export(module.exports, "messages", () => $bd1dff7261c6de61$export$defe85febe8b728c);
// Delete file when cleaning up deliveroo_compal_a11y_fixes

var $7qGN1 = parcelRequire("7qGN1");
const $bd1dff7261c6de61$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.project.project-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the project {name}"
    },
    issueIconAltTextGalaxia: {
        "id": "command-palette-common.common.command.project.project-left-icon.issue-icon-alt-text-galaxia",
        "defaultMessage": "Icon for the space {name}"
    }
});

});




parcelRegister("eH2xq", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4782d7944ffa075f$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $4782d7944ffa075f$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    recentlyViewedProjects: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.projects.recently-viewed-projects",
        "defaultMessage": "Recently Viewed Projects"
    },
    recentlyViewedProjectsGalaxia: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.projects.recently-viewed-projects-galaxia",
        "defaultMessage": "Recently viewed spaces"
    }
});

});



parcelRegister("iDJqM", function(module, exports) {
$parcel$export(module.exports, "useGetSearchResults", () => $3ef4ec0093544d20$export$bca2834c2ecfc5f9);

var $eJOHy = parcelRequire("eJOHy");

var $2OtIa = parcelRequire("2OtIa");

var $SPYRa = parcelRequire("SPYRa");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $bDJNS = parcelRequire("bDJNS");

var $5opHR = parcelRequire("5opHR");

var $623Vg = parcelRequire("623Vg");

var $gpyau = parcelRequire("gpyau");

var $5iJEF = parcelRequire("5iJEF");

var $pwwIY = parcelRequire("pwwIY");

var $6bdjT = parcelRequire("6bdjT");

var $7lvoE = parcelRequire("7lvoE");

var $2uO81 = parcelRequire("2uO81");
const $3ef4ec0093544d20$export$bca2834c2ecfc5f9 = ()=>{
    const { getChildResult: getErrorChildResult } = (0, $bDJNS.useGetErrorChildResult)();
    const { getChildResult: getRecommendedChildResult } = (0, $5opHR.useGetRecommendedChildResult)();
    const { getChildResult: getSearchIssuesChildResult } = (0, $6bdjT.useGetSearchIssuesChildResult)();
    const { getChildResult: getSearchProjectsChildResult } = (0, $2uO81.useGetSearchProjectsChildResult)();
    const { getChildResult: getSearchBoardsChildResult } = (0, $5iJEF.useGetSearchBoardsChildResult)();
    const { getChildResult: getSearchFiltersChildResult } = (0, $pwwIY.useGetSearchFiltersChildResult)();
    const { getChildResult: getSearchPlansChildResult } = (0, $7lvoE.useGetSearchPlansChildResult)();
    const [hasEditOrViewPermissions] = (0, $SPYRa.useNavigationViewPlansPermission)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $623Vg.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    const getSearchResults = (0, $eJOHy.useCallback)(({ search: search, quickSearchResponseData: quickSearchResponseData, error: error })=>{
        setTimeoutFunc(()=>{
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'searchResults shown', 'postQuerySearchResults', {
                ...(0, $gpyau.transformResultsForAnalytics)(quickSearchResponseData, false)
            });
        }, 0);
        return (0, $2OtIa.mergeChildResults)([
            getErrorChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getRecommendedChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchIssuesChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchProjectsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchBoardsChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            getSearchFiltersChildResult({
                search: search,
                quickSearchResponseData: quickSearchResponseData,
                error: error
            }),
            ...hasEditOrViewPermissions ? [
                getSearchPlansChildResult({
                    search: search,
                    quickSearchResponseData: quickSearchResponseData,
                    error: error
                })
            ] : []
        ]);
    }, [
        createAnalyticsEvent,
        getErrorChildResult,
        getRecommendedChildResult,
        getSearchBoardsChildResult,
        getSearchFiltersChildResult,
        getSearchIssuesChildResult,
        getSearchPlansChildResult,
        getSearchProjectsChildResult,
        hasEditOrViewPermissions,
        setTimeoutFunc
    ]);
    return getSearchResults;
};

});
parcelRegister("5iJEF", function(module, exports) {
$parcel$export(module.exports, "useGetSearchBoardsChildResult", () => $654bc526d7cfc671$export$894d6ed9a271a485);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $5FwSV = parcelRequire("5FwSV");

var $9V8uj = parcelRequire("9V8uj");


var $khkIK = parcelRequire("khkIK");
const $654bc526d7cfc671$export$894d6ed9a271a485 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchBoardCommands: getQuickSearchBoardCommands } = (0, $5FwSV.useGetQuickSearchBoardCommands)({
        section: (0, $ebebd8721f37505b$export$501955bd67991a25),
        showViewAll: true
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const sections = {
            [(0, $ebebd8721f37505b$export$501955bd67991a25)]: {
                id: (0, $ebebd8721f37505b$export$501955bd67991a25),
                name: formatMessage((0, $khkIK.messages).boards),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).BOARDS
            }
        };
        const commands = getQuickSearchBoardCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchBoardCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
const $ebebd8721f37505b$export$501955bd67991a25 = 'jira.board';

parcelRegister("khkIK", function(module, exports) {
$parcel$export(module.exports, "messages", () => $69c8da50d7d613a6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $69c8da50d7d613a6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    boards: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.boards.boards",
        "defaultMessage": "Boards"
    }
});

});


parcelRegister("pwwIY", function(module, exports) {
$parcel$export(module.exports, "useGetSearchFiltersChildResult", () => $d5390b547bce34f7$export$679a1b8aea427942);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $f6acb = parcelRequire("f6acb");


var $bbQyc = parcelRequire("bbQyc");
const $d5390b547bce34f7$export$679a1b8aea427942 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchFilterCommands: getQuickSearchFilterCommands } = (0, $f6acb.useGetQuickSearchFilterCommands)({
        section: (0, $d4fae450596b6a71$export$501955bd67991a25),
        showViewAll: true
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const sections = {
            [(0, $d4fae450596b6a71$export$501955bd67991a25)]: {
                id: (0, $d4fae450596b6a71$export$501955bd67991a25),
                name: formatMessage((0, $bbQyc.messages).filters),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).FILTERS
            }
        };
        const commands = getQuickSearchFilterCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchFilterCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
const $d4fae450596b6a71$export$501955bd67991a25 = 'jira.filter';

parcelRegister("bbQyc", function(module, exports) {
$parcel$export(module.exports, "messages", () => $259d3ae6e2bcfc43$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $259d3ae6e2bcfc43$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    filters: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.filters.filters",
        "defaultMessage": "Filters"
    }
});

});


parcelRegister("6bdjT", function(module, exports) {
$parcel$export(module.exports, "useGetSearchIssuesChildResult", () => $c977c23468125f9e$export$87713fad27eebcf1);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $fgA0y = parcelRequire("fgA0y");

var $kmKJq = parcelRequire("kmKJq");
const $c977c23468125f9e$var$SECTION_ID = 'jira.issue';
const $c977c23468125f9e$export$87713fad27eebcf1 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchIssueCommands: getQuickSearchIssueCommands } = (0, $fgA0y.useGetQuickSearchIssueCommands)({
        section: $c977c23468125f9e$var$SECTION_ID,
        errorMessage: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $kmKJq.messages).issueErrorIssueTermRefresh : (0, $kmKJq.messages).issueError),
        showViewAll: true
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const sections = {
            [$c977c23468125f9e$var$SECTION_ID]: {
                id: $c977c23468125f9e$var$SECTION_ID,
                name: formatMessage((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3') ? (0, $kmKJq.messages).issuesIssueTermRefresh : (0, $kmKJq.messages).issues),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).ISSUES
            }
        };
        const commands = getQuickSearchIssueCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchIssueCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("kmKJq", function(module, exports) {
$parcel$export(module.exports, "messages", () => $17f83389c5172464$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $17f83389c5172464$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    issueError: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issue-error",
        "defaultMessage": "We\u2019re having trouble searching issues. You can try again in a few moments."
    },
    issues: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issues",
        "defaultMessage": "Issues"
    },
    issueErrorIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issue-error-issue-term-refresh",
        "defaultMessage": "We\u2019re having trouble searching work items. You can try again in a few moments."
    },
    issuesIssueTermRefresh: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.issues.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    }
});

});


parcelRegister("7lvoE", function(module, exports) {
$parcel$export(module.exports, "useGetSearchPlansChildResult", () => $0cd11157aed11301$export$fc9d0a774ff010f1);

var $eJOHy = parcelRequire("eJOHy");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $9GhHk = parcelRequire("9GhHk");


var $c0Lxe = parcelRequire("c0Lxe");
const $0cd11157aed11301$export$fc9d0a774ff010f1 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchPlanCommands: getQuickSearchPlanCommands } = (0, $9GhHk.useGetQuickSearchPlanCommands)({
        section: (0, $44223f11b1e39750$export$501955bd67991a25),
        showViewAll: true
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const sections = {
            [(0, $44223f11b1e39750$export$501955bd67991a25)]: {
                id: (0, $44223f11b1e39750$export$501955bd67991a25),
                name: formatMessage((0, $c0Lxe.messages).plans),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).PLANS
            }
        };
        const commands = getQuickSearchPlanCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchPlanCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
const $44223f11b1e39750$export$501955bd67991a25 = 'jira.plan';

parcelRegister("c0Lxe", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f17510e902a011e3$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f17510e902a011e3$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    plans: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.plans.plans",
        "defaultMessage": "Plans"
    }
});

});


parcelRegister("2uO81", function(module, exports) {
$parcel$export(module.exports, "useGetSearchProjectsChildResult", () => $83982c3622bc7523$export$e18d773eb3827574);

var $eJOHy = parcelRequire("eJOHy");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $9V8uj = parcelRequire("9V8uj");

var $7fQun = parcelRequire("7fQun");

var $lf7Tq = parcelRequire("lf7Tq");
const $83982c3622bc7523$var$SECTION_ID = 'jira.project';
const $83982c3622bc7523$export$e18d773eb3827574 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getQuickSearchProjectCommands: getQuickSearchProjectCommands } = (0, $7fQun.useGetQuickSearchProjectCommands)({
        section: $83982c3622bc7523$var$SECTION_ID,
        showViewAll: true
    });
    const getChildResult = (0, $eJOHy.useCallback)((props)=>{
        const projectsGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $lf7Tq.messages).projectsGalaxia : (0, $lf7Tq.messages).projects;
        const sections = {
            [$83982c3622bc7523$var$SECTION_ID]: {
                id: $83982c3622bc7523$var$SECTION_ID,
                name: formatMessage(projectsGalaxia),
                priority: (0, $9V8uj.QUICK_SEARCH_PRIORITY).PROJECTS
            }
        };
        const commands = getQuickSearchProjectCommands(props);
        return {
            sections: sections,
            commands: commands
        };
    }, [
        formatMessage,
        getQuickSearchProjectCommands
    ]);
    return {
        getChildResult: getChildResult
    };
};

});
parcelRegister("lf7Tq", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5c4fbc46fee97dcc$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5c4fbc46fee97dcc$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    projects: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.projects.projects",
        "defaultMessage": "Projects"
    },
    projectsGalaxia: {
        "id": "command-palette-quick-search.use-quick-search-command.use-quick-search-children.search.projects.projects-galaxia",
        "defaultMessage": "Spaces"
    }
});

});




parcelRegister("12IQN", function(module, exports) {
$parcel$export(module.exports, "QuickSearchChildWrapper", () => $a954e67be5e32e1b$export$85ee85d7d315a747);

var $eJOHy = parcelRequire("eJOHy");

var $djaLS = parcelRequire("djaLS");

var $lDtQl = parcelRequire("lDtQl");

var $cezcy = parcelRequire("cezcy");
const $a954e67be5e32e1b$export$85ee85d7d315a747 = ({ children: children })=>{
    const [attributes, { reset: reset }] = (0, $djaLS.useQuickSearchAnalyticsAttributes)();
    (0, $eJOHy.useEffect)(()=>{
        reset();
        return ()=>{
            reset();
        };
    }, [
        reset
    ]);
    const shouldFireScreenAnalytics = attributes.queryVersion >= 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lDtQl.QuickSearchWrapper), null, shouldFireScreenAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cezcy.QuickSearchFireScreenAnalytics), null), children);
};

});
parcelRegister("lDtQl", function(module, exports) {
$parcel$export(module.exports, "QuickSearchWrapper", () => $6b5eb4b1a7078b0c$export$2398c0852f2402a1);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $kGj4V = parcelRequire("kGj4V");

var $djaLS = parcelRequire("djaLS");
const $6b5eb4b1a7078b0c$export$2398c0852f2402a1 = ({ children: children })=>{
    const [attributes] = (0, $djaLS.useQuickSearchAnalyticsAttributes)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        packageName: "jiraCommandPaletteQuickSearch",
        id: "quick-search",
        teamName: "deliveroo"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: attributes
    }, children));
};

});

parcelRegister("cezcy", function(module, exports) {
$parcel$export(module.exports, "QuickSearchFireScreenAnalytics", () => $a9674d3c2ceaca64$export$7b8039e0ef5a7b1b);

var $eJOHy = parcelRequire("eJOHy");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $djaLS = parcelRequire("djaLS");
const $a9674d3c2ceaca64$export$7b8039e0ef5a7b1b = ()=>{
    const [{ query: query }] = (0, $djaLS.useQuickSearchAnalytics)();
    const isSearch = (0, $eJOHy.useMemo)(()=>Boolean(query?.length), [
        query
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: isSearch ? 'searchCommandPalettePostQuery' : 'searchCommandPalettePreQuery',
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), null));
};

});



parcelRegister("eu8sK", function(module, exports) {
$parcel$export(module.exports, "useAskRovoCommand", () => $cf0f7e2df3209ca9$export$f127825fa798b8fe);

var $eJOHy = parcelRequire("eJOHy");

var $jWSvL = parcelRequire("jWSvL");

var $leNtV = parcelRequire("leNtV");

var $1Zcfy = parcelRequire("1Zcfy");

var $ii7Oz = parcelRequire("ii7Oz");

var $lRq8t = parcelRequire("lRq8t");

var $hf4h9 = parcelRequire("hf4h9");

var $lb6FK = parcelRequire("lb6FK");

var $ec6mp = parcelRequire("ec6mp");
const $cf0f7e2df3209ca9$export$f127825fa798b8fe = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const publish = (0, $leNtV.usePublish)('ai-mate');
    const { data: rovoEntitlementData } = (0, $lb6FK.useRovoEntitlementResource)();
    const askRovoCommand = (0, $eJOHy.useMemo)(()=>{
        // AI entitlement check this will prevent the command from appearing if tenant doesn't have ai enabled
        if (!rovoEntitlementData?.isRovoEnabled) return null;
        return {
            id: 'ask-rovo-command',
            name: formatMessage((0, $ec6mp.messages).askRovoCommandName),
            keywords: formatMessage((0, $ec6mp.messages).askRovoCommandDescription),
            section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
            priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).askRovo,
            alwaysShowWithSearchResults: true,
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWSvL))), {
                        label: ""
                    })
            },
            analytics: {
                action: 'askRovo'
            },
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: (context)=>{
                    // Open Rovo chat with the user's search query
                    // if you don't want auto-submit use insert-prompt in type and placeholderType: 'generic' in data:{}
                    publish({
                        type: 'chat-new',
                        source: 'command-palette',
                        data: {
                            name: 'Command palette chat',
                            dialogues: [],
                            prompt: context?.search?.trim()
                        }
                    });
                }
            }
        };
    }, [
        formatMessage,
        publish,
        rovoEntitlementData?.isRovoEnabled
    ]);
    return askRovoCommand;
};

});
parcelRegister("jWSvL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e85db7e8e238d3f4$var$_react = $e85db7e8e238d3f4$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e85db7e8e238d3f4$var$_baseNew = $e85db7e8e238d3f4$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e85db7e8e238d3f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e85db7e8e238d3f4$var$RovoIcon = (props)=>/*#__PURE__*/ $e85db7e8e238d3f4$var$_react.default.createElement($e85db7e8e238d3f4$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$e85db7e8e238d3f4$var$RovoIcon.displayName = 'RovoIcon';
var $e85db7e8e238d3f4$var$_default = module.exports.default = $e85db7e8e238d3f4$var$RovoIcon;

});

parcelRegister("ii7Oz", function(module, exports) {
$parcel$export(module.exports, "COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY", () => $4dacf61939d854f6$export$5ea2dca0a260365d);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $4dacf61939d854f6$export$5ea2dca0a260365d = /*#__PURE__*/ function(COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY) {
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["askRovo"] = 0] = "askRovo";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["createIssue"] = 1] = "createIssue";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["searchOnCurrentPage"] = 2] = "searchOnCurrentPage";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openQuickSearch"] = 3] = "openQuickSearch";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["copyUrl"] = 4] = "copyUrl";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["checkNotifications"] = 5] = "checkNotifications";
    COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY[COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY["openFilterPopup"] = 6] = "openFilterPopup";
    return COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY;
}({});

});

parcelRegister("lb6FK", function(module, exports) {
$parcel$export(module.exports, "rovoEntitlementResource", () => $010e266d7d00b5af$export$a0974cf24d16bc5d);
$parcel$export(module.exports, "useRovoEntitlementResource", () => $010e266d7d00b5af$export$b9cee3799212b85a);

var $9pTd3 = parcelRequire("9pTd3");

var $3ugTQ = parcelRequire("3ugTQ");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $4cTDP = parcelRequire("4cTDP");

const $010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT = 'ROVO_ENTITLEMENT';
const $010e266d7d00b5af$var$fetchRovoEntitlement = async (cloudId)=>{
    try {
        const response = await (0, $3ugTQ.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $a630de669343b4d7$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId,
                    shouldShowRovoLLMEnabled: (0, $4cTDP.fg)('rovo_use_rovo_llm_enabled_check')
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        const isRovoEnabled = response.data?.jira?.isRovoEnabled ?? null;
        // defaulting to isRovoEnabled if the feature flag is not enabled
        const isRovoLLMEnabled = (0, $4cTDP.fg)('rovo_use_rovo_llm_enabled_check') ? response.data?.jira_isRovoLLMEnabled ?? null : isRovoEnabled;
        return {
            isRovoEnabled: isRovoEnabled,
            isRovoLLMEnabled: isRovoLLMEnabled
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRouterResourcesRovoEntitlement',
                teamName: 'ai-mate'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null,
        isRovoLLMEnabled: undefined
    };
};
const $010e266d7d00b5af$export$a0974cf24d16bc5d = (0, $l1VxS.createResource)({
    type: $010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getKey: ()=>$010e266d7d00b5af$var$RESOURCE_TYPE_ROVO_ENTITLEMENT,
    getData: (_, { tenantContext: { cloudId: cloudId } })=>$010e266d7d00b5af$var$fetchRovoEntitlement(cloudId),
    maxAge: Infinity,
    isCritical: true
});
const $010e266d7d00b5af$export$b9cee3799212b85a = ()=>(0, $eJrcF.useResource)($010e266d7d00b5af$export$a0974cf24d16bc5d);

});
const $a630de669343b4d7$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldShowRovoLLMEnabled: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldShowRovoLLMEnabled)
}
`;


parcelRegister("ec6mp", function(module, exports) {
$parcel$export(module.exports, "messages", () => $dd6d8eef68956306$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $dd6d8eef68956306$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    askRovoCommandName: {
        "id": "compal.ask-rovo.command.name",
        "defaultMessage": "Ask Rovo"
    },
    askRovoCommandDescription: {
        "id": "compal.ask-rovo.command.description",
        "defaultMessage": "Get help from Rovo AI assistant"
    }
});

});


parcelRegister("hJ5Q8", function(module, exports) {
$parcel$export(module.exports, "useCommandPaletteRegistry", () => $098d8e57a8c4f000$export$843ca10488699b0c);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $fWwfy = parcelRequire("fWwfy");
const $098d8e57a8c4f000$export$843ca10488699b0c = ()=>{
    const { setRegistry: setRegistry } = (0, $g51Bg.useActionsCommandPalette)();
    (0, $eJOHy.useState)(()=>{
        setRegistry((0, $fWwfy.COMMAND_PALETTE_REGISTRY));
    });
};

});

parcelRegister("I0FBf", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteModal", () => $3bcc91fb9f7342de$export$9b347310d90ce55);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $956it = parcelRequire("956it");

var $h6i8k = parcelRequire("h6i8k");

var $lRq8t = parcelRequire("lRq8t");

var $lJKII = parcelRequire("lJKII");

var $cMTOh = parcelRequire("cMTOh");

var $g51Bg = parcelRequire("g51Bg");


var $Zthn4 = parcelRequire("Zthn4");

var $e8LYt = parcelRequire("e8LYt");

var $kX1q7 = parcelRequire("kX1q7");
const $3bcc91fb9f7342de$export$9b347310d90ce55 = ({ defaultAriaLabel: defaultAriaLabel, defaultPlaceholder: defaultPlaceholder, defaultFooterContent: defaultFooterContent, onAnalytics: onAnalytics, onErrorAnalytics: onErrorAnalytics, defaultFallback: defaultFallback, rootFallback: rootFallback })=>{
    const [{ commandPaletteSessionId: commandPaletteSessionId, isOpen: isOpen, hasPopupOverlay: hasPopupOverlay }, { close: close, markAsLoaded: markAsLoaded, setAnalytics: setAnalytics }] = (0, $g51Bg.useCommandPalette)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        setAnalytics(onAnalytics, onErrorAnalytics);
    }, [
        onAnalytics,
        onErrorAnalytics,
        setAnalytics
    ]);
    const sendAnalyticsEvent = (0, $eJOHy.useCallback)((action)=>{
        const ev = createAnalyticsEvent({
            action: action,
            actionSubject: 'commandPalette'
        });
        if (onAnalytics) onAnalytics(ev, (0, $cMTOh.UI_EVENT_TYPE), {
            attributes: {
                commandPaletteSessionId: commandPaletteSessionId
            }
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        onAnalytics
    ]);
    const onEscPressed = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Escape' && isOpen) {
            event.preventDefault();
            event.stopPropagation();
            sendAnalyticsEvent('closed');
            (0, $h6i8k.default)('command-palette-closed');
            close();
        }
    }, [
        isOpen,
        sendAnalyticsEvent,
        close
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (hasPopupOverlay) return;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('keydown', onEscPressed, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('keydown', onEscPressed, true);
        };
    }, [
        hasPopupOverlay,
        onEscPressed
    ]);
    (0, $eJOHy.useEffect)(()=>{
        markAsLoaded();
    }, [
        markAsLoaded
    ]);
    const onClose = (0, $eJOHy.useCallback)(()=>{
        sendAnalyticsEvent('closed');
        (0, $h6i8k.default)('command-palette-closed');
        close();
    }, [
        sendAnalyticsEvent,
        close
    ]);
    const onOpenComplete = (0, $eJOHy.useCallback)(()=>{
        sendAnalyticsEvent('viewed');
    }, [
        sendAnalyticsEvent
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
        onClose: onClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEscapePress: true,
        autoFocus: false,
        testId: (0, $1ea66a6021d50bb7$export$7622d28bacf170d1),
        onOpenComplete: onOpenComplete,
        width: 752,
        isBlanketHidden: true,
        label: formatMessage((0, $Zthn4.messages).modalLabel),
        messageId: "command-palette.ui.modal.modal-dialog",
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kX1q7.ModalWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e8LYt.ModalContent), {
        defaultAriaLabel: defaultAriaLabel,
        defaultFallback: defaultFallback,
        rootFallback: rootFallback,
        defaultPlaceholder: defaultPlaceholder,
        defaultFooterContent: defaultFooterContent,
        onClose: onClose
    }))));
};

});
const $1ea66a6021d50bb7$export$7622d28bacf170d1 = 'command-palette.ui.modal.modal-dialog';

parcelRegister("Zthn4", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5d7071c88942bc4c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $5d7071c88942bc4c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    modalLabel: {
        "id": "command-palette.modal.modal-label",
        "defaultMessage": "Command palette modal"
    }
});

});

parcelRegister("e8LYt", function(module, exports) {
$parcel$export(module.exports, "ModalContent", () => $9fb4daa87134b284$export$6da19a24bf249f17);

var $eJOHy = parcelRequire("eJOHy");

var $4EKqI = parcelRequire("4EKqI");

var $dUOwK = parcelRequire("dUOwK");

var $g51Bg = parcelRequire("g51Bg");

var $c2Oqi = parcelRequire("c2Oqi");

var $dOC1o = parcelRequire("dOC1o");

var $6oAbc = parcelRequire("6oAbc");

var $ibBH9 = parcelRequire("ibBH9");

var $hG7Z0 = parcelRequire("hG7Z0");


var $2St1x = parcelRequire("2St1x");

var $8CZxQ = parcelRequire("8CZxQ");

var $3HXVh = parcelRequire("3HXVh");
const $9fb4daa87134b284$export$6da19a24bf249f17 = ({ defaultAriaLabel: defaultAriaLabel, defaultFallback: defaultFallback, rootFallback: rootFallback, defaultPlaceholder: defaultPlaceholder, defaultFooterContent: defaultFooterContent, onClose: onClose })=>{
    const { total: total, fallback: fallback, results: results, renderAfterCommands: renderAfterCommands, activeCommand: activeCommand } = (0, $c2Oqi.useMatches)({
        defaultFallback: defaultFallback,
        rootFallback: rootFallback
    });
    const [registryData] = (0, $g51Bg.useCommandPaletteRegistryCurrentAttribution)();
    (0, $6oAbc.usePerformPendingCommandOnClose)();
    (0, $dOC1o.usePerformMode)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8CZxQ.default), {
        onClose: onClose,
        defaultAriaLabel: defaultAriaLabel,
        defaultPlaceholder: defaultPlaceholder,
        results: results,
        activeCommand: activeCommand
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "command-palette-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ibBH9.CommandBodyErrorBoundary), {
        teamName: registryData?.registryData?.teamName || 'deliveroo',
        attributes: registryData?.analyticsAttributes,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dUOwK.NoResultsContainer), {
                "data-testid": (0, $465ec7af0a4db9dc$export$3545956e927a0d0a)
            }, fallback?.onError?.renderLabel?.() || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            fallback?.onError?.label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hG7Z0.Body), {
        fallback: fallback,
        results: results,
        total: total,
        renderAfterCommands: renderAfterCommands
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3HXVh.ScreenReaderContent), {
        activeCommand: activeCommand,
        results: results
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2St1x.Footer), {
        defaultFooterContent: defaultFooterContent,
        activeCommand: activeCommand
    }));
};

});
parcelRegister("c2Oqi", function(module, exports) {
$parcel$export(module.exports, "useMatches", () => $9482cdf1a0cb322f$export$2378eb7f5ff86053);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $2OtIa = parcelRequire("2OtIa");

var $1tIH1 = parcelRequire("1tIH1");

var $k2EaF = parcelRequire("k2EaF");

var $g51Bg = parcelRequire("g51Bg");

var $bEAft = parcelRequire("bEAft");

var $aRfNo = parcelRequire("aRfNo");

var $gkyXU = parcelRequire("gkyXU");
const $9482cdf1a0cb322f$export$2378eb7f5ff86053 = ({ defaultFallback: defaultFallback, rootFallback: rootFallback })=>{
    const [{ commands: commands, expandedCommand: expandedCommand, childResult: childResult, loadingList: loadingList, sections: sections, fallbackOverride: fallbackOverride, activeIndex: activeIndex }] = (0, $g51Bg.useCommandPalette)();
    const [search] = (0, $bEAft.useCommandPaletteSearchDebounced)();
    const hasLoadChildren = (0, $2OtIa.hasChildren)(expandedCommand);
    const selectedCommands = (0, $eJOHy.useMemo)(()=>hasLoadChildren ? childResult?.commands || [] : commands, [
        hasLoadChildren,
        childResult?.commands,
        commands
    ]);
    const selectedSections = (0, $eJOHy.useMemo)(()=>hasLoadChildren ? childResult?.sections : (0, $2OtIa.mergeSections)(sections), [
        hasLoadChildren,
        childResult?.sections,
        sections
    ]);
    const filterCommandsOverride = (0, $eJOHy.useMemo)(()=>(0, $1tIH1.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.filterAndSortOverrideFn, [
        expandedCommand
    ]);
    const flattenedResults = (0, $gkyXU.useSortAndFilter)(search, selectedCommands, selectedSections, filterCommandsOverride);
    const fallback = (0, $eJOHy.useMemo)(()=>(0, $aRfNo.getFallback)({
            rootFallback: rootFallback,
            defaultFallback: defaultFallback,
            expandedCommand: expandedCommand,
            noResults: Boolean(flattenedResults.results.length === 0 && !loadingList),
            fallbackOverride: fallbackOverride
        }), [
        defaultFallback,
        expandedCommand,
        fallbackOverride,
        flattenedResults.results.length,
        loadingList,
        rootFallback
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if ((0, $1tIH1.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.shouldShowNoCommandsWhileLoading && loadingList) return {
            results: [],
            total: 0
        };
        const fallbackCommandResult = (0, $4cTDP.fg)('jjj_ask_rovo_compal_v1') ? (0, $k2EaF.getFallbackCommandResult)(fallback, activeIndex) : (0, $k2EaF.getFallbackCommandResultOld)(fallback);
        if (fallbackCommandResult) return fallbackCommandResult;
        return {
            ...flattenedResults,
            fallback: fallback
        };
    }, [
        expandedCommand,
        fallback,
        flattenedResults,
        loadingList,
        activeIndex
    ]);
};

});
parcelRegister("k2EaF", function(module, exports) {
$parcel$export(module.exports, "getFallbackCommandResultOld", () => $fb54df7c24973004$export$b17f8fc4de4b141e);
$parcel$export(module.exports, "getFallbackCommandResult", () => $fb54df7c24973004$export$f6daf99735e387a3);
const $fb54df7c24973004$export$b17f8fc4de4b141e = (fallback)=>{
    if (!fallback || !fallback?.onNoResults?.fallbackCommand) return undefined;
    const { fallbackCommand: fallbackCommand, fallbackSection: fallbackSection } = fallback.onNoResults;
    const section = fallbackSection;
    const fallbackCommandHeader = fallbackCommand && section ? {
        ...section.renderName ? {
            renderGroup: section.renderName
        } : {
            group: section.name
        },
        isGroup: true
    } : undefined;
    return {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        results: [
            fallbackCommandHeader,
            {
                command: fallbackCommand,
                active: true,
                index: 0
            }
        ].filter(Boolean),
        total: 1,
        activeCommand: fallbackCommand,
        fallback: fallback
    };
};
const $fb54df7c24973004$export$f6daf99735e387a3 = (fallback, activeIndex = 0)=>{
    if (!fallback || !fallback?.onNoResults?.fallbackCommand && !fallback?.onNoResults?.fallbackCommands) return undefined;
    const { fallbackCommands: fallbackCommands, fallbackSection: fallbackSection } = fallback.onNoResults;
    const section = fallbackSection;
    const commands = fallbackCommands || [];
    if (commands.length === 0) return undefined;
    // Create section header (e.g., "Recommended") - this is NOT actionable via keyboard
    // Headers appear in the UI but don't participate in keyboard navigation
    const fallbackCommandHeader = commands.length > 0 && section ? {
        ...section.renderName ? {
            renderGroup: section.renderName
        } : {
            group: section.name
        },
        isGroup: true
    } : undefined;
    // Transform commands into navigable results with correct active/index calculations
    // Sequential counter for actionable commands only (excludes headers)
    let actionableIndex = 0;
    const commandResults = commands.map((command)=>{
        const result = {
            command: command,
            // ACTIVE CALCULATION: This command is visually highlighted if its position matches keyboard position
            // Example: When activeIndex=1, only the command at actionableIndex=1 will have active=true
            // This drives the visual highlighting and determines which command executes on Enter
            active: activeIndex === actionableIndex,
            // INDEX ASSIGNMENT: Sequential position for keyboard navigation boundaries
            // Used by navigation logic to know valid range (0 to total-1)
            // Example: [Command1=0, Command2=1] allows ArrowDown from 0->1, ArrowUp from 1->0
            index: actionableIndex
        };
        actionableIndex++;
        return result;
    });
    return {
        // Combine header + commands, filter out undefined header if no section configured
        // Final structure: [SectionHeader?, Command1, Command2, ...]
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        results: [
            fallbackCommandHeader,
            ...commandResults
        ].filter(Boolean),
        // TOTAL COUNT: Number of actionable commands (used for navigation boundaries)
        // Keyboard navigation uses this to prevent going beyond valid indices
        // Example: total=2 means valid activeIndex range is 0-1
        total: actionableIndex,
        // ACTIVE COMMAND: The command object that should execute when user presses Enter
        // Must match the command that has active=true in the results array
        // The || commands[0] is a defensive fallback - should never be needed due to activeIndex reset logic,
        // but prevents crashes if activeIndex somehow becomes out of bounds
        activeCommand: commands.find((_, index)=>index === activeIndex) || commands[0],
        fallback: fallback
    };
};

});

parcelRegister("bEAft", function(module, exports) {
$parcel$export(module.exports, "useCommandPaletteSearchDebounced", () => $dce65d16fc2a1bf2$export$f36a4bb9041c3f69);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $cMTOh = parcelRequire("cMTOh");

var $g51Bg = parcelRequire("g51Bg");
const $dce65d16fc2a1bf2$export$f36a4bb9041c3f69 = (debounceTime = (0, $cMTOh.COMMAND_PALETTE_DEBOUNCE_DEFAULT))=>{
    const [{ search: search }, { handleSearch: handleSearch }] = (0, $g51Bg.useCommandPaletteSearch)();
    const [debouncedSearch, setDebouncedSearch] = (0, $eJOHy.useState)(search);
    const debouncedSetSearch = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(setDebouncedSearch, debounceTime), [
        debounceTime
    ]);
    (0, $eJOHy.useEffect)(()=>{
        debouncedSetSearch(search);
    }, [
        debouncedSetSearch,
        search
    ]);
    (0, $eJOHy.useEffect)(()=>()=>debouncedSetSearch.cancel(), [
        debouncedSetSearch
    ]);
    const setSearch = (0, $eJOHy.useCallback)((newSearch)=>{
        debouncedSetSearch.cancel();
        handleSearch(newSearch);
        setDebouncedSearch(newSearch);
    }, [
        debouncedSetSearch,
        handleSearch
    ]);
    return (0, $eJOHy.useMemo)(()=>[
            debouncedSearch,
            setSearch
        ], [
        debouncedSearch,
        setSearch
    ]);
};

});

parcelRegister("aRfNo", function(module, exports) {
$parcel$export(module.exports, "getFallback", () => $1c289d1f188f7cc0$export$ad095be9c56d0fc8);

var $1tIH1 = parcelRequire("1tIH1");
const $1c289d1f188f7cc0$export$ad095be9c56d0fc8 = ({ defaultFallback: defaultFallback, rootFallback: rootFallback, expandedCommand: expandedCommand, noResults: noResults, fallbackOverride: fallbackOverride })=>{
    const rootNoResultsFallback = rootFallback ? {
        onNoResults: rootFallback
    } : undefined;
    if (fallbackOverride) return {
        ...rootNoResultsFallback,
        ...fallbackOverride,
        ...!noResults && {
            onNoResults: undefined
        }
    };
    const wasSecondaryTriggered = expandedCommand?.wasSecondaryTriggered;
    const activeCommandList = (0, $1tIH1.getActiveCommandList)(expandedCommand, wasSecondaryTriggered);
    const commandFallback = activeCommandList?.fallback;
    if (!defaultFallback && !commandFallback && !rootNoResultsFallback) return undefined;
    return {
        ...rootNoResultsFallback,
        ...expandedCommand ? defaultFallback : {},
        ...commandFallback,
        ...!noResults && {
            onNoResults: undefined
        }
    };
};

});

parcelRegister("gkyXU", function(module, exports) {
$parcel$export(module.exports, "useSortAndFilter", () => $a24fd238ea215d99$export$329b92741e754bfe);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $6bjI6 = parcelRequire("6bjI6");

var $d9gB6 = parcelRequire("d9gB6");

var $g51Bg = parcelRequire("g51Bg");

var $hA8kX = parcelRequire("hA8kX");

var $enWaV = parcelRequire("enWaV");

var $kY3Fc = parcelRequire("kY3Fc");

var $3SCzb = parcelRequire("3SCzb");

var $dvufr = parcelRequire("dvufr");
const $a24fd238ea215d99$export$329b92741e754bfe = (search, selectedCommands, selectedSections, filterCommandsOverride)=>{
    const queryKeywordCount = (0, $eJOHy.useMemo)(()=>search.trim().split(' ').filter(Boolean).length, [
        search
    ]);
    const searchableCommands = (0, $kY3Fc.useSearchableCommands)(selectedCommands);
    const [{ activeIndex: activeIndex }] = (0, $g51Bg.useCommandPalette)();
    const fuse = (0, $eJOHy.useMemo)(()=>(0, $enWaV.createFuseFromCommands)(searchableCommands, queryKeywordCount), [
        searchableCommands,
        queryKeywordCount
    ]);
    const sortedAndFilteredCommands = (0, $eJOHy.useMemo)(()=>{
        if (filterCommandsOverride) return filterCommandsOverride(search, selectedCommands, selectedSections);
        let filteredCommands;
        if (!search.trim().toLowerCase().length) filteredCommands = selectedCommands.map((command)=>({
                ...command,
                searchRelevancyScore: 1
            }));
        else {
            const fuseResults = (0, $enWaV.searchFuseIndex)(fuse, search);
            filteredCommands = (0, $hA8kX.filterCommandsFromSearch)(search, fuseResults, searchableCommands);
        }
        return (0, $3SCzb.sortCommands)(filteredCommands, selectedSections);
    }, [
        filterCommandsOverride,
        fuse,
        search,
        searchableCommands,
        selectedCommands,
        selectedSections
    ]);
    const groupedCommands = (0, $eJOHy.useMemo)(()=>{
        const grouped = (0, $d9gB6.getGroupedCommands)(sortedAndFilteredCommands, selectedSections);
        if ((0, $4cTDP.fg)('jjj_ask_rovo_compal_v1')) // Apply commands marked with alwaysShowWithSearchResults when search has results
        {
            if (search.trim() && sortedAndFilteredCommands.length > 0) {
                // Get IDs of commands already in the filtered results to avoid duplicates
                const existingCommandIds = new Set(sortedAndFilteredCommands.map((cmd)=>cmd.id));
                // Only include alwaysShow commands that aren't already in the search results
                const alwaysShowCommands = selectedCommands.filter((command)=>command.alwaysShowWithSearchResults && !existingCommandIds.has(command.id));
                if (alwaysShowCommands.length > 0) return (0, $dvufr.applyAlwaysShowWithSearchResults)(grouped, alwaysShowCommands, selectedSections);
            }
        }
        return grouped;
    }, [
        selectedSections,
        sortedAndFilteredCommands,
        search,
        selectedCommands
    ]);
    const commandMatches = (0, $eJOHy.useMemo)(()=>(0, $6bjI6.getFlattenedResults)(groupedCommands, activeIndex), [
        groupedCommands,
        activeIndex
    ]);
    return commandMatches;
};

});
parcelRegister("6bjI6", function(module, exports) {
$parcel$export(module.exports, "getFlattenedResults", () => $e73556154c8b8679$export$2915eee4e3cdb2f0);
const $e73556154c8b8679$export$2915eee4e3cdb2f0 = (groupedCommands, activeIndex)=>{
    const ungroupedCommands = groupedCommands.ungrouped.slice(0);
    let results = ungroupedCommands;
    const sortedGroups = Object.values(groupedCommands.grouped);
    sortedGroups.forEach(({ id: id, group: group, renderGroup: renderGroup, commands: groupCommands })=>{
        results = results.concat({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...renderGroup ? {
                renderGroup: renderGroup
            } : {
                group: group
            },
            isGroup: true,
            id: id
        }, groupCommands);
    });
    const hasAction = (listed)=>Boolean(listed.command.primaryAction || listed.command.secondaryAction);
    let index = 0;
    let totalActionableCommands = 0;
    let activeCommand;
    let sectionIndex = -1;
    let indexWithinSection = 0;
    let sectionId;
    results = results.map((result)=>{
        if (result.isGroup) {
            const newResult = result;
            indexWithinSection = 0;
            sectionIndex += 1;
            newResult.index = sectionIndex;
            sectionId = result.id;
        }
        if (!result.isGroup) {
            const newResult = result;
            if (hasAction(result)) {
                newResult.index = index;
                index += 1;
                totalActionableCommands += 1;
                newResult.active = activeIndex === result.index;
            }
            newResult.indexWithinSection = indexWithinSection;
            newResult.sectionIndex = sectionIndex;
            newResult.sectionId = sectionId;
            indexWithinSection += 1;
            if (newResult.active) activeCommand = newResult.command;
            return newResult;
        }
        return result;
    });
    return {
        results: results,
        total: totalActionableCommands,
        activeCommand: activeCommand
    };
};

});

parcelRegister("d9gB6", function(module, exports) {
$parcel$export(module.exports, "getGroupedCommands", () => $1c3c756694cf84af$export$30f49bc6f46f80dd);
const $1c3c756694cf84af$export$30f49bc6f46f80dd = (commands, sections)=>commands.reduce((acc, command)=>{
        const listedCommand = {
            command: command
        };
        const createGroup = (id, section)=>{
            if (!acc.grouped.some((group)=>group.id === id)) acc.grouped.push({
                ...section.renderName ? {
                    renderGroup: section.renderName
                } : {
                    group: section.name
                },
                id: id,
                priority: section.priority,
                commands: []
            });
        };
        /**
			 * Add command to the group
			 */ const addCommandGroup = (name, newCommand)=>{
            acc.grouped.find((group)=>group.id === name)?.commands.push(newCommand);
        };
        const section = !!command.section && sections?.[command.section];
        if (section) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const id = command.section;
            createGroup?.(id, section);
            addCommandGroup(id, listedCommand);
        } else acc.ungrouped.push(listedCommand);
        acc.length += 1;
        return acc;
    }, {
        grouped: [],
        ungrouped: [],
        length: 0
    });

});

parcelRegister("hA8kX", function(module, exports) {
$parcel$export(module.exports, "filterCommandsFromSearch", () => $8fd788c148056959$export$552543cdf42ae2bf);
const $8fd788c148056959$export$552543cdf42ae2bf = (search, fuseResults, commands)=>{
    const trimmedSearch = search.trim().toLowerCase();
    if (!trimmedSearch.length) return commands.map((command)=>({
            ...command,
            searchRelevancyScore: 1
        }));
    return commands.flatMap((command)=>{
        const fuseResult = fuseResults.find((result)=>result.item.id === command.id);
        if (fuseResult) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return [
            {
                ...command,
                searchRelevancyScore: fuseResult.score
            }
        ]; // includeScore is true, will always return a number
        return [];
    });
};

});

parcelRegister("enWaV", function(module, exports) {
$parcel$export(module.exports, "createFuseFromCommands", () => $ded77d543f11b5c2$export$3047320e6ed5178f);
$parcel$export(module.exports, "searchFuseIndex", () => $ded77d543f11b5c2$export$17e53d0bddbf4060);

var $j2ANb = parcelRequire("j2ANb");

var $e3rIV = parcelRequire("e3rIV");
const $ded77d543f11b5c2$export$dee16a5b7a115788 = (queryKeywordCount = 1)=>({
        ...(0, $e3rIV.FUSE_SEARCH_OPTIONS),
        keys: (0, $e3rIV.FUSE_SEARCH_OPTIONS).keys?.map((key)=>typeof key === 'object' && 'name' in key ? {
                ...key,
                weight: key.name === 'searchKeywordsArray' ? (key.weight ?? 1) / Math.max(queryKeywordCount, 1) : key.weight
            } : key)
    });
const $ded77d543f11b5c2$export$3047320e6ed5178f = (allCommands, queryKeywordCount = 1)=>new (0, $j2ANb.default)(allCommands, $ded77d543f11b5c2$export$dee16a5b7a115788(queryKeywordCount));
const $ded77d543f11b5c2$export$17e53d0bddbf4060 = (fuse, query)=>fuse.search({
        $or: [
            {
                name: query
            },
            {
                shortcut: query
            },
            {
                sectionName: query
            },
            {
                $or: query.split(' ').map((word)=>({
                        searchKeywordsArray: word
                    }))
            }
        ]
    });

});
parcelRegister("j2ANb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddcabe690daac191$export$2e2bcd8739ae039);
/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $ddcabe690daac191$var$isArray(value) {
    return !Array.isArray ? $ddcabe690daac191$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $ddcabe690daac191$var$INFINITY = 1 / 0;
function $ddcabe690daac191$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$ddcabe690daac191$var$INFINITY ? '-0' : result;
}
function $ddcabe690daac191$var$toString(value) {
    return value == null ? '' : $ddcabe690daac191$var$baseToString(value);
}
function $ddcabe690daac191$var$isString(value) {
    return typeof value === 'string';
}
function $ddcabe690daac191$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $ddcabe690daac191$var$isBoolean(value) {
    return value === true || value === false || $ddcabe690daac191$var$isObjectLike(value) && $ddcabe690daac191$var$getTag(value) == '[object Boolean]';
}
function $ddcabe690daac191$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $ddcabe690daac191$var$isObjectLike(value) {
    return $ddcabe690daac191$var$isObject(value) && value !== null;
}
function $ddcabe690daac191$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $ddcabe690daac191$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $ddcabe690daac191$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $ddcabe690daac191$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $ddcabe690daac191$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $ddcabe690daac191$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $ddcabe690daac191$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $ddcabe690daac191$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $ddcabe690daac191$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $ddcabe690daac191$var$hasOwn = Object.prototype.hasOwnProperty;
class $ddcabe690daac191$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $ddcabe690daac191$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $ddcabe690daac191$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($ddcabe690daac191$var$isString(key) || $ddcabe690daac191$var$isArray(key)) {
        src = key;
        path = $ddcabe690daac191$var$createKeyPath(key);
        id = $ddcabe690daac191$var$createKeyId(key);
    } else {
        if (!$ddcabe690daac191$var$hasOwn.call(key, 'name')) throw new Error($ddcabe690daac191$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($ddcabe690daac191$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($ddcabe690daac191$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $ddcabe690daac191$var$createKeyPath(name);
        id = $ddcabe690daac191$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $ddcabe690daac191$var$createKeyPath(key) {
    return $ddcabe690daac191$var$isArray(key) ? key : key.split('.');
}
function $ddcabe690daac191$var$createKeyId(key) {
    return $ddcabe690daac191$var$isArray(key) ? key.join('.') : key;
}
function $ddcabe690daac191$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$ddcabe690daac191$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$ddcabe690daac191$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($ddcabe690daac191$var$isString(value) || $ddcabe690daac191$var$isNumber(value) || $ddcabe690daac191$var$isBoolean(value))) list.push($ddcabe690daac191$var$toString(value));
            else if ($ddcabe690daac191$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $ddcabe690daac191$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $ddcabe690daac191$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $ddcabe690daac191$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $ddcabe690daac191$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $ddcabe690daac191$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $ddcabe690daac191$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $ddcabe690daac191$var$Config = {
    ...$ddcabe690daac191$var$BasicOptions,
    ...$ddcabe690daac191$var$MatchOptions,
    ...$ddcabe690daac191$var$FuzzyOptions,
    ...$ddcabe690daac191$var$AdvancedOptions
};
const $ddcabe690daac191$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $ddcabe690daac191$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($ddcabe690daac191$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $ddcabe690daac191$var$FuseIndex {
    constructor({ getFn: getFn = $ddcabe690daac191$var$Config.getFn, fieldNormWeight: fieldNormWeight = $ddcabe690daac191$var$Config.fieldNormWeight } = {}){
        this.norm = $ddcabe690daac191$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($ddcabe690daac191$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($ddcabe690daac191$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$ddcabe690daac191$var$isDefined(doc) || $ddcabe690daac191$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$ddcabe690daac191$var$isDefined(value)) return;
            if ($ddcabe690daac191$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$ddcabe690daac191$var$isDefined(value)) continue;
                    if ($ddcabe690daac191$var$isString(value) && !$ddcabe690daac191$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($ddcabe690daac191$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($ddcabe690daac191$var$isString(value) && !$ddcabe690daac191$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $ddcabe690daac191$var$createIndex(keys, docs, { getFn: getFn = $ddcabe690daac191$var$Config.getFn, fieldNormWeight: fieldNormWeight = $ddcabe690daac191$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $ddcabe690daac191$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($ddcabe690daac191$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $ddcabe690daac191$var$parseIndex(data, { getFn: getFn = $ddcabe690daac191$var$Config.getFn, fieldNormWeight: fieldNormWeight = $ddcabe690daac191$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $ddcabe690daac191$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $ddcabe690daac191$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $ddcabe690daac191$var$Config.distance, ignoreLocation: ignoreLocation = $ddcabe690daac191$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $ddcabe690daac191$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $ddcabe690daac191$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $ddcabe690daac191$var$MAX_BITS = 32;
function $ddcabe690daac191$var$search(text, pattern, patternAlphabet, { location: location = $ddcabe690daac191$var$Config.location, distance: distance = $ddcabe690daac191$var$Config.distance, threshold: threshold = $ddcabe690daac191$var$Config.threshold, findAllMatches: findAllMatches = $ddcabe690daac191$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $ddcabe690daac191$var$Config.minMatchCharLength, includeMatches: includeMatches = $ddcabe690daac191$var$Config.includeMatches, ignoreLocation: ignoreLocation = $ddcabe690daac191$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $ddcabe690daac191$var$MAX_BITS) throw new Error($ddcabe690daac191$var$PATTERN_LENGTH_TOO_LARGE($ddcabe690daac191$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $ddcabe690daac191$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $ddcabe690daac191$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $ddcabe690daac191$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $ddcabe690daac191$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $ddcabe690daac191$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $ddcabe690daac191$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $ddcabe690daac191$var$BitapSearch {
    constructor(pattern, { location: location = $ddcabe690daac191$var$Config.location, threshold: threshold = $ddcabe690daac191$var$Config.threshold, distance: distance = $ddcabe690daac191$var$Config.distance, includeMatches: includeMatches = $ddcabe690daac191$var$Config.includeMatches, findAllMatches: findAllMatches = $ddcabe690daac191$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $ddcabe690daac191$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $ddcabe690daac191$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $ddcabe690daac191$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $ddcabe690daac191$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $ddcabe690daac191$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $ddcabe690daac191$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $ddcabe690daac191$var$MAX_BITS), i);
                i += $ddcabe690daac191$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $ddcabe690daac191$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $ddcabe690daac191$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $ddcabe690daac191$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $ddcabe690daac191$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $ddcabe690daac191$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $ddcabe690daac191$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $ddcabe690daac191$var$ExactMatch extends $ddcabe690daac191$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $ddcabe690daac191$var$InverseExactMatch extends $ddcabe690daac191$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $ddcabe690daac191$var$PrefixExactMatch extends $ddcabe690daac191$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $ddcabe690daac191$var$InversePrefixExactMatch extends $ddcabe690daac191$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $ddcabe690daac191$var$SuffixExactMatch extends $ddcabe690daac191$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $ddcabe690daac191$var$InverseSuffixExactMatch extends $ddcabe690daac191$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $ddcabe690daac191$var$FuzzyMatch extends $ddcabe690daac191$var$BaseMatch {
    constructor(pattern, { location: location = $ddcabe690daac191$var$Config.location, threshold: threshold = $ddcabe690daac191$var$Config.threshold, distance: distance = $ddcabe690daac191$var$Config.distance, includeMatches: includeMatches = $ddcabe690daac191$var$Config.includeMatches, findAllMatches: findAllMatches = $ddcabe690daac191$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $ddcabe690daac191$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $ddcabe690daac191$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $ddcabe690daac191$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $ddcabe690daac191$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $ddcabe690daac191$var$IncludeMatch extends $ddcabe690daac191$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $ddcabe690daac191$var$searchers = [
    $ddcabe690daac191$var$ExactMatch,
    $ddcabe690daac191$var$IncludeMatch,
    $ddcabe690daac191$var$PrefixExactMatch,
    $ddcabe690daac191$var$InversePrefixExactMatch,
    $ddcabe690daac191$var$InverseSuffixExactMatch,
    $ddcabe690daac191$var$SuffixExactMatch,
    $ddcabe690daac191$var$InverseExactMatch,
    $ddcabe690daac191$var$FuzzyMatch
];
const $ddcabe690daac191$var$searchersLen = $ddcabe690daac191$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $ddcabe690daac191$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $ddcabe690daac191$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $ddcabe690daac191$var$parseQuery(pattern, options = {}) {
    return pattern.split($ddcabe690daac191$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($ddcabe690daac191$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $ddcabe690daac191$var$searchersLen){
                const searcher = $ddcabe690daac191$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $ddcabe690daac191$var$searchersLen){
                const searcher = $ddcabe690daac191$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $ddcabe690daac191$var$MultiMatchSet = new Set([
    $ddcabe690daac191$var$FuzzyMatch.type,
    $ddcabe690daac191$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $ddcabe690daac191$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $ddcabe690daac191$var$Config.isCaseSensitive, includeMatches: includeMatches = $ddcabe690daac191$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $ddcabe690daac191$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $ddcabe690daac191$var$Config.ignoreLocation, findAllMatches: findAllMatches = $ddcabe690daac191$var$Config.findAllMatches, location: location = $ddcabe690daac191$var$Config.location, threshold: threshold = $ddcabe690daac191$var$Config.threshold, distance: distance = $ddcabe690daac191$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $ddcabe690daac191$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($ddcabe690daac191$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $ddcabe690daac191$var$registeredSearchers = [];
function $ddcabe690daac191$var$register(...args) {
    $ddcabe690daac191$var$registeredSearchers.push(...args);
}
function $ddcabe690daac191$var$createSearcher(pattern, options) {
    for(let i = 0, len = $ddcabe690daac191$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $ddcabe690daac191$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $ddcabe690daac191$var$BitapSearch(pattern, options);
}
const $ddcabe690daac191$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $ddcabe690daac191$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $ddcabe690daac191$var$isExpression = (query)=>!!(query[$ddcabe690daac191$var$LogicalOperator.AND] || query[$ddcabe690daac191$var$LogicalOperator.OR]);
const $ddcabe690daac191$var$isPath = (query)=>!!query[$ddcabe690daac191$var$KeyType.PATH];
const $ddcabe690daac191$var$isLeaf = (query)=>!$ddcabe690daac191$var$isArray(query) && $ddcabe690daac191$var$isObject(query) && !$ddcabe690daac191$var$isExpression(query);
const $ddcabe690daac191$var$convertToExplicit = (query)=>({
        [$ddcabe690daac191$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $ddcabe690daac191$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $ddcabe690daac191$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$ddcabe690daac191$var$isExpression(query)) return next($ddcabe690daac191$var$convertToExplicit(query));
        if ($ddcabe690daac191$var$isLeaf(query)) {
            const key = isQueryPath ? query[$ddcabe690daac191$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$ddcabe690daac191$var$KeyType.PATTERN] : query[key];
            if (!$ddcabe690daac191$var$isString(pattern)) throw new Error($ddcabe690daac191$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $ddcabe690daac191$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $ddcabe690daac191$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($ddcabe690daac191$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$ddcabe690daac191$var$isExpression(query)) query = $ddcabe690daac191$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $ddcabe690daac191$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $ddcabe690daac191$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $ddcabe690daac191$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$ddcabe690daac191$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$ddcabe690daac191$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $ddcabe690daac191$var$transformScore(result, data) {
    data.score = result.score;
}
function $ddcabe690daac191$var$format(results, docs, { includeMatches: includeMatches = $ddcabe690daac191$var$Config.includeMatches, includeScore: includeScore = $ddcabe690daac191$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($ddcabe690daac191$var$transformMatches);
    if (includeScore) transformers.push($ddcabe690daac191$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $ddcabe690daac191$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$ddcabe690daac191$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $ddcabe690daac191$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $ddcabe690daac191$var$FuseIndex)) throw new Error($ddcabe690daac191$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $ddcabe690daac191$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$ddcabe690daac191$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $ddcabe690daac191$var$isString(query) ? $ddcabe690daac191$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $ddcabe690daac191$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($ddcabe690daac191$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $ddcabe690daac191$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $ddcabe690daac191$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$ddcabe690daac191$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $ddcabe690daac191$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $ddcabe690daac191$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($ddcabe690daac191$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $ddcabe690daac191$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$ddcabe690daac191$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$ddcabe690daac191$var$isDefined(value)) return [];
        let matches = [];
        if ($ddcabe690daac191$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$ddcabe690daac191$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$ddcabe690daac191$export$2e2bcd8739ae039.version = '7.0.0';
$ddcabe690daac191$export$2e2bcd8739ae039.createIndex = $ddcabe690daac191$var$createIndex;
$ddcabe690daac191$export$2e2bcd8739ae039.parseIndex = $ddcabe690daac191$var$parseIndex;
$ddcabe690daac191$export$2e2bcd8739ae039.config = $ddcabe690daac191$var$Config;
$ddcabe690daac191$export$2e2bcd8739ae039.parseQuery = $ddcabe690daac191$var$parse;
$ddcabe690daac191$var$register($ddcabe690daac191$var$ExtendedSearch);

});

parcelRegister("e3rIV", function(module, exports) {
$parcel$export(module.exports, "FUSE_SEARCH_OPTIONS", () => $85775cf3b4bcaca4$export$833d69a1b36f826e);

var $2OtIa = parcelRequire("2OtIa");
const $85775cf3b4bcaca4$export$833d69a1b36f826e = {
    threshold: 0.3,
    keys: [
        {
            name: 'shortcut',
            getFn: (command)=>(0, $2OtIa.removeShortcutSpecialCharacters)(command.shortcut ?? ''),
            weight: Math.pow(2, 6)
        },
        {
            name: 'name',
            weight: Math.pow(2, 5)
        },
        {
            name: 'searchKeywordsArray',
            weight: Math.pow(2, 2)
        },
        {
            name: 'sectionName',
            weight: Math.pow(2, 1)
        }
    ],
    includeScore: true,
    shouldSort: false,
    distance: 1000,
    ignoreFieldNorm: true
};

});


parcelRegister("kY3Fc", function(module, exports) {
$parcel$export(module.exports, "useSearchableCommands", () => $8e998b8b17ca3eb5$export$9fc7cf5dc38ed809);

var $eJOHy = parcelRequire("eJOHy");

var $hf4h9 = parcelRequire("hf4h9");

var $g51Bg = parcelRequire("g51Bg");

const $8e998b8b17ca3eb5$var$getSearchableChildrenCommands = (action)=>{
    if (action?.type === (0, $hf4h9.CommandActionType).COMMAND_LIST && action.commands !== undefined) return action.commands;
    return [];
};
const $8e998b8b17ca3eb5$export$9fc7cf5dc38ed809 = (commands)=>{
    const [{ sections: sections }] = (0, $g51Bg.useCommandPalette)();
    return (0, $eJOHy.useMemo)(()=>$8e998b8b17ca3eb5$export$529e2322cf5eecf3(commands, sections), [
        commands,
        sections
    ]);
};
const $8e998b8b17ca3eb5$var$getSectionName = (command, sectionMap)=>{
    const sectionId = command.section ?? '';
    const section = sectionMap.get(sectionId);
    if (!section) return '';
    if (section.name) return section.name;
    const textContent = (elem)=>{
        if (!elem) return '';
        if (typeof elem === 'string') return elem;
        const children = elem.props && elem.props.children;
        return children instanceof Array ? children.map(textContent).join('') : textContent(children);
    };
    return textContent(section.renderName?.() ?? '');
};
const $8e998b8b17ca3eb5$export$529e2322cf5eecf3 = (commands, sections)=>{
    const sectionMap = new Map(sections.flatMap((section)=>Object.entries(section)));
    const findCommands = (currentCommands, depth = 1)=>{
        const allCommands = [];
        const commandsToPrepare = currentCommands;
        commandsToPrepare.forEach((command)=>{
            allCommands.push({
                ...command,
                searchKeywordsArray: command.keywords?.split(' ') ?? [],
                sectionName: $8e998b8b17ca3eb5$var$getSectionName(command, sectionMap)
            });
            const searchableChildren = [];
            const searchablePrimaryChildren = $8e998b8b17ca3eb5$var$getSearchableChildrenCommands(command.primaryAction);
            const searchableSecondaryChildren = $8e998b8b17ca3eb5$var$getSearchableChildrenCommands(command.secondaryAction);
            if (depth < (0, $3081f918c86e2c0a$export$f1496885619d1f75) && searchablePrimaryChildren.length) searchableChildren.push(...findCommands(searchablePrimaryChildren, depth + 1));
            if (depth < (0, $3081f918c86e2c0a$export$f1496885619d1f75) && searchableSecondaryChildren.length) searchableChildren.push(...findCommands(searchableSecondaryChildren, depth + 1));
            searchableChildren.forEach((childCommand)=>{
                const breadcrumb = [
                    command?.components?.Name || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, command.name))
                ];
                if (childCommand.breadcrumb?.length) breadcrumb.push(...childCommand.breadcrumb);
                else breadcrumb.push(childCommand?.components?.Name || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, childCommand.name)));
                const parentCommands = [
                    command
                ];
                if (childCommand.parentCommands?.length) parentCommands.push(...childCommand.parentCommands);
                allCommands.push({
                    ...childCommand,
                    searchKeywordsArray: childCommand.keywords?.split(' ') ?? [],
                    section: command.section,
                    sectionName: $8e998b8b17ca3eb5$var$getSectionName(command, sectionMap),
                    parentCommands: parentCommands,
                    breadcrumb: breadcrumb
                });
            });
        });
        return allCommands;
    };
    return findCommands(commands);
};

});
const $3081f918c86e2c0a$export$f1496885619d1f75 = 3;


parcelRegister("3SCzb", function(module, exports) {
$parcel$export(module.exports, "sortCommands", () => $d953bf09b13e90af$export$e679a6aefb43ec97);

const $d953bf09b13e90af$var$getSectionOffset = (section)=>1 + (section.priority ?? 0) * (0, $446958e093c657e1$export$af5cf775e0899047);
const $d953bf09b13e90af$export$e679a6aefb43ec97 = (commands, selectedSections)=>{
    const sortByPriority = (commandsToSort)=>commandsToSort.sort((a, b)=>(a.priority || 0) - (b.priority || 0));
    const sortedSections = Object.entries(selectedSections ?? {}).sort(([idA, valA], [idB, valB])=>{
        const aScore = Math.min(...commands.filter((command)=>command.section === idA).map((command)=>command.searchRelevancyScore ?? 1), 1) * $d953bf09b13e90af$var$getSectionOffset(valA);
        const bScore = Math.min(...commands.filter((command)=>command.section === idB).map((command)=>command.searchRelevancyScore ?? 1), 1) * $d953bf09b13e90af$var$getSectionOffset(valB);
        if (aScore !== bScore) return aScore - bScore;
        const priorityA = valA.priority || 0;
        const priorityB = valB.priority || 0;
        return priorityA - priorityB;
    });
    return sortByPriority(commands).sort((a, b)=>{
        if (a.section && !b.section) return 1;
        if (!a.section && b.section) return -1;
        if (a.section === b.section) return (a.searchRelevancyScore ?? 1) - (b.searchRelevancyScore ?? 1);
        return sortedSections.findIndex(([id])=>id === a.section) - sortedSections.findIndex(([id])=>id === b.section);
    });
};

});
const $446958e093c657e1$export$af5cf775e0899047 = 10e3;


parcelRegister("dvufr", function(module, exports) {
$parcel$export(module.exports, "applyAlwaysShowWithSearchResults", () => $808ed0fbfd782ad7$export$a685ccd9ec1c14b2);
const $808ed0fbfd782ad7$export$a685ccd9ec1c14b2 = (grouped, alwaysShowCommands, selectedSections)=>{
    if (alwaysShowCommands.length === 0) return grouped;
    // Create new grouped result to avoid mutation
    const newGrouped = {
        ...grouped,
        grouped: [
            ...grouped.grouped
        ],
        ungrouped: [
            ...grouped.ungrouped
        ]
    };
    for (const command of alwaysShowCommands){
        // Create command internal with fixed search relevancy
        const commandInternal = {
            ...command,
            searchRelevancyScore: 0
        };
        if (!command.section) {
            newGrouped.ungrouped.push({
                command: commandInternal
            });
            newGrouped.length += 1;
            continue;
        }
        // Find existing section group
        const existingSectionGroupIndex = newGrouped.grouped.findIndex((group)=>group.id === command.section);
        // FindIndex returns -1 when no match is found
        if (existingSectionGroupIndex >= 0) {
            // Add command to existing section
            newGrouped.grouped[existingSectionGroupIndex] = {
                ...newGrouped.grouped[existingSectionGroupIndex],
                commands: [
                    ...newGrouped.grouped[existingSectionGroupIndex].commands,
                    {
                        command: commandInternal
                    }
                ]
            };
            newGrouped.length += 1;
        } else if (selectedSections?.[command.section]) {
            // Create new section with the command if section is registered
            const section = selectedSections[command.section];
            const newSectionGroup = {
                ...section.renderName ? {
                    renderGroup: section.renderName
                } : {
                    group: section.name
                },
                id: command.section,
                priority: section.priority,
                commands: [
                    {
                        command: commandInternal
                    }
                ]
            };
            newGrouped.grouped.push(newSectionGroup);
            newGrouped.length += 1;
        }
    }
    return newGrouped;
};

});



parcelRegister("dOC1o", function(module, exports) {
$parcel$export(module.exports, "usePerformMode", () => $82c278972446bcd0$export$8d997d005eb1dc1c);

var $eJOHy = parcelRequire("eJOHy");

var $ftN6c = parcelRequire("ftN6c");

var $2OtIa = parcelRequire("2OtIa");

var $g51Bg = parcelRequire("g51Bg");
const $82c278972446bcd0$export$8d997d005eb1dc1c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ commands: commands, search: search, expandedCommand: expandedCommand, childResult: childResult, registry: registry, activeRegistry: activeRegistry }, { executeCommand: executeCommand }] = (0, $g51Bg.useCommandPaletteUsePerformModeState)();
    const hasLoadChildren = (0, $2OtIa.hasChildren)(expandedCommand);
    const selectedCommands = (0, $eJOHy.useMemo)(()=>hasLoadChildren ? childResult?.commands || [] : commands, [
        hasLoadChildren,
        childResult?.commands,
        commands
    ]);
    const foundCommand = (0, $eJOHy.useMemo)(()=>selectedCommands.find((command)=>command.mode && command.mode === search), [
        search,
        selectedCommands
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (foundCommand) executeCommand(foundCommand, {
            method: 'mode',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: (0, $2OtIa.getRegistryData)(registry, activeRegistry, foundCommand.id)
        });
    }, [
        executeCommand,
        createAnalyticsEvent,
        registry,
        activeRegistry,
        foundCommand
    ]);
};

});

parcelRegister("6oAbc", function(module, exports) {
$parcel$export(module.exports, "usePerformPendingCommandOnClose", () => $ec35643703e420a6$export$25863b30ab942012);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");
const $ec35643703e420a6$export$25863b30ab942012 = ()=>{
    const { performDialogCloseCommand: performDialogCloseCommand } = (0, $g51Bg.useActionsCommandPalette)();
    (0, $eJOHy.useEffect)(()=>()=>{
            performDialogCloseCommand();
        }, [
        performDialogCloseCommand
    ]);
};

});

parcelRegister("ibBH9", function(module, exports) {
$parcel$export(module.exports, "CommandBodyErrorBoundary", () => $4ca863be978cadea$export$3f5cc8366a41f7db);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $g51Bg = parcelRequire("g51Bg");
const $4ca863be978cadea$export$3f5cc8366a41f7db = ({ teamName: teamName, attributes: attributes, fallback: fallback, children: children })=>{
    const [{ expandedCommand: expandedCommand }] = (0, $g51Bg.useCommandPaletteExpandedCommand)();
    const capturedErrorRef = (0, $eJOHy.useRef)();
    const [prevExpandedCommand, setPrevExpandedCommand] = (0, $eJOHy.useState)(expandedCommand);
    const [hasReset, setHasReset] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (hasReset) {
            capturedErrorRef.current = undefined;
            // eslint-disable-next-line react-you-might-not-need-an-effect/no-chain-state-updates
            setHasReset(false);
        }
    }, [
        hasReset
    ]);
    const onRetry = (0, $eJOHy.useCallback)(()=>{
        setHasReset(true);
    }, []);
    const getCapturedError = (0, $eJOHy.useCallback)(()=>{
        return capturedErrorRef.current;
    }, [
        capturedErrorRef
    ]);
    // This is so that changing body triggers a reset if an error was caught and then the user goes back a level or to another command list
    // Without this, the body would not rerender, and the fallback would remain present
    (0, $eJOHy.useEffect)(()=>{
        if (getCapturedError() && !hasReset && prevExpandedCommand !== expandedCommand) onRetry();
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state
        setPrevExpandedCommand(expandedCommand);
    }, [
        expandedCommand,
        hasReset,
        onRetry,
        prevExpandedCommand,
        getCapturedError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "command.body",
        packageName: "jiraCommandPalette",
        teamName: teamName || 'deliveroo',
        attributes: attributes,
        onError: (_location, error)=>{
            capturedErrorRef.current = error;
        },
        fallback: fallback || 'unmount',
        resetCaughtError: hasReset ? getCapturedError() : undefined
    }, children);
};

});

parcelRegister("hG7Z0", function(module, exports) {
$parcel$export(module.exports, "Body", () => $b1356dfe32678049$export$4b2c32e08f77ff18);

var $eJOHy = parcelRequire("eJOHy");

var $jmeeg = parcelRequire("jmeeg");

var $1tIH1 = parcelRequire("1tIH1");

var $g51Bg = parcelRequire("g51Bg");
const $b1356dfe32678049$export$4b2c32e08f77ff18 = ({ fallback: fallback, results: results, total: total, renderAfterCommands: renderAfterCommands })=>{
    const [{ expandedCommand: expandedCommand }, { setChildCommands: setChildCommands, setLoadingList: setLoadingList, setFallbackOverride: setFallbackOverride }] = (0, $g51Bg.useCommandPaletteExpandedCommand)();
    const ExpandedBody = (0, $eJOHy.useMemo)(()=>(0, $1tIH1.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Body || (0, $jmeeg.components).Body, [
        expandedCommand
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ExpandedBody, {
        setChildResult: setChildCommands,
        setLoading: setLoadingList,
        fallback: fallback,
        results: results,
        total: total,
        renderAfterCommands: renderAfterCommands,
        setFallbackOverride: setFallbackOverride
    });
};

});

const $465ec7af0a4db9dc$export$3545956e927a0d0a = 'command-palette.ui.modal.modal-content.no-results-container';

parcelRegister("2St1x", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $9c07b4f80aa1d27a$export$a06f1c675e846f6f);

var $eJOHy = parcelRequire("eJOHy");

var $jmeeg = parcelRequire("jmeeg");
const $9c07b4f80aa1d27a$export$a06f1c675e846f6f = (props)=>{
    const { activeCommand: activeCommand, ...rest } = props;
    const FooterComponent = activeCommand?.components?.Footer || (0, $jmeeg.components).Footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FooterComponent, rest);
};

});

parcelRegister("8CZxQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b69b55fd62fdb96$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $8PCRQ = parcelRequire("8PCRQ");

var $ftN6c = parcelRequire("ftN6c");

var $goZPP = parcelRequire("goZPP");

var $dt3aG = parcelRequire("dt3aG");

var $7ep4S = parcelRequire("7ep4S");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $cMTOh = parcelRequire("cMTOh");

var $6h69o = parcelRequire("6h69o");

var $jmeeg = parcelRequire("jmeeg");

var $1k1Uh = parcelRequire("1k1Uh");

var $2OtIa = parcelRequire("2OtIa");

var $1tIH1 = parcelRequire("1tIH1");

var $g51Bg = parcelRequire("g51Bg");


var $4kU6n = parcelRequire("4kU6n");
const $2b69b55fd62fdb96$export$8b251419efc915eb = ({ defaultAriaLabel: defaultAriaLabel, defaultPlaceholder: defaultPlaceholder, results: results, activeCommand: activeCommand })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [{ search: search, forceSearchFocus: forceSearchFocus, isOpen: isOpen, expandedCommand: expandedCommand, activeIndex: activeIndex, loadingList: loadingList, onAnalytics: onAnalytics, registry: registry, activeRegistry: activeRegistry, shouldForceSearchValue: shouldForceSearchValue }, { handleSearch: handleSearch, goBackLevel: goBackLevel, forceFocusSearch: forceFocusSearch, executeCommand: executeCommand, setFocusInput: setFocusInput, resetShouldForceSearchValue: resetShouldForceSearchValue }] = (0, $g51Bg.useCommandPalette)();
    const textFieldRef = (0, $eJOHy.useRef)();
    const onFocusInput = (isFocused)=>()=>{
            setFocusInput(isFocused);
        };
    (0, $eJOHy.useEffect)(()=>{
        if (shouldForceSearchValue && textFieldRef.current && textFieldRef.current.value !== search) {
            resetShouldForceSearchValue();
            textFieldRef.current.value = search;
        }
    }, [
        resetShouldForceSearchValue,
        search,
        shouldForceSearchValue
    ]);
    const onInputKeyPress = (0, $eJOHy.useCallback)((event)=>{
        if (event.key === 'Backspace' && search === '') goBackLevel(false, {
            createAnalyticsEvent: createAnalyticsEvent,
            method: 'keyboard'
        });
        if (event.key === 'Enter') {
            event.preventDefault();
            const listed = results.find((result)=>!result.isGroup && result.index === activeIndex);
            if (listed) executeCommand(listed.command, {
                method: 'keyboard',
                createAnalyticsEvent: createAnalyticsEvent,
                attributes: {
                    ...(0, $2OtIa.getAnalyticsAttributesFromResult)(listed),
                    ...(0, $2OtIa.getRegistryData)(registry, activeRegistry, listed.command.id)
                }
            }, (0, $2OtIa.isSecondaryTrigger)(event));
        }
    }, [
        search,
        goBackLevel,
        createAnalyticsEvent,
        results,
        activeIndex,
        executeCommand,
        registry,
        activeRegistry
    ]);
    const onTypeAnalytics = (0, $eJOHy.useCallback)((query)=>{
        if (onAnalytics && createAnalyticsEvent) {
            const event = createAnalyticsEvent({});
            onAnalytics(event, (0, $cMTOh.TRACK_EVENT_TYPE), {
                action: 'entered',
                actionSubject: 'text',
                actionSubjectId: 'commandPaletteSearch',
                attributes: {
                    wordCount: (0, $2OtIa.getWordCount)(query),
                    queryLength: query.length,
                    queryHash: (0, $2OtIa.getQueryHash)(query),
                    queryVersion: -1 // This is done to prevent the quickSearch queryVersion being sent which may be confusing, something to reimplement later
                }
            });
        }
    }, [
        createAnalyticsEvent,
        onAnalytics
    ]);
    const onTypeAnalyticsDebounced = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(onTypeAnalytics, 400), [
        onTypeAnalytics
    ]);
    (0, $eJOHy.useEffect)(()=>()=>{
            onTypeAnalyticsDebounced?.cancel?.();
        }, [
        onTypeAnalyticsDebounced
    ]);
    const onTypeSearch = (0, $eJOHy.useCallback)((ev)=>{
        const searchValue = ev.target.value;
        handleSearch(searchValue);
        onTypeAnalyticsDebounced(searchValue);
    }, [
        handleSearch,
        onTypeAnalyticsDebounced
    ]);
    const handleBackButton = (0, $eJOHy.useCallback)(()=>{
        goBackLevel(false, {
            createAnalyticsEvent: createAnalyticsEvent,
            method: 'mouse'
        });
    }, [
        createAnalyticsEvent,
        goBackLevel
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (textFieldRef.current && forceSearchFocus) {
            textFieldRef.current.focus();
            forceFocusSearch(false);
        }
    }, [
        forceSearchFocus,
        forceFocusSearch
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (isOpen && textFieldRef.current) textFieldRef.current.focus();
    }, [
        isOpen
    ]);
    const renderLozenge = (0, $eJOHy.useCallback)((command)=>{
        if (command.mode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1k1Uh.OutlinedLozenge), {
            key: command.id,
            "data-testid": (0, $fe240500a8c4e06d$export$a670752bd2308067)
        }, "\xa0", command.mode, "\xa0");
        const searchLozengeName = command.searchLozengeName || command.name;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1k1Uh.SearchLozenge), {
            key: command.id,
            "data-testid": (0, $fe240500a8c4e06d$export$1bc358df5aba61fd)
        }, searchLozengeName);
    }, []);
    const elemBeforeInput = (0, $eJOHy.useMemo)(()=>{
        if (!expandedCommand) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-subtle, #626F86)"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b69b55fd62fdb96$var$ElemBeforeInputWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $4kU6n.default).goBack)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b69b55fd62fdb96$var$BackButton, {
            testId: (0, $fe240500a8c4e06d$export$69f261bc56a05f72),
            appearance: "subtle",
            onClick: handleBackButton
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8PCRQ))), {
            spacing: "spacious",
            label: formatMessage((0, $4kU6n.default).goBack),
            color: "var(--ds-icon-subtle, #626F86)",
            size: "small"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b69b55fd62fdb96$var$LozengeContainer, null, renderLozenge(expandedCommand)));
    }, [
        expandedCommand,
        formatMessage,
        handleBackButton,
        renderLozenge
    ]);
    const elemAfterInput = (0, $eJOHy.useMemo)(()=>{
        if (expandedCommand && loadingList) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b69b55fd62fdb96$var$SpinnerContainer, {
            "data-testid": (0, $fe240500a8c4e06d$export$b2afd57a1d4bc9e4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "small"
        }));
        return null;
    }, [
        expandedCommand,
        loadingList
    ]);
    const placeholder = (0, $eJOHy.useMemo)(()=>{
        if (expandedCommand) return expandedCommand.placeholder || expandedCommand.name;
        return defaultPlaceholder;
    }, [
        expandedCommand,
        defaultPlaceholder
    ]);
    const ModalHeader = (0, $eJOHy.useMemo)(()=>(0, $1tIH1.getActiveCommandList)(expandedCommand)?.components?.Header || (0, $jmeeg.components).Header, [
        expandedCommand
    ]);
    const ariaLabel = (0, $eJOHy.useMemo)(()=>{
        if (!expandedCommand && defaultAriaLabel) return defaultAriaLabel;
        return placeholder;
    }, [
        defaultAriaLabel,
        expandedCommand,
        placeholder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ModalHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6h69o.CommandPaletteSearchInput), {
        "aria-label": ariaLabel,
        placeholder: placeholder,
        onKeyDown: onInputKeyPress,
        elemBeforeInput: elemBeforeInput,
        elemAfterInput: elemAfterInput,
        onChange: onTypeSearch,
        ref: textFieldRef,
        onFocus: onFocusInput(true),
        onBlur: onFocusInput(false),
        activeId: activeCommand?.id
    }));
};
var $2b69b55fd62fdb96$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $2b69b55fd62fdb96$export$8b251419efc915eb;
const $2b69b55fd62fdb96$var$BackButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _1bsba982 _4t3ia982 _t7bl1lpd _4hh6wdcn _1fyqwdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b69b55fd62fdb96$var$SpinnerContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b69b55fd62fdb96$var$ElemBeforeInputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2b69b55fd62fdb96$var$LozengeContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("6h69o", function(module, exports) {
$parcel$export(module.exports, "CommandPaletteSearchInput", () => $3b8dd03b9cd7b4a8$export$1f98f66b42e34226);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $jPROM = parcelRequire("jPROM");

var $sY9BV = parcelRequire("sY9BV");

const $3b8dd03b9cd7b4a8$export$1f98f66b42e34226 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ activeId: activeId, ...rest }, ref)=>{
    const ariaProps = !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(activeId) ? {
        'aria-expanded': true,
        'aria-controls': (0, $19c39496d342d719$export$9ffb4923f81813d9),
        role: 'combobox'
    } : {
        role: 'searchbox'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3b8dd03b9cd7b4a8$var$TextFieldStyle, {
        appearance: "none",
        testId: (0, $19c39496d342d719$export$d3cd230e107fbce),
        ref: ref,
        ...ariaProps,
        ...rest
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b8dd03b9cd7b4a8$var$TextFieldStyle = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $sY9BV.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _syaz1fxt _ca0q12x7 _u5f31b66 _n3td12x7 _19bv1b66 _swxz1ixg _10wj1ixg _v69yidpf _h61aidpf _1qtqidpf _1bayidpf _n9z41b66 _lmlq1b66 _pytkgktf _k2u0gktf _5ce6131l _irr31r81",
            __cmplp.className
        ])
    });
});

});

const $fe240500a8c4e06d$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $fe240500a8c4e06d$export$a670752bd2308067 = 'command-palette.ui.modal.header.command-mode';
const $fe240500a8c4e06d$export$69f261bc56a05f72 = 'command-palette.ui.modal.header.left-arrow';
const $fe240500a8c4e06d$export$b2afd57a1d4bc9e4 = 'command-palette.ui.modal.header.spinner-container';
const $fe240500a8c4e06d$export$1bc358df5aba61fd = 'command-palette.ui.modal.modal-content.header.search-lozenge';

parcelRegister("4kU6n", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a7a643742d9123a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $9a7a643742d9123a$var$messages = (0, $7qGN1.defineMessages)({
    goBack: {
        "id": "command-palette.modal.modal-content.header.go-back",
        "defaultMessage": "Go back"
    }
});
var $9a7a643742d9123a$export$2e2bcd8739ae039 = $9a7a643742d9123a$var$messages;

});


parcelRegister("3HXVh", function(module, exports) {
$parcel$export(module.exports, "ScreenReaderContent", () => $999d20cd9469fb04$export$d133a8e1226db0f3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3s8bj = parcelRequire("3s8bj");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");


var $g51Bg = parcelRequire("g51Bg");

var $35Q97 = parcelRequire("35Q97");
const $999d20cd9469fb04$var$CommandPaletteScreenReaderContent = ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($999d20cd9469fb04$var$ScreenReaderOnly, {
        "aria-live": "polite",
        "aria-atomic": "false",
        tabIndex: -1,
        ...props,
        id: (0, $19c39496d342d719$export$9e40a0642460a944)
    });
const $999d20cd9469fb04$export$d133a8e1226db0f3 = ({ activeCommand: activeCommand, results: results })=>{
    const [{ search: search, activeIndex: activeIndex }, { forceFocusSearch: forceFocusSearch }] = (0, $g51Bg.useCommandPalette)();
    const previousSearch = (0, $6d9QY.usePrevious)(search);
    const { getScreenReaderText: getScreenReaderText } = $999d20cd9469fb04$export$a59db8e7afab3919();
    const [screenReaderText, setScreenReaderText] = (0, $eJOHy.useState)(null);
    const debouncedSetScreenReaderText = (0, $eJOHy.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(setScreenReaderText, 400), []);
    (0, $eJOHy.useEffect)(()=>()=>{
            debouncedSetScreenReaderText?.cancel?.();
        }, [
        debouncedSetScreenReaderText
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (previousSearch !== search) debouncedSetScreenReaderText(getScreenReaderText({
            activeCommand: activeCommand,
            results: results,
            activeIndex: activeIndex
        }));
    }, [
        activeCommand,
        getScreenReaderText,
        previousSearch,
        results,
        search,
        activeIndex,
        debouncedSetScreenReaderText
    ]);
    const onFocus = (0, $eJOHy.useCallback)(()=>{
        forceFocusSearch(true);
    }, [
        forceFocusSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($999d20cd9469fb04$var$CommandPaletteScreenReaderContent, {
        "data-testid": "command-palette.ui.modal.modal-content.screen-reader-content.command-palette-screen-reader-content",
        onFocus: onFocus
    }, screenReaderText);
};
const $999d20cd9469fb04$export$a59db8e7afab3919 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getScreenReaderText = ({ activeCommand: activeCommand, results: results, activeIndex: activeIndex })=>{
        if (!activeCommand) return null;
        const selectedOptionLabel = activeCommand?.name;
        const selectedIndex = activeIndex + 1;
        const totalSuggestions = results.filter((result)=>!result.isGroup).length;
        return formatMessage((0, $35Q97.default).selectedOption, {
            selectedOptionLabel: selectedOptionLabel,
            selectedIndex: selectedIndex,
            totalSuggestions: totalSuggestions
        });
    };
    return {
        getScreenReaderText: getScreenReaderText
    };
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $999d20cd9469fb04$var$ScreenReaderOnly = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _19itidpf _kqswstnw _1bsbt94y _4t3it94y _ogtocqaw _slp34jg8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("35Q97", function(module, exports) {
$parcel$export(module.exports, "default", () => $02fde1c08ab18b35$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $02fde1c08ab18b35$var$messages = (0, $7qGN1.defineMessages)({
    selectedOption: {
        "id": "command-palette.modal.modal-content.screen-reader-content.selected-option",
        "defaultMessage": "{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions})"
    },
    selectedOptionWithSearch: {
        "id": "command-palette.modal.modal-content.screen-reader-content.selected-option-with-search",
        "defaultMessage": "{selectedOptionLabel}, selected, ({selectedIndex} of {totalSuggestions}) for {search}"
    }
});
var $02fde1c08ab18b35$export$2e2bcd8739ae039 = $02fde1c08ab18b35$var$messages;

});



parcelRegister("kX1q7", function(module, exports) {
$parcel$export(module.exports, "ModalWrapper", () => $e4d3b169decbcca3$export$858bfd02c3f2fba5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1tIH1 = parcelRequire("1tIH1");

var $g51Bg = parcelRequire("g51Bg");
const $e4d3b169decbcca3$export$858bfd02c3f2fba5 = ({ children: children })=>{
    const [{ expandedCommand: expandedCommand }] = (0, $g51Bg.useCommandPaletteExpandedCommand)();
    const Wrapper = (0, $eJOHy.useMemo)(()=>(0, $1tIH1.getActiveCommandList)(expandedCommand, expandedCommand?.wasSecondaryTriggered)?.components?.Wrapper || (0, $eJOHy.Fragment), [
        expandedCommand
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e4d3b169decbcca3$var$ModalDialogWrapper, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e4d3b169decbcca3$var$ModalDialogWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2rko1j6v _19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr _bfhk1bhr _16qs1cd0",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dY8y3", function(module, exports) {
$parcel$export(module.exports, "ForgeCommandPaletteCommandsWithFF", () => $722129adcc40ffe3$export$77d9c831a8af7615);

var $eJOHy = parcelRequire("eJOHy");

var $bJscI = parcelRequire("bJscI");

var $5vQ2T = parcelRequire("5vQ2T");

var $2qV1B = parcelRequire("2qV1B");

var $1Or1i = parcelRequire("1Or1i");

var $jcY6n = parcelRequire("jcY6n");
const $722129adcc40ffe3$export$6241f4da0c01b11b = ()=>{
    const { loading: loading, jiraCommand: jiraCommand, fullPageModules: fullPageModules } = (0, $2qV1B.useForgeCommandPaletteModules)();
    if (loading) return null;
    if (!jiraCommand) return null;
    const pageCommands = jiraCommand.filter((extension)=>'page' in extension.properties.target);
    const modalCommands = jiraCommand.filter((extension)=>'resource' in extension.properties.target);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, pageCommands && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Or1i.ForgeLinkCommands), {
        commands: pageCommands,
        pageModules: fullPageModules
    }), modalCommands && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jcY6n.ForgeModalCommands), {
        commands: modalCommands
    }));
};
const $722129adcc40ffe3$export$303419414ed8f11b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "forge-compal",
        teamName: "tomatoes",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($722129adcc40ffe3$export$6241f4da0c01b11b, null));
const $722129adcc40ffe3$export$77d9c831a8af7615 = (0, $bJscI.componentWithFG)('forge-command-palette', $722129adcc40ffe3$export$303419414ed8f11b, ()=>null);

});
parcelRegister("2qV1B", function(module, exports) {
$parcel$export(module.exports, "useForgeCommandPaletteModules", () => $d5d6ee872147fb6d$export$21e295f0cacdf3f2);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $eLqdN = parcelRequire("eLqdN");

var $fohjD = parcelRequire("fohjD");

var $5KBwc = parcelRequire("5KBwc");

var $cHtIB = parcelRequire("cHtIB");

var $kh7bJ = parcelRequire("kh7bJ");

var $3hRxq = parcelRequire("3hRxq");
const $d5d6ee872147fb6d$var$jiraForgeLocalStorage = (0, $3hRxq.createLocalStorageProvider)('jira-forge-compal');
const $d5d6ee872147fb6d$var$MODULES_TO_FETCH = [
    (0, $fohjD.COMMAND_PALETTE_MODULE),
    (0, $fohjD.GLOBAL_PAGE_MODULE),
    (0, $fohjD.ADMIN_PAGE_MODULE),
    (0, $fohjD.PROJECT_PAGE_MODULE),
    (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE),
    (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE),
    (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE)
];
const $d5d6ee872147fb6d$export$21e295f0cacdf3f2 = ()=>{
    const cloudId = (0, $cHtIB.useCloudId)();
    const isAnonymous = (0, $kh7bJ.useIsAnonymous)();
    const [{ isOpen: isOpen }] = (0, $g51Bg.useCommandPalette)();
    const request = (0, $eJOHy.useCallback)(()=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            types: $d5d6ee872147fb6d$var$MODULES_TO_FETCH,
            isAnonymous: isAnonymous,
            includeHidden: false,
            context: {}
        }), [
        cloudId,
        isAnonymous
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $eLqdN.useService)(request);
    (0, $eJOHy.useEffect)(()=>{
        if (!isOpen) return;
        const cachedData = $d5d6ee872147fb6d$var$getCachedData();
        if (cachedData) return;
        fetch().then((newData)=>{
            if (newData) $d5d6ee872147fb6d$var$jiraForgeLocalStorage.set($d5d6ee872147fb6d$export$7b9c2315e94d8d2f, JSON.stringify({
                data: newData,
                timestamp: Date.now()
            }));
        });
    }, [
        fetch,
        isOpen
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        if (!data) return {
            loading: loading,
            error: error,
            jiraCommand: [],
            fullPageModules: []
        };
        const { 'jira:command': jiraCommand, ...fullPageModules } = data;
        return {
            jiraCommand: jiraCommand,
            fullPageModules: Object.values(fullPageModules).flat(),
            loading: loading,
            error: error
        };
    }, [
        data,
        error,
        loading
    ]);
};
const $d5d6ee872147fb6d$export$7b9c2315e94d8d2f = 'forge-compal-modules-cache';
const $d5d6ee872147fb6d$var$CACHE_EXPIRY = 30000; // 30 seconds
const $d5d6ee872147fb6d$var$getCachedData = ()=>{
    const cached = $d5d6ee872147fb6d$var$jiraForgeLocalStorage.get($d5d6ee872147fb6d$export$7b9c2315e94d8d2f);
    if (cached) {
        const { data: data, timestamp: timestamp } = JSON.parse(cached);
        if (Date.now() - timestamp < $d5d6ee872147fb6d$var$CACHE_EXPIRY) return data;
    }
    return null;
};

});
parcelRegister("5KBwc", function(module, exports) {
$parcel$export(module.exports, "fetchModules", () => $90fa207631d927ef$export$24d8e11b15325c53);

var $jNLTH = parcelRequire("jNLTH");

var $j4oe4 = parcelRequire("j4oe4");

var $4cTDP = parcelRequire("4cTDP");

var $a1pDt = parcelRequire("a1pDt");

var $ayoPl = parcelRequire("ayoPl");

var $9gq2c = parcelRequire("9gq2c");

var $b6ojT = parcelRequire("b6ojT");

var $fohjD = parcelRequire("fohjD");

var $7zZ4w = parcelRequire("7zZ4w");

var $jNLTH = parcelRequire("jNLTH");

var $lB0Td = parcelRequire("lB0Td");

var $TUft0 = parcelRequire("TUft0");

var $aiU3I = parcelRequire("aiU3I");
const $90fa207631d927ef$export$24d8e11b15325c53 = async (params)=>{
    const { types: types, cloudId: cloudId, isAnonymous: isAnonymous, source: source = (0, $fohjD.SOURCE_UNKNOWN) } = params;
    if (!(0, $lB0Td.canFetchForgeModules)({
        cloudId: cloudId,
        isAnonymous: isAnonymous
    })) return (0, $TUft0.toMappedExtensions)(types, []);
    try {
        const extensions = await (0, $ayoPl.measureExecutionTimeMetrics)(()=>$90fa207631d927ef$export$9f9fdbce0829073d(params));
        if (Math.random() * 100 < (0, $9gq2c.FORGE_SAMPLING_RATE)) (0, $b6ojT.fireInitializationFetchFinishedEvent)(source);
        return (0, $TUft0.toMappedExtensions)(types, extensions);
    } catch (error) {
        const errorType = (0, $a1pDt.getErrorType)(error);
        (0, $b6ojT.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        if ($90fa207631d927ef$export$458cbcb6374269d2.includes(errorType)) return (0, $TUft0.toMappedExtensions)(types, []);
        throw error;
    }
};
function $90fa207631d927ef$export$9f9fdbce0829073d(props) {
    // includeScopes is true by default to enable decoupling scopes from forge app
    const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = true } = props;
    if (types.length === 0) throw new Error('No modules to fetch provided');
    const operationName = (0, $jNLTH.default).params.name;
    const { stopGraphQLErrorTracking: stopGraphQLErrorTracking, getGraphQLError: getGraphQLError } = (0, $aiU3I.trackGraphQLErrors)(operationName);
    let extensions;
    return new Promise((resolve, reject)=>{
        const subscription = (0, $j4oe4.fetchQuery)((0, $7zZ4w.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $jNLTH.default), /* eslint-enable @atlassian/relay/unused-fields */ {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes,
            includeModuleId: (0, $4cTDP.fg)('forge-extensions-module-id-for-relay')
        }).subscribe({
            next: (response)=>{
                stopGraphQLErrorTracking();
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const responseExtensions = response.jira?.forge?.extensions;
                // @ts-expect-error - TODO: new genereated type is incompatible with it
                extensions = responseExtensions?.concat().map((ext)=>({
                        ...ext,
                        moduleId: ext.moduleId ?? null
                    })) || null;
            },
            error: (error)=>{
                stopGraphQLErrorTracking();
                reject(error);
                subscription.unsubscribe();
            },
            complete: ()=>{
                // If there is a GraphQL error and extensions are `null`, it means a critical error has happened, and we have to reject the promise.
                // However, if the list of extensions is present in the response, it shouldn't be considered an error.
                const graphQLError = getGraphQLError();
                if (graphQLError) extensions != null ? resolve(extensions || []) : reject(graphQLError);
                else resolve(extensions || []);
                subscription.unsubscribe();
            }
        });
    });
}
const $90fa207631d927ef$export$458cbcb6374269d2 = [
    (0, $a1pDt.FAILED_TO_FETCH),
    (0, $a1pDt.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
    (0, $a1pDt.DATA_CLASSIFICATION_NO_ACCESS)
];

});
parcelRegister("jNLTH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d74065d4e27f303$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<463943aee983fc126f5370d765a8751e>>
 * @relayHash 2db705908fb7ae6ea6c5baa7d6869971
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e3998a2b80f7ce45338ea81f0d72cd7081b5a2168e78a5fe88be51536bfd04a8
const $6d74065d4e27f303$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeModuleId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeScopes"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "condition": "includeHidden",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeScopes",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "condition": "includeModuleId",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "moduleId"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "concreteType": "JiraUserAppAccess",
                                    "kind": "LinkedField",
                                    "name": "userAccess",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasAccess"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "inScopeEUD"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                    "kind": "LinkedField",
                                    "name": "installationConfig",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "id": "e3998a2b80f7ce45338ea81f0d72cd7081b5a2168e78a5fe88be51536bfd04a8",
            "metadata": {},
            "name": "doFetchWithGraphQLErrorsTrackingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6d74065d4e27f303$var$node.hash = "ca4e63c9dc9ed48bca68759cbd53c29a";
var $6d74065d4e27f303$export$2e2bcd8739ae039 = $6d74065d4e27f303$var$node;

});

parcelRegister("ayoPl", function(module, exports) {
$parcel$export(module.exports, "measureExecutionTimeMetrics", () => $8f610b55c617371f$export$a859f6866f4653e0);

var $aXKmr = parcelRequire("aXKmr");

var $9gq2c = parcelRequire("9gq2c");

var $lHD3D = parcelRequire("lHD3D");
const $8f610b55c617371f$export$a859f6866f4653e0 = async (action)=>{
    const concurrentId = (0, $aXKmr.v4)();
    const shouldSendTimeMetric = Math.random() * 100 < (0, $9gq2c.FORGE_SAMPLING_RATE);
    try {
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).start({
            startTime: performance.now()
        });
        const result = await action();
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).stop({
            stopTime: performance.now()
        });
        return result;
    } catch (error) {
        if (shouldSendTimeMetric) (0, $lHD3D.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
        throw error;
    }
};

});

parcelRegister("b6ojT", function(module, exports) {
$parcel$export(module.exports, "fireInitializationFetchFinishedEvent", () => $b46b77cba3fc4937$export$132ca822850e455f);
$parcel$export(module.exports, "fireInitializationFetchFailedEvent", () => $b46b77cba3fc4937$export$b5ca88b1053f1ad0);

var $5IiZP = parcelRequire("5IiZP");

var $1GZq2 = parcelRequire("1GZq2");
const $b46b77cba3fc4937$var$INITIALIZATION_ACTIONS = {
    STARTED: 'started',
    FINISHED: 'finished',
    FAILED: 'failed'
};
const $b46b77cba3fc4937$export$917d0643b0111a02 = (0, $5IiZP.toEventId)('issueViewInitialization');
const $b46b77cba3fc4937$export$43e875fd63e64525 = (0, $5IiZP.toEventId)('fetchModulesInitialization');
const $b46b77cba3fc4937$export$132ca822850e455f = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $b46b77cba3fc4937$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $b46b77cba3fc4937$export$43e875fd63e64525,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$e914f7df1e4ad79b = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FINISHED, {
        id: $b46b77cba3fc4937$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });
const $b46b77cba3fc4937$export$b274c658390b491b = (source, attributes)=>(0, $1GZq2.fireInitializationEvent)($b46b77cba3fc4937$var$INITIALIZATION_ACTIONS.FAILED, {
        id: $b46b77cba3fc4937$export$917d0643b0111a02,
        source: source,
        attributes: attributes
    });

});

parcelRegister("aiU3I", function(module, exports) {
$parcel$export(module.exports, "trackGraphQLErrors", () => $0e4de19c3dd7a13b$export$a5c00ff206a4c88b);

var $g1oKu = parcelRequire("g1oKu");

var $5Z6L0 = parcelRequire("5Z6L0");

var $jHI6h = parcelRequire("jHI6h");
function $0e4de19c3dd7a13b$export$a5c00ff206a4c88b(operationName) {
    const queryId = (0, $g1oKu.startCaptureGraphQlErrors)();
    (0, $jHI6h.startCapturingTraceIds)(operationName);
    return {
        stopGraphQLErrorTracking: ()=>(0, $jHI6h.stopCapturingTraceIds)(operationName),
        getGraphQLError: ()=>$0e4de19c3dd7a13b$var$getGraphQLError(queryId, operationName)
    };
}
function $0e4de19c3dd7a13b$var$getGraphQLError(key, operationName) {
    const errors = (0, $g1oKu.stopCaptureGraphQlErrors)(key).filter((errorWrapper)=>errorWrapper.meta.operationName === operationName).flatMap((errorWrapper)=>errorWrapper.errors);
    if (errors.length) return new (0, $5Z6L0.TrackedGraphQLError)(`Query ${operationName} had graphql errors`, errors, (0, $jHI6h.getTraceIds)(operationName));
    return undefined;
}

});



parcelRegister("1Or1i", function(module, exports) {
$parcel$export(module.exports, "ForgeLinkCommands", () => $01e9a00e2982b7b6$export$7a4b28a9f4469c71);

var $eJOHy = parcelRequire("eJOHy");

var $ePxSL = parcelRequire("ePxSL");

var $1Zcfy = parcelRequire("1Zcfy");

var $hf4h9 = parcelRequire("hf4h9");

var $2aY2d = parcelRequire("2aY2d");

var $83DiZ = parcelRequire("83DiZ");

var $4cTDP = parcelRequire("4cTDP");

var $3y7H4 = parcelRequire("3y7H4");

var $7votZ = parcelRequire("7votZ");

var $7PHxd = parcelRequire("7PHxd");
const $01e9a00e2982b7b6$export$7a4b28a9f4469c71 = ({ commands: commands, pageModules: pageModules })=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const commandsWithActions = (0, $eJOHy.useMemo)(()=>$01e9a00e2982b7b6$export$1bd5700c2fc72e18({
            commands: commands,
            projectContextData: projectContextData,
            push: push,
            pageModules: pageModules
        }), [
        commands,
        pageModules,
        projectContextData,
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7votZ.RegisterForgeCommands), {
        commands: commandsWithActions
    });
};
const $01e9a00e2982b7b6$export$1bd5700c2fc72e18 = ({ commands: commands, projectContextData: projectContextData, push: push, pageModules: pageModules })=>{
    return commands.map((extension)=>{
        const { id: rawCommandPaletteExtensionId, properties: properties } = extension;
        const { title: title, keywords: keywords, shortcut: shortcut, icon: icon, target: target } = properties;
        const LeftIcon = (0, $3y7H4.FORGE_COMMAND_PALETTE_ICON_MAP)[icon];
        const components = LeftIcon ? {
            LeftIcon: LeftIcon
        } : {
            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                    label: "",
                    "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                })
        };
        return {
            id: rawCommandPaletteExtensionId,
            title: title,
            section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).forge,
            icon: icon,
            keywords: keywords?.join(' '),
            shortcut: shortcut,
            name: title,
            components: components,
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>{
                    const matchingPageModule = (0, $7PHxd.findMatchingModule)({
                        pageModules: pageModules,
                        rawCommandPaletteExtensionId: rawCommandPaletteExtensionId,
                        target: target
                    });
                    if (!matchingPageModule) return null;
                    (0, $7PHxd.navigateToPage)({
                        pageModule: matchingPageModule,
                        push: push,
                        projectContext: projectContextData
                    });
                }
            }
        };
    });
};

});
parcelRegister("3y7H4", function(module, exports) {
$parcel$export(module.exports, "FORGE_COMMAND_PALETTE_ICON_MAP", () => $09d5649fbc23ace7$export$8ba7c361aaaf5df0);

var $dcLzM = parcelRequire("dcLzM");

var $ePxSL = parcelRequire("ePxSL");

var $ac080 = parcelRequire("ac080");

var $lGr6J = parcelRequire("lGr6J");

var $5SdQs = parcelRequire("5SdQs");

var $gTr6H = parcelRequire("gTr6H");

var $jvbqF = parcelRequire("jvbqF");

var $dCT0T = parcelRequire("dCT0T");

var $bRsun = parcelRequire("bRsun");

var $DtmfJ = parcelRequire("DtmfJ");

var $gNUuP = parcelRequire("gNUuP");

var $4F5bb = parcelRequire("4F5bb");

var $fwcMD = parcelRequire("fwcMD");
const $09d5649fbc23ace7$export$8ba7c361aaaf5df0 = {
    add: (0, (/*@__PURE__*/$parcel$interopDefault($dcLzM))),
    'arrow-right': (0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))),
    copy: (0, (/*@__PURE__*/$parcel$interopDefault($lGr6J))),
    open: (0, (/*@__PURE__*/$parcel$interopDefault($ac080))),
    page: (0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))),
    edit: (0, (/*@__PURE__*/$parcel$interopDefault($gTr6H))),
    'user-avatar': (0, (/*@__PURE__*/$parcel$interopDefault($gNUuP))),
    activity: (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs))),
    settings: (0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))),
    undo: (0, (/*@__PURE__*/$parcel$interopDefault($fwcMD))),
    document: (0, (/*@__PURE__*/$parcel$interopDefault($jvbqF))),
    'notification-direct': (0, (/*@__PURE__*/$parcel$interopDefault($bRsun))),
    folder: (0, (/*@__PURE__*/$parcel$interopDefault($dCT0T)))
};

});
parcelRegister("ac080", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2228fa01b7e8b5ee470ffc60df47923d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76bb1fce06e44d9d$var$_react = $76bb1fce06e44d9d$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $76bb1fce06e44d9d$var$_baseNew = $76bb1fce06e44d9d$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $76bb1fce06e44d9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUpRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76bb1fce06e44d9d$var$ArrowUpRightIcon = (props)=>/*#__PURE__*/ $76bb1fce06e44d9d$var$_react.default.createElement($76bb1fce06e44d9d$var$_baseNew.default, Object.assign({
        name: "ArrowUpRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.47 12.47 9.75-9.75 1.06 1.06-9.75 9.75z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M12 4H5.75V2.5h7a.75.75 0 0 1 .75.75v7H12z" clip-rule="evenodd"/>`
    }, props));
$76bb1fce06e44d9d$var$ArrowUpRightIcon.displayName = 'ArrowUpRightIcon';
var $76bb1fce06e44d9d$var$_default = module.exports.default = $76bb1fce06e44d9d$var$ArrowUpRightIcon;

});

parcelRegister("jvbqF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::51c2fad80696a752d051082f1f9faaf4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e329c724a11ab833$var$_react = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e329c724a11ab833$var$_baseNew = $e329c724a11ab833$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e329c724a11ab833$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e329c724a11ab833$var$FileIcon = (props)=>/*#__PURE__*/ $e329c724a11ab833$var$_react.default.createElement($e329c724a11ab833$var$_baseNew.default, Object.assign({
        name: "FileIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e329c724a11ab833$var$FileIcon.displayName = 'FileIcon';
var $e329c724a11ab833$var$_default = module.exports.default = $e329c724a11ab833$var$FileIcon;

});

parcelRegister("dCT0T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::329ffe53264930b81eb140b6c3cd31f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9eb97f7a872c0087$var$_react = $9eb97f7a872c0087$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $9eb97f7a872c0087$var$_baseNew = $9eb97f7a872c0087$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $9eb97f7a872c0087$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9eb97f7a872c0087$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $9eb97f7a872c0087$var$_react.default.createElement($9eb97f7a872c0087$var$_baseNew.default, Object.assign({
        name: "FolderClosedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$9eb97f7a872c0087$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $9eb97f7a872c0087$var$_default = module.exports.default = $9eb97f7a872c0087$var$FolderClosedIcon;

});

parcelRegister("fwcMD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd1cfcbb5080c9044de22389be7f741e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4c3c2af49004355$var$_react = $b4c3c2af49004355$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $b4c3c2af49004355$var$_baseNew = $b4c3c2af49004355$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $b4c3c2af49004355$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4c3c2af49004355$var$UndoIcon = (props)=>/*#__PURE__*/ $b4c3c2af49004355$var$_react.default.createElement($b4c3c2af49004355$var$_baseNew.default, Object.assign({
        name: "UndoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$b4c3c2af49004355$var$UndoIcon.displayName = 'UndoIcon';
var $b4c3c2af49004355$var$_default = module.exports.default = $b4c3c2af49004355$var$UndoIcon;

});


parcelRegister("7votZ", function(module, exports) {
$parcel$export(module.exports, "RegisterForgeCommands", () => $b86e81850a1d4a4a$export$cc0cc5320637090e);

var $eJOHy = parcelRequire("eJOHy");

var $fo3wk = parcelRequire("fo3wk");

var $fWwfy = parcelRequire("fWwfy");

var $73jrx = parcelRequire("73jrx");

var $cQLh3 = parcelRequire("cQLh3");
const $b86e81850a1d4a4a$export$cc0cc5320637090e = ({ commands: commands })=>{
    if (commands?.length === 0 || !commands) return null;
    const commandsWithShortcut = commands.filter((command)=>command.shortcut);
    if (commandsWithShortcut.length === 0) return null;
    /**
	 * As commands is an object, it changes at every render.
	 * To memoise the commands properly in the command palette
	 * the ids are stringified and add as a dependency of the effect
	 */ const commandIds = commands.map(({ id: id })=>id).toString();
    const keyMap = (0, $cQLh3.mapCommandsToShortcuts)(commandsWithShortcut);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, keyMap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fo3wk.default), {
        keyMap: keyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $73jrx.RegisterCommands), {
        commands: commands,
        registrationId: (0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).COPY_URL,
        deps: [
            commandIds
        ]
    }));
};

});
parcelRegister("73jrx", function(module, exports) {
$parcel$export(module.exports, "RegisterCommands", () => $54ccbd2a3c61da6a$export$cd555833c78729f1);

var $eJOHy = parcelRequire("eJOHy");

var $3DnU9 = parcelRequire("3DnU9");
const $54ccbd2a3c61da6a$export$cd555833c78729f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3DnU9.RegisterCommandsWithRegistry), props);

});
parcelRegister("3DnU9", function(module, exports) {
$parcel$export(module.exports, "RegisterCommandsWithRegistry", () => $c82e68fcec934ed3$export$b8955a01360d2876);

var $cQKVu = parcelRequire("cQKVu");
function $c82e68fcec934ed3$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
    (0, $cQKVu.useRegisterCommandsWithRegistry)(registrationId, commands, deps);
    return null;
}

});


parcelRegister("cQLh3", function(module, exports) {
$parcel$export(module.exports, "mapCommandsToShortcuts", () => $8fdd97fcb5d79a6e$export$495c3f0cdb073927);
function $8fdd97fcb5d79a6e$export$495c3f0cdb073927(commandsWithShortcut) {
    if (!Array.isArray(commandsWithShortcut)) return null;
    if (commandsWithShortcut.length === 0) return null;
    const commandWithShortcut = commandsWithShortcut.filter((command)=>command.shortcut);
    const initialValue = {};
    return commandWithShortcut.reduce((acc, command)=>{
        acc[command.shortcut] = {
            callback: ()=>{
                command.primaryAction.perform();
            },
            registerInCommandPalette: {
                section: command.section,
                name: command.name,
                components: command.components
            }
        };
        return acc;
    }, initialValue);
}

});


parcelRegister("7PHxd", function(module, exports) {
$parcel$export(module.exports, "findMatchingModule", () => $102a143eec0e8961$export$33158950c8814dc2);
$parcel$export(module.exports, "navigateToPage", () => $102a143eec0e8961$export$c515cccf018994b3);

var $ezmKu = parcelRequire("ezmKu");

var $ePLco = parcelRequire("ePLco");

var $bTfs5 = parcelRequire("bTfs5");

var $2qjvD = parcelRequire("2qjvD");

var $lL0Pt = parcelRequire("lL0Pt");

var $bnptD = parcelRequire("bnptD");

var $lusn0 = parcelRequire("lusn0");

var $kAWUp = parcelRequire("kAWUp");

var $gars4 = parcelRequire("gars4");

var $5AUSA = parcelRequire("5AUSA");

var $3Thdh = parcelRequire("3Thdh");

var $b1IkX = parcelRequire("b1IkX");

var $4PPl0 = parcelRequire("4PPl0");

var $fDVia = parcelRequire("fDVia");
const $102a143eec0e8961$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $102a143eec0e8961$export$33158950c8814dc2 = ({ pageModules: pageModules, target: target, rawCommandPaletteExtensionId: rawCommandPaletteExtensionId })=>pageModules.find((page)=>{
        if (!('page' in target)) return false;
        const commandPaletteExtensionId = (0, $ezmKu.parseExtensionId)(rawCommandPaletteExtensionId);
        const { appId: appId, environmentId: environmentId, moduleKey: moduleKey } = (0, $ezmKu.parseExtensionId)(page.id);
        const isExtensionMatch = appId === commandPaletteExtensionId.appId && environmentId === commandPaletteExtensionId.environmentId && moduleKey === target.page;
        return isExtensionMatch;
    });
const $102a143eec0e8961$var$navigateToPageOldNav = ({ pageModule: pageModule, push: push, projectContext: projectContext })=>{
    switch(pageModule.type){
        case 'jira:adminPage':
            push((0, $bTfs5.getItemHref)(pageModule));
            break;
        case 'jira:projectPage':
            if (!projectContext) break;
            push((0, $2qjvD.getItemHref)(pageModule, projectContext.projectType, projectContext.projectKey));
            break;
        case 'jira:globalPage':
            push((0, $kAWUp.getItemHref)(pageModule));
            break;
        case 'jira:projectSettingsPage':
            if (!projectContext) break;
            push((0, $lusn0.getItemHref)(pageModule, projectContext.projectType, projectContext.projectKey));
            break;
        case 'jira:personalSettingsPage':
            push((0, $lL0Pt.getItemHref)(pageModule));
            break;
        case 'jiraServiceManagement:queuePage':
            if (!projectContext) break;
            push((0, $bnptD.getItemHref)(pageModule, projectContext.projectKey));
            break;
        default:
            // This has no impact on runtime but whenever new page module will be added this will fail and will require to handle that case
            pageModule;
            break;
    }
};
const $102a143eec0e8961$export$ce33e03cb3231314 = ({ pageModule: pageModule, push: push, projectContext: projectContext })=>{
    switch(pageModule.type){
        case 'jira:adminPage':
            push((0, $gars4.getItemHref)(pageModule));
            break;
        case 'jira:projectPage':
            if (!projectContext) break;
            push((0, $5AUSA.getItemHref)(pageModule, projectContext.projectType, projectContext.projectKey));
            break;
        case 'jira:globalPage':
            push((0, $kAWUp.getItemHref)(pageModule));
            break;
        case 'jira:projectSettingsPage':
            if (!projectContext) break;
            push((0, $4PPl0.getItemHref)(pageModule, projectContext.projectType, projectContext.projectKey));
            break;
        case 'jira:personalSettingsPage':
            push((0, $3Thdh.getItemHref)(pageModule));
            break;
        case 'jiraServiceManagement:queuePage':
            if (!projectContext) break;
            push((0, $b1IkX.getItemHref)(pageModule, projectContext.projectKey));
            break;
        default:
            // This has no impact on runtime but whenever new page module will be added this will fail and will require to handle that case
            pageModule;
            break;
    }
};
const $102a143eec0e8961$export$c515cccf018994b3 = (0, $fDVia.functionWithFF)(// TODO: Find this ff out
'forge-command-palette', $102a143eec0e8961$export$ce33e03cb3231314, $102a143eec0e8961$var$navigateToPageOldNav);

});
parcelRegister("ezmKu", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $e9a4e064bdee1059$export$bae42cbaf7fa3e1b);

var $63yBZ = parcelRequire("63yBZ");
const $e9a4e064bdee1059$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $63yBZ.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("63yBZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dnskZ = parcelRequire("dnskZ");

var $ik6eF = parcelRequire("ik6eF");

$dnskZ.__exportStar((parcelRequire("jWqQq")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $468ddf0950beb311$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $468ddf0950beb311$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $468ddf0950beb311$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $468ddf0950beb311$var$InvalidAriError;
function $468ddf0950beb311$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $468ddf0950beb311$var$basicCharConstraint = $ik6eF.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $468ddf0950beb311$var$resourceTypeCharConstraints = $ik6eF.pattern(/^[a-z][a-z.-]*$/i);
const $468ddf0950beb311$var$resourceOwnerConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$basicCharConstraint
];
const $468ddf0950beb311$var$resourceTypeConstraints = [
    $ik6eF.lengthBetween(3, 255),
    $468ddf0950beb311$var$resourceTypeCharConstraints
];
const $468ddf0950beb311$var$cloudIdConstraints = [
    $ik6eF.lengthBetween(3, 255)
];
const $468ddf0950beb311$var$siteResourceType = 'site';
const $468ddf0950beb311$var$resourceIdChars = /[\w-._~:@#]/.source;
const $468ddf0950beb311$var$resourceIdConstraints = [
    $ik6eF.pattern(new RegExp(`^${$468ddf0950beb311$var$resourceIdChars}+(/${$468ddf0950beb311$var$resourceIdChars}*)*(;v=${$468ddf0950beb311$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $468ddf0950beb311$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $468ddf0950beb311$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $468ddf0950beb311$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $468ddf0950beb311$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $468ddf0950beb311$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $468ddf0950beb311$var$InvalidAriError(ariString);
        return new $468ddf0950beb311$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $468ddf0950beb311$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $468ddf0950beb311$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $468ddf0950beb311$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $468ddf0950beb311$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $468ddf0950beb311$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $468ddf0950beb311$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $468ddf0950beb311$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $468ddf0950beb311$var$siteResourceType && !!other.resourceType || $468ddf0950beb311$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $468ddf0950beb311$var$siteResourceType && !cloudId) return new $ik6eF.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'resourceOwner', $468ddf0950beb311$var$resourceOwnerConstraints),
            $ik6eF.validateField(this, 'resourceType', $468ddf0950beb311$var$resourceTypeConstraints),
            $ik6eF.validateField(this, 'resourceId', $468ddf0950beb311$var$resourceIdConstraints),
            $ik6eF.validateField(this, 'cloudId', $468ddf0950beb311$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $468ddf0950beb311$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $468ddf0950beb311$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $468ddf0950beb311$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parse(ariString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $468ddf0950beb311$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $468ddf0950beb311$var$parseEncoded(encodedAriString) {
    return $468ddf0950beb311$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $468ddf0950beb311$var$parseEncoded;

});
parcelRegister("ik6eF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eDoz3 = parcelRequire("eDoz3");
class $d56eee7d06fcc64a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $d56eee7d06fcc64a$var$LengthConstraint;
class $d56eee7d06fcc64a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $d56eee7d06fcc64a$var$RegexConstraint;
class $d56eee7d06fcc64a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $d56eee7d06fcc64a$var$GeneralValidationError;
class $d56eee7d06fcc64a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $d56eee7d06fcc64a$var$ConstraintViolation;
function $d56eee7d06fcc64a$var$lengthBetween(min, max) {
    return new $d56eee7d06fcc64a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $d56eee7d06fcc64a$var$lengthBetween;
function $d56eee7d06fcc64a$var$pattern(regex) {
    return new $d56eee7d06fcc64a$var$RegexConstraint(regex);
}
module.exports.pattern = $d56eee7d06fcc64a$var$pattern;
function $d56eee7d06fcc64a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($eDoz3.isDefined);
    return violatedConstraints.length > 0 ? new $d56eee7d06fcc64a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $d56eee7d06fcc64a$var$validateField;

});
parcelRegister("eDoz3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $aa77c3314e9d9437$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $aa77c3314e9d9437$var$isPresent;
function $aa77c3314e9d9437$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $aa77c3314e9d9437$var$isDefined;
function $aa77c3314e9d9437$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $aa77c3314e9d9437$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $aa77c3314e9d9437$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $aa77c3314e9d9437$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $aa77c3314e9d9437$var$hasValueAtKey;

});


parcelRegister("jWqQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4ZFVe = parcelRequire("4ZFVe");
var $e84841da69f5e74e$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($e84841da69f5e74e$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $e84841da69f5e74e$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $e84841da69f5e74e$var$AppFamilyAriError;
class $e84841da69f5e74e$var$NotAppFamilyAriError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $e84841da69f5e74e$var$NotAppFamilyAriError;
class $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError extends $e84841da69f5e74e$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $e84841da69f5e74e$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $e84841da69f5e74e$var$parseAppAri(ari) {
    return $4ZFVe.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $e84841da69f5e74e$var$parseAppAri;
function $e84841da69f5e74e$var$createAppAri(json) {
    return new $4ZFVe.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $e84841da69f5e74e$var$createAppAri;

});
parcelRegister("4ZFVe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jWqQq = parcelRequire("jWqQq");

var $63yBZ = parcelRequire("63yBZ");

var $ik6eF = parcelRequire("ik6eF");
const $3a2d60ca363a4626$var$versionPrefix = ';v=';
const $3a2d60ca363a4626$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $3a2d60ca363a4626$var$uuidConstraints = [
    $ik6eF.pattern(new RegExp(`^${$3a2d60ca363a4626$var$uuidRegExpString}$`, 'i'))
];
const $3a2d60ca363a4626$var$extensionGroupIdConstraints = [
    $ik6eF.pattern(new RegExp(`^(${$3a2d60ca363a4626$var$uuidRegExpString}|static)$`, 'i'))
];
class $3a2d60ca363a4626$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $jWqQq.AppFamilyAri.resourceOwner) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$jWqQq.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $jWqQq.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $jWqQq.NotAppFamilyAriError(ari, `resourceType must be one of ${$jWqQq.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $jWqQq.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($3a2d60ca363a4626$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($3a2d60ca363a4626$var$versionPrefix) > versionIndex) throw new $jWqQq.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($3a2d60ca363a4626$var$versionPrefix);
        const segments = mainResourceId.split('/').map($3a2d60ca363a4626$var$stripToUndefined);
        if (segments.length > 4) throw new $jWqQq.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $jWqQq.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType || resourceType === $jWqQq.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $jWqQq.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$jWqQq.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $jWqQq.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $jWqQq.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$jWqQq.AppFamilyAri.environmentResourceType}`);
        return new $3a2d60ca363a4626$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $jWqQq.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $ik6eF.validateField(this, 'environmentId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'appId', $3a2d60ca363a4626$var$uuidConstraints),
            $ik6eF.validateField(this, 'extensionGroupId', $3a2d60ca363a4626$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $63yBZ.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $jWqQq.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$3a2d60ca363a4626$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $63yBZ.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $jWqQq.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $3a2d60ca363a4626$var$AppFamilyAriImpl;
function $3a2d60ca363a4626$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("bTfs5", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $68a3102da3fb02be$export$ed6342e0e28465a6);
$parcel$export(module.exports, "default", () => $68a3102da3fb02be$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");

var $aeOhE = parcelRequire("aeOhE");

var $g3Q1G = parcelRequire("g3Q1G");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $lRq8t = parcelRequire("lRq8t");

var $bOOEr = parcelRequire("bOOEr");

var $cIeoi = parcelRequire("cIeoi");

var $2D0O0 = parcelRequire("2D0O0");

var $jwDMz = parcelRequire("jwDMz");
const $68a3102da3fb02be$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/settings/apps/${appId}/${envId}`;
};
const $68a3102da3fb02be$export$a70dd1f096fc6a5f = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: data } = (0, $2D0O0.useAdminForgeApps)();
    const pages = data?.adminPage ?? null;
    if (!pages?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $jwDMz.messages).forgeSectionTitle)
    }, pages.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bOOEr.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $68a3102da3fb02be$export$ed6342e0e28465a6(extension),
            name: extension.properties.title,
            sections: (0, $cIeoi.toSections)(extension),
            moduleName: (0, $fohjD.ADMIN_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.ADMIN_PAGE_MODULE)
        }
    }));
};
const $68a3102da3fb02be$var$ForgeAdminSectionWithTriggerAnalytics = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g3Q1G.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($68a3102da3fb02be$export$a70dd1f096fc6a5f, null));
var $68a3102da3fb02be$export$2e2bcd8739ae039 = $68a3102da3fb02be$var$ForgeAdminSectionWithTriggerAnalytics;

});
parcelRegister("diNYL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c44efaa9252dc1d8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $6YEko = parcelRequire("6YEko");

var $2eOKX = parcelRequire("2eOKX");
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $c44efaa9252dc1d8$var$Section = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6YEko.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $c44efaa9252dc1d8$export$2e2bcd8739ae039 = $c44efaa9252dc1d8$var$Section;

});

parcelRegister("g3Q1G", function(module, exports) {
$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $f243f016930b2cb2$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $f243f016930b2cb2$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $f243f016930b2cb2$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.ADMIN_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $f243f016930b2cb2$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.ADMIN_PAGE_MODULE),
        ...props,
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER)
    });

});

parcelRegister("bOOEr", function(module, exports) {
$parcel$export(module.exports, "ForgeSubpagesView", () => $c5634d45af064bd6$export$9711365f685f75c0);
$parcel$export(module.exports, "ForgeItem", () => $c5634d45af064bd6$export$26a5287439a1d287);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $kcLaf = parcelRequire("kcLaf");

var $diNYL = parcelRequire("diNYL");

var $iMZxW = parcelRequire("iMZxW");

var $dysoB = parcelRequire("dysoB");

var $6QqPe = parcelRequire("6QqPe");

var $G9fRP = parcelRequire("G9fRP");

var $gkhxF = parcelRequire("gkhxF");

var $8xDPn = parcelRequire("8xDPn");
const $c5634d45af064bd6$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $c5634d45af064bd6$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5634d45af064bd6$var$ForgeIcon, {
        alt: "",
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), {
        spacing: "spacious",
        label: ""
    });
const $c5634d45af064bd6$export$df3259e43d89ee7b = (props)=>{
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5634d45af064bd6$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        href: url,
        selectedOn: (0, $8xDPn.matchPartialUrlPathname)(),
        analytics: {
            itemId: itemId,
            itemType: 'forge',
            module: moduleName
        }
    }, (0, $iMZxW.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};
const $c5634d45af064bd6$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, $G9fRP.ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ForgePageHeader, {
        avatarUrl: iconUrl || '',
        name: name,
        environmentType: environmentType,
        environmentKey: environmentKey,
        nestedMenuActive: nestedMenuActive
    });
const $c5634d45af064bd6$export$9711365f685f75c0 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
    const selectedOn = (0, $eJOHy.useCallback)((route)=>[
            '',
            '/'
        ].includes(String(route || '').trim()) ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, $8xDPn.matchPartialUrlPathname)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5634d45af064bd6$var$ForgeSubpagesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5634d45af064bd6$export$961eebe0deda9ad3, props), sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
            key: index
        }, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6QqPe.SectionHeader), null, section.header) : null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dysoB.MenuItem), {
                key: page.route,
                iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5634d45af064bd6$export$f04a61298a47a40f, {
                    url: page.icon
                }) : null,
                href: $c5634d45af064bd6$export$9ffb311b483a1e2b(url, page.route),
                selectedOn: selectedOn(page.route),
                analytics: {
                    itemId: itemId,
                    itemType: 'forge',
                    module: moduleName
                }
            }, page.title)))));
};
const $c5634d45af064bd6$export$26a5287439a1d287 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
    const selectedOn = (0, $eJOHy.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
        url
    ]);
    const onNestedMenuItemClick = (0, $eJOHy.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
    }, [
        overrides
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5634d45af064bd6$export$df3259e43d89ee7b, props);
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5634d45af064bd6$export$9711365f685f75c0, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkhxF.NestingMenuItem), {
        analytics: {
            itemId: 'subpages'
        },
        id: `${itemId}-subpages`,
        iconBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5634d45af064bd6$export$f04a61298a47a40f, {
            url: iconUrl
        }) : null,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        title: (0, $iMZxW.nameWithCustomEnvironment)(name, environmentType, environmentKey),
        selectedOn: selectedOn,
        onClick: onNestedMenuItemClick,
        // @ts-expect-error - overrides types mismatch
        overrides: overrides
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c5634d45af064bd6$export$9711365f685f75c0, props));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c5634d45af064bd6$var$ForgeSubpagesContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_14tkpxbi _t3zcv47k _1so41gjq",
            __cmplp.className
        ])
    });
});
const $c5634d45af064bd6$var$ForgeIcon = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kcLaf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc410b5a6f105623fd92b95efc5298a4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb5983796d13f8e5$var$_react = $eb5983796d13f8e5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $eb5983796d13f8e5$var$_baseNew = $eb5983796d13f8e5$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $eb5983796d13f8e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "App".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for marketplace apps and integrations across apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eb5983796d13f8e5$var$AppIcon = (props)=>/*#__PURE__*/ $eb5983796d13f8e5$var$_react.default.createElement($eb5983796d13f8e5$var$_baseNew.default, Object.assign({
        name: "AppIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 5.208a.5.5 0 0 0-.243-.429l-5-3a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.43v5.583a.5.5 0 0 0 .243.429l5 3a.5.5 0 0 0 .514 0l5-3a.5.5 0 0 0 .243-.429zm1.5 5.584a2 2 0 0 1-.97 1.715l-5 3a2 2 0 0 1-2.06 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .97-1.715l5-3a2 2 0 0 1 2.06 0l5 3A2 2 0 0 1 15 5.208z"/><path fill="currentcolor" d="M9.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>`
    }, props));
$eb5983796d13f8e5$var$AppIcon.displayName = 'AppIcon';
var $eb5983796d13f8e5$var$_default = module.exports.default = $eb5983796d13f8e5$var$AppIcon;

});

parcelRegister("iMZxW", function(module, exports) {
$parcel$export(module.exports, "EnvironmentLozenge", () => $7f2b53f517ab6796$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $7f2b53f517ab6796$export$f9338c21ba7c7334);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $fohjD = parcelRequire("fohjD");

var $kDaaB = parcelRequire("kDaaB");

var $bh015 = parcelRequire("bh015");
const $7f2b53f517ab6796$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $fohjD.DEVELOPMENT_ENVIRONMENT:
            return (0, $bh015.messages).developmentEnvironmentLozenge;
        case 0, $fohjD.STAGING_ENVIRONMENT:
            return (0, $bh015.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $7f2b53f517ab6796$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $7f2b53f517ab6796$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $fohjD.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), labelKey)) : null;
};
const $7f2b53f517ab6796$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $fohjD.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $fohjD.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("bh015", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e5510659054de5bf$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e5510659054de5bf$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});


parcelRegister("dysoB", function(module, exports) {
$parcel$export(module.exports, "MenuItem", () => $af143be694f933c4$export$2ce376c2cc3355c8);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $3Q6BV = parcelRequire("3Q6BV");

var $4vQlI = parcelRequire("4vQlI");

var $c9uTK = parcelRequire("c9uTK");
var $gCY1z = parcelRequire("gCY1z");

var $8KWr1 = parcelRequire("8KWr1");

var $fZmSO = parcelRequire("fZmSO");
const $af143be694f933c4$var$cssVarPrefix = '--sidebar-menu-item';
const $af143be694f933c4$var$bgColorCssVar = `${$af143be694f933c4$var$cssVarPrefix}-bg-color`;
const $af143be694f933c4$var$bgColorHoverCssVar = `${$af143be694f933c4$var$cssVarPrefix}-bg-color-hover`;
const $af143be694f933c4$var$bgColorActiveCssVar = `${$af143be694f933c4$var$cssVarPrefix}-bg-color-active`;
const $af143be694f933c4$var$colorCssVar = `${$af143be694f933c4$var$cssVarPrefix}-color`;
const $af143be694f933c4$var$colorHoverCssVar = `${$af143be694f933c4$var$cssVarPrefix}-color-hover`;
const $af143be694f933c4$var$colorActiveCssVar = `${$af143be694f933c4$var$cssVarPrefix}-color-active`;
const $af143be694f933c4$var$boxShadowCssVar = `${$af143be694f933c4$var$cssVarPrefix}-box-shadow`;
const $af143be694f933c4$var$iconSecondaryColorHoverCssVar = `${$af143be694f933c4$var$cssVarPrefix}-icon-secondary-color-hover`;
const $af143be694f933c4$var$styles = {
    root: "_ow0718uv _vwjz18uv _el8t18uv _17rj1kw7 _1f981kw7 _12pi1kw7 _1iqunqa1 _6xf7nqa1 _1lwpnqa1 _144v1r31 _3m4d1r31 _epv21r31 _chl4glyw _1bblglyw _1xhsglyw _1txwidpf _fg45idpf _gmaiidpf _10fu1oxo _iozn1cd0 _1vzi1w2z _davf29yu _1lfucjiy _s3s5tlke _12pzh2mm",
    selected: "_1cmdaqb7",
    themeColorDefault: "_1w905hvc _zelm5hvc _1f1j5hvc _1cmd5hvc",
    themeColorHover: "_1fh1smn3",
    themeColorActive: "_1l5a14t4 _1gdc14t4 _g8mu14t4 _434t14t4",
    themeBgColorDefault: "_16hgrn9c",
    themeBgColorHover: "_u1mb58tq",
    themeBgColorActive: "_1lg618j6",
    themeIconSecondaryColorHover: "_1k5811db"
};
const $af143be694f933c4$var$WrapperComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: // @ts-expect-error - TS2339 - Property 'useButtonLink' does not exist on type 'CustomItemComponentProps & AnchorHTMLAttributes<HTMLAnchorElement> & { children: ReactNode; ... 10 more ...; prefetch?: false | ... 2 more ... | undefined; } & { ...; }'.
useButtonLink, ...props }, ref)=>{
    const commonProps = {
        ...props,
        children: children,
        className: `${className ?? ''} ${legacyClassName ?? ''}`
    };
    return href != null || to != null ? /*#__PURE__*/ $eJOHy.createElement((0, $c9uTK.Link), {
        ...commonProps,
        href: href,
        to: to,
        target: target,
        ref: ref,
        type: useButtonLink ? 'button' : 'a'
    }) : // @ts-expect-error Type 'HTMLAnchorElement | HTMLButtonElement | null' is not assignable to type 'HTMLButtonElement | null'
    /*#__PURE__*/ $eJOHy.createElement($af143be694f933c4$var$ButtonItem, {
        ...commonProps,
        type: "button",
        ref: ref
    });
});
const $af143be694f933c4$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, className: className, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
    const onClickHandler = (0, $fZmSO.useOnClick)({
        onClick: onClick,
        analytics: analytics
    });
    const [{ route: route, query: query, location: location }] = (0, $gCY1z.useRouter)();
    let isSelected;
    // Currently, because the CMP project settings are not part of the SPA, the whole sidebar reloads everytime a menu item
    // is clicked -> As part of the Lunar Project Settings improvements, we're scrolling selected items into view once the
    // page reloads.
    //
    // We're setting a timeout to wait for the event loop to complete prior to scrolling.
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
        if (isSelected && ref?.current != null) setTimeout(()=>{
            // using ref?.current doesn't seem to work specifically here
            // Flow complianed about this part here specifically :/
            ref && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current != null && // @ts-expect-error - TS2339 - Property 'current' does not exist on type 'MutableRefObject<any> | ((instance: any) => void)'.
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }, [
        selectedOn,
        ref,
        // @ts-expect-error - Variable 'isSelected' is used before being assigned.
        isSelected
    ]);
    if (typeof selectedOn === 'function') isSelected = route != null && // @ts-expect-error - Property 'search' is missing in type 'URLParse' but required in type 'MatcherLocation'.
    selectedOn({
        ...location,
        query: query
    }, (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(href || '/', true));
    else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
    const theme = (0, $8KWr1.useSidebarTheme)();
    const itemTheme = theme?.navigation?.item;
    const iconTheme = theme?.navigation?.icon;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customProps = {
        ...rest,
        component: $af143be694f933c4$var$WrapperComponent,
        href: href,
        isSelected: isSelected,
        onClick: onClickHandler,
        overrides: overrides,
        ref: ref,
        useButtonLink: useButtonLink,
        'aria-current': isSelected ? 'page' : undefined,
        style: {
            [$af143be694f933c4$var$bgColorCssVar]: itemTheme?.background?.default ?? undefined,
            [$af143be694f933c4$var$bgColorHoverCssVar]: itemTheme?.background?.hover ?? undefined,
            [$af143be694f933c4$var$bgColorActiveCssVar]: itemTheme?.background?.active ?? undefined,
            [$af143be694f933c4$var$colorCssVar]: itemTheme?.color?.default ?? undefined,
            [$af143be694f933c4$var$colorHoverCssVar]: itemTheme?.color?.hover ?? undefined,
            [$af143be694f933c4$var$colorActiveCssVar]: itemTheme?.color?.active ?? undefined,
            [$af143be694f933c4$var$boxShadowCssVar]: itemTheme?.color?.active != null ? `${itemTheme?.color?.active} 0 0 0 2px inset` : `${"var(--ds-border-focused, #388BFF)"} 0 0 0 2px inset`,
            [$af143be694f933c4$var$iconSecondaryColorHoverCssVar]: iconTheme?.secondary?.color?.hover ?? undefined
        }
    };
    if (overrides?.CustomItem?.render) return overrides?.CustomItem?.render({
        ...customProps,
        className: (0, $hcewu.default)([
            (0, $hcewu.default)([
                $af143be694f933c4$var$styles.root
            ]),
            isSelected && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.selected
            ]),
            itemTheme?.color?.default && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeColorDefault
            ]),
            itemTheme?.background?.default && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeBgColorDefault
            ]),
            itemTheme?.background?.hover && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeBgColorHover
            ]),
            itemTheme?.background?.active && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeBgColorActive
            ]),
            itemTheme?.color?.hover && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeColorHover
            ]),
            itemTheme?.color?.active && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeColorActive
            ]),
            iconTheme?.secondary?.color?.hover && (0, $hcewu.default)([
                $af143be694f933c4$var$styles.themeIconSecondaryColorHover
            ]),
            className
        ])
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $4vQlI.default), {
        ...customProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            $af143be694f933c4$var$styles.root,
            isSelected && $af143be694f933c4$var$styles.selected,
            itemTheme?.color?.default && $af143be694f933c4$var$styles.themeColorDefault,
            itemTheme?.background?.default && $af143be694f933c4$var$styles.themeBgColorDefault,
            itemTheme?.background?.hover && $af143be694f933c4$var$styles.themeBgColorHover,
            itemTheme?.background?.active && $af143be694f933c4$var$styles.themeBgColorActive,
            itemTheme?.color?.hover && $af143be694f933c4$var$styles.themeColorHover,
            itemTheme?.color?.active && $af143be694f933c4$var$styles.themeColorActive,
            iconTheme?.secondary?.color?.hover && $af143be694f933c4$var$styles.themeIconSecondaryColorHover,
            className
        ])
    });
});
// this should be same as ButtonItem in '@atlaskit/menu'
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af143be694f933c4$var$ButtonItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4vQlI", function(module, exports) {
$parcel$export(module.exports, "default", () => $8450fbee69ab3a89$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1PYwQ = parcelRequire("1PYwQ");

var $2eOKX = parcelRequire("2eOKX");
const $8450fbee69ab3a89$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 */ const $8450fbee69ab3a89$var$CustomItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1PYwQ.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $8450fbee69ab3a89$var$styles.root,
            props.isSelected && $8450fbee69ab3a89$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $8450fbee69ab3a89$export$2e2bcd8739ae039 = $8450fbee69ab3a89$var$CustomItem;

});

parcelRegister("8KWr1", function(module, exports) {
$parcel$export(module.exports, "SidebarThemeProvider", () => $76cb412fcc597faf$export$92cd68117b68bf5f);
$parcel$export(module.exports, "useSidebarTheme", () => $76cb412fcc597faf$export$b1a81b4626bc52c3);

var $eJOHy = parcelRequire("eJOHy");
const $76cb412fcc597faf$var$ThemeContext = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $76cb412fcc597faf$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($76cb412fcc597faf$var$ThemeContext.Provider, {
        value: theme
    }, children);
const $76cb412fcc597faf$export$b1a81b4626bc52c3 = ()=>(0, $eJOHy.useContext)($76cb412fcc597faf$var$ThemeContext);

});

parcelRegister("fZmSO", function(module, exports) {
$parcel$export(module.exports, "useOnClick", () => $95214767aefcba5f$export$a81c45382e7253ac);

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $95214767aefcba5f$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return (event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        });
        if (analytics) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
        else (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'sidebar');
        onClick && onClick(event);
    };
};

});


parcelRegister("6QqPe", function(module, exports) {
$parcel$export(module.exports, "SectionHeader", () => $8a36874e3cae24c5$export$8adb256d999cd5a0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** Wrapper around <HeadingItem> adding custom theming
 * @see @atlaskit/side-navigation
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7lClg = parcelRequire("7lClg");

var $8KWr1 = parcelRequire("8KWr1");
const $8a36874e3cae24c5$var$textColorCssVar = '--section-header-text-color';
const $8a36874e3cae24c5$var$opacityCssVar = '--section-header-opacity';
const $8a36874e3cae24c5$var$colorThemeStyles = null;
const $8a36874e3cae24c5$var$opacityThemeStyles = null;
const $8a36874e3cae24c5$export$8adb256d999cd5a0 = ({ children: children })=>{
    const theme = (0, $8KWr1.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $eJOHy.createElement((0, $7lClg.default), {
        // @ts-expect-error - className is a valid prop
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            [$8a36874e3cae24c5$var$opacityCssVar]: item?.opacity,
            [$8a36874e3cae24c5$var$textColorCssVar]: item?.color?.default
        },
        className: (0, $hcewu.default)([
            item?.opacity && "_tzy4blmq",
            item?.color?.default && "_syazoa1y"
        ])
    }, children);
};

});
parcelRegister("7lClg", function(module, exports) {
$parcel$export(module.exports, "default", () => $742c860a021d8da7$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eJOdq = parcelRequire("eJOdq");

var $2eOKX = parcelRequire("2eOKX");
const $742c860a021d8da7$var$styles = {
    headingItem: "_18zru2gc"
};
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */ const $742c860a021d8da7$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    // @ts-expect-error - Although this isn't defined on props it is available because we've used
    // spread props below and on the jsx element in MenuHeadingItem.
    const UNSAFE_className = props.className;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOdq.default), {
        ...props,
        // @ts-expect-error
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            $742c860a021d8da7$var$styles.headingItem,
            UNSAFE_className
        ])
    });
};
var $742c860a021d8da7$export$2e2bcd8739ae039 = $742c860a021d8da7$var$HeadingItem;

});


parcelRegister("G9fRP", function(module, exports) {
$parcel$export(module.exports, "ForgePageHeader", () => $0020be834948b728$export$a4f83f6df17decd4);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $kcLaf = parcelRequire("kcLaf");

var $iMZxW = parcelRequire("iMZxW");

var $1H6cR = parcelRequire("1H6cR");
const $0020be834948b728$var$containerNestedStyles = null;
const $0020be834948b728$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, $5DgXR.default), AddonIcon: AddonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), Header: Header = (0, $1H6cR.CustomHeader), EnvironmentLozenge: EnvironmentLozenge = (0, $iMZxW.EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, nestedMenuActive: nestedMenuActive })=>{
    return /*#__PURE__*/ $eJOHy.createElement(Header, {
        iconBefore: avatarUrl?.length ? /*#__PURE__*/ $eJOHy.createElement(Avatar, {
            appearance: "square",
            borderColor: "transparent",
            size: "small",
            src: `${avatarUrl}?size=xxlarge`
        }) : /*#__PURE__*/ $eJOHy.createElement(AddonIcon, {
            label: "",
            size: "medium",
            spacing: "spacious"
        }),
        iconAfter: /*#__PURE__*/ $eJOHy.createElement(EnvironmentLozenge, {
            environmentType: environmentType
        }),
        className: (0, $hcewu.default)([
            nestedMenuActive && "_19bv183y"
        ])
    }, (0, $iMZxW.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});
parcelRegister("1H6cR", function(module, exports) {
$parcel$export(module.exports, "CustomHeader", () => $c6612ad9800f1aa6$export$a231a61d189ef09a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4vQlI = parcelRequire("4vQlI");

var $8KWr1 = parcelRequire("8KWr1");
const $c6612ad9800f1aa6$var$bgColorCssVar = '--header-bg-color';
const $c6612ad9800f1aa6$var$textColorCssVar = '--header-text-color';
const $c6612ad9800f1aa6$var$containerStyles = null;
const $c6612ad9800f1aa6$var$bgColorThemeStyles = null;
const $c6612ad9800f1aa6$var$colorThemeStyles = null;
const $c6612ad9800f1aa6$export$1e86fd0e1db89578 = ({ className: className, ...props })=>{
    const theme = (0, $8KWr1.useSidebarTheme)();
    const item = theme?.navigation?.item;
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_syaz1jnk _kqswh2mm _uizt1wug _vrjt140y _1cmdleuv _jl2n73ad _1v6j1fxt",
            item?.background?.default && "_bfhk1im0",
            item?.color?.default && "_syaz1jnk _i9a11jnk",
            className
        ]),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            [$c6612ad9800f1aa6$var$bgColorCssVar]: item?.background?.default,
            [$c6612ad9800f1aa6$var$textColorCssVar]: item?.color?.default
        },
        ...props
    });
};
const $c6612ad9800f1aa6$export$a231a61d189ef09a = ({ iconBefore: iconBefore, iconAfter: iconAfter, children: children, ...rest })=>{
    return /*#__PURE__*/ $eJOHy.createElement((0, $4vQlI.default), {
        ...rest,
        component: $c6612ad9800f1aa6$export$1e86fd0e1db89578,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isTitleHeading: true
    }, children);
};

});


parcelRegister("gkhxF", function(module, exports) {
$parcel$export(module.exports, "NestingMenuItem", () => $fac5addee1b29ecd$export$4c594f24f8e4128a);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $aqu01 = parcelRequire("aqu01");

var $eOsRG = parcelRequire("eOsRG");

var $dysGT = parcelRequire("dysGT");

var $dysoB = parcelRequire("dysoB");

var $8KWr1 = parcelRequire("8KWr1");

var $762yz = parcelRequire("762yz");
const $fac5addee1b29ecd$var$iconSecondaryColorCssVar = '--nesting-menu-item-icon-secondary-color';
const $fac5addee1b29ecd$var$styles = {
    backButtonThemeOverrides: "_18ljulk5 _ksbyulk5",
    customItem: "_4t3i1ady _vl7qglyw _slhpglyw _7upw1txw _1nrm18uv _1a3b18uv _1ydc18uv _c2wa1kw7 _4fpr1kw7 _1x281kw7 _1iohnqa1 _5goinqa1 _1726nqa1 _1q5t1r31 _nt751r31 _9nxe1r31 _1ohyglyw _49pcglyw _tpgfglyw _1r9xidpf _1hvwidpf _12gridpf"
};
const $fac5addee1b29ecd$var$WrappingLinkComponent = (props)=>/*#__PURE__*/ $eJOHy.createElement("a", props, props.children);
const $fac5addee1b29ecd$export$4c594f24f8e4128a = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
    const theme = (0, $8KWr1.useSidebarTheme)();
    const iconSecondaryColor = theme?.navigation?.icon?.secondary?.color?.default;
    const { BackMenuItem: BackMenuItem = {} } = overrides;
    const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $eJOHy.Fragment), ...backItemProps } = BackMenuItem; // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const renderBackItem = (0, $eJOHy.useCallback)(({ onClick: onClick })=>/*#__PURE__*/ $eJOHy.createElement(WrapperComponent, null, /*#__PURE__*/ $eJOHy.createElement((0, $dysoB.MenuItem), {
            ...backItemProps,
            analytics: {
                itemId: 'back'
            },
            iconBefore: /*#__PURE__*/ $eJOHy.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aqu01))), {
                spacing: "spacious",
                label: ""
            }),
            onClick: (ev)=>{
                if ((0, $762yz.isNormalClick)(ev)) {
                    onClick();
                    backItemProps.onClick?.(ev);
                }
            },
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                [$fac5addee1b29ecd$var$iconSecondaryColorCssVar]: iconSecondaryColor ?? undefined
            },
            className: (0, $hcewu.default)([
                iconSecondaryColor && $fac5addee1b29ecd$var$styles.backButtonThemeOverrides
            ])
        }, backTitle)), [
        WrapperComponent,
        backItemProps,
        backTitle,
        iconSecondaryColor
    ]);
    const renderCustomItem = (0, $eJOHy.useCallback)(({ children: itemTitle, onClick: onClick, className: className, ...props })=>/*#__PURE__*/ $eJOHy.createElement((0, $eOsRG.default), {
            ...props,
            id: id,
            component: reloadOnNavigationToNesting ? $fac5addee1b29ecd$var$WrappingLinkComponent : props.component,
            onClick: (ev)=>{
                // if nesting item already selected do not trigger route change
                if (props.isSelected === true) ev.preventDefault();
                onClick && onClick(ev);
            },
            // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
            overrides: {
                GoBackItem: {
                    render: renderBackItem
                }
            },
            title: itemTitle,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: (0, $hcewu.default)([
                $fac5addee1b29ecd$var$styles.customItem,
                className
            ])
        }, /*#__PURE__*/ $eJOHy.createElement((0, $dysGT.SidebarErrorBoundary), {
            id: `${id}Nesting`,
            packageName: "jiraSpaAppsSidebarCommon"
        }, children)), [
        children,
        id,
        reloadOnNavigationToNesting,
        renderBackItem
    ]);
    return /*#__PURE__*/ $eJOHy.createElement((0, $dysoB.MenuItem), {
        ...rest,
        ref: ref,
        overrides: {
            CustomItem: {
                render: renderCustomItem
            }
        }
    }, title);
});

});
parcelRegister("eOsRG", function(module, exports) {
$parcel$export(module.exports, "default", () => $31cdf6c97a90d3e9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $3qZZA = parcelRequire("3qZZA");

var $eGOwo = parcelRequire("eGOwo");

var $8IeH1 = parcelRequire("8IeH1");


var $lOpB3 = parcelRequire("lOpB3");
var $4vQlI = parcelRequire("4vQlI");
var $8NVZT = parcelRequire("8NVZT");

var $jcciq = parcelRequire("jcciq");

var $2eOKX = parcelRequire("2eOKX");

var $iIZJ5 = parcelRequire("iIZJ5");
const $31cdf6c97a90d3e9$var$styles = {
    iconContainer: "_1e0c1nu9",
    nestingItem: "_udl3glyw _kqsfglyw _udrwglyw _13qvglyw _9mqr1kw7 _povs1kw7 _uv2d1kw7 _atks1kw7",
    nestingItemDisabled: "_1c06idpf _udl3glyw"
};
/**
 * NestingItem will render itself differently depending in what context it is rendered in.
 * When not open - it will render itself as an item.
 * When open - it will render its children.
 */ const $31cdf6c97a90d3e9$var$NestingItem = (props)=>{
    const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, className: className, isDisabled: isDisabled, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
    const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator, activeParentId: activeParentId, goBackButtonRef: goBackButtonRef, isDefaultFocusControl: isDefaultFocusControl, focusGoBackButton: focusGoBackButton } = (0, $2eOKX.useNestedContext)();
    const [isInteracted, setIsInteracted] = (0, $eJOHy.useState)(false);
    const parentItemRef = (0, $eJOHy.useRef)(null);
    // To avoid error we need to make sure that the component is wrapped in ForwardRef
    const isForwardRefCheck = (component)=>{
        if (component?.prototype?.isReactComponent) return false;
        return component?.$$typeof === Symbol.for('react.forward_ref');
    };
    const shouldFocus = isDefaultFocusControl && (0, $eGOwo.fg)('platform-side-navigation-keyboard-focus');
    const backButtonRef = shouldFocus ? goBackButtonRef : null;
    const activeParentRef = shouldFocus ? parentItemRef : null;
    (0, $eJOHy.useEffect)(()=>{
        if (shouldFocus) {
            if (activeParentId === id) parentItemRef?.current?.focus();
            if (focusGoBackButton) goBackButtonRef?.current?.focus();
        }
    }, [
        activeParentId,
        id,
        goBackButtonRef,
        focusGoBackButton,
        isDefaultFocusControl,
        shouldFocus
    ]);
    const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
        onClick: onUnNest,
        testId: testId && `${testId}--go-back-item`,
        ref: backButtonRef
    }) || contextualBackButton;
    const context = (0, $eJOHy.useMemo)(()=>({
            stack: stack,
            currentStackId: currentStackId,
            onNest: onNest,
            onUnNest: onUnNest,
            backButton: backButton,
            parentId: id,
            childIds: childIds,
            forceShowTopScrollIndicator: forceShowTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        stack,
        currentStackId,
        onNest,
        onUnNest,
        backButton,
        id,
        childIds,
        forceShowTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    (0, $iIZJ5.useChildIdsEffect)(childIds, id);
    const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
    /**
   * We want both the on nest handler and the onclick handler to be called.
   * We create a wrapper function to call both.
   */ const onClickHandler = (0, $eJOHy.useCallback)((e)=>{
        if (isInteracted) // We return early if this has been interacted with because its assumed
        // this will be already exiting - so we don't want to double up the click.
        return;
        // Avoid a nesting transition if a modifier key is detected during click.
        // @ts-expect-error - Argument of type 'MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>' is not assignable to parameter of type 'MouseEvent'
        if (isNormalClick(e)) {
            setIsInteracted(true);
            onNest(id);
        }
        onClick && onClick(e);
    }, [
        isInteracted,
        onClick,
        onNest,
        id
    ]);
    if (currentStackId === id) return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $2eOKX.NestedContext).Provider, {
        value: context,
        children: [
            stack.length >= 1 && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                paddingBlock: "space.075",
                paddingInline: "space.100",
                children: backButton
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8NVZT.default), {
                testId: testId,
                showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1,
                children: children
            })
        ]
    });
    if ([
        (0, $jcciq.ROOT_ID),
        ...stack
    ].includes(id)) return children;
    const componentProps = {
        iconAfter: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $eJOHy.Fragment), {
            children: [
                iconAfter ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: $31cdf6c97a90d3e9$var$styles.iconContainer,
                    "data-custom-icon": true,
                    as: "span",
                    children: iconAfter
                }) : null,
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    "data-right-arrow": true,
                    xcss: $31cdf6c97a90d3e9$var$styles.iconContainer,
                    as: "span",
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3qZZA))), {
                        testId: testId && `${testId}--item--right-arrow`,
                        color: "currentColor",
                        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $7bb4c1736002a04a$export$e655ef011c4aa1a2)})`,
                        label: ""
                    })
                })
            ]
        }),
        onClick: onClickHandler,
        isSelected: isSelected,
        isDisabled: isDisabled,
        testId: testId && `${testId}--item`,
        ...rest,
        children: title
    };
    if (component) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4vQlI.default), {
        ref: isForwardRefCheck(component) ? parentItemRef : null,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $31cdf6c97a90d3e9$var$styles.nestingItem,
            isDisabled && $31cdf6c97a90d3e9$var$styles.nestingItemDisabled,
            className
        ]),
        //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
        component: component
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lOpB3.default), {
        ref: activeParentRef,
        ...componentProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $31cdf6c97a90d3e9$var$styles.nestingItem,
            isDisabled && $31cdf6c97a90d3e9$var$styles.nestingItemDisabled,
            className
        ])
    });
};
var $31cdf6c97a90d3e9$export$2e2bcd8739ae039 = $31cdf6c97a90d3e9$var$NestingItem;

});
parcelRegister("3qZZA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c6e834f7127447f187253f462afe4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2803e32c3ab3bcb7$var$_react = $2803e32c3ab3bcb7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2803e32c3ab3bcb7$var$_arrowRight = $2803e32c3ab3bcb7$var$_interopRequireDefault((parcelRequire("ePxSL")));

var $2803e32c3ab3bcb7$var$_arrowRightCircle = $2803e32c3ab3bcb7$var$_interopRequireDefault((parcelRequire("9YAbA")));
function $2803e32c3ab3bcb7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2803e32c3ab3bcb7$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $2803e32c3ab3bcb7$var$_react.default.createElement($2803e32c3ab3bcb7$var$_arrowRight.default, Object.assign({
        name: "ArrowRightIcon",
        LEGACY_fallbackIcon: $2803e32c3ab3bcb7$var$_arrowRightCircle.default
    }, props));
$2803e32c3ab3bcb7$var$ArrowRightIcon.displayName = 'ArrowRightIconMigration';
var $2803e32c3ab3bcb7$var$_default = module.exports.default = $2803e32c3ab3bcb7$var$ArrowRightIcon;

});
parcelRegister("9YAbA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7435c96ecc9ed077$var$_react = $7435c96ecc9ed077$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $7435c96ecc9ed077$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7435c96ecc9ed077$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $7435c96ecc9ed077$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
    }, props));
$7435c96ecc9ed077$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $7435c96ecc9ed077$var$_default = module.exports.default = $7435c96ecc9ed077$var$ArrowRightCircleIcon;

});


var $7bb4c1736002a04a$exports = {};
$parcel$export($7bb4c1736002a04a$exports, "R50", () => $7bb4c1736002a04a$export$4b84fd0e2c617bd);
$parcel$export($7bb4c1736002a04a$exports, "R75", () => $7bb4c1736002a04a$export$b34b069eff244586);
$parcel$export($7bb4c1736002a04a$exports, "R100", () => $7bb4c1736002a04a$export$be802dd0d8b57f35);
$parcel$export($7bb4c1736002a04a$exports, "R200", () => $7bb4c1736002a04a$export$60847d42f9da92a6);
$parcel$export($7bb4c1736002a04a$exports, "R300", () => $7bb4c1736002a04a$export$4a7404f376229999);
$parcel$export($7bb4c1736002a04a$exports, "R400", () => $7bb4c1736002a04a$export$2010d0fb4295b346);
$parcel$export($7bb4c1736002a04a$exports, "R500", () => $7bb4c1736002a04a$export$2837b5a1a71d5c02);
$parcel$export($7bb4c1736002a04a$exports, "Y50", () => $7bb4c1736002a04a$export$8d9596b529bbb9cf);
$parcel$export($7bb4c1736002a04a$exports, "Y75", () => $7bb4c1736002a04a$export$41060a744ab0b7ae);
$parcel$export($7bb4c1736002a04a$exports, "Y100", () => $7bb4c1736002a04a$export$1cc05bbbf340e559);
$parcel$export($7bb4c1736002a04a$exports, "Y200", () => $7bb4c1736002a04a$export$5aae31392d72caaa);
$parcel$export($7bb4c1736002a04a$exports, "Y300", () => $7bb4c1736002a04a$export$c6930421db9fa514);
$parcel$export($7bb4c1736002a04a$exports, "Y400", () => $7bb4c1736002a04a$export$59619663aa6500fb);
$parcel$export($7bb4c1736002a04a$exports, "Y500", () => $7bb4c1736002a04a$export$874739ea9e379ab6);
$parcel$export($7bb4c1736002a04a$exports, "G50", () => $7bb4c1736002a04a$export$8a6341c32b6a3ee6);
$parcel$export($7bb4c1736002a04a$exports, "G75", () => $7bb4c1736002a04a$export$69a3bf21b9686c2b);
$parcel$export($7bb4c1736002a04a$exports, "G100", () => $7bb4c1736002a04a$export$afbce1382ec95f73);
$parcel$export($7bb4c1736002a04a$exports, "G200", () => $7bb4c1736002a04a$export$747d86715d4175de);
$parcel$export($7bb4c1736002a04a$exports, "G300", () => $7bb4c1736002a04a$export$940e1f69e873f202);
$parcel$export($7bb4c1736002a04a$exports, "G400", () => $7bb4c1736002a04a$export$a49394138f7b8e85);
$parcel$export($7bb4c1736002a04a$exports, "G500", () => $7bb4c1736002a04a$export$6fa04827ac68a4fb);
$parcel$export($7bb4c1736002a04a$exports, "B50", () => $7bb4c1736002a04a$export$226de0355ed012f8);
$parcel$export($7bb4c1736002a04a$exports, "B75", () => $7bb4c1736002a04a$export$8c13c2ee36917869);
$parcel$export($7bb4c1736002a04a$exports, "B100", () => $7bb4c1736002a04a$export$ecfc1dff386a3e7a);
$parcel$export($7bb4c1736002a04a$exports, "B200", () => $7bb4c1736002a04a$export$215b7063051591f1);
$parcel$export($7bb4c1736002a04a$exports, "B300", () => $7bb4c1736002a04a$export$e62e8919cca44969);
$parcel$export($7bb4c1736002a04a$exports, "B400", () => $7bb4c1736002a04a$export$b3de0ae08da2ce64);
$parcel$export($7bb4c1736002a04a$exports, "B500", () => $7bb4c1736002a04a$export$a6ee3d71bc067634);
$parcel$export($7bb4c1736002a04a$exports, "B600", () => $7bb4c1736002a04a$export$67f15409e87642a1);
$parcel$export($7bb4c1736002a04a$exports, "B700", () => $7bb4c1736002a04a$export$f0539dbc42dbb067);
$parcel$export($7bb4c1736002a04a$exports, "P50", () => $7bb4c1736002a04a$export$363e4475840015bb);
$parcel$export($7bb4c1736002a04a$exports, "P75", () => $7bb4c1736002a04a$export$4b0a4417ed59760f);
$parcel$export($7bb4c1736002a04a$exports, "P100", () => $7bb4c1736002a04a$export$6011520a64d9a187);
$parcel$export($7bb4c1736002a04a$exports, "P200", () => $7bb4c1736002a04a$export$a7175d4e9206bc80);
$parcel$export($7bb4c1736002a04a$exports, "P300", () => $7bb4c1736002a04a$export$b48405b95304b5a1);
$parcel$export($7bb4c1736002a04a$exports, "P400", () => $7bb4c1736002a04a$export$c71e4279dd54a18d);
$parcel$export($7bb4c1736002a04a$exports, "P500", () => $7bb4c1736002a04a$export$147899de772240ec);
$parcel$export($7bb4c1736002a04a$exports, "T50", () => $7bb4c1736002a04a$export$2cf711fe14c66f06);
$parcel$export($7bb4c1736002a04a$exports, "T75", () => $7bb4c1736002a04a$export$7a8f4d33f6f9772c);
$parcel$export($7bb4c1736002a04a$exports, "T100", () => $7bb4c1736002a04a$export$776c9c497ef08533);
$parcel$export($7bb4c1736002a04a$exports, "T200", () => $7bb4c1736002a04a$export$69cb3ca10c1e330e);
$parcel$export($7bb4c1736002a04a$exports, "T300", () => $7bb4c1736002a04a$export$9dc1ef0f3f48059b);
$parcel$export($7bb4c1736002a04a$exports, "T400", () => $7bb4c1736002a04a$export$7c835c78b6fcdef8);
$parcel$export($7bb4c1736002a04a$exports, "T500", () => $7bb4c1736002a04a$export$6036577f95c3877e);
$parcel$export($7bb4c1736002a04a$exports, "N0", () => $7bb4c1736002a04a$export$29a4f05edc054374);
$parcel$export($7bb4c1736002a04a$exports, "N10", () => $7bb4c1736002a04a$export$e655ef011c4aa1a2);
$parcel$export($7bb4c1736002a04a$exports, "N20", () => $7bb4c1736002a04a$export$9fdfb749e33cdf97);
$parcel$export($7bb4c1736002a04a$exports, "N30", () => $7bb4c1736002a04a$export$3e51e8f1440314ba);
$parcel$export($7bb4c1736002a04a$exports, "N40", () => $7bb4c1736002a04a$export$1ce2d1575d444ceb);
$parcel$export($7bb4c1736002a04a$exports, "N50", () => $7bb4c1736002a04a$export$8754fc7e6d8b3000);
$parcel$export($7bb4c1736002a04a$exports, "N60", () => $7bb4c1736002a04a$export$c2e91cbeada39b8b);
$parcel$export($7bb4c1736002a04a$exports, "N70", () => $7bb4c1736002a04a$export$5f71e19f3a7ad9de);
$parcel$export($7bb4c1736002a04a$exports, "N80", () => $7bb4c1736002a04a$export$eaa8c8a70ac22806);
$parcel$export($7bb4c1736002a04a$exports, "N90", () => $7bb4c1736002a04a$export$7c87d337fb91a97d);
$parcel$export($7bb4c1736002a04a$exports, "N100", () => $7bb4c1736002a04a$export$d6447c357493214f);
$parcel$export($7bb4c1736002a04a$exports, "N200", () => $7bb4c1736002a04a$export$f563ee71e9ee74cd);
$parcel$export($7bb4c1736002a04a$exports, "N300", () => $7bb4c1736002a04a$export$e2ef2124cf4024b1);
$parcel$export($7bb4c1736002a04a$exports, "N400", () => $7bb4c1736002a04a$export$eece5f492e429f08);
$parcel$export($7bb4c1736002a04a$exports, "N500", () => $7bb4c1736002a04a$export$c39c0fe0f26207ae);
$parcel$export($7bb4c1736002a04a$exports, "N600", () => $7bb4c1736002a04a$export$7090862dc3038a9f);
$parcel$export($7bb4c1736002a04a$exports, "N700", () => $7bb4c1736002a04a$export$ad0bacf983b7ddaa);
$parcel$export($7bb4c1736002a04a$exports, "N800", () => $7bb4c1736002a04a$export$7d61b15e0da132af);
$parcel$export($7bb4c1736002a04a$exports, "N900", () => $7bb4c1736002a04a$export$fbda843f0a27fe96);
$parcel$export($7bb4c1736002a04a$exports, "N10A", () => $7bb4c1736002a04a$export$791e57b27ca738ef);
$parcel$export($7bb4c1736002a04a$exports, "N20A", () => $7bb4c1736002a04a$export$8d43898f60b96a82);
$parcel$export($7bb4c1736002a04a$exports, "N30A", () => $7bb4c1736002a04a$export$920c0d5c49070351);
$parcel$export($7bb4c1736002a04a$exports, "N40A", () => $7bb4c1736002a04a$export$46987b49aab6d1a8);
$parcel$export($7bb4c1736002a04a$exports, "N50A", () => $7bb4c1736002a04a$export$7d3359664e8bb0e5);
$parcel$export($7bb4c1736002a04a$exports, "N60A", () => $7bb4c1736002a04a$export$d2d3bedfb276cac0);
$parcel$export($7bb4c1736002a04a$exports, "N70A", () => $7bb4c1736002a04a$export$6e5e7499ff054f6d);
$parcel$export($7bb4c1736002a04a$exports, "N80A", () => $7bb4c1736002a04a$export$59264b346c877fa7);
$parcel$export($7bb4c1736002a04a$exports, "N90A", () => $7bb4c1736002a04a$export$d092757d7c64925c);
$parcel$export($7bb4c1736002a04a$exports, "N100A", () => $7bb4c1736002a04a$export$486ab785e4bac3c6);
$parcel$export($7bb4c1736002a04a$exports, "N200A", () => $7bb4c1736002a04a$export$fba592bbc6419fea);
$parcel$export($7bb4c1736002a04a$exports, "N300A", () => $7bb4c1736002a04a$export$13609db0e6812ab8);
$parcel$export($7bb4c1736002a04a$exports, "N400A", () => $7bb4c1736002a04a$export$fbae4efaa892d883);
$parcel$export($7bb4c1736002a04a$exports, "N500A", () => $7bb4c1736002a04a$export$f13946d26f440ce6);
$parcel$export($7bb4c1736002a04a$exports, "N600A", () => $7bb4c1736002a04a$export$19f58225ac52a306);
$parcel$export($7bb4c1736002a04a$exports, "N700A", () => $7bb4c1736002a04a$export$6384f09da70e7b62);
$parcel$export($7bb4c1736002a04a$exports, "N800A", () => $7bb4c1736002a04a$export$d0dccc730683edc2);
$parcel$export($7bb4c1736002a04a$exports, "DN900", () => $7bb4c1736002a04a$export$2f6319cf7d736c2a);
$parcel$export($7bb4c1736002a04a$exports, "DN800", () => $7bb4c1736002a04a$export$95126bc8884d6634);
$parcel$export($7bb4c1736002a04a$exports, "DN700", () => $7bb4c1736002a04a$export$8338d8c35d44ff1);
$parcel$export($7bb4c1736002a04a$exports, "DN600", () => $7bb4c1736002a04a$export$5368d76ae4fbbda7);
$parcel$export($7bb4c1736002a04a$exports, "DN500", () => $7bb4c1736002a04a$export$9f0a771d16ec8d36);
$parcel$export($7bb4c1736002a04a$exports, "DN400", () => $7bb4c1736002a04a$export$abcf8c38338b4aa5);
$parcel$export($7bb4c1736002a04a$exports, "DN300", () => $7bb4c1736002a04a$export$97e81faa16a182c7);
$parcel$export($7bb4c1736002a04a$exports, "DN200", () => $7bb4c1736002a04a$export$bfe21c59123ecf33);
$parcel$export($7bb4c1736002a04a$exports, "DN100", () => $7bb4c1736002a04a$export$ee82aa2ea6a1558);
$parcel$export($7bb4c1736002a04a$exports, "DN90", () => $7bb4c1736002a04a$export$682927c6ed76be02);
$parcel$export($7bb4c1736002a04a$exports, "DN80", () => $7bb4c1736002a04a$export$91fd9994c5be9757);
$parcel$export($7bb4c1736002a04a$exports, "DN70", () => $7bb4c1736002a04a$export$d281fbfe3cff2df6);
$parcel$export($7bb4c1736002a04a$exports, "DN60", () => $7bb4c1736002a04a$export$3902c91d8b98a753);
$parcel$export($7bb4c1736002a04a$exports, "DN50", () => $7bb4c1736002a04a$export$8e8133c1ba5845b5);
$parcel$export($7bb4c1736002a04a$exports, "DN40", () => $7bb4c1736002a04a$export$33ff357f6620b39);
$parcel$export($7bb4c1736002a04a$exports, "DN30", () => $7bb4c1736002a04a$export$633847cf062b69e0);
$parcel$export($7bb4c1736002a04a$exports, "DN20", () => $7bb4c1736002a04a$export$9776a6e503bdbf76);
$parcel$export($7bb4c1736002a04a$exports, "DN10", () => $7bb4c1736002a04a$export$6c813d5160dff5db);
$parcel$export($7bb4c1736002a04a$exports, "DN0", () => $7bb4c1736002a04a$export$3d4f271a500072a);
$parcel$export($7bb4c1736002a04a$exports, "DN800A", () => $7bb4c1736002a04a$export$fe151285c22759ec);
$parcel$export($7bb4c1736002a04a$exports, "DN700A", () => $7bb4c1736002a04a$export$a101c6190d0da34);
$parcel$export($7bb4c1736002a04a$exports, "DN600A", () => $7bb4c1736002a04a$export$4b16f52932fda51);
$parcel$export($7bb4c1736002a04a$exports, "DN500A", () => $7bb4c1736002a04a$export$a74bcd7b9845b0d8);
$parcel$export($7bb4c1736002a04a$exports, "DN400A", () => $7bb4c1736002a04a$export$9209c179316d1751);
$parcel$export($7bb4c1736002a04a$exports, "DN300A", () => $7bb4c1736002a04a$export$88f55133f636c8dd);
$parcel$export($7bb4c1736002a04a$exports, "DN200A", () => $7bb4c1736002a04a$export$51126f85d1009512);
$parcel$export($7bb4c1736002a04a$exports, "DN100A", () => $7bb4c1736002a04a$export$a069b547bd23af78);
$parcel$export($7bb4c1736002a04a$exports, "DN90A", () => $7bb4c1736002a04a$export$40cce05af3b2600a);
$parcel$export($7bb4c1736002a04a$exports, "DN80A", () => $7bb4c1736002a04a$export$b78942185925a0d);
$parcel$export($7bb4c1736002a04a$exports, "DN70A", () => $7bb4c1736002a04a$export$e058fb44b8eaafca);
$parcel$export($7bb4c1736002a04a$exports, "DN60A", () => $7bb4c1736002a04a$export$92b0b8de26920c18);
$parcel$export($7bb4c1736002a04a$exports, "DN50A", () => $7bb4c1736002a04a$export$67564f7459d3fc9e);
$parcel$export($7bb4c1736002a04a$exports, "DN40A", () => $7bb4c1736002a04a$export$77868e1ca884ffa3);
$parcel$export($7bb4c1736002a04a$exports, "DN30A", () => $7bb4c1736002a04a$export$2afd71d7d3ea2cd5);
$parcel$export($7bb4c1736002a04a$exports, "DN20A", () => $7bb4c1736002a04a$export$f2a0acaab9972c70);
$parcel$export($7bb4c1736002a04a$exports, "DN10A", () => $7bb4c1736002a04a$export$9ab70e67d6475361);
$parcel$export($7bb4c1736002a04a$exports, "T30", () => $7bb4c1736002a04a$export$d2adc5dedf09fced);
$parcel$export($7bb4c1736002a04a$exports, "L50", () => $7bb4c1736002a04a$export$f51762073d2bb381);
$parcel$export($7bb4c1736002a04a$exports, "L75", () => $7bb4c1736002a04a$export$95e26d54def96891);
// Reds
const $7bb4c1736002a04a$export$4b84fd0e2c617bd = '#FFEBE6';
const $7bb4c1736002a04a$export$b34b069eff244586 = '#FFBDAD';
const $7bb4c1736002a04a$export$be802dd0d8b57f35 = '#FF8F73';
const $7bb4c1736002a04a$export$60847d42f9da92a6 = '#FF7452';
const $7bb4c1736002a04a$export$4a7404f376229999 = '#FF5630';
const $7bb4c1736002a04a$export$2010d0fb4295b346 = '#DE350B';
const $7bb4c1736002a04a$export$2837b5a1a71d5c02 = '#BF2600';
const $7bb4c1736002a04a$export$8d9596b529bbb9cf = '#FFFAE6';
const $7bb4c1736002a04a$export$41060a744ab0b7ae = '#FFF0B3';
const $7bb4c1736002a04a$export$1cc05bbbf340e559 = '#FFE380';
const $7bb4c1736002a04a$export$5aae31392d72caaa = '#FFC400';
const $7bb4c1736002a04a$export$c6930421db9fa514 = '#FFAB00';
const $7bb4c1736002a04a$export$59619663aa6500fb = '#FF991F';
const $7bb4c1736002a04a$export$874739ea9e379ab6 = '#FF8B00';
const $7bb4c1736002a04a$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $7bb4c1736002a04a$export$69a3bf21b9686c2b = '#ABF5D1';
const $7bb4c1736002a04a$export$afbce1382ec95f73 = '#79F2C0';
const $7bb4c1736002a04a$export$747d86715d4175de = '#57D9A3';
const $7bb4c1736002a04a$export$940e1f69e873f202 = '#36B37E';
const $7bb4c1736002a04a$export$a49394138f7b8e85 = '#00875A';
const $7bb4c1736002a04a$export$6fa04827ac68a4fb = '#006644';
const $7bb4c1736002a04a$export$226de0355ed012f8 = '#DEEBFF';
const $7bb4c1736002a04a$export$8c13c2ee36917869 = '#B3D4FF';
const $7bb4c1736002a04a$export$ecfc1dff386a3e7a = '#4C9AFF';
const $7bb4c1736002a04a$export$215b7063051591f1 = '#2684FF';
const $7bb4c1736002a04a$export$e62e8919cca44969 = '#0065FF';
const $7bb4c1736002a04a$export$b3de0ae08da2ce64 = '#0052CC';
const $7bb4c1736002a04a$export$a6ee3d71bc067634 = '#0747A6';
const $7bb4c1736002a04a$export$67f15409e87642a1 = '#669DF1';
const $7bb4c1736002a04a$export$f0539dbc42dbb067 = '#8FB8F6';
const $7bb4c1736002a04a$export$363e4475840015bb = '#EAE6FF';
const $7bb4c1736002a04a$export$4b0a4417ed59760f = '#C0B6F2';
const $7bb4c1736002a04a$export$6011520a64d9a187 = '#998DD9';
const $7bb4c1736002a04a$export$a7175d4e9206bc80 = '#8777D9';
const $7bb4c1736002a04a$export$b48405b95304b5a1 = '#6554C0';
const $7bb4c1736002a04a$export$c71e4279dd54a18d = '#5243AA';
const $7bb4c1736002a04a$export$147899de772240ec = '#403294';
const $7bb4c1736002a04a$export$2cf711fe14c66f06 = '#E6FCFF';
const $7bb4c1736002a04a$export$7a8f4d33f6f9772c = '#B3F5FF';
const $7bb4c1736002a04a$export$776c9c497ef08533 = '#79E2F2';
const $7bb4c1736002a04a$export$69cb3ca10c1e330e = '#00C7E6';
const $7bb4c1736002a04a$export$9dc1ef0f3f48059b = '#00B8D9';
const $7bb4c1736002a04a$export$7c835c78b6fcdef8 = '#00A3BF';
const $7bb4c1736002a04a$export$6036577f95c3877e = '#008DA6';
const $7bb4c1736002a04a$export$29a4f05edc054374 = '#FFFFFF';
const $7bb4c1736002a04a$export$e655ef011c4aa1a2 = '#FAFBFC';
const $7bb4c1736002a04a$export$9fdfb749e33cdf97 = '#F4F5F7';
const $7bb4c1736002a04a$export$3e51e8f1440314ba = '#EBECF0';
const $7bb4c1736002a04a$export$1ce2d1575d444ceb = '#DFE1E6';
const $7bb4c1736002a04a$export$8754fc7e6d8b3000 = '#C1C7D0';
const $7bb4c1736002a04a$export$c2e91cbeada39b8b = '#B3BAC5';
const $7bb4c1736002a04a$export$5f71e19f3a7ad9de = '#A5ADBA';
const $7bb4c1736002a04a$export$eaa8c8a70ac22806 = '#97A0AF';
const $7bb4c1736002a04a$export$7c87d337fb91a97d = '#8993A4';
const $7bb4c1736002a04a$export$d6447c357493214f = '#7A869A';
const $7bb4c1736002a04a$export$f563ee71e9ee74cd = '#6B778C';
const $7bb4c1736002a04a$export$e2ef2124cf4024b1 = '#5E6C84';
const $7bb4c1736002a04a$export$eece5f492e429f08 = '#505F79';
const $7bb4c1736002a04a$export$c39c0fe0f26207ae = '#42526E';
const $7bb4c1736002a04a$export$7090862dc3038a9f = '#344563';
const $7bb4c1736002a04a$export$ad0bacf983b7ddaa = '#253858';
const $7bb4c1736002a04a$export$7d61b15e0da132af = '#172B4D';
const $7bb4c1736002a04a$export$fbda843f0a27fe96 = '#091E42';
const $7bb4c1736002a04a$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $7bb4c1736002a04a$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $7bb4c1736002a04a$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $7bb4c1736002a04a$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $7bb4c1736002a04a$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $7bb4c1736002a04a$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $7bb4c1736002a04a$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $7bb4c1736002a04a$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $7bb4c1736002a04a$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $7bb4c1736002a04a$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $7bb4c1736002a04a$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $7bb4c1736002a04a$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $7bb4c1736002a04a$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $7bb4c1736002a04a$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $7bb4c1736002a04a$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $7bb4c1736002a04a$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $7bb4c1736002a04a$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $7bb4c1736002a04a$export$2f6319cf7d736c2a = '#E6EDFA';
const $7bb4c1736002a04a$export$95126bc8884d6634 = '#DCE5F5';
const $7bb4c1736002a04a$export$8338d8c35d44ff1 = '#CED9EB';
const $7bb4c1736002a04a$export$5368d76ae4fbbda7 = '#B8C7E0';
const $7bb4c1736002a04a$export$9f0a771d16ec8d36 = '#ABBBD6';
const $7bb4c1736002a04a$export$abcf8c38338b4aa5 = '#9FB0CC';
const $7bb4c1736002a04a$export$97e81faa16a182c7 = '#8C9CB8';
const $7bb4c1736002a04a$export$bfe21c59123ecf33 = '#7988A3';
const $7bb4c1736002a04a$export$ee82aa2ea6a1558 = '#67758F';
const $7bb4c1736002a04a$export$682927c6ed76be02 = '#56637A';
const $7bb4c1736002a04a$export$91fd9994c5be9757 = '#455166';
const $7bb4c1736002a04a$export$d281fbfe3cff2df6 = '#3B475C';
const $7bb4c1736002a04a$export$3902c91d8b98a753 = '#313D52';
const $7bb4c1736002a04a$export$8e8133c1ba5845b5 = '#283447';
const $7bb4c1736002a04a$export$33ff357f6620b39 = '#202B3D';
const $7bb4c1736002a04a$export$633847cf062b69e0 = '#1B2638';
const $7bb4c1736002a04a$export$9776a6e503bdbf76 = '#121A29';
const $7bb4c1736002a04a$export$6c813d5160dff5db = '#0E1624';
const $7bb4c1736002a04a$export$3d4f271a500072a = '#0D1424';
const $7bb4c1736002a04a$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $7bb4c1736002a04a$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $7bb4c1736002a04a$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $7bb4c1736002a04a$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $7bb4c1736002a04a$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $7bb4c1736002a04a$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $7bb4c1736002a04a$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $7bb4c1736002a04a$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $7bb4c1736002a04a$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $7bb4c1736002a04a$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $7bb4c1736002a04a$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $7bb4c1736002a04a$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $7bb4c1736002a04a$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $7bb4c1736002a04a$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $7bb4c1736002a04a$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $7bb4c1736002a04a$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $7bb4c1736002a04a$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $7bb4c1736002a04a$export$d2adc5dedf09fced = '#292A2E';
const $7bb4c1736002a04a$export$f51762073d2bb381 = '#94C748';
const $7bb4c1736002a04a$export$95e26d54def96891 = '#B3DF72';

parcelRegister("lOpB3", function(module, exports) {
$parcel$export(module.exports, "default", () => $aef0022280e1b0e9$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7saMl = parcelRequire("7saMl");

var $2eOKX = parcelRequire("2eOKX");
const $aef0022280e1b0e9$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhk1w7a _1a391k8s _racp1k8s _30l3jjyb _irr314ae _ppn2dud1 _183j1l7b",
    selectedStyles: "_bfhkbal5 _syaz1ldt _10531ldt _irr31gf2 _30l31pwi _1di61elt _9h8h1ldt"
};
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $aef0022280e1b0e9$var$ButtonItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7saMl.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $aef0022280e1b0e9$var$styles.root,
            props.isSelected && $aef0022280e1b0e9$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $aef0022280e1b0e9$export$2e2bcd8739ae039 = $aef0022280e1b0e9$var$ButtonItem;

});

parcelRegister("8NVZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $81e34849b6770769$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $9RjqB = parcelRequire("9RjqB");

var $2eOKX = parcelRequire("2eOKX");
const $81e34849b6770769$var$outerContainerCSS = null;
const $81e34849b6770769$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjlb4i _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $81e34849b6770769$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $81e34849b6770769$var$NavigationContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $2eOKX.useShouldNestedElementRender)();
    const scrollbar = (0, $9RjqB.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rus1p09 _1kt9b3bt _1enwftgi _z5wtu2gc _14mjlb4i _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfk1p09 _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            ref: scrollbar.ref,
            className: (0, $hcewu.default)([
                $81e34849b6770769$var$innerContainerCSS.basic,
                !showTopScrollIndicator && $81e34849b6770769$var$innerContainerCSS.topScrollIndicator
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $81e34849b6770769$var$containerCSS.basic,
                    showTopScrollIndicator && $81e34849b6770769$var$containerCSS.marginBlockStart
                ]),
                children: children
            })
        })
    });
});
var $81e34849b6770769$export$2e2bcd8739ae039 = $81e34849b6770769$var$NavigationContent;

});
parcelRegister("9RjqB", function(module, exports) {
$parcel$export(module.exports, "default", () => $956c679486dfb22d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $956c679486dfb22d$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $eJOHy.useState)(0);
    const elementRef = (0, $eJOHy.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eJOHy.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("jcciq", function(module, exports) {
$parcel$export(module.exports, "ROOT_ID", () => $bed75de04f6c5b44$export$ec71a3379b43ae5c);
$parcel$export(module.exports, "default", () => $bed75de04f6c5b44$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $Ys7jv = parcelRequire("Ys7jv");

var $eGOwo = parcelRequire("eGOwo");

var $fV1cq = parcelRequire("fV1cq");

var $eOsRG = parcelRequire("eOsRG");

var $iIZJ5 = parcelRequire("iIZJ5");

var $2eOKX = parcelRequire("2eOKX");

var $gkgS5 = parcelRequire("gkgS5");
const $bed75de04f6c5b44$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
const $bed75de04f6c5b44$var$nestableNavigationContentStyles = null;
const $bed75de04f6c5b44$var$nestingRootStyles = null;
/**
 * __Nestable navigation content__
 *
 * The container for navigation items with nested views
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#nested-navigation)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $bed75de04f6c5b44$var$NestableNavigationContent = (props)=>{
    const containerRef = (0, $eJOHy.useRef)(null);
    const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator, isDefaultFocusControl: isDefaultFocusControl = true } = props;
    const goBackButtonRef = (0, $eJOHy.useRef)(null);
    const [committedStack, setCommittedStack] = (0, $eJOHy.useState)(stack || initialStack || []);
    const controlledStack = stack || undefined;
    const currentStackId = committedStack[committedStack.length - 1] || $bed75de04f6c5b44$export$ec71a3379b43ae5c;
    const [transition, setTransition] = (0, $eJOHy.useState)('nesting');
    const backTestId = testId && `${testId}--go-back-item`;
    const [activeParentId, setActiveParentId] = (0, $eJOHy.useState)('');
    const [focusGoBackButton, setFocusGoBackButton] = (0, $eJOHy.useState)(false);
    const shouldFocus = isDefaultFocusControl && (0, $eGOwo.fg)('platform-side-navigation-keyboard-focus');
    const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $fV1cq.default), {
            ...props,
            children: "Go back"
        });
    const { childIdsRef: childIdsRef } = (0, $iIZJ5.useChildIds)(currentStackId, committedStack, onUnknownNest);
    const onNestHandler = (0, $eJOHy.useCallback)((layerId)=>{
        onChange && onChange(committedStack.concat(layerId));
        setFocusGoBackButton(true);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.concat(layerId);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack
    ]);
    const onUnNestHandler = (0, $eJOHy.useCallback)(()=>{
        onChange && onChange(committedStack.slice(0, committedStack.length - 1));
        setActiveParentId(currentStackId);
        setFocusGoBackButton(false);
        if (controlledStack) // We are in controlled mode - ignore the steps.
        return;
        // We need to split the state update into to parts.
        // First: Updating the direction of the motions.
        // Second: Actually updating the stack (which will cause elements to enter & leave).
        setTransition('unnesting');
        requestAnimationFrame(()=>{
            setCommittedStack((prev)=>{
                const newStack = prev.slice(0, prev.length - 1);
                return newStack;
            });
        });
    }, [
        controlledStack,
        onChange,
        committedStack,
        setActiveParentId,
        currentStackId
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!controlledStack) // We aren't in controlled mode - bail out.
        return;
        if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) // stacks are equal - do nothing!
        return;
        // Controlled prop updated, let's figure out if we're nesting or unnesting.
        if (controlledStack.length < committedStack.length) // We are unnesting (removing from the stack)
        setTransition('unnesting');
        else // We are nesting (adding to the stack)
        setTransition('nesting');
        requestAnimationFrame(()=>{
            setCommittedStack(controlledStack);
        });
    }, [
        committedStack,
        controlledStack
    ]);
    const backButton = renderGoBackItem({
        onClick: onUnNestHandler,
        testId: backTestId,
        ref: shouldFocus ? goBackButtonRef : null
    });
    const context = (0, $eJOHy.useMemo)(()=>({
            currentStackId: currentStackId,
            backButton: backButton,
            stack: committedStack,
            onNest: onNestHandler,
            onUnNest: onUnNestHandler,
            parentId: $bed75de04f6c5b44$export$ec71a3379b43ae5c,
            childIds: childIdsRef,
            forceShowTopScrollIndicator: showTopScrollIndicator,
            activeParentId: activeParentId,
            goBackButtonRef: goBackButtonRef,
            isDefaultFocusControl: isDefaultFocusControl,
            focusGoBackButton: focusGoBackButton
        }), [
        currentStackId,
        backButton,
        committedStack,
        onNestHandler,
        onUnNestHandler,
        childIdsRef,
        showTopScrollIndicator,
        activeParentId,
        goBackButtonRef,
        isDefaultFocusControl,
        focusGoBackButton
    ]);
    const manageFocus = (event)=>{
        const triggeredByKeyboard = event.nativeEvent.detail === 0;
        if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
    };
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            "data-testid": testId,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus,
            className: (0, $hcewu.default)([
                "_12ji1r31 _1qu2glyw _12y31o36 _4t3i1osq _kqswh2mm"
            ]),
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ys7jv.default), {
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gkgS5.NestingMotion), {
                    enterFrom: transition === 'nesting' ? 'right' : 'left',
                    exitTo: transition === 'nesting' ? 'left' : 'right',
                    testId: testId && `${testId}-anim`,
                    children: (motion)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                            ...motion,
                            className: (0, $hcewu.default)([
                                "_1e0c1txw _1bsb1osq _4t3i1osq _kqswstnw _2lx21bp4",
                                motion.className
                            ]),
                            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2eOKX.NestedContext).Provider, {
                                // This provider is inside the NestingMotion to ensure it keeps a stale
                                // reference to the previous value.
                                value: context,
                                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eOsRG.default), {
                                    title: "",
                                    id: $bed75de04f6c5b44$export$ec71a3379b43ae5c,
                                    children: children
                                })
                            })
                        })
                }, currentStackId)
            })
        })
    });
};
var $bed75de04f6c5b44$export$2e2bcd8739ae039 = $bed75de04f6c5b44$var$NestableNavigationContent;

});
parcelRegister("fV1cq", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8afd681eb2485e3$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aJCX7 = parcelRequire("aJCX7");


var $lOpB3 = parcelRequire("lOpB3");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 */ const $d8afd681eb2485e3$var$GoBackItem = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aJCX7))), {
    color: "currentColor",
    LEGACY_secondaryColor: `var(--ds-surface, ${(0, $7bb4c1736002a04a$export$e655ef011c4aa1a2)})`,
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $eJOHy.useState)(false);
    const onClickHandler = (0, $eJOHy.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $lOpB3.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $d8afd681eb2485e3$export$2e2bcd8739ae039 = $d8afd681eb2485e3$var$GoBackItem;

});
parcelRegister("aJCX7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14166727518fb35f8b6d88aee12f245c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d0c52868d3bbdb8$var$_react = $7d0c52868d3bbdb8$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7d0c52868d3bbdb8$var$_arrowLeft = $7d0c52868d3bbdb8$var$_interopRequireDefault((parcelRequire("aqu01")));

var $7d0c52868d3bbdb8$var$_arrowLeftCircle = $7d0c52868d3bbdb8$var$_interopRequireDefault((parcelRequire("ebhGv")));
function $7d0c52868d3bbdb8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowLeftIcon.
 * This component is ArrowLeftIcon, with `UNSAFE_fallbackIcon` set to "ArrowLeftCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d0c52868d3bbdb8$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $7d0c52868d3bbdb8$var$_react.default.createElement($7d0c52868d3bbdb8$var$_arrowLeft.default, Object.assign({
        name: "ArrowLeftIcon",
        LEGACY_fallbackIcon: $7d0c52868d3bbdb8$var$_arrowLeftCircle.default
    }, props));
$7d0c52868d3bbdb8$var$ArrowLeftIcon.displayName = 'ArrowLeftIconMigration';
var $7d0c52868d3bbdb8$var$_default = module.exports.default = $7d0c52868d3bbdb8$var$ArrowLeftIcon;

});
parcelRegister("ebhGv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a52fcf907d8b67b3$var$_react = $a52fcf907d8b67b3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $a52fcf907d8b67b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a52fcf907d8b67b3$var$ArrowLeftCircleIcon = (props)=>/*#__PURE__*/ $a52fcf907d8b67b3$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
    }, props));
$a52fcf907d8b67b3$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
var $a52fcf907d8b67b3$var$_default = module.exports.default = $a52fcf907d8b67b3$var$ArrowLeftCircleIcon;

});



parcelRegister("iIZJ5", function(module, exports) {
$parcel$export(module.exports, "useChildIds", () => $94c16a439874c22d$export$61b3ef4f009a9474);
$parcel$export(module.exports, "useChildIdsEffect", () => $94c16a439874c22d$export$ea18c2b5f0e24612);

var $eJOHy = parcelRequire("eJOHy");

var $jcciq = parcelRequire("jcciq");
const $94c16a439874c22d$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
    const childIdsRef = (0, $eJOHy.useRef)(new Set());
    (0, $eJOHy.useEffect)(()=>{
        // we are holding navigation item IDs in childIdsRef
        // check if the current displayed nav item (currentStackId) is in childIdsRef. if it's not, this means it's undefined
        if (currentStackId === (0, $jcciq.ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
        onUnknownNest(committedStack || [
            currentStackId
        ]);
    }, [
        currentStackId,
        committedStack,
        onUnknownNest
    ]);
    return {
        childIdsRef: childIdsRef
    };
};
const $94c16a439874c22d$export$ea18c2b5f0e24612 = (childIds, id)=>{
    (0, $eJOHy.useEffect)(()=>{
        if (!childIds || !childIds.current) return;
        if (!childIds.current.has(id)) childIds.current.add(id);
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            childIds.current.delete(id);
        };
    // childIds shouldn't change as it's a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
};

});

parcelRegister("gkgS5", function(module, exports) {
$parcel$export(module.exports, "NestingMotion", () => $a5b530baab8af272$export$9e743a8c2a6b450e);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8UpxG = parcelRequire("8UpxG");
const $a5b530baab8af272$export$9e743a8c2a6b450e = (props)=>{
    const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8UpxG.default), {
        exitTo: exitTo,
        enterFrom: enterFrom,
        animationTimingFunction: "ease-out",
        children: (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            })
    });
};

});



parcelRegister("dysGT", function(module, exports) {
$parcel$export(module.exports, "SidebarErrorBoundary", () => $c7f6dd1cac39f594$export$62853c5766dad0c4);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $kQnVX = parcelRequire("kQnVX");

var $ea4Iz = parcelRequire("ea4Iz");
const $c7f6dd1cac39f594$export$62853c5766dad0c4 = (props)=>{
    const userLocation = (0, $kQnVX.getUserLocation)();
    const extraEventData = (0, $eJOHy.useMemo)(()=>({
            ...props.extraEventData,
            userLocation: userLocation
        }), [
        props.extraEventData,
        userLocation
    ]);
    const fallback = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ea4Iz.Fallback), {
            error: error
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        ...props,
        extraEventData: extraEventData,
        fallback: fallback
    });
};

});
parcelRegister("ea4Iz", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $9b4051d45e6e7b1f$export$fb8d7f40caaeea67);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $806LH = parcelRequire("806LH");

var $jLjxj = parcelRequire("jLjxj");

var $lRq8t = parcelRequire("lRq8t");

var $lh7Oqf = parcelRequire("lh7Oqf");

var $6aoQW = parcelRequire("6aoQW");
const $9b4051d45e6e7b1f$var$styles = {
    wrapper: "_zulpu2gc _bfhk1jdc _syaz1mjl _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _y3gn1h6o _4cvr1h6o _1e0c1txw _2lx21bp4",
    error: "_2rkowr30 _11c8dcr7 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
    image: "_4t3i12am"
};
const $9b4051d45e6e7b1f$export$fb8d7f40caaeea67 = (props)=>{
    const { error: error } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.wrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("img", {
        alt: "",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lh7Oqf))),
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.image
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall"
    }, formatMessage((0, $6aoQW.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $6aoQW.default).errorBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("code", {
        className: (0, $hcewu.default)([
            $9b4051d45e6e7b1f$var$styles.error
        ])
    }, "ERROR: ", (0, $jLjxj.getErrorHash)(error)));
};

});
parcelRegister("lh7Oqf", function(module, exports) {
module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();

});

parcelRegister("6aoQW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f850c5d954b638cc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f850c5d954b638cc$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorHeading: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
        "defaultMessage": "Try refreshing or navigating to another page."
    }
});

});



parcelRegister("762yz", function(module, exports) {
$parcel$export(module.exports, "isNormalClick", () => $79b800b4de890321$export$729f3684d5c2b9b9);
const $79b800b4de890321$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);

});


parcelRegister("8xDPn", function(module, exports) {
$parcel$export(module.exports, "matchPathname", () => $d5c7bfee55dffd85$export$b71b01274a8bb9ec);
$parcel$export(module.exports, "matchUrlPathname", () => $d5c7bfee55dffd85$export$6bfcf8859d3bc51c);
$parcel$export(module.exports, "matchPartialUrlPathname", () => $d5c7bfee55dffd85$export$9870a2fa97808ed7);
$parcel$export(module.exports, "matchUrlExact", () => $d5c7bfee55dffd85$export$422d2a799c6e30b8);
$parcel$export(module.exports, "matchUrlParams", () => $d5c7bfee55dffd85$export$63fdecce99465869);

var $ee5Jg = parcelRequire("ee5Jg");
// Jira url paths are messy, so we have to try to clean them to avoid missing matches
// - pages urls sometimes have /secure, sometimes they don't
// - jspa pages urls sometimes have !action, sometimes they don't
const $d5c7bfee55dffd85$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
const $d5c7bfee55dffd85$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$d5c7bfee55dffd85$var$cleanPath(currentUrlPath) === $d5c7bfee55dffd85$var$cleanPath(itemUrlPath);
const $d5c7bfee55dffd85$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$d5c7bfee55dffd85$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
const $d5c7bfee55dffd85$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
const $d5c7bfee55dffd85$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$d5c7bfee55dffd85$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, (/*@__PURE__*/$parcel$interopDefault($ee5Jg)))(currentLocation.query, itemLocation.query);
const $d5c7bfee55dffd85$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $d5c7bfee55dffd85$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);

});


parcelRegister("cIeoi", function(module, exports) {
$parcel$export(module.exports, "toSections", () => $b85249c542836091$export$29678d1e04c0e8c4);

var $LFmXM = parcelRequire("LFmXM");
/**
 * Just in case someone passes a broken object we don't want to blow up the sidebar
 */ const $b85249c542836091$var$normalizeSection = (section)=>({
        header: section?.header,
        pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                icon: page?.icon,
                route: page?.route,
                title: page?.title
            })) : []
    });
const $b85249c542836091$export$29678d1e04c0e8c4 = (0, $LFmXM.default)((extension)=>{
    const { properties: properties } = extension;
    // Only Custom UI supports subpages
    if (typeof properties.resource !== 'string') return [];
    // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.pages !== 'undefined' && properties.pages?.length) // @ts-expect-error - TS2339 - Property 'pages' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return [
        {
            pages: properties.pages
        }
    ].map($b85249c542836091$var$normalizeSection);
    // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'. | TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    if (typeof properties.sections !== 'undefined' && properties.sections?.length) // @ts-expect-error - TS2339 - Property 'sections' does not exist on type 'CommonProps & SubPages & { icon?: string | undefined; layout?: FullPageLayout | undefined; }'.
    return properties.sections.map($b85249c542836091$var$normalizeSection);
    return [];
});

});

parcelRegister("2D0O0", function(module, exports) {
$parcel$export(module.exports, "useAdminForgeApps", () => $657fff86bbca61e2$export$5e650d426477650e);

var $eJOHy = parcelRequire("eJOHy");

var $kU13U = parcelRequire("kU13U");

var $hHbzj = parcelRequire("hHbzj");

var $eJrcF = parcelRequire("eJrcF");

var $f0kD3 = parcelRequire("f0kD3");
const $657fff86bbca61e2$var$configPageFilter = (extension)=>extension.properties.useAsConfig;
const $657fff86bbca61e2$var$getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
const $657fff86bbca61e2$var$adminPageFilter = (extension)=>!$657fff86bbca61e2$var$configPageFilter(extension) && !$657fff86bbca61e2$var$getStartedPageFilter(extension);
const $657fff86bbca61e2$export$5e650d426477650e = (routeName)=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $hHbzj.forgeAdminModuleResource));
    const visibleExtensions = data ? data.filter((0, $kU13U.isExtensionVisible)) : null;
    const stackData = visibleExtensions ? visibleExtensions.filter($657fff86bbca61e2$var$adminPageFilter) : null;
    const stack = (0, $f0kD3.useForgeItemStack)(stackData, routeName);
    return (0, $eJOHy.useMemo)(()=>{
        if (!visibleExtensions) return {
            data: null,
            loading: loading,
            error: error,
            stack: stack
        };
        return {
            data: {
                adminPage: visibleExtensions.filter($657fff86bbca61e2$var$adminPageFilter),
                configPage: visibleExtensions.filter($657fff86bbca61e2$var$configPageFilter),
                getStartedPage: visibleExtensions.filter($657fff86bbca61e2$var$getStartedPageFilter)
            },
            loading: loading,
            error: error,
            stack: stack
        };
    }, [
        visibleExtensions,
        loading,
        error,
        stack
    ]);
};

});
parcelRegister("kU13U", function(module, exports) {
$parcel$export(module.exports, "isExtensionVisible", () => $6d662423b598e6b2$export$41e48b53c2cc2013);
$parcel$export(module.exports, "isExtensionHidden", () => $6d662423b598e6b2$export$3f5b3e61d567ef3);
$parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", () => $6d662423b598e6b2$export$5c38dfa9d1f96e61);
const $6d662423b598e6b2$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
const $6d662423b598e6b2$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
const $6d662423b598e6b2$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
const $6d662423b598e6b2$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';

});

parcelRegister("hHbzj", function(module, exports) {
$parcel$export(module.exports, "forgeAdminModuleResource", () => $7eeccaa3259d40ce$export$b9489d8c5c5e3626);
$parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", () => $7eeccaa3259d40ce$export$dcc98f4b36ce9223);
$parcel$export(module.exports, "forgeProjectModuleResource", () => $7eeccaa3259d40ce$export$72db683c2914a65e);
$parcel$export(module.exports, "forgeBacklogModuleResource", () => $7eeccaa3259d40ce$export$7523db37432ba090);
$parcel$export(module.exports, "forgeBoardModuleResource", () => $7eeccaa3259d40ce$export$cfd99f451b423d3a);
$parcel$export(module.exports, "forgeSprintModuleResource", () => $7eeccaa3259d40ce$export$7b639f33f086f9f1);
$parcel$export(module.exports, "forgePersonalSettingsPageModuleResource", () => $7eeccaa3259d40ce$export$8a5aed164e925eb6);
$parcel$export(module.exports, "getNavigationForgePersonalSettingsPageResources", () => $7eeccaa3259d40ce$export$ec3265610584f9ce);
$parcel$export(module.exports, "forgeProjectSettingsModuleResource", () => $7eeccaa3259d40ce$export$7a928d209faf75f);
$parcel$export(module.exports, "useForgeProjectSettingsModuleResource", () => $7eeccaa3259d40ce$export$e81e11bbc3239153);
$parcel$export(module.exports, "forgeGlobalModuleResource", () => $7eeccaa3259d40ce$export$97b0827022fdafe3);
$parcel$export(module.exports, "getNavigationForgeGlobalPageResources", () => $7eeccaa3259d40ce$export$80b2f91dabb3dd65);
$parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", () => $7eeccaa3259d40ce$export$ebf5369e4dcfad00);
$parcel$export(module.exports, "forgeCustomFieldTypeResource", () => $7eeccaa3259d40ce$export$e6be2f0ca0849869);

var $4sqLM = parcelRequire("4sqLM");

var $fohjD = parcelRequire("fohjD");

var $5KBwc = parcelRequire("5KBwc");

var $fcQiO = parcelRequire("fcQiO");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $aOcSy = parcelRequire("aOcSy");
const $7eeccaa3259d40ce$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
    const isModuleWithAccessNarrowing = [
        (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE),
        (0, $fohjD.PROJECT_PAGE_MODULE),
        (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE)
    ] // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .includes(moduleName);
    const projectIdOrKey = (0, $fcQiO.getProjectKeyOrId)(params);
    if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
        projectIdOrKey: projectIdOrKey
    };
    return null;
};
const $7eeccaa3259d40ce$export$b9489d8c5c5e3626 = (0, $l1VxS.createResource)({
    type: 'FORGE_ADMIN_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.ADMIN_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.ADMIN_PAGE_MODULE], (0, $aOcSy.adminPageFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$dcc98f4b36ce9223 = ()=>[
        $7eeccaa3259d40ce$export$b9489d8c5c5e3626
    ];
const $7eeccaa3259d40ce$export$72db683c2914a65e = (0, $l1VxS.createResource)({
    type: 'FORGE_PROJECT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PROJECT_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PROJECT_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $7eeccaa3259d40ce$export$7523db37432ba090 = (0, $l1VxS.createResource)({
    type: 'FORGE_BACKLOG_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.BACKLOG_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.BACKLOG_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$cfd99f451b423d3a = (0, $l1VxS.createResource)({
    type: 'FORGE_BOARD_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.BOARD_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.BOARD_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$7b639f33f086f9f1 = (0, $l1VxS.createResource)({
    type: 'FORGE_SPRINT_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.SPRINT_ACTION_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: false,
            source: (0, $fohjD.SOURCE_ROUTER)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.SPRINT_ACTION_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$8a5aed164e925eb6 = (0, $l1VxS.createResource)({
    type: 'FORGE_PERSONAL_SETTINGS_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$ec3265610584f9ce = ()=>[
        $7eeccaa3259d40ce$export$8a5aed164e925eb6
    ];
const $7eeccaa3259d40ce$export$7a928d209faf75f = (0, $l1VxS.createResource)({
    type: 'FORGE_PROJECT_SETTINGS_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.PROJECT_SETTINGS_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER,
    isCritical: true
});
const $7eeccaa3259d40ce$export$e81e11bbc3239153 = ()=>(0, $eJrcF.useResource)($7eeccaa3259d40ce$export$7a928d209faf75f);
const $7eeccaa3259d40ce$export$97b0827022fdafe3 = (0, $l1VxS.createResource)({
    type: 'FORGE_GLOBAL_MODULE',
    getKey: ()=>'extensions',
    getData: (_, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.GLOBAL_PAGE_MODULE)
            ],
            context: {},
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.GLOBAL_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$80b2f91dabb3dd65 = ()=>[
        $7eeccaa3259d40ce$export$97b0827022fdafe3
    ];
const $7eeccaa3259d40ce$export$ebf5369e4dcfad00 = (0, $l1VxS.createResource)({
    type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
    getKey: (routeContext)=>{
        const projectKeyOrId = (0, $fcQiO.getProjectKeyOrId)(routeContext.match);
        return `extensions-${projectKeyOrId}`;
    },
    getData: (routeContext, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE)
            ],
            context: {
                projectKey: (0, $fcQiO.getProjectKeyOrId)(routeContext.match)
            },
            includeHidden: true,
            source: (0, $fohjD.SOURCE_FULL_PAGE_APP)
        }).then((modules)=>$7eeccaa3259d40ce$var$normalizeModules(modules[0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $aOcSy.uniqueExtensionsFilter))),
    maxAge: Number.MAX_SAFE_INTEGER
});
const $7eeccaa3259d40ce$export$e6be2f0ca0849869 = (0, $l1VxS.createResource)({
    type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
    getKey: ()=>'extensions',
    getData: (_route, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>(0, $5KBwc.fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            types: [
                (0, $fohjD.CUSTOM_FIELD_TYPE_MODULE)
            ],
            context: {},
            includeHidden: false,
            source: (0, $fohjD.SOURCE_NAVIGATION)
        }).then(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (modules)=>modules[0, $fohjD.CUSTOM_FIELD_TYPE_MODULE]),
    maxAge: Number.MAX_SAFE_INTEGER
});
/**
 * Makes sure modules are filtered out depending on the predicate and sorted alphabetically by title.
 */ function $7eeccaa3259d40ce$var$normalizeModules(modules, filter) {
    return filter(modules).sort((a, b)=>(0, $4sqLM.alphabeticalSort)(a.properties.title, b.properties.title));
}

});
parcelRegister("4sqLM", function(module, exports) {
$parcel$export(module.exports, "alphabeticalSort", () => $b0b7341e5e59d415$export$89a1f01f2a7cb2a1);

var $eSnSE = parcelRequire("eSnSE");
const $b0b7341e5e59d415$export$89a1f01f2a7cb2a1 = (a, b)=>{
    // @ts-expect-error This condition will always return true since this function is always defined. Did you mean to call it instead?ts(2774)
    if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
        numeric: true,
        caseFirst: 'upper'
    });
    const typeOfA = a === null ? 'null' : typeof a;
    const typeOfB = b === null ? 'null' : typeof b;
    const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
    (0, $eSnSE.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
    return 1;
};

});

parcelRegister("aOcSy", function(module, exports) {
$parcel$export(module.exports, "uniqueExtensionsFilter", () => $a0b01b44bfd87d67$export$2b91ba95eded67f6);
$parcel$export(module.exports, "adminPageFilter", () => $a0b01b44bfd87d67$export$1eefd1d9cde49fd5);

var $jOCpp = parcelRequire("jOCpp");

var $ePLco = parcelRequire("ePLco");
const $a0b01b44bfd87d67$export$2b91ba95eded67f6 = (extensions)=>(0, (/*@__PURE__*/$parcel$interopDefault($jOCpp)))(extensions, (extension)=>{
        const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
        return `${appId}_${envId}`;
    });
const $a0b01b44bfd87d67$export$1eefd1d9cde49fd5 = (extensions)=>{
    const configPageFilter = (extension)=>extension.properties.useAsConfig;
    const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
    const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
    return [
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
        ...$a0b01b44bfd87d67$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
    ];
};

});


parcelRegister("f0kD3", function(module, exports) {
$parcel$export(module.exports, "useForgeItemStack", () => $7c0ac0c2556405af$export$462f82a278743d46);

var $eJOHy = parcelRequire("eJOHy");

var $ew1wJ = parcelRequire("ew1wJ");

var $gCY1z = parcelRequire("gCY1z");

var $cIeoi = parcelRequire("cIeoi");
const $7c0ac0c2556405af$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
    const [{ match: match, route: route }] = (0, $gCY1z.useRouter)();
    const matchedExtension = (0, $ew1wJ.useMatchedExtension)({
        modules: modules,
        match: match
    });
    return (0, $eJOHy.useMemo)(()=>{
        if (route.name !== routeName) return null;
        // match nested navigation view
        if (matchedExtension && (0, $cIeoi.toSections)(matchedExtension).length) {
            const stackId = `${matchedExtension.id}-subpages`;
            return parentStack ? [
                ...parentStack,
                stackId
            ] : [
                stackId
            ];
        }
        // match a simple navigation item (a single top-level page is defined in the manifest)
        if (matchedExtension && parentStack) return parentStack;
        // skip
        return null;
    }, [
        matchedExtension,
        parentStack,
        route.name,
        routeName
    ]);
};

});
parcelRegister("ew1wJ", function(module, exports) {
$parcel$export(module.exports, "useMatchedExtension", () => $f86adfa34dae31c9$export$13375c0abccaf6f6);
$parcel$export(module.exports, "useExtensionBasePath", () => $f86adfa34dae31c9$export$25abed85383f0fbb);

var $eJOHy = parcelRequire("eJOHy");

var $ePLco = parcelRequire("ePLco");
const $f86adfa34dae31c9$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $eJOHy.useMemo)(()=>(modules || []).find((app)=>{
            const parsedExtensionId = (0, $ePLco.parseExtensionId)(app.id);
            return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
        }), [
        modules,
        match.params.appId,
        match.params.envId
    ]);
const $f86adfa34dae31c9$export$25abed85383f0fbb = (basePath, route)=>route !== undefined ? basePath.replace(/\/?$/, '').slice(0, -route.length - 1) : basePath.replace(/\/?$/, '');

});



parcelRegister("jwDMz", function(module, exports) {
$parcel$export(module.exports, "messages", () => $b6fd6d66ebacc16e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $b6fd6d66ebacc16e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.admin-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("2qjvD", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $20498ab572fb061d$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeProjectSection", () => $20498ab572fb061d$export$fb7da191295a7e22);
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- PLEASE FIX - ENABLING FLAT LINT CONFIG

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");

var $FhXEJ = parcelRequire("FhXEJ");

var $aeOhE = parcelRequire("aeOhE");

var $kA543 = parcelRequire("kA543");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $lRq8t = parcelRequire("lRq8t");

var $2aY2d = parcelRequire("2aY2d");

var $bOOEr = parcelRequire("bOOEr");

var $cIeoi = parcelRequire("cIeoi");

var $7tFyB = parcelRequire("7tFyB");

var $aTUdE = parcelRequire("aTUdE");
// @ts-expect-error - It's genuinely missing Jira Product Discovery.
const $20498ab572fb061d$var$projectTypeRouteMap = {
    [(0, $FhXEJ.CORE_PROJECT)]: 'core',
    [(0, $FhXEJ.SOFTWARE_PROJECT)]: 'software',
    [(0, $FhXEJ.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $20498ab572fb061d$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/${$20498ab572fb061d$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $20498ab572fb061d$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
    const { data: data } = (0, $7tFyB.useProjectForgeApps)();
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const filteredForgeAppsData = (0, $eJOHy.useMemo)(()=>overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
            overrides.selectedApp
        ] : data || [], [
        data,
        overrides
    ]);
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey, projectType: projectType } = projectContextData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kA543.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, $aTUdE.messages).forgeSectionTitle)
    }, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bOOEr.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $20498ab572fb061d$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $cIeoi.toSections)(extension),
            moduleName: (0, $fohjD.PROJECT_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true,
            nestedMenuActive: nestedMenuActive,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.PROJECT_PAGE_MODULE)
        }
    })));
};

});
parcelRegister("kA543", function(module, exports) {
$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $401f565946816ef4$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $401f565946816ef4$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $401f565946816ef4$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.PROJECT_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $401f565946816ef4$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.PROJECT_PAGE_MODULE),
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("7tFyB", function(module, exports) {
$parcel$export(module.exports, "useProjectForgeApps", () => $5c893daac437a4fa$export$338edd25edcf3648);
$parcel$export(module.exports, "useProjectForgeAppsNav4", () => $5c893daac437a4fa$export$80e84933a3e2f677);

var $eJOHy = parcelRequire("eJOHy");

var $kU13U = parcelRequire("kU13U");

var $hHbzj = parcelRequire("hHbzj");

var $bo7Z6 = parcelRequire("bo7Z6");

var $f0kD3 = parcelRequire("f0kD3");
const $5c893daac437a4fa$export$338edd25edcf3648 = (routeName, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $hHbzj.forgeProjectModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const projectData = (0, $eJOHy.useMemo)(()=>data?.filter?.((0, $kU13U.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $eJOHy.useMemo)(()=>data?.filter?.((0, $kU13U.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $f0kD3.useForgeItemStack)(projectData, routeName);
    return (0, $eJOHy.useMemo)(()=>({
            data: projectData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        projectData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $5c893daac437a4fa$export$80e84933a3e2f677 = (projectKey)=>$5c893daac437a4fa$export$338edd25edcf3648(undefined, projectKey);

});

parcelRegister("aTUdE", function(module, exports) {
$parcel$export(module.exports, "messages", () => $570944cb831a48ba$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $570944cb831a48ba$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("lL0Pt", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $3f877eb35d2d400a$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgePersonalSettingsSection", () => $3f877eb35d2d400a$export$3f793b2ffe120524);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");

var $aeOhE = parcelRequire("aeOhE");

var $8PvQT = parcelRequire("8PvQT");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $lRq8t = parcelRequire("lRq8t");

var $bxWdr = parcelRequire("bxWdr");

var $bOOEr = parcelRequire("bOOEr");

var $cIeoi = parcelRequire("cIeoi");

var $2RByg = parcelRequire("2RByg");

var $hSFjO = parcelRequire("hSFjO");
const $3f877eb35d2d400a$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `${(0, $bxWdr.getAppsPersonalSettingsPath)()}/${appId}/${envId}`;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3f877eb35d2d400a$var$BaseForgePersonalSettingsSection = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: pages } = (0, $2RByg.usePersonalSettingsForgeApps)();
    if (!pages?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $hSFjO.messages).forgeSectionTitle)
    }, pages.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bOOEr.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $3f877eb35d2d400a$export$ed6342e0e28465a6(extension),
            name: extension.properties.title,
            sections: (0, $cIeoi.toSections)(extension),
            moduleName: (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
        }
    }));
};
const $3f877eb35d2d400a$export$3f793b2ffe120524 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8PvQT.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f877eb35d2d400a$var$BaseForgePersonalSettingsSection, null));

});
parcelRegister("8PvQT", function(module, exports) {
$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $d37d14948a8f563c$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $d37d14948a8f563c$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $d37d14948a8f563c$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $d37d14948a8f563c$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE),
        ...props,
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER)
    });

});

parcelRegister("bxWdr", function(module, exports) {
$parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$693b70d1bcef8627);
$parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$21946ea4c58fd4c9);
$parcel$export(module.exports, "DIGEST_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$cff16c3a6aa7a3a9);
$parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", () => $07c184ad65442c98$export$2321c59d517801c8);
$parcel$export(module.exports, "getGeneralPersonalSettingsPath", () => $07c184ad65442c98$export$db9e3ccc1e5e3317);
$parcel$export(module.exports, "getNotificationsPersonalSettingsPath", () => $07c184ad65442c98$export$64a672523a583594);
$parcel$export(module.exports, "getAppsPersonalSettingsPath", () => $07c184ad65442c98$export$1a7321c4210a3049);
const $07c184ad65442c98$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
const $07c184ad65442c98$export$a974f4af282a75ba = '/jira/settings/personal';
const $07c184ad65442c98$export$693b70d1bcef8627 = `${$07c184ad65442c98$export$a974f4af282a75ba}/general`;
const $07c184ad65442c98$export$21946ea4c58fd4c9 = `${$07c184ad65442c98$export$a974f4af282a75ba}/notifications`;
const $07c184ad65442c98$export$cff16c3a6aa7a3a9 = `${$07c184ad65442c98$export$a974f4af282a75ba}/digests`;
const $07c184ad65442c98$export$1fffbb6055aa320a = `${$07c184ad65442c98$export$a974f4af282a75ba}/apps`;
const $07c184ad65442c98$export$2321c59d517801c8 = `${$07c184ad65442c98$export$a974f4af282a75ba}/alert-notifications`;
function $07c184ad65442c98$export$db9e3ccc1e5e3317() {
    return $07c184ad65442c98$export$693b70d1bcef8627;
}
function $07c184ad65442c98$export$88a45ae8c4b1c664() {
    return $07c184ad65442c98$export$2321c59d517801c8;
}
function $07c184ad65442c98$export$64a672523a583594() {
    return $07c184ad65442c98$export$21946ea4c58fd4c9;
}
function $07c184ad65442c98$export$1a7321c4210a3049() {
    return $07c184ad65442c98$export$1fffbb6055aa320a;
}

});

parcelRegister("2RByg", function(module, exports) {
$parcel$export(module.exports, "usePersonalSettingsForgeApps", () => $340427429f0f97f4$export$8d963c22c65d141a);

var $eJOHy = parcelRequire("eJOHy");

var $hHbzj = parcelRequire("hHbzj");

var $eJrcF = parcelRequire("eJrcF");

var $f0kD3 = parcelRequire("f0kD3");
const $340427429f0f97f4$export$8d963c22c65d141a = (routeName)=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $hHbzj.forgePersonalSettingsPageModuleResource));
    const stack = (0, $f0kD3.useForgeItemStack)(data, routeName);
    return (0, $eJOHy.useMemo)(()=>{
        return {
            data: data,
            loading: loading,
            error: error,
            stack: stack
        };
    }, [
        data,
        loading,
        error,
        stack
    ]);
};

});

parcelRegister("hSFjO", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9fa736d3bbe71bc0$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $9fa736d3bbe71bc0$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.personal-settings-section.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("bnptD", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $73419d8189bc5995$export$ed6342e0e28465a6);
$parcel$export(module.exports, "default", () => $73419d8189bc5995$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $diNYL = parcelRequire("diNYL");

var $aeOhE = parcelRequire("aeOhE");

var $g9x9X = parcelRequire("g9x9X");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $lRq8t = parcelRequire("lRq8t");

var $2aY2d = parcelRequire("2aY2d");

var $bOOEr = parcelRequire("bOOEr");

var $cIeoi = parcelRequire("cIeoi");

var $10vUC = parcelRequire("10vUC");

var $fB8GV = parcelRequire("fB8GV");
const $73419d8189bc5995$export$ed6342e0e28465a6 = (extension, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/servicedesk/projects/${projectKey}/queues/apps/${appId}/${envId}`;
};
const $73419d8189bc5995$export$a133aa9cc8b5e080 = ()=>{
    const { data: data } = (0, $10vUC.useServiceDeskQueueForgeApps)();
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!data?.length || !projectContextData) return null;
    const { projectKey: projectKey } = projectContextData;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $diNYL.default), {
        title: formatMessage((0, $fB8GV.messages).forgeSectionTitle)
    }, data.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bOOEr.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $73419d8189bc5995$export$ed6342e0e28465a6(extension, projectKey),
            name: extension.properties.title,
            sections: (0, $cIeoi.toSections)(extension),
            moduleName: (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE)
        }
    }));
};
const $73419d8189bc5995$var$ForgeServiceDeskQueueSectionWithTriggerAnalytics = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g9x9X.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($73419d8189bc5995$export$a133aa9cc8b5e080, null));
var $73419d8189bc5995$export$2e2bcd8739ae039 = $73419d8189bc5995$var$ForgeServiceDeskQueueSectionWithTriggerAnalytics;

});
parcelRegister("g9x9X", function(module, exports) {
$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $6b8a739d74e689b8$export$c794eb4124961145);
$parcel$export(module.exports, "TriggerAnalyticsWrapper", () => $6b8a739d74e689b8$export$e1a79e3d472c925a);

var $eJOHy = parcelRequire("eJOHy");

var $fohjD = parcelRequire("fohjD");

var $aeOhE = parcelRequire("aeOhE");

var $9gq2c = parcelRequire("9gq2c");
const $6b8a739d74e689b8$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $6b8a739d74e689b8$export$e1a79e3d472c925a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeAnalyticsWrapper), {
        module: (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE),
        moduleType: (0, $9gq2c.MODULE_TYPE_TRIGGER),
        ...props
    });

});

parcelRegister("10vUC", function(module, exports) {
$parcel$export(module.exports, "useServiceDeskQueueForgeApps", () => $9094fe08f163a507$export$8a2bb837db423089);
$parcel$export(module.exports, "useServiceDeskQueueForgeAppsNav4", () => $9094fe08f163a507$export$52b0be0dcb122e71);

var $eJOHy = parcelRequire("eJOHy");

var $kU13U = parcelRequire("kU13U");

var $hHbzj = parcelRequire("hHbzj");

var $bo7Z6 = parcelRequire("bo7Z6");

var $f0kD3 = parcelRequire("f0kD3");
const $9094fe08f163a507$export$8a2bb837db423089 = (routeName, parentStack, projectKey)=>{
    const { data: data, loading: loading, error: error } = (0, $bo7Z6.useResourceWithCustomRouterContext)((0, $hHbzj.forgeServiceDeskQueueModuleResource), projectKey ? {
        matchParams: {
            projectKey: projectKey
        }
    } : undefined);
    const serviceDeskQueueData = (0, $eJOHy.useMemo)(()=>data?.filter?.((0, $kU13U.isExtensionVisible)) || null, [
        data
    ]);
    const accessNarrowedData = (0, $eJOHy.useMemo)(()=>data?.filter?.((0, $kU13U.isExtensionHiddenByAppAccessRules)) || null, [
        data
    ]);
    const stack = (0, $f0kD3.useForgeItemStack)(serviceDeskQueueData, routeName, parentStack);
    return (0, $eJOHy.useMemo)(()=>({
            data: serviceDeskQueueData,
            accessNarrowedData: accessNarrowedData,
            loading: loading,
            error: error,
            stack: stack
        }), [
        serviceDeskQueueData,
        accessNarrowedData,
        loading,
        error,
        stack
    ]);
};
const $9094fe08f163a507$export$52b0be0dcb122e71 = (projectKey)=>$9094fe08f163a507$export$8a2bb837db423089(undefined, undefined, projectKey);

});

parcelRegister("fB8GV", function(module, exports) {
$parcel$export(module.exports, "messages", () => $842f3e91864a3326$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $842f3e91864a3326$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    forgeSectionTitle: {
        "id": "navigation-apps-sidebar-forge.servicedesk-queue.forge-section-title",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("lusn0", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $45efb96e424cf390$export$ed6342e0e28465a6);

var $ePLco = parcelRequire("ePLco");
const $45efb96e424cf390$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/${projectType}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};

});

parcelRegister("kAWUp", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $9bb328f2d74bd123$export$ed6342e0e28465a6);
$parcel$export(module.exports, "useGlobalForgeApps", () => $9bb328f2d74bd123$export$f834c14187f80532);

var $eJOHy = parcelRequire("eJOHy");

var $ePLco = parcelRequire("ePLco");

var $kU13U = parcelRequire("kU13U");

var $hHbzj = parcelRequire("hHbzj");

var $eJrcF = parcelRequire("eJrcF");
const $9bb328f2d74bd123$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/apps/${appId}/${envId}`;
};
const $9bb328f2d74bd123$export$f834c14187f80532 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $eJrcF.useResource)((0, $hHbzj.forgeGlobalModuleResource));
    return (0, $eJOHy.useMemo)(()=>({
            data: data ? data.filter((0, $kU13U.isExtensionVisible)) : null,
            loading: loading,
            error: error
        }), [
        data,
        loading,
        error
    ]);
};

});

parcelRegister("gars4", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $6847a66f90d6aa1f$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeAdminSection", () => $6847a66f90d6aa1f$export$a70dd1f096fc6a5f);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $4cTDP = parcelRequire("4cTDP");

var $aeOhE = parcelRequire("aeOhE");

var $g3Q1G = parcelRequire("g3Q1G");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $lRq8t = parcelRequire("lRq8t");

var $cIeoi = parcelRequire("cIeoi");

var $2D0O0 = parcelRequire("2D0O0");

var $euVUL = parcelRequire("euVUL");

var $e7t2M = parcelRequire("e7t2M");
const $6847a66f90d6aa1f$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/settings/apps/${appId}/${envId}`;
};
const $6847a66f90d6aa1f$export$a70dd1f096fc6a5f = ({ analytics: analytics })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: data } = (0, $2D0O0.useAdminForgeApps)();
    const pages = data?.adminPage ?? null;
    if (!pages?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g3Q1G.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), {
        isMenuListItem: (0, $4cTDP.fg)('platform_design_system_nav4_sidenav_a11y')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $e7t2M.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, pages.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euVUL.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $6847a66f90d6aa1f$export$ed6342e0e28465a6(extension),
            name: extension.properties.title,
            sections: (0, $cIeoi.toSections)(extension),
            iconUrl: extension.properties.icon,
            analytics: analytics,
            showIcon: true
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.ADMIN_PAGE_MODULE)
        }
    }));
};

});
parcelRegister("85fS3", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $d7024e53a2ac3b55$export$d4c4e98c5044dc8);

var $1CMu6 = parcelRequire("1CMu6");
const $d7024e53a2ac3b55$export$d4c4e98c5044dc8 = (0, $1CMu6.List);

});

parcelRegister("1ejND", function(module, exports) {
$parcel$export(module.exports, "MenuSection", () => $ab29bba6ec8b0fc6$export$4b1545b4f2016d26);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $gl2vi = parcelRequire("gl2vi");

var $ih05Y = parcelRequire("ih05Y");

var $4ymIv = parcelRequire("4ymIv");
const $ab29bba6ec8b0fc6$export$4b1545b4f2016d26 = ({ children: children, testId: testId, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $gl2vi.useId)();
    const content = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4ymIv.MenuSectionContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
            role: "group",
            "aria-labelledby": `${id}-heading`,
            children: children
        })
    });
    if (isMenuListItem) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ih05Y.MenuListItem), {
        testId: testId,
        children: content
    });
    // Legacy. isMenuListItem should become default.
    return content;
};

});
parcelRegister("ih05Y", function(module, exports) {
$parcel$export(module.exports, "MenuListItem", () => $8ad28d791afa23ab$export$6c2f3257abc4825b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4sCzd = parcelRequire("4sCzd");
const $8ad28d791afa23ab$export$6c2f3257abc4825b = (0, $4sCzd.ListItem);

});

parcelRegister("4ymIv", function(module, exports) {
$parcel$export(module.exports, "MenuSectionContext", () => $0c2005f77fb11a65$export$728ac99b9c7eea8a);
$parcel$export(module.exports, "useMenuSectionContext", () => $0c2005f77fb11a65$export$8100cda602411810);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");
const $0c2005f77fb11a65$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $0c2005f77fb11a65$export$8100cda602411810 = ()=>{
    const context = (0, $eJOHy.useContext)($0c2005f77fb11a65$export$728ac99b9c7eea8a);
    (0, $8GOss.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};

});


parcelRegister("4REVJ", function(module, exports) {
$parcel$export(module.exports, "MenuSectionHeading", () => $f105840484298cca$export$5d3acdbf9237a364);
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $4ymIv = parcelRequire("4ymIv");
const $f105840484298cca$var$styles = {
    root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
};
const $f105840484298cca$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $4ymIv.useMenuSectionContext)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)("p", {
        id: `${id}-heading`,
        className: (0, $hcewu.default)([
            $f105840484298cca$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("euVUL", function(module, exports) {
$parcel$export(module.exports, "getForgeItemAnalytics", () => $af531e8059fb799c$export$1ad91c1de5ad0bdf);
$parcel$export(module.exports, "ForgeItem", () => $af531e8059fb799c$export$26a5287439a1d287);

var $eJOHy = parcelRequire("eJOHy");

var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");

var $iMZxW = parcelRequire("iMZxW");

var $4cTDP = parcelRequire("4cTDP");

var $8z6Yy = parcelRequire("8z6Yy");

var $lTN3C = parcelRequire("lTN3C");

var $jRu18 = parcelRequire("jRu18");

var $4QtKR = parcelRequire("4QtKR");

var $eaBoL = parcelRequire("eaBoL");

var $estpl = parcelRequire("estpl");
const $af531e8059fb799c$export$1ad91c1de5ad0bdf = (analytics, itemId)=>{
    return {
        ...analytics,
        // @ts-expect-error - itemType is not in the type
        itemType: 'app',
        componentType: 'customItem',
        itemId: itemId
    };
};
const $af531e8059fb799c$export$26a5287439a1d287 = (props)=>{
    const { id: itemId, url: url, showIcon: showIcon, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides, analytics: analytics, HideFromSidebarButton: HideFromSidebarButton } = props;
    const location = (0, $jRu18.useLocation)();
    const shouldExpandAsDefault = (0, $eJOHy.useMemo)(()=>location.pathname.includes(url), [
        url,
        location
    ]);
    const onNestedMenuItemClick = (0, $eJOHy.useCallback)((event)=>{
        if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event);
        return ()=>null;
    }, [
        overrides
    ]);
    const itemAnalytics = (0, $eJOHy.useMemo)(()=>{
        return $af531e8059fb799c$export$1ad91c1de5ad0bdf(analytics, itemId);
    }, [
        analytics,
        itemId
    ]);
    const expandableItemAnalytics = (0, $eJOHy.useMemo)(()=>{
        return {
            ...itemAnalytics,
            level: 2,
            itemType: 'appSubpage',
            parentItemType: 'app'
        };
    }, [
        itemAnalytics
    ]);
    if (!sections?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $estpl.ForgeItemSimple), {
        ...props,
        analytics: itemAnalytics
    });
    if (overrides?.showSelectedAppMenuOnly) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eaBoL.ForgeItemExpandable), {
        ...props,
        analytics: itemAnalytics
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
        isDefaultExpanded: shouldExpandAsDefault
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTN3C.default), {
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QtKR.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        testId: `navigation-sidebar.project-menu.forge-app.${itemId}.expandable-menu-item-trigger.root`,
        analytics: itemAnalytics,
        onClick: onNestedMenuItemClick,
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-forge-item' : undefined,
        ...(0, $4cTDP.fg)('more_for_nav_4_level_3') ? {
            actionsOnHover: HideFromSidebarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
                MenuItems: HideFromSidebarButton,
                name: name
            })
        } : {}
    }, (0, $iMZxW.nameWithCustomEnvironment)(name, environmentType, environmentKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eaBoL.ForgeItemExpandable), {
        ...props,
        analytics: expandableItemAnalytics
    })));
};

});
parcelRegister("1Bb7G", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItem", () => $9e505f6b36dba8ea$export$341dea48c30b36ff);
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $7O2l7 = parcelRequire("7O2l7");

var $ih05Y = parcelRequire("ih05Y");

var $yFG6a = parcelRequire("yFG6a");
const $9e505f6b36dba8ea$var$relativeStyles = {
    root: "_kqswh2mm"
};
const $9e505f6b36dba8ea$export$341dea48c30b36ff = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $7O2l7.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ih05Y.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                        className: (0, $hcewu.default)([
                            dropIndicator && $9e505f6b36dba8ea$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});

});
parcelRegister("yFG6a", function(module, exports) {
$parcel$export(module.exports, "AreAllAncestorsExpandedContext", () => $8ec41dd7e18c6b5c$export$9c01e0e6a504d553);
$parcel$export(module.exports, "IsExpandedContext", () => $8ec41dd7e18c6b5c$export$c856e5885cc34d81);
$parcel$export(module.exports, "SetIsExpandedContext", () => $8ec41dd7e18c6b5c$export$48cb11cb8691f597);
$parcel$export(module.exports, "OnExpansionToggleContext", () => $8ec41dd7e18c6b5c$export$572ce188c913ceba);
$parcel$export(module.exports, "LevelContext", () => $8ec41dd7e18c6b5c$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "useIsExpanded", () => $8ec41dd7e18c6b5c$export$37e565a09598825e);
$parcel$export(module.exports, "useSetIsExpanded", () => $8ec41dd7e18c6b5c$export$c9a171ea8de5861b);
$parcel$export(module.exports, "useOnExpansionToggle", () => $8ec41dd7e18c6b5c$export$56c8438498b72c7a);
$parcel$export(module.exports, "useLevel", () => $8ec41dd7e18c6b5c$export$fdfe9e5e8183d4f2);
$parcel$export(module.exports, "useAreAllAncestorsExpanded", () => $8ec41dd7e18c6b5c$export$57108b5f08ae5194);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $4vXRJ = parcelRequire("4vXRJ");
const $8ec41dd7e18c6b5c$export$9c01e0e6a504d553 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8ec41dd7e18c6b5c$export$c856e5885cc34d81 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8ec41dd7e18c6b5c$export$48cb11cb8691f597 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8ec41dd7e18c6b5c$export$572ce188c913ceba = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8ec41dd7e18c6b5c$export$650d12d3c2ddb8fc = (0, $4vXRJ.ExpandableMenuItemLevelContext);
const $8ec41dd7e18c6b5c$export$37e565a09598825e = ()=>{
    const context = (0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$c856e5885cc34d81);
    (0, $8GOss.default)(context !== null, 'useIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $8ec41dd7e18c6b5c$export$c9a171ea8de5861b = ()=>{
    const context = (0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$48cb11cb8691f597);
    (0, $8GOss.default)(context !== null, 'useSetIsExpanded must be used within an ExpandableMenuItem');
    return context;
};
const $8ec41dd7e18c6b5c$export$56c8438498b72c7a = ()=>(0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$572ce188c913ceba);
const $8ec41dd7e18c6b5c$export$fdfe9e5e8183d4f2 = ()=>(0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$650d12d3c2ddb8fc);
const $8ec41dd7e18c6b5c$export$57108b5f08ae5194 = ()=>(0, $eJOHy.useContext)($8ec41dd7e18c6b5c$export$9c01e0e6a504d553) ?? true;

});
parcelRegister("4vXRJ", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemLevelContext", () => $38818bcdf3089c2e$export$f8d6463f9b5ca897);

var $eJOHy = parcelRequire("eJOHy");
const $38818bcdf3089c2e$export$f8d6463f9b5ca897 = /*#__PURE__*/ (0, $eJOHy.createContext)(0);

});



parcelRegister("7Z9EK", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemContent", () => $b0b0a6a7ad4d5986$export$bd680a81504a92e9);
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $1CMu6 = parcelRequire("1CMu6");

var $yFG6a = parcelRequire("yFG6a");
const $b0b0a6a7ad4d5986$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $b0b0a6a7ad4d5986$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $yFG6a.useIsExpanded)();
    const level = (0, $yFG6a.useLevel)();
    const hasExpanded = (0, $eJOHy.useRef)(false);
    const areAllAncestorsExpanded = (0, $yFG6a.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $yFG6a.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1CMu6.List), {
                ref: forwardedRef,
                xcss: (0, $k0ahr.cx)($b0b0a6a7ad4d5986$var$styles.content, !isExpanded && $b0b0a6a7ad4d5986$var$styles.collapsedContent),
                children: children
            })
        })
    });
});

});

parcelRegister("8z6Yy", function(module, exports) {
$parcel$export(module.exports, "MoreNavMenuButton", () => $9131585cbd63b3e0$export$df3f5812ef8777cb);

var $eJOHy = parcelRequire("eJOHy");

var $8nMzv = parcelRequire("8nMzv");

var $he6m3 = parcelRequire("he6m3");

var $hWhA8 = parcelRequire("hWhA8");

var $uUJju = parcelRequire("uUJju");
const $9131585cbd63b3e0$export$df3f5812ef8777cb = /*#__PURE__*/ (0, $eJOHy.memo)(({ MenuItems: MenuItems, name: name, onOpen: onOpen, onClose: onCloseFlyout })=>{
    const { isOpen: isOpen, onClose: onCloseDropdown, onToggle: onToggle } = (0, $he6m3.useOpenable)();
    const content = (0, $eJOHy.useCallback)((contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hWhA8.MoreNavMenuButtonSubmenu), {
            ...contentProps,
            MenuItems: MenuItems
        }), [
        MenuItems
    ]);
    const onClose = (0, $eJOHy.useCallback)((e)=>{
        try {
            onCloseFlyout?.(e);
        } finally{
            onCloseDropdown();
        }
    }, [
        onCloseFlyout,
        onCloseDropdown
    ]);
    const onTriggerClick = (0, $eJOHy.useCallback)(()=>{
        try {
            if (!isOpen) onOpen?.();
        } finally{
            onToggle();
        }
    }, [
        isOpen,
        onOpen,
        onToggle
    ]);
    const trigger = (0, $eJOHy.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $uUJju.MoreNavMenuButtonTrigger), {
            ...triggerProps,
            name: name,
            onClick: onTriggerClick,
            isSelected: isOpen,
            testId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.more-nav-menu-button-trigger"
        }), [
        isOpen,
        name,
        onTriggerClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nMzv.JiraPopup), {
        content: content,
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        messageId: "navigation-apps-sidebar-nav4-sidebars-common-core.ui.more-nav-menu-button.popup",
        messageType: "transactional",
        trigger: trigger,
        shouldRenderToParent: true
    });
});

});
parcelRegister("he6m3", function(module, exports) {
$parcel$export(module.exports, "useOpenable", () => $40c5fa9f2d8d08c0$export$e07f550759260fd7);

var $eJOHy = parcelRequire("eJOHy");
const $40c5fa9f2d8d08c0$export$e07f550759260fd7 = (initialState = false)=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(initialState);
    const onClose = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const onOpen = (0, $eJOHy.useCallback)(()=>setIsOpen(true), [
        setIsOpen
    ]);
    const onToggle = (0, $eJOHy.useCallback)(()=>setIsOpen((value)=>!value), [
        setIsOpen
    ]);
    return {
        isOpen: isOpen,
        onClose: onClose,
        onOpen: onOpen,
        onToggle: onToggle,
        setIsOpen: setIsOpen
    };
};

});

parcelRegister("hWhA8", function(module, exports) {
$parcel$export(module.exports, "MoreNavMenuButtonSubmenu", () => $c9f675a950e90253$export$ac88f3e136748c4a);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $8IeH1 = parcelRequire("8IeH1");

var $5Q9JR = parcelRequire("5Q9JR");
const $c9f675a950e90253$var$stopEventPropagation = (event)=>event.stopPropagation();
const $c9f675a950e90253$export$ac88f3e136748c4a = ({ MenuItems: MenuItems, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        onMouseEnter: $c9f675a950e90253$var$stopEventPropagation,
        onMouseLeave: $c9f675a950e90253$var$stopEventPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), {
        minWidth: (0, $5Q9JR.MENU_GROUP_MIN_WIDTH)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MenuItems, {
        onClose: onClose
    })));

});
parcelRegister("5Q9JR", function(module, exports) {
$parcel$export(module.exports, "MENU_GROUP_MIN_WIDTH", () => $15777f70405f0cfb$export$47f3715a07cde7e8);
$parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", () => $15777f70405f0cfb$export$f5a7bd7eb586e4e8);
$parcel$export(module.exports, "GLOBAL_APP_MENU_IDS_AS_STRINGS", () => $15777f70405f0cfb$export$de634ec0f98ab74b);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM", () => $15777f70405f0cfb$export$9a6cc3b78524c807);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_AND_ICON_MAP", () => $15777f70405f0cfb$export$5034ad0032cd499d);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM", () => $15777f70405f0cfb$export$9c99028e1421f69f);
$parcel$export(module.exports, "SPACES_MESSAGE_AND_ICON_MAP_WITH_PROJECT_TERM", () => $15777f70405f0cfb$export$e0063c8eec18df81);
$parcel$export(module.exports, "SPACES_MESSAGE_AND_ICON_MAP_WITHOUT_PROJECT_TERM", () => $15777f70405f0cfb$export$dbe1165a572764fa);
$parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", () => $15777f70405f0cfb$export$9fcc53f3b36e0949);
$parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", () => $15777f70405f0cfb$export$2eb8dda9e83d33ff);
$parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", () => $15777f70405f0cfb$export$9cf873ba2e9a3ce0);
$parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", () => $15777f70405f0cfb$export$a495ba70b16d4d90);
$parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", () => $15777f70405f0cfb$export$89de709e88232646);
$parcel$export(module.exports, "FOR_YOU_MESSAGE_STRING", () => $15777f70405f0cfb$export$b66ae8c18ec95bc6);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITHOUT_PROJECT_TERM", () => $15777f70405f0cfb$export$4da83c858d129f7f);
$parcel$export(module.exports, "CONFIGURABLE_MESSAGE_STRING_WITH_PROJECT_TERM", () => $15777f70405f0cfb$export$a9a6fdcb59a8001e);

var $eJOHy = parcelRequire("eJOHy");

var $m9SlP = parcelRequire("m9SlP");

var $bGbhe = parcelRequire("bGbhe");

var $cYbWd = parcelRequire("cYbWd");

var $i5stJ = parcelRequire("i5stJ");

var $5SdQs = parcelRequire("5SdQs");

var $KDB2z = parcelRequire("KDB2z");

var $iBgxn = parcelRequire("iBgxn");

var $9qes7 = parcelRequire("9qes7");

var $3XKBx = parcelRequire("3XKBx");

var $gm7H7 = parcelRequire("gm7H7");

var $lgMTT = parcelRequire("lgMTT");

var $lmJ87 = parcelRequire("lmJ87");

var $3pQT5 = parcelRequire("3pQT5");

var $l5gdO = parcelRequire("l5gdO");

var $aaIe7 = parcelRequire("aaIe7");

var $eALjj = parcelRequire("eALjj");

var $gNUuP = parcelRequire("gNUuP");

var $h0FG3 = parcelRequire("h0FG3");

var $9mydb = parcelRequire("9mydb");

var $h4Bzb = parcelRequire("h4Bzb");

var $hEgdr = parcelRequire("hEgdr");

var $8IuE5 = parcelRequire("8IuE5");
const $15777f70405f0cfb$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
const $15777f70405f0cfb$export$d57b6b390e78d90f = 'jira-cosmos';
const $15777f70405f0cfb$export$47f3715a07cde7e8 = 250;
const $15777f70405f0cfb$export$421b92818c76ee2d = Object.values((0, $h4Bzb.CONFIGURABLE_MENU_ID));
const $15777f70405f0cfb$export$f5a7bd7eb586e4e8 = $15777f70405f0cfb$export$421b92818c76ee2d;
const $15777f70405f0cfb$export$c52c93cc28495ab0 = Object.values((0, $h4Bzb.GLOBAL_APP_MENU_ID));
const $15777f70405f0cfb$export$de634ec0f98ab74b = $15777f70405f0cfb$export$c52c93cc28495ab0;
const $15777f70405f0cfb$export$9a6cc3b78524c807 = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bGbhe)))
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9qes7)))
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($m9SlP)))
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($l5gdO)))
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projectsGalaxia,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lmJ87)))
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z)))
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs)))
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBgxn)))
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9mydb)))
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cYbWd)))
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eALjj)))
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ)))
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3XKBx)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($h0FG3)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMERS]: {
        message: (0, $hEgdr.default).customers,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gm7H7)))
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.AssetsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.GoalsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    // App Shortcuts for Platform Component
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ConfluenceIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.LoomIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ProjectsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.TeamsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.OpsgenieIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "small"
            })
    }
};
const $15777f70405f0cfb$export$5034ad0032cd499d = {
    message: (0, $hEgdr.default).forYou,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gNUuP)))
};
const $15777f70405f0cfb$export$9c99028e1421f69f = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: {
        message: (0, $hEgdr.default).apps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bGbhe)))
    },
    [(0, $8IuE5.L1_MENU_ID).GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9qes7)))
    },
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: {
        message: (0, $hEgdr.default).roadmaps,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($m9SlP)))
    },
    [(0, $8IuE5.L1_MENU_ID).PLANS]: {
        message: (0, $hEgdr.default).plans,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($l5gdO)))
    },
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lmJ87)))
    },
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: {
        message: (0, $hEgdr.default).filters,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($KDB2z)))
    },
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: {
        message: (0, $hEgdr.default).dashboards,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs)))
    },
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: {
        message: (0, $hEgdr.default).overviews,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBgxn)))
    },
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: {
        message: (0, $hEgdr.default).operations,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9mydb)))
    },
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cYbWd)))
    },
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eALjj)))
    },
    [(0, $8IuE5.L1_MENU_ID).RECENT]: {
        message: (0, $hEgdr.default).recent,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($i5stJ)))
    },
    [(0, $8IuE5.L1_MENU_ID).STARRED]: {
        message: (0, $hEgdr.default).starred,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: {
        message: (0, $hEgdr.default).customerHubs,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3XKBx)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: {
        message: (0, $hEgdr.default).customerServiceAnalytics,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($h0FG3)))
    },
    [(0, $8IuE5.L1_MENU_ID).CUSTOMERS]: {
        message: (0, $hEgdr.default).customers,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gm7H7)))
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: {
        message: (0, $hEgdr.default).assets,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.AssetsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: {
        message: (0, $hEgdr.default).goals,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.GoalsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    // App Shortcuts for Platform Component
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: {
        message: (0, $hEgdr.default).confluence,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ConfluenceIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: {
        message: (0, $hEgdr.default).loom,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.LoomIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: {
        message: (0, $hEgdr.default).projects,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.ProjectsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: {
        message: (0, $hEgdr.default).teams,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.TeamsIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "xsmall"
            })
    },
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: {
        message: (0, $hEgdr.default).opsgenie,
        Icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lgMTT.OpsgenieIcon), {
                ...props,
                shouldUseNewLogoDesign: true,
                size: "small"
            })
    }
};
const $15777f70405f0cfb$export$e0063c8eec18df81 = {
    message: (0, $hEgdr.default).projects,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3pQT5)))
};
const $15777f70405f0cfb$export$dbe1165a572764fa = {
    message: (0, $hEgdr.default).projectsGalaxia,
    Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3pQT5)))
};
const $15777f70405f0cfb$export$9fcc53f3b36e0949 = 240; // in pixels
const $15777f70405f0cfb$export$6621cd553335536a = 320; // in pixels
const $15777f70405f0cfb$export$2eb8dda9e83d33ff = false;
const $15777f70405f0cfb$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
const $15777f70405f0cfb$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
const $15777f70405f0cfb$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
const $15777f70405f0cfb$export$a495ba70b16d4d90 = 'nav4-sidebar';
const $15777f70405f0cfb$export$89de709e88232646 = 25;
const $15777f70405f0cfb$export$b66ae8c18ec95bc6 = (0, $hEgdr.default).forYou;
const $15777f70405f0cfb$export$4da83c858d129f7f = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: (0, $hEgdr.default).apps,
    [(0, $8IuE5.L1_MENU_ID).GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: (0, $hEgdr.default).roadmaps,
    [(0, $8IuE5.L1_MENU_ID).PLANS]: (0, $hEgdr.default).plans,
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: (0, $hEgdr.default).projectsGalaxia,
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: (0, $hEgdr.default).filters,
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: (0, $hEgdr.default).dashboards,
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: (0, $hEgdr.default).overviews,
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: (0, $hEgdr.default).operations,
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).RECENT]: (0, $hEgdr.default).recent,
    [(0, $8IuE5.L1_MENU_ID).STARRED]: (0, $hEgdr.default).starred,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: (0, $hEgdr.default).customerHubs,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: (0, $hEgdr.default).customerServiceAnalytics,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMERS]: (0, $hEgdr.default).customers,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $hEgdr.default).confluence,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $hEgdr.default).loom,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: (0, $hEgdr.default).projects,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: (0, $hEgdr.default).opsgenie
};
const $15777f70405f0cfb$export$a9a6fdcb59a8001e = {
    [(0, $8IuE5.L1_MENU_ID).APPS]: (0, $hEgdr.default).apps,
    [(0, $8IuE5.L1_MENU_ID).GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).ROADMAPS]: (0, $hEgdr.default).roadmaps,
    [(0, $8IuE5.L1_MENU_ID).PLANS]: (0, $hEgdr.default).plans,
    [(0, $8IuE5.L1_MENU_ID).PROJECTS]: (0, $hEgdr.default).projects,
    [(0, $8IuE5.L1_MENU_ID).FILTERS]: (0, $hEgdr.default).filters,
    [(0, $8IuE5.L1_MENU_ID).DASHBOARDS]: (0, $hEgdr.default).dashboards,
    [(0, $8IuE5.L1_MENU_ID).OVERVIEWS]: (0, $hEgdr.default).overviews,
    [(0, $8IuE5.L1_MENU_ID).OPERATIONS]: (0, $hEgdr.default).operations,
    [(0, $8IuE5.L1_MENU_ID).ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).RECENT]: (0, $hEgdr.default).recent,
    [(0, $8IuE5.L1_MENU_ID).STARRED]: (0, $hEgdr.default).starred,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE]: (0, $hEgdr.default).customerHubs,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS]: (0, $hEgdr.default).customerServiceAnalytics,
    [(0, $8IuE5.L1_MENU_ID).CUSTOMERS]: (0, $hEgdr.default).customers,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_ASSETS]: (0, $hEgdr.default).assets,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_GOALS]: (0, $hEgdr.default).goals,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_CONFLUENCE]: (0, $hEgdr.default).confluence,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_LOOM]: (0, $hEgdr.default).loom,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_PROJECTS]: (0, $hEgdr.default).projects,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_TEAMS]: (0, $hEgdr.default).teams,
    [(0, $8IuE5.L1_MENU_ID).GLOBAL_APP_OPSGENIE]: (0, $hEgdr.default).opsgenie
};

});
parcelRegister("h4Bzb", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID", () => $330926e53d81707a$export$1bb3d16bc95080e3);
$parcel$export(module.exports, "GLOBAL_APP_MENU_ID_TO_APS_KEY", () => $330926e53d81707a$export$3b4ca8d4d769a311);
$parcel$export(module.exports, "CONFIGURABLE_MENU_ID", () => $330926e53d81707a$export$7838b734e4cd5e8d);
$parcel$export(module.exports, "ENTITY_ID", () => $330926e53d81707a$export$103ff18fe29ee1b);
$parcel$export(module.exports, "MENU_ID_APPS", () => $330926e53d81707a$export$441cd608ea3204f4);
$parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", () => $330926e53d81707a$export$5baa9c2e3c3931c5);
$parcel$export(module.exports, "MENU_ID_ASSETS", () => $330926e53d81707a$export$75c65bfc98b3a6e1);
$parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", () => $330926e53d81707a$export$8a0af92d49f1d13d);
$parcel$export(module.exports, "MENU_ID_ASSETS_FOR_YOU", () => $330926e53d81707a$export$5115ccb493164b9);
$parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", () => $330926e53d81707a$export$a09300d15acc958a);
$parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", () => $330926e53d81707a$export$4d718fbd418eef5c);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS", () => $330926e53d81707a$export$dd009509c2dabb5e);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", () => $330926e53d81707a$export$d3da0455b4200fb2);
$parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$b9dd2b5309d19763);
$parcel$export(module.exports, "MENU_ID_FILTERS", () => $330926e53d81707a$export$3d81af172a8e3c57);
$parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", () => $330926e53d81707a$export$1e2599eaf0039a97);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", () => $330926e53d81707a$export$53d274d993c9d5b5);
$parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$7661ea763be69cfa);
$parcel$export(module.exports, "MENU_ID_GOALS", () => $330926e53d81707a$export$47c6ce6a83a59eab);
$parcel$export(module.exports, "MENU_ID_OPERATIONS", () => $330926e53d81707a$export$ef89639b7d9c162a);
$parcel$export(module.exports, "MENU_ID_OPS_ALERTS", () => $330926e53d81707a$export$af4ab6d4e920522a);
$parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", () => $330926e53d81707a$export$25c40acb2c53a294);
$parcel$export(module.exports, "MENU_ID_OPS_REPORTS", () => $330926e53d81707a$export$c7d8892f1628b844);
$parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", () => $330926e53d81707a$export$bb19a52e3df99541);
$parcel$export(module.exports, "MENU_ID_OVERVIEWS", () => $330926e53d81707a$export$3bd12c092f8db11b);
$parcel$export(module.exports, "MENU_ID_PLANS", () => $330926e53d81707a$export$f2533da33c749933);
$parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", () => $330926e53d81707a$export$8468c5b6648f4f1f);
$parcel$export(module.exports, "MENU_ID_PROJECT_APPS", () => $330926e53d81707a$export$fed17b4c0866b97d);
$parcel$export(module.exports, "MENU_ID_PROJECTS", () => $330926e53d81707a$export$9c5278bd360a285);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", () => $330926e53d81707a$export$85389c606bb641dd);
$parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", () => $330926e53d81707a$export$4a1974b63c858e9c);
$parcel$export(module.exports, "MENU_ID_RECENT", () => $330926e53d81707a$export$692b796030a796f3);
$parcel$export(module.exports, "MENU_ID_ROADMAPS", () => $330926e53d81707a$export$cdc80d4b5ce0c6a);
$parcel$export(module.exports, "MENU_ID_ROADMAPS_VIEW_ALL", () => $330926e53d81707a$export$7606c0134aabf3d7);
$parcel$export(module.exports, "MENU_ID_STARRED", () => $330926e53d81707a$export$5637ca42a4d77f32);
$parcel$export(module.exports, "MENU_ID_TEAMS", () => $330926e53d81707a$export$d4f6fcf571f9c50);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE", () => $330926e53d81707a$export$11fcdf33179ef88e);
$parcel$export(module.exports, "MENU_ID_CUSTOMER_SERVICE_ANALYTICS", () => $330926e53d81707a$export$1d260f51eeaab73d);
$parcel$export(module.exports, "MENU_ID_CUSTOMERS", () => $330926e53d81707a$export$7ded421b1395251e);
$parcel$export(module.exports, "MENU_ID_YOUR_WORK", () => $330926e53d81707a$export$80dc576e446bdb6b);
$parcel$export(module.exports, "MENU_ID_FOR_YOU", () => $330926e53d81707a$export$c68b73f0d8c14f41);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_ASSETS", () => $330926e53d81707a$export$5aa3e4dd37f372d5);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_GOALS", () => $330926e53d81707a$export$7986b535c183c592);
$parcel$export(module.exports, "MENU_ID_COMMUNICATIONS_STAKEHOLDERS", () => $330926e53d81707a$export$784c436fb3f51c19);
$parcel$export(module.exports, "MENU_ID_OPS_STATUS_PAGES", () => $330926e53d81707a$export$151c003f483b38);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_CONFLUENCE", () => $330926e53d81707a$export$c093b87743053085);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_LOOM", () => $330926e53d81707a$export$e316a54b33dbe500);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_PROJECTS", () => $330926e53d81707a$export$8ceb414d866f12fc);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_TEAMS", () => $330926e53d81707a$export$804187987544d0f8);
$parcel$export(module.exports, "MENU_ID_GLOBAL_APP_OPSGENIE", () => $330926e53d81707a$export$83352ab9064f1723);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", () => $330926e53d81707a$export$79c15668ed799a1b);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", () => $330926e53d81707a$export$e299bb06c4370c0d);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", () => $330926e53d81707a$export$713b9b0a69a79cf9);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", () => $330926e53d81707a$export$f1d9c0f27216aa1c);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", () => $330926e53d81707a$export$45763fa331781074);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", () => $330926e53d81707a$export$6ee20c845dbab3e3);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", () => $330926e53d81707a$export$b3815dd180ce5e61);
$parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", () => $330926e53d81707a$export$100a1a639a0db980);
const $330926e53d81707a$export$1bb3d16bc95080e3 = {
    GLOBAL_APP_GOALS: 'jira.sidebar.globalApp.goals',
    GLOBAL_APP_ASSETS: 'jira.sidebar.globalApp.assets',
    // Global App Shortcuts for Platform Component
    GLOBAL_APP_CONFLUENCE: 'jira.sidebar.globalApp.confluence',
    GLOBAL_APP_LOOM: 'jira.sidebar.globalApp.loom',
    GLOBAL_APP_PROJECTS: 'jira.sidebar.globalApp.projects',
    GLOBAL_APP_TEAMS: 'jira.sidebar.globalApp.teams',
    GLOBAL_APP_OPSGENIE: 'jira.sidebar.globalApp.opsgenie'
};
const $330926e53d81707a$export$3b4ca8d4d769a311 = {
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_CONFLUENCE]: 'CONFLUENCE',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_LOOM]: 'LOOM',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_GOALS]: 'GOALS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_PROJECTS]: 'PROJECTS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_TEAMS]: 'TEAMS',
    [$330926e53d81707a$export$1bb3d16bc95080e3.GLOBAL_APP_OPSGENIE]: 'OPSGENIE'
};
const $330926e53d81707a$export$7838b734e4cd5e8d = {
    APPS: 'jira.sidebar.apps',
    ASSETS: 'jira.sidebar.assets',
    DASHBOARDS: 'jira.sidebar.dashboards',
    FILTERS: 'jira.sidebar.filters',
    GOALS: 'jira.sidebar.goals',
    OPERATIONS: 'jira.sidebar.operations',
    OVERVIEWS: 'jira.sidebar.overviews',
    PLANS: 'jira.sidebar.plans',
    PROJECTS: 'jira.sidebar.projects',
    RECENT: 'jira.sidebar.recent',
    STARRED: 'jira.sidebar.starred',
    TEAMS: 'jira.sidebar.teams',
    ROADMAPS: 'jira.sidebar.roadmaps',
    CUSTOMER_SERVICE: 'jira.sidebar.customerService',
    CUSTOMER_SERVICE_ANALYTICS: 'jira.sidebar.customerServiceAnalytics',
    CUSTOMERS: 'jira.sidebar.customers',
    ...$330926e53d81707a$export$1bb3d16bc95080e3
};
const $330926e53d81707a$export$103ff18fe29ee1b = {
    ALARM_QUEUE: (id)=>`alrm_${id}`,
    APP: (id)=>`app_${id}`,
    BOARD: (id)=>`boar_${id}`,
    DASHBOARD: (id)=>`dash_${id}`,
    FILTER: (id)=>`filt_${id}`,
    FORM: (id)=>`form_${id}`,
    OVERVIEW: (id)=>`over_${id}`,
    PLAN: (id)=>`plan_${id}`,
    PROJECT: (id)=>`proj_${id}`,
    PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
    PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
    PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
    PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
    PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
    PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
    PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
    PROJECT_JCS_GET_STARTED: (projectKey)=>`proj-${projectKey}-jcs-gtst`,
    PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
    PROJECT_OPERATIONS: (projectKey)=>`proj-${projectKey}-ops`,
    PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
    PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
    PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
    PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
    PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
    PROJECT_DASHBOARDS: (projectKey)=>`proj-${projectKey}-dashboards`,
    PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
    PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
    PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
    ROADMAP: (id)=>`roadmap_${id}`,
    QUEUE: (id)=>`queu_${id}`,
    ISSUE: (id)=>`issue_${id}`,
    ARCHIVED_WORK_ITEMS: (id)=>`archived_work_items_${id}`,
    PROJECT_ROVO_AGENT: (projectKey)=>`proj-${projectKey}-rovo-agent`
}; // We MUST use the same IDs for the same components, otherwise we run into trouble (especially with peeking / more-menu)
const $330926e53d81707a$export$441cd608ea3204f4 = $330926e53d81707a$export$7838b734e4cd5e8d.APPS;
const $330926e53d81707a$export$5baa9c2e3c3931c5 = 'app_mrkt';
const $330926e53d81707a$export$75c65bfc98b3a6e1 = $330926e53d81707a$export$7838b734e4cd5e8d.ASSETS;
const $330926e53d81707a$export$8a0af92d49f1d13d = 'asst_schm';
const $330926e53d81707a$export$5115ccb493164b9 = 'asst_for_you';
const $330926e53d81707a$export$a09300d15acc958a = 'asst_rprt';
const $330926e53d81707a$export$4d718fbd418eef5c = 'board-view-all';
const $330926e53d81707a$export$dd009509c2dabb5e = $330926e53d81707a$export$7838b734e4cd5e8d.DASHBOARDS;
const $330926e53d81707a$export$d3da0455b4200fb2 = 'dash-view';
const $330926e53d81707a$export$b9dd2b5309d19763 = 'dash-view-starred';
const $330926e53d81707a$export$3d81af172a8e3c57 = $330926e53d81707a$export$7838b734e4cd5e8d.FILTERS;
const $330926e53d81707a$export$1e2599eaf0039a97 = 'filt-search';
const $330926e53d81707a$export$53d274d993c9d5b5 = 'filt-view-all';
const $330926e53d81707a$export$7661ea763be69cfa = 'filt-view-starred';
const $330926e53d81707a$export$47c6ce6a83a59eab = $330926e53d81707a$export$7838b734e4cd5e8d.GOALS;
const $330926e53d81707a$export$ef89639b7d9c162a = $330926e53d81707a$export$7838b734e4cd5e8d.OPERATIONS;
const $330926e53d81707a$export$af4ab6d4e920522a = 'ops-alrt';
const $330926e53d81707a$export$25c40acb2c53a294 = 'ops-over';
const $330926e53d81707a$export$c7d8892f1628b844 = 'ops-rprt';
const $330926e53d81707a$export$bb19a52e3df99541 = 'ops-oncl';
const $330926e53d81707a$export$3bd12c092f8db11b = $330926e53d81707a$export$7838b734e4cd5e8d.OVERVIEWS;
const $330926e53d81707a$export$f2533da33c749933 = $330926e53d81707a$export$7838b734e4cd5e8d.PLANS;
const $330926e53d81707a$export$8468c5b6648f4f1f = 'plan-view-all';
const $330926e53d81707a$export$fed17b4c0866b97d = 'proj-app';
const $330926e53d81707a$export$9c5278bd360a285 = $330926e53d81707a$export$7838b734e4cd5e8d.PROJECTS;
const $330926e53d81707a$export$85389c606bb641dd = 'proj-view-all';
const $330926e53d81707a$export$4a1974b63c858e9c = 'proj-view-starred';
const $330926e53d81707a$export$692b796030a796f3 = $330926e53d81707a$export$7838b734e4cd5e8d.RECENT;
const $330926e53d81707a$export$cdc80d4b5ce0c6a = $330926e53d81707a$export$7838b734e4cd5e8d.ROADMAPS;
const $330926e53d81707a$export$7606c0134aabf3d7 = 'roadmaps-view-all';
const $330926e53d81707a$export$5637ca42a4d77f32 = $330926e53d81707a$export$7838b734e4cd5e8d.STARRED;
const $330926e53d81707a$export$d4f6fcf571f9c50 = $330926e53d81707a$export$7838b734e4cd5e8d.TEAMS;
const $330926e53d81707a$export$11fcdf33179ef88e = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_SERVICE;
const $330926e53d81707a$export$1d260f51eeaab73d = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMER_SERVICE_ANALYTICS;
const $330926e53d81707a$export$7ded421b1395251e = $330926e53d81707a$export$7838b734e4cd5e8d.CUSTOMERS;
const $330926e53d81707a$export$80dc576e446bdb6b = 'yrwk';
const $330926e53d81707a$export$c68b73f0d8c14f41 = 'for-you';
const $330926e53d81707a$export$5aa3e4dd37f372d5 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_ASSETS;
const $330926e53d81707a$export$7986b535c183c592 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_GOALS;
const $330926e53d81707a$export$b3b2df3daae04417 = 'comm';
const $330926e53d81707a$export$784c436fb3f51c19 = 'comm-stkhldr';
const $330926e53d81707a$export$205988f610130417 = 'comm-stkhldr-grp';
const $330926e53d81707a$export$151c003f483b38 = 'ops-status-pages';
const $330926e53d81707a$export$c093b87743053085 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_CONFLUENCE;
const $330926e53d81707a$export$e316a54b33dbe500 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_LOOM;
const $330926e53d81707a$export$8ceb414d866f12fc = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_PROJECTS;
const $330926e53d81707a$export$804187987544d0f8 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_TEAMS;
const $330926e53d81707a$export$83352ab9064f1723 = $330926e53d81707a$export$7838b734e4cd5e8d.GLOBAL_APP_OPSGENIE;
const $330926e53d81707a$export$79c15668ed799a1b = 'sd-sett-acc';
const $330926e53d81707a$export$e299bb06c4370c0d = 'sd-sett-req-man';
const $330926e53d81707a$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
const $330926e53d81707a$export$f1d9c0f27216aa1c = 'sd-sett-aut';
const $330926e53d81707a$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
const $330926e53d81707a$export$6ee20c845dbab3e3 = 'sd-sett-not';
const $330926e53d81707a$export$b3815dd180ce5e61 = 'sd-sett-apps';
const $330926e53d81707a$export$100a1a639a0db980 = 'sd-sett-ops';

});

parcelRegister("hEgdr", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcc397343fd47548$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $bcc397343fd47548$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    projects: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects",
        "defaultMessage": "Projects"
    },
    filters: {
        "id": "navigation-apps-sidebar-nav4-common.common.filters",
        "defaultMessage": "Filters"
    },
    dashboards: {
        "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
        "defaultMessage": "Dashboards"
    },
    overviews: {
        "id": "navigation-apps-sidebar-nav4-common.common.overviews",
        "defaultMessage": "Overviews"
    },
    teams: {
        "id": "navigation-apps-sidebar-nav4-common.common.teams",
        "defaultMessage": "Teams"
    },
    assets: {
        "id": "navigation-apps-sidebar-nav4-common.common.assets",
        "defaultMessage": "Assets"
    },
    plans: {
        "id": "navigation-apps-sidebar-nav4-common.common.plans",
        "defaultMessage": "Plans"
    },
    apps: {
        "id": "navigation-apps-sidebar-nav4-common.common.apps",
        "defaultMessage": "Apps"
    },
    operations: {
        "id": "navigation-apps-sidebar-nav4-common.common.operations",
        "defaultMessage": "Operations"
    },
    goals: {
        "id": "navigation-apps-sidebar-nav4-common.common.goals",
        "defaultMessage": "Goals"
    },
    recent: {
        "id": "navigation-apps-sidebar-nav4-common.common.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-common.common.starred",
        "defaultMessage": "Starred"
    },
    roadmaps: {
        "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
        "defaultMessage": "Roadmaps"
    },
    customerHubs: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-hubs",
        "defaultMessage": "Customer experiences"
    },
    customerServiceAnalytics: {
        "id": "navigation-apps-sidebar-nav4-common.common.customerServiceAnalytics",
        "defaultMessage": "Customer service overview"
    },
    customers: {
        "id": "navigation-apps-sidebar-nav4-common.common.customer-s",
        "defaultMessage": "Customers"
    },
    forYou: {
        "id": "navigation-apps-sidebar-nav4-common.common.forYou",
        "defaultMessage": "For you"
    },
    confluence: {
        "id": "navigation-apps-sidebar-nav4-common.common.confluence",
        "defaultMessage": "Confluence"
    },
    loom: {
        "id": "navigation-apps-sidebar-nav4-common.common.loom",
        "defaultMessage": "Loom"
    },
    opsgenie: {
        "id": "navigation-apps-sidebar-nav4-common.common.opsgenie",
        "defaultMessage": "Opsgenie"
    },
    projectsGalaxia: {
        "id": "navigation-apps-sidebar-nav4-common.common.projects-galaxia",
        "defaultMessage": "Spaces"
    }
});

});

parcelRegister("8IuE5", function(module, exports) {
$parcel$export(module.exports, "L1_MENU_ID", () => $63cd73d0cb684b2a$export$918aea3cf024d90b);

var $h4Bzb = parcelRequire("h4Bzb");
const $63cd73d0cb684b2a$var$OPERATIONS_MENU_ID = {
    OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
    OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
};
const $63cd73d0cb684b2a$export$bb47524d7f3cb1f8 = {
    ...(0, $h4Bzb.CONFIGURABLE_MENU_ID),
    BOARDS: 'jira.sidebar.boards',
    QUEUES: 'jira.sidebar.queues',
    ALL: 'jira.sidebar.all'
};
const $63cd73d0cb684b2a$export$918aea3cf024d90b = {
    YOUR_WORK: 'jira.sidebar.yourWork',
    ...(0, $h4Bzb.CONFIGURABLE_MENU_ID),
    ...$63cd73d0cb684b2a$var$OPERATIONS_MENU_ID
};

});



parcelRegister("uUJju", function(module, exports) {
$parcel$export(module.exports, "MoreNavMenuButtonTrigger", () => $dfbe3a7f7d9c0985$export$c1fd214ac7085e79);

var $eJOHy = parcelRequire("eJOHy");

var $NByNW = parcelRequire("NByNW");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $ajqBI = parcelRequire("ajqBI");

var $fo9o5 = parcelRequire("fo9o5");
const $dfbe3a7f7d9c0985$export$c1fd214ac7085e79 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(// @ts-expect-error: to unblock React 18.2.0 -> 18.3.1 version bump
({ name: name, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ajqBI.CommonNavMenuButton), {
        ...props,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($NByNW))), {
                ...iconProps,
                size: "small"
            }),
        label: name ? formatMessage((0, $fo9o5.default).moreActionsFor, {
            name: name
        }) : formatMessage((0, $fo9o5.default).moreActions),
        ref: ref,
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            isTooltipDisabled: false,
            tooltip: {
                content: formatMessage((0, $fo9o5.default).moreActions),
                hideTooltipOnClick: true
            }
        } : {},
        interactionName: "nav4-sidebar-more-actions-button"
    });
});

});
parcelRegister("ajqBI", function(module, exports) {
$parcel$export(module.exports, "CommonNavMenuButton", () => $bf8e167060ed7219$export$358f21998d56a71e);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");
const $bf8e167060ed7219$export$358f21998d56a71e = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, icon: icon, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        ...props,
        icon: icon,
        onClick: onClick,
        ref: ref,
        spacing: "compact",
        appearance: "subtle"
    });
});

});

parcelRegister("fo9o5", function(module, exports) {
$parcel$export(module.exports, "default", () => $2728ae4146a63f7b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $2728ae4146a63f7b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    moreActions: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions",
        "defaultMessage": "More actions"
    },
    moreActionsFor: {
        "id": "navigation-apps-sidebar-nav4-common.more-nav-menu-button.trigger.more-actions-for",
        "defaultMessage": "More actions for {name}"
    }
});

});



parcelRegister("lTN3C", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8ba3a90889d5720$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fFq5m = parcelRequire("fFq5m");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
const $b8ba3a90889d5720$export$3776992222b2b40f = {
    EXPAND: 'expand',
    COLLAPSE: 'collapse'
};
const $b8ba3a90889d5720$var$ExpandableMenuItemTriggerWithAnalytics = ({ analytics: analytics, onClick: onClick, ...rest }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleClick = (event, analyticsEvent, { isExpanded: isExpanded })=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'navigationItem'
        }), actionSubjectId, {
            ...analyticsAttributes,
            expandAction: isExpanded ? $b8ba3a90889d5720$export$3776992222b2b40f.EXPAND : $b8ba3a90889d5720$export$3776992222b2b40f.COLLAPSE
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fFq5m.ExpandableMenuItemTrigger), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
};
var $b8ba3a90889d5720$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)($b8ba3a90889d5720$var$ExpandableMenuItemTriggerWithAnalytics);

});
parcelRegister("fFq5m", function(module, exports) {
$parcel$export(module.exports, "ExpandableMenuItemTrigger", () => $be2c8cebc5d88fe6$export$fe6fe51056867f4d);
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $1OQKp = parcelRequire("1OQKp");

var $cQxBL = parcelRequire("cQxBL");

var $2tKAE = parcelRequire("2tKAE");

var $eekOJ = parcelRequire("eekOJ");

var $yFG6a = parcelRequire("yFG6a");
// Widening type to `string` to side-step Compiled cssMap typescript warnings with unknown properties
const $be2c8cebc5d88fe6$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $be2c8cebc5d88fe6$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $be2c8cebc5d88fe6$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $be2c8cebc5d88fe6$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syaz1qo3"
};
const $be2c8cebc5d88fe6$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($1OQKp))) : (0, (/*@__PURE__*/$parcel$interopDefault($cQxBL)));
    const chevronElem = /*#__PURE__*/ (0, $gt9Am.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $be2c8cebc5d88fe6$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                className: (0, $hcewu.default)([
                    $be2c8cebc5d88fe6$var$iconStyles.providedElemBefore,
                    isSelected && $be2c8cebc5d88fe6$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $be2c8cebc5d88fe6$export$fe6fe51056867f4d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $eJOHy.useId)();
    const onExpansionToggle = (0, $yFG6a.useOnExpansionToggle)();
    const isExpanded = (0, $yFG6a.useIsExpanded)();
    const setIsExpanded = (0, $yFG6a.useSetIsExpanded)();
    const itemRef = (0, $eJOHy.useRef)(null);
    const handleIconClick = (0, $eJOHy.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $eekOJ.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    });
    // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $Ay1uj.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $gt9Am.jsx)($be2c8cebc5d88fe6$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // We are labelling the icon button using the containing menu item's content, to provide context to
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // IconButton requires a label prop, however it will not be used by screen readers as we are setting
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $gt9Am.jsx)($be2c8cebc5d88fe6$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    });
    // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: itemRef,
        className: (0, $hcewu.default)([
            $be2c8cebc5d88fe6$var$wrapperStyles.root,
            providedElemBefore && $be2c8cebc5d88fe6$var$wrapperStyles.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKAE.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});

});
parcelRegister("2tKAE", function(module, exports) {
$parcel$export(module.exports, "MenuItemBase", () => $f3ea94f8b9659885$export$859b390bf71e044e);
/* menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $k0ahr = parcelRequire("k0ahr");

var $l8fMV = parcelRequire("l8fMV");

var $immLL = parcelRequire("immLL");

var $gyJTO = parcelRequire("gyJTO");

var $eGOwo = parcelRequire("eGOwo");

var $lc0OY = parcelRequire("lc0OY");
var $46R8N = parcelRequire("46R8N");
var $3cMgR = parcelRequire("3cMgR");

var $k71qx = parcelRequire("k71qx");
var $7AseU = parcelRequire("7AseU");


var $yFG6a = parcelRequire("yFG6a");

var $1C3j7 = parcelRequire("1C3j7");

var $kbcF8 = parcelRequire("kbcF8");

// Using `lazy` so that only consumers who want drag and drop
// need to include code for the drag handle.
const $f3ea94f8b9659885$var$LazyDragHandle = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("e1A1g")));
const $f3ea94f8b9659885$var$tooltipStyles = {
    root: "_2rko12b0 _11c8dcr7 _1e0c1txw _2lx21bp4 _1bah1h6o _1tkezwfg _p12f1pna _vchhusvi _1q51v77o _y4ti12x7 _85i5v77o _bozg12x7 _bfhkcdhy _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _slp31hna"
};
const $f3ea94f8b9659885$var$MenuItemTooltip = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function MenuItemTooltip({ children: children, className: className, ...rest }, ref) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7AseU.default), {
        ...rest,
        // Manually passing on `className` so it gets merged correctly in the build output.
        // The passed classname is mostly used for integration testing (`.Tooltip`)
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            $f3ea94f8b9659885$var$tooltipStyles.root,
            className
        ]),
        // "css" does not "exist" - it gets transformed into "className" by compiled
        ref: ref,
        children: children
    });
});
function $f3ea94f8b9659885$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $f3ea94f8b9659885$var$defaultAvatarValues = {
    size: 'small'
};
const $f3ea94f8b9659885$var$elemAfterDisplayVar = '--elem-after-display';
const $f3ea94f8b9659885$var$actionsOnHoverOpacityVar = '--actions-on-hover-opacity';
const $f3ea94f8b9659885$var$actionsOnHoverWidthVar = '--actions-on-hover-width';
const $f3ea94f8b9659885$var$actionsOnHoverPaddingInlineEndVar = '--actions-on-hover-padding';
const $f3ea94f8b9659885$var$notchColorVar = '--notch-color';
// Note: this is also used in `drag-handle.tsx`
const $f3ea94f8b9659885$var$dragHandleDisplayVar = '--drag-handle-display';
const $f3ea94f8b9659885$var$dragCursorAnimation = null;
/**
 * ## 🤹 `position:relative`
 *
 * We need `position:relative` on an element that takes
 * up the full size of the interactive element so we
 * can correctly use `position:absolute` to place:
 * 1. the notch for links
 * 2. drop indicators for drag and drop
 * 3. a child of button / anchor to stretch it out to
 *    increase it's pressable area.
 *
 * ⛔️ We cannot add `position:relative` _only_ on the
 * button / anchor as that will cause sibling elements
 * to be rendered under the button / anchor when setting
 * a background color on the button / anchor.
 *
 * 📖 Note: `position:relative` elements are painted after
 * elements with `position:static` (the default)
 * https://drafts.csswg.org/css-position-4/#painting-order
 *
 * ⛔️ We cannot add `position:relative` to the container
 * element, as then the `:focus` ring styles on the
 * button / anchor can be cut off by the next sibling if it has
 * has a background color set (eg when selected)
 *
 * ✅ Add `position:relative` to all first level descendants
 * of the container element so that we don't impact DOM ordered
 * paint ordering within the item and the button / anchor focus
 * ring can still bleed over siblings
 *
 * 📖 We could use `> * { position: relative; }` on the container,
 * but that would violate our styling standard.
 */ const $f3ea94f8b9659885$var$topLevelSiblingStyles = {
    root: "_kqswh2mm"
};
/**
 * All slots on the menu item (eg `elemBefore`) are rendered as siblings
 * of our main button / anchor element and they are visually placed on
 * top of the main button / anchor.
 *
 * 📖 This is done so that we don't nest interactive elements in our markup.
 *
 * ✅ This is great when element in the slot is an interactive element
 * as we don't want the main menu item button / anchor to be triggered
 * when interacting with the element in the slot.
 *
 * ⛔️ When the element in the slot is static content (eg an `<Icon>`) it will
 * prevent the main button / anchor (that is visually behind the element in
 * the slot) from being clicked. The element in the slot is a sibling of our
 * main button / anchor (not a child of it) so clicking on the element in the
 * slot will not bubble up to the button / anchor.
 *
 * 🚀 We set `pointer-events:none` on a slot if it does not contain and interactive
 * element so that static content in a slot does not prevent clicking on the main
 * button / anchor.
 */ const $f3ea94f8b9659885$var$onTopOfButtonOrAnchorStyles = {
    root: "_18ukglyw"
};
const $f3ea94f8b9659885$export$91f7cd3f990d8a52 = '&:has([aria-expanded="true"][aria-haspopup="true"])';
const $f3ea94f8b9659885$var$containerStyles = {
    root: "_2rko12b0 _vchhusvi _1e0c11p5 _yv0e7dup _2z05hkll _1lmcu4vt _1ul9t9kd _4t3iviql _4cvr1h6o _uiztglyw _syaz1gjq _1yyu3acm _91ju1txw _uomdidpf _pmxpidpf _db80idpf _qxq9kb7n _1rbv1wug _kwq51b66 _1swv108i _irr3108i _t7p8kb7n _g4kikb7n _91nl1wug _ynyi1wug _iy5o1b66 _v4o21b66",
    removeElemAfter: "_91juglyw",
    showHoverActions: "_uomdkb7n _pmxp1wug _db801b66",
    removeElemAfterOnHoverOrOpenNestedPopup: "_1djyglyw _1mfcglyw _1sjuglyw",
    selected: "_bfhkfg4m _syazaqb7 _1yyu1fvw _1swvi1yw _30l3aqb7 _irr3i1yw",
    disabled: "_syaz1lh4 _irr3n7od",
    hasDescription: "_4t3i1wto",
    dragging: "_tzy41ou4"
};
const $f3ea94f8b9659885$var$buttonOrAnchorStyles = {
    root: "_2rko12b0 _yyhyjvu9 _1ii7kb7n _1e0c11p5 _yv0enbh3 _2z05nbh3 _y4ti1b66 _bozg1b66 _1q511b66 _85i51b66 _bfhk18uv _syaz1gjq _4cvr1h6o _y3gnv2br _14iu1ji5",
    selected: "_syazaqb7 _14iu19ru",
    hasDragIndicator: "_1ifmglyw _1cykglyw _x0kw1txw _11om6b4r _7psyru3m _1uy01amc _bir2q7pw"
};
const $f3ea94f8b9659885$var$extendButtonOrAnchorStyles = {
    root: "_1r04ze3t _kqswstnw"
};
const $f3ea94f8b9659885$var$notchStyles = {
    root: "_kqswstnw _152t1ssb _1e02ze3t _1bsbyh40 _4t3i1crf _t9ec1i34 _bfhk1o0g"
};
const $f3ea94f8b9659885$var$actionStyles = {
    root: "_zulp1b66 _nd5lbc26 _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
const $f3ea94f8b9659885$var$actionsOnHoverStyles = {
    root: "_nd5l16dh _zulp1b66 _1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _tzy4pnc3 _1bsbty16 _y4tidria _1guo18uv _12s918uv"
};
const $f3ea94f8b9659885$var$textStyles = {
    root: "_zulpv77o _1reo15vq _18m915vq _y4ti1b66 _bozg1b66 _1e0c1txw _2lx21bp4 _1ul91c9m _1guo18uv _12s918uv",
    noElemBeforeIndent: "_bozg12x7"
};
const $f3ea94f8b9659885$var$elemBeforeStyles = {
    root: "_nd5l17zh _1reo15vq _18m915vq _1e0c1txw _1o9zidpf _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _bozg1b66 _vchh18uv _1guo18uv _12s918uv"
};
const $f3ea94f8b9659885$var$elemAfterStyles = {
    root: "_nd5l16dh _1reo15vq _18m915vq _1e0c13yo _1o9zidpf _4t3i1tcg _4cvr1h6o _y4ti1b66 _1guo18uv _12s918uv"
};
/**
 * We are using a wrapping element for our interactive content
 * even though only the `Text` element is the only thing not using `position:absolute`
 *
 * Rationale:
 * - Super clear that everything inside the interactive content should be in a specific slot in the grid
 * - To work around a browser bug in Safari where it does not work well with `position:absolute`
 *   on a subgrid child.
 *   Safari bug: https://bugs.webkit.org/show_bug.cgi?id=292516
 */ const $f3ea94f8b9659885$var$interactiveContentStyles = {
    root: "_nd5l19l3 _1e0c1txw _2lx21bp4 _ae4v1h6o"
};
function $f3ea94f8b9659885$var$getTextColor({ isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'color.text.disabled';
    if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
}
/**
 * This is the internal version of the component, to be passed into `forwardRef`.
 *
 * It contains a type argument `<T>`, to specify the type of the interactive element (`button` or `a`).
 * This can be inferred from the type of the `onClick` prop.
 */ const $f3ea94f8b9659885$var$MenuItemBaseNoRef = ({ id: id, testId: testId, actions: actions, actionsOnHover: actionsOnHover, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaHasPopup: ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const level = (0, $yFG6a.useLevel)();
    const setFlyoutMenuOpen = (0, $1C3j7.useSetFlyoutMenuOpen)();
    const isFlyoutMenuOpen = (0, $1C3j7.useFlyoutMenuOpen)();
    const isLink = typeof href !== 'undefined';
    const labelRef = (0, $eJOHy.useRef)(null);
    const descriptionRef = (0, $eJOHy.useRef)(null);
    const tooltipOnClick = (0, $eJOHy.useRef)(null);
    const handleClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        // Toggle flyout menu open state when inside a flyout context provider
        setFlyoutMenuOpen(!isFlyoutMenuOpen);
        tooltipOnClick.current?.(event);
    }, [
        onClick,
        setFlyoutMenuOpen,
        isFlyoutMenuOpen
    ]);
    /**
   * Show the tooltip if _either_ label or description is truncated
   */ const canTooltipAppear = (0, $eJOHy.useCallback)(()=>{
        if (isContentTooltipDisabled) return false;
        // Show tooltip if _either_ label or description are clamped
        const label = labelRef.current;
        const description = descriptionRef.current;
        if (label && $f3ea94f8b9659885$var$isTextClamped(label)) return true;
        return Boolean(description && $f3ea94f8b9659885$var$isTextClamped(description));
    }, [
        isContentTooltipDisabled
    ]);
    // By default provide the spacing for `elemBefore` to have good
    // vertical alignment of labels and to give clear indentation between levels
    // in the side navigation (even when items don't use elemBefore).
    const showElemBefore = elemBefore !== (0, $kbcF8.COLLAPSE_ELEM_BEFORE);
    const interactiveElemContent = /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        className: (0, $hcewu.default)([
            $f3ea94f8b9659885$var$interactiveContentStyles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                // This extends the clickable area of nested menu items to the width
                // of the root level menu items, while being visually indented.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                style: {
                    insetInlineStart: `calc(-1 * ${level} * ${(0, $51149c97989df8ee$export$d492445a79a49b48)})`
                },
                "aria-hidden": "true",
                className: (0, $hcewu.default)([
                    $f3ea94f8b9659885$var$extendButtonOrAnchorStyles.root
                ])
            }),
            /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
                className: (0, $hcewu.default)([
                    $f3ea94f8b9659885$var$textStyles.root,
                    !showElemBefore && $f3ea94f8b9659885$var$textStyles.noElemBeforeIndent
                ]),
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        weight: "medium",
                        maxLines: 1,
                        color: $f3ea94f8b9659885$var$getTextColor({
                            isDisabled: isDisabled,
                            isSelected: isSelected
                        }),
                        ref: labelRef,
                        children: children
                    }),
                    description && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                        color: isDisabled ? 'color.text.disabled' : 'color.text.subtle',
                        size: "small",
                        maxLines: 1,
                        ref: descriptionRef,
                        children: description
                    })
                ]
            }),
            hasDragIndicator ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)($f3ea94f8b9659885$var$LazyDragHandle, {})
            }) : null,
            dropIndicator
        ]
    });
    /**
   *  If the [expandable] menu item is expanded, show hover actions even when *not* hovered.
   *
   * Note: we also remove the `elemAfter` when showing `actionsOnHover`
   */ const showHoverActionsWhenNotHovered = Boolean(ariaExpanded && actionsOnHover);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $l8fMV.AvatarContext).Provider, {
        value: $f3ea94f8b9659885$var$defaultAvatarValues,
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
            ref: visualContentRef,
            "data-testid": testId ? `${testId}-container` : undefined,
            "data-selected": isSelected,
            className: (0, $hcewu.default)([
                $f3ea94f8b9659885$var$containerStyles.root,
                isSelected && $f3ea94f8b9659885$var$containerStyles.selected,
                isDragging && $f3ea94f8b9659885$var$containerStyles.dragging,
                description && $f3ea94f8b9659885$var$containerStyles.hasDescription,
                showHoverActionsWhenNotHovered && $f3ea94f8b9659885$var$containerStyles.showHoverActions,
                showHoverActionsWhenNotHovered && elemAfter && $f3ea94f8b9659885$var$containerStyles.removeElemAfter,
                actionsOnHover && elemAfter && $f3ea94f8b9659885$var$containerStyles.removeElemAfterOnHoverOrOpenNestedPopup,
                isDisabled && $f3ea94f8b9659885$var$containerStyles.disabled
            ]),
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
                    content: ()=>/*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    children: children
                                }),
                                description ? /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    children: description
                                }) : null
                            ]
                        }),
                    position: (0, $eGOwo.fg)('platform_dst_side_nav_remove_custom_tooltip') ? 'right-start' : 'right',
                    // NOTE: Types in React 18 have changed and `forwardRef(() => <TooltipPrimitive>)` no longer appears to match 100%
                    component: (0, $eGOwo.fg)('platform_dst_side_nav_remove_custom_tooltip') ? undefined : $f3ea94f8b9659885$var$MenuItemTooltip,
                    ignoreTooltipPointerEvents: true,
                    hideTooltipOnMouseDown: true,
                    // We don't need a duplicate hidden element containing tooltip content
                    // as the content of the tooltip matches what is rendered for the menu item.
                    isScreenReaderAnnouncementDisabled: true,
                    canAppear: canTooltipAppear,
                    children: (tooltipProps)=>{
                        // Putting the tooltip onClick into a ref.
                        // This way we don't need to create a new `onClick` function on each
                        // render (as we would need to merge `tooltipProps.onClick` and our `handleClick`)
                        tooltipOnClick.current = tooltipProps.onClick;
                        const sharedProps = {
                            ...tooltipProps,
                            'aria-controls': ariaControls,
                            'aria-haspopup': ariaHasPopup,
                            ref: (0, $gyJTO.default)([
                                forwardedRef,
                                tooltipProps.ref
                            ]),
                            id: id,
                            testId: testId,
                            interactionName: interactionName
                        };
                        return isLink ? /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $lc0OY.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $k0ahr.cx)($f3ea94f8b9659885$var$buttonOrAnchorStyles.root, $f3ea94f8b9659885$var$topLevelSiblingStyles.root, isSelected && $f3ea94f8b9659885$var$buttonOrAnchorStyles.selected, hasDragIndicator && $f3ea94f8b9659885$var$buttonOrAnchorStyles.hasDragIndicator),
                            // Needed to override Anchor style due to a compiled/emotion conflict
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                            style: {
                                textDecoration: 'none'
                            },
                            "aria-current": isSelected ? 'page' : undefined,
                            href: href,
                            target: target,
                            /**
           * For anchors we don't want to have the standard drag and drop behaviour.
           *
           * Thinking on the topic:
           *
           * - Anchors look visually similar to buttons in the sidenav
           * - Why should some menu items be natively draggable, while others are not?
           * - A user cannot know which menu items are "natively" draggable (ie anchors)
           * - If you wire up an anchor to be draggable using our standard affordances
           *   it will have a different preview experience to native anchor dragging.
           *
           * To promote consistency, all elements need to use the same visual affordances.
           *
           * Anchor elements will automatically attach URL information
           * to the native data store.
           *
           * When `hasDragIndicator` is `true` we are expecting consumers to register
           * the element as draggable through the `draggable()` Pragmatic drag and drop function.
           * The `draggable()` function will add `draggable="true"` to the element.
           */ draggable: hasDragIndicator ? undefined : false,
                            children: [
                                /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                                    "aria-hidden": "true",
                                    className: (0, $hcewu.default)([
                                        $f3ea94f8b9659885$var$notchStyles.root
                                    ])
                                }),
                                interactiveElemContent
                            ]
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                            ...sharedProps,
                            onClick: handleClick,
                            xcss: (0, $k0ahr.cx)($f3ea94f8b9659885$var$buttonOrAnchorStyles.root, $f3ea94f8b9659885$var$topLevelSiblingStyles.root, isSelected && $f3ea94f8b9659885$var$buttonOrAnchorStyles.selected, hasDragIndicator && $f3ea94f8b9659885$var$buttonOrAnchorStyles.hasDragIndicator),
                            "aria-expanded": ariaExpanded,
                            isDisabled: isDisabled,
                            children: interactiveElemContent
                        });
                    }
                }),
                showElemBefore && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f3ea94f8b9659885$var$elemBeforeStyles.root,
                        $f3ea94f8b9659885$var$topLevelSiblingStyles.root,
                        $f3ea94f8b9659885$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemBefore
                }),
                actionsOnHover && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f3ea94f8b9659885$var$actionsOnHoverStyles.root
                    ]),
                    children: actionsOnHover
                }),
                elemAfter && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f3ea94f8b9659885$var$elemAfterStyles.root,
                        $f3ea94f8b9659885$var$topLevelSiblingStyles.root,
                        $f3ea94f8b9659885$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: elemAfter
                }),
                actions && /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
                    className: (0, $hcewu.default)([
                        $f3ea94f8b9659885$var$actionStyles.root,
                        $f3ea94f8b9659885$var$topLevelSiblingStyles.root,
                        $f3ea94f8b9659885$var$onTopOfButtonOrAnchorStyles.root
                    ]),
                    children: actions
                })
            ]
        })
    });
};
const $f3ea94f8b9659885$export$859b390bf71e044e = (0, $immLL.default)($f3ea94f8b9659885$var$MenuItemBaseNoRef);

});
/**
 * _Internally_ shared value for the menu item indentation. Used in:
 * - Expandable menu item content, to add padding for each expandable level
 * - The base menu item, to set the negative inset to extend the clickable area of nested menu items
 * to the root level menu items.
 *
 * Internal to the package only. Should not be exported from the package.
 *
 * Note: We're unable to use a token() call here, as Compiled complains about function calls in imported
 * values - it requires statically defined values only.
 *
 * @private
 * @internal
 */ const $51149c97989df8ee$export$d492445a79a49b48 = '12px';

parcelRegister("1C3j7", function(module, exports) {
$parcel$export(module.exports, "IsOpenContext", () => $c440e95460a477ac$export$efa4d9670e96ac31);
$parcel$export(module.exports, "SetIsOpenContext", () => $c440e95460a477ac$export$4c55b1c61a116b42);
$parcel$export(module.exports, "useFlyoutMenuOpen", () => $c440e95460a477ac$export$6927118f874a49aa);
$parcel$export(module.exports, "useSetFlyoutMenuOpen", () => $c440e95460a477ac$export$538ac1aa421adb94);

var $eJOHy = parcelRequire("eJOHy");

var $3Vuhz = parcelRequire("3Vuhz");
const $c440e95460a477ac$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $eJOHy.createContext)(false);
const $c440e95460a477ac$export$4c55b1c61a116b42 = /*#__PURE__*/ (0, $eJOHy.createContext)((0, $3Vuhz.default));
const $c440e95460a477ac$export$6927118f874a49aa = ()=>(0, $eJOHy.useContext)($c440e95460a477ac$export$efa4d9670e96ac31);
const $c440e95460a477ac$export$538ac1aa421adb94 = ()=>(0, $eJOHy.useContext)($c440e95460a477ac$export$4c55b1c61a116b42);

});

parcelRegister("kbcF8", function(module, exports) {
$parcel$export(module.exports, "COLLAPSE_ELEM_BEFORE", () => $693f3748e4f4c29a$export$f4b8e24fae579c6f);
/**
 * A symbol to collapse the `elemBefore` slot.
 * This should be placed in the `elemBefore` prop of supported menu items.
 */ const $693f3748e4f4c29a$export$f4b8e24fae579c6f = Symbol('collapse-elem-before');

});

parcelRegister("e1A1g", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("4PYBD").then(()=>parcelRequire('1hwjy'));

});


parcelRegister("eekOJ", function(module, exports) {
$parcel$export(module.exports, "useScrollMenuItemIntoView", () => $4aac6b18583f3fd8$export$2c52ec851fcc6058);

var $eJOHy = parcelRequire("eJOHy");

var $8GOss = parcelRequire("8GOss");

var $yFG6a = parcelRequire("yFG6a");
function $4aac6b18583f3fd8$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ if (typeof element.scrollIntoViewIfNeeded === 'function') {
        element.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4aac6b18583f3fd8$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $yFG6a.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $eJOHy.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $eJOHy.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $8GOss.default)(element, 'Element ref must be set');
            $4aac6b18583f3fd8$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}

});



parcelRegister("jRu18", function(module, exports) {
$parcel$export(module.exports, "useLocation", () => $a841cad6e309fab1$export$45d76561a5302f2b);

var $kfvK2 = parcelRequire("kfvK2");
const $a841cad6e309fab1$export$45d76561a5302f2b = (0, $kfvK2.createRouterSelector)((state)=>state.location);

});

parcelRegister("4QtKR", function(module, exports) {
$parcel$export(module.exports, "ForgeIcon", () => $8bcd31fd394b5754$export$fe0464db4dc93ab4);

var $eJOHy = parcelRequire("eJOHy");

var $kcLaf = parcelRequire("kcLaf");

var $6l5yN = parcelRequire("6l5yN");
const $8bcd31fd394b5754$export$fe0464db4dc93ab4 = ({ url: url })=>url != null && String(url).trim().length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6l5yN.ContainerAvatar), {
        src: url
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), {
        label: "",
        color: "var(--ds-icon, #44546F)"
    });

});
parcelRegister("6l5yN", function(module, exports) {
$parcel$export(module.exports, "ContainerAvatar", () => $8872ad00786981a3$export$f35a2d11bd6ae97);
/* container-avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $8872ad00786981a3$var$styles = {
    root: "_2rko12b0 _vchhusvi _4t3igktf _1bsbgktf"
};
const $8872ad00786981a3$export$f35a2d11bd6ae97 = ({ src: src })=>/*#__PURE__*/ (0, $gt9Am.jsx)("img", {
        src: src,
        alt: "",
        className: (0, $hcewu.default)([
            $8872ad00786981a3$var$styles.root
        ])
    });

});


parcelRegister("eaBoL", function(module, exports) {
$parcel$export(module.exports, "ForgeItemExpandable", () => $c598ae4d995c2c0a$export$532bd53ddb8882b3);

var $eJOHy = parcelRequire("eJOHy");

var $8n30H = parcelRequire("8n30H");
var $1Bb7G = parcelRequire("1Bb7G");
var $7Z9EK = parcelRequire("7Z9EK");
var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");

var $lHD3D = parcelRequire("lHD3D");

var $lTN3C = parcelRequire("lTN3C");

var $bo95Y = parcelRequire("bo95Y");

var $206hf = parcelRequire("206hf");

var $4cTDP = parcelRequire("4cTDP");

var $4QtKR = parcelRequire("4QtKR");
const $c598ae4d995c2c0a$var$createPageUrl = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
const $c598ae4d995c2c0a$var$ForgeItemExpandableWithHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $206hf.useGetLinkProps)();
    const { id: itemId, url: url, section: section, analytics: analytics } = props;
    const subItemAnalytics = (0, $eJOHy.useMemo)(()=>analytics && {
            ...analytics,
            level: analytics && analytics.level + 1
        }, [
        analytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Bb7G.ExpandableMenuItem), {
        isDefaultExpanded: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lTN3C.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QtKR.ForgeIcon), null),
        analytics: analytics,
        interactionName: (0, $4cTDP.fg)('blu-7963_add_ufo_interaction_names_nav') ? 'nav4-sidebar-forge-item-expandable' : undefined
    }, section.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7Z9EK.ExpandableMenuItemContent), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
            key: page.route,
            ...getLinkProps($c598ae4d995c2c0a$var$createPageUrl(url, page.route)),
            analytics: subItemAnalytics,
            onClick: ()=>{
                (0, $lHD3D.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)))));
};
const $c598ae4d995c2c0a$var$ForgeItemExpandableWithoutHeader = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $206hf.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, url: url, section: section, analytics: analytics } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, section.pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
            key: page.route,
            elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QtKR.ForgeIcon), {
                url: page.icon
            }) : undefined,
            ...getLinkProps($c598ae4d995c2c0a$var$createPageUrl(url, page.route)),
            analytics: analytics,
            onClick: ()=>{
                (0, $lHD3D.forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, page.title)));
};
const $c598ae4d995c2c0a$export$532bd53ddb8882b3 = (props)=>{
    const { showIcon: showIcon, id: itemId, url: url, sections: sections, analytics: analytics } = props;
    const hasSectionsWithHeader = sections?.some((section)=>!!section.header);
    return sections?.map((section, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, typeof section.header === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c598ae4d995c2c0a$var$ForgeItemExpandableWithHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon,
            analytics: analytics
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, !hasSectionsWithHeader && index !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8n30H.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c598ae4d995c2c0a$var$ForgeItemExpandableWithoutHeader, {
            id: itemId,
            section: section,
            url: url,
            showIcon: showIcon,
            analytics: analytics
        })))));
};

});
parcelRegister("8n30H", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $0a505da4c4c84dd7$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $0a505da4c4c84dd7$var$styles = null;
const $0a505da4c4c84dd7$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $gt9Am.jsx)("hr", {
        /**
 * The existing usage of these dividers is presentational,
 * so we are removing the separator semantics by default.
 *
 * In the future we may consider allowing opt-in separator semantics,
 * but it probably isn't necessary.
 */ role: "none",
        className: (0, $hcewu.default)([
            "_h7alglyw _179rglyw _mqm27r9e _1bsb1osq"
        ])
    });

});

parcelRegister("bo95Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6e941be7dec1b83$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2dvSy = parcelRequire("2dvSy");


var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");
function $d6e941be7dec1b83$var$LinkMenuItemWithAnalytics({ analytics: analytics, onClick: onClick, ...rest }, ref) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const handleClick = (0, $eJOHy.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        if (!analytics) return;
        const { actionSubjectId: actionSubjectId, ...analyticsAttributes } = analytics;
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: (0, $bfc89d778f76f56d$export$6dd9406e478a1fe2)
        }), actionSubjectId, analyticsAttributes);
    }, [
        analytics,
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2dvSy.LinkMenuItem), {
        ref: ref,
        onClick: handleClick,
        ...rest
    });
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$d6e941be7dec1b83$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.forwardRef)($d6e941be7dec1b83$var$LinkMenuItemWithAnalytics);

});
parcelRegister("2dvSy", function(module, exports) {
$parcel$export(module.exports, "LinkMenuItem", () => $8915a16da7f35027$export$d2cad7a1cce7b35f);
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $immLL = parcelRequire("immLL");

var $gyJTO = parcelRequire("gyJTO");

var $4sCzd = parcelRequire("4sCzd");

var $2tKAE = parcelRequire("2tKAE");

var $eekOJ = parcelRequire("eekOJ");
const $8915a16da7f35027$var$listItemStyles = {
    root: "_10m98stt"
};
const $8915a16da7f35027$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $eJOHy.useRef)(null);
    (0, $eekOJ.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $eJOHy.useMemo)(()=>{
        return (0, $gyJTO.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4sCzd.ListItem), {
        ref: ref,
        xcss: $8915a16da7f35027$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2tKAE.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $8915a16da7f35027$export$d2cad7a1cce7b35f = (0, $immLL.default)($8915a16da7f35027$var$LinkMenuItemNoRef);

});

const $bfc89d778f76f56d$export$6dd9406e478a1fe2 = 'navigationItem';
const $bfc89d778f76f56d$export$b887e88d8d0739f6 = 'button';
const $bfc89d778f76f56d$export$64fed82162bd367 = 'dropdownItem';
const $bfc89d778f76f56d$export$b0a8b257f1f878a2 = 'searchInput';


parcelRegister("206hf", function(module, exports) {
$parcel$export(module.exports, "useGetLinkProps", () => $2cc0385e8de7b401$export$a3307878c8496d13);

var $eJOHy = parcelRequire("eJOHy");

var $02kpm = parcelRequire("02kpm");

var $jRu18 = parcelRequire("jRu18");
const $2cc0385e8de7b401$export$a3307878c8496d13 = ()=>{
    const location = (0, $jRu18.useLocation)();
    const getLinkProps = (0, $eJOHy.useCallback)((menuItemPath, options)=>$2cc0385e8de7b401$var$getMenuLinkPropsFromUrlPath({
            currentPath: location.pathname,
            menuItemPath: menuItemPath,
            options: options
        }), [
        location.pathname
    ]);
    const getLinkPropsFromRoute = (0, $eJOHy.useCallback)((menuItemRoute, pathParamValues = {}, options)=>{
        const menuItemPath = (0, $02kpm.generatePath)(menuItemRoute.path, pathParamValues);
        return getLinkProps(menuItemPath, options);
    }, [
        getLinkProps
    ]);
    return {
        getLinkPropsFromRoute: getLinkPropsFromRoute,
        getLinkProps: /**
		 * Consider using getLinkPropsFromRoute instead, to be able to reuse the page route object, rather than copying its url path around.
		 */ getLinkProps
    };
};
const $2cc0385e8de7b401$var$defaultOptions = {
    shouldMatchExactPath: true
};
const $2cc0385e8de7b401$var$getMenuLinkPropsFromUrlPath = ({ currentPath: currentPath, menuItemPath: menuItemPath, options: options })=>{
    const { shouldMatchExactPath: shouldMatchExactPath } = {
        ...$2cc0385e8de7b401$var$defaultOptions,
        ...options
    };
    return {
        href: menuItemPath,
        isSelected: shouldMatchExactPath ? currentPath.replace(/\/$/, '') === menuItemPath.replace(/\/$/, '') : currentPath.includes(menuItemPath.replace(/\/$/, ''))
    };
};

});


parcelRegister("estpl", function(module, exports) {
$parcel$export(module.exports, "ForgeItemSimple", () => $a9e2f0e4cda36aae$export$df3259e43d89ee7b);

var $eJOHy = parcelRequire("eJOHy");

var $lHD3D = parcelRequire("lHD3D");

var $iMZxW = parcelRequire("iMZxW");

var $4cTDP = parcelRequire("4cTDP");

var $8z6Yy = parcelRequire("8z6Yy");

var $bo95Y = parcelRequire("bo95Y");

var $206hf = parcelRequire("206hf");

var $4QtKR = parcelRequire("4QtKR");
const $a9e2f0e4cda36aae$export$df3259e43d89ee7b = (props)=>{
    const { getLinkProps: getLinkProps } = (0, $206hf.useGetLinkProps)();
    const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, overrides: overrides, analytics: analytics, HideFromSidebarButton: HideFromSidebarButton } = props;
    if (overrides?.showSelectedAppMenuOnly) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bo95Y.default), {
        analytics: analytics,
        elemBefore: showIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4QtKR.ForgeIcon), {
            url: iconUrl
        }) : undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMZxW.EnvironmentLozenge), {
            environmentType: environmentType
        }),
        ...getLinkProps(url, {
            shouldMatchExactPath: false
        }),
        onClick: ()=>{
            (0, $lHD3D.forgeModulesConcurrentLoadTime)(itemId).start({
                startTime: performance.now()
            });
        },
        ...(0, $4cTDP.fg)('more_for_nav_4_level_3') ? {
            actionsOnHover: HideFromSidebarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
                MenuItems: HideFromSidebarButton,
                name: name
            })
        } : {}
    }, (0, $iMZxW.nameWithCustomEnvironment)(name, environmentType, environmentKey));
};

});


parcelRegister("e7t2M", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc3619814d166ac$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6bc3619814d166ac$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-forge.admin-section.heading",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("5AUSA", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $57909de3172819f0$export$ed6342e0e28465a6);
$parcel$export(module.exports, "analytics", () => $57909de3172819f0$export$71a493436f9bccb6);
$parcel$export(module.exports, "useForgeProjectSectionAppsData", () => $57909de3172819f0$export$d842b2285df6024c);
$parcel$export(module.exports, "renderForgeProjectSectionItem", () => $57909de3172819f0$export$5ca83c51de550ed4);
$parcel$export(module.exports, "ForgeProjectSection", () => $57909de3172819f0$export$fb7da191295a7e22);

var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $aeOhE = parcelRequire("aeOhE");

var $kA543 = parcelRequire("kA543");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $cIeoi = parcelRequire("cIeoi");

var $7tFyB = parcelRequire("7tFyB");



var $2aY2d = parcelRequire("2aY2d");

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");

var $euVUL = parcelRequire("euVUL");
const $57909de3172819f0$var$projectTypeRouteMap = {
    [(0, $FhXEJ.CORE_PROJECT)]: 'core',
    [(0, $FhXEJ.SOFTWARE_PROJECT)]: 'software',
    [(0, $FhXEJ.SERVICE_DESK_PROJECT)]: 'servicedesk'
};
const $57909de3172819f0$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/${$57909de3172819f0$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
};
const $57909de3172819f0$export$71a493436f9bccb6 = {
    actionSubjectId: (0, $16a7021d28f78da7$export$8d155d2412839524),
    componentType: (0, $493796f3bdee881c$export$4165a3d0da3bd147),
    level: 2
};
const $57909de3172819f0$var$ForgeProjectSectionOld = ({ overrides: overrides, projectKey: projectKey })=>{
    const { data: data } = (0, $7tFyB.useProjectForgeAppsNav4)(projectKey);
    const { data: projectContext } = (0, $2aY2d.useProjectContext)({
        matchParams: {
            projectKey: projectKey
        }
    });
    if (!data?.length || !projectKey || !projectContext) return null;
    const { projectType: projectType } = projectContext;
    const filteredForgeAppsData = overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
        overrides.selectedApp
    ] : data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kA543.TriggerAnalyticsWrapper), null, filteredForgeAppsData.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euVUL.ForgeItem), {
            key: extension.id,
            id: extension.id,
            analytics: $57909de3172819f0$export$71a493436f9bccb6,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $57909de3172819f0$export$ed6342e0e28465a6(extension, projectType, projectKey),
            name: extension.properties.title,
            sections: (0, $cIeoi.toSections)(extension),
            iconUrl: extension.properties.icon,
            showIcon: true,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.PROJECT_PAGE_MODULE)
        }
    }));
};
const $57909de3172819f0$export$d842b2285df6024c = ({ overrides: overrides, projectKey: projectKey })=>{
    const { data: data } = (0, $7tFyB.useProjectForgeAppsNav4)(projectKey);
    if (!data?.length || !projectKey) return null;
    return overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
        overrides.selectedApp
    ] : data;
};
const $57909de3172819f0$export$5ca83c51de550ed4 = ({ extension: extension, projectType: projectType, projectKey: projectKey, overrides: overrides, HideFromSidebarButton: HideFromSidebarButton })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euVUL.ForgeItem), {
        key: extension.id,
        id: extension.id,
        analytics: $57909de3172819f0$export$71a493436f9bccb6,
        environmentType: extension.environmentType,
        environmentKey: extension.environmentKey,
        HideFromSidebarButton: HideFromSidebarButton,
        url: $57909de3172819f0$export$ed6342e0e28465a6(extension, projectType, projectKey),
        name: extension.properties.title,
        sections: (0, $cIeoi.toSections)(extension),
        iconUrl: extension.properties.icon,
        showIcon: true,
        overrides: overrides
    });
const $57909de3172819f0$var$ForgeProjectSectionNew = ({ overrides: overrides, projectKey: projectKey })=>{
    const filteredForgeAppsData = $57909de3172819f0$export$d842b2285df6024c({
        overrides: overrides,
        projectKey: projectKey
    });
    const { data: projectContext } = (0, $2aY2d.useProjectContext)({
        matchParams: {
            projectKey: projectKey
        }
    });
    if (filteredForgeAppsData === null || !projectContext) return null;
    const { projectType: projectType } = projectContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kA543.TriggerAnalyticsWrapper), null, filteredForgeAppsData.map((extension)=>$57909de3172819f0$export$5ca83c51de550ed4({
            extension: extension,
            projectType: projectType,
            projectKey: projectKey,
            overrides: overrides
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.PROJECT_PAGE_MODULE)
        }
    }));
};
const $57909de3172819f0$export$fb7da191295a7e22 = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('more_for_nav_4_level_3'), $57909de3172819f0$var$ForgeProjectSectionNew, $57909de3172819f0$var$ForgeProjectSectionOld);

});
const $16a7021d28f78da7$export$8d155d2412839524 = 'projectsNavigationMenuItem';
const $16a7021d28f78da7$export$13171e509c859bbf = 'projectSettingsNavigationMenuItem';
const $16a7021d28f78da7$export$8ebfc84e07851700 = 'moreProjectsSearch';

const $493796f3bdee881c$export$4165a3d0da3bd147 = 'fixedItem';
const $493796f3bdee881c$export$95b0c331af13d819 = 'fixedItemButton';
const $493796f3bdee881c$export$74712b62056d422e = 'fixedItemAction';
const $493796f3bdee881c$export$3ac911b122986477 = 'customItem';
const $493796f3bdee881c$export$9bd6c21d500ae611 = 'customItemButton';
const $493796f3bdee881c$export$5374c2c2d3ece55e = 'customItemAction';
const $493796f3bdee881c$export$56981f28056f258e = 'customItemDropdownAction';
const $493796f3bdee881c$export$17bca95234dea43b = 'fixedItemDropdownAction';


parcelRegister("3Thdh", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $aeec205949befefe$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgePersonalSettingsSection", () => $aeec205949befefe$export$3f793b2ffe120524);

var $eJOHy = parcelRequire("eJOHy");

var $85fS3 = parcelRequire("85fS3");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $aeOhE = parcelRequire("aeOhE");

var $8PvQT = parcelRequire("8PvQT");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $lRq8t = parcelRequire("lRq8t");

var $cIeoi = parcelRequire("cIeoi");

var $2RByg = parcelRequire("2RByg");

var $bxWdr = parcelRequire("bxWdr");

var $euVUL = parcelRequire("euVUL");

var $cb8aY = parcelRequire("cb8aY");
const $aeec205949befefe$export$ed6342e0e28465a6 = (extension)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `${(0, $bxWdr.getAppsPersonalSettingsPath)()}/${appId}/${envId}`;
};
const $aeec205949befefe$var$BaseForgePersonalSettingsSection = ({ analytics: analytics })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { data: pages } = (0, $2RByg.usePersonalSettingsForgeApps)();
    if (!pages?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, formatMessage((0, $cb8aY.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, pages.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euVUL.ForgeItem), {
            key: extension.id,
            id: extension.id,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $aeec205949befefe$export$ed6342e0e28465a6(extension),
            name: extension.properties.title,
            sections: (0, $cIeoi.toSections)(extension),
            iconUrl: extension.properties.icon,
            analytics: analytics,
            showIcon: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.PERSONAL_SETTINGS_PAGE_MODULE)
        }
    }));
};
const $aeec205949befefe$export$3f793b2ffe120524 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8PvQT.TriggerAnalyticsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($aeec205949befefe$var$BaseForgePersonalSettingsSection, props));

});
parcelRegister("cb8aY", function(module, exports) {
$parcel$export(module.exports, "default", () => $dabb5749547fda99$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $dabb5749547fda99$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "navigation-apps-sidebar-nav4-sidebars-common-forge.personal-settings-section.heading",
        "defaultMessage": "Apps"
    }
});

});


parcelRegister("b1IkX", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $8064b7ec58737162$export$ed6342e0e28465a6);
$parcel$export(module.exports, "ForgeServiceDeskQueueSection", () => $8064b7ec58737162$export$a133aa9cc8b5e080);

var $eJOHy = parcelRequire("eJOHy");

var $aeOhE = parcelRequire("aeOhE");

var $g9x9X = parcelRequire("g9x9X");

var $fohjD = parcelRequire("fohjD");

var $ePLco = parcelRequire("ePLco");

var $cIeoi = parcelRequire("cIeoi");

var $10vUC = parcelRequire("10vUC");

var $euVUL = parcelRequire("euVUL");
const $8064b7ec58737162$export$ed6342e0e28465a6 = (extension, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/servicedesk/projects/${projectKey}/queues/apps/${appId}/${envId}`;
};
const $8064b7ec58737162$export$a133aa9cc8b5e080 = ({ projectKey: projectKey, analytics: analytics })=>{
    const { data: data } = (0, $10vUC.useServiceDeskQueueForgeAppsNav4)(projectKey);
    if (!data?.length || !projectKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $g9x9X.TriggerAnalyticsWrapper), null, data.map((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $euVUL.ForgeItem), {
            key: extension.id,
            id: extension.id,
            analytics: analytics,
            environmentType: extension.environmentType,
            environmentKey: extension.environmentKey,
            url: $8064b7ec58737162$export$ed6342e0e28465a6(extension, projectKey),
            name: extension.properties.title,
            sections: (0, $cIeoi.toSections)(extension),
            iconUrl: extension.properties.icon,
            showIcon: true
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aeOhE.ForgeScreenEvent), {
        attributes: {
            moduleType: (0, $fohjD.SERVICEDESK_QUEUE_PAGE_MODULE)
        }
    }));
};

});

parcelRegister("4PPl0", function(module, exports) {
$parcel$export(module.exports, "getItemHref", () => $2bdfe44e1770f5d3$export$ed6342e0e28465a6);

var $ePLco = parcelRequire("ePLco");
const $2bdfe44e1770f5d3$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
    const { appId: appId, envId: envId } = (0, $ePLco.parseExtensionId)(extension.id);
    return `/jira/${projectType}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
};

});

parcelRegister("fDVia", function(module, exports) {
$parcel$export(module.exports, "functionWithFF", () => $dbb95a8afa9a44e2$export$3b8cbae22108d228);

var $bi9FK = parcelRequire("bi9FK");

var $hbF3h = parcelRequire("hbF3h");
const $dbb95a8afa9a44e2$export$3b8cbae22108d228 = (featureFlagName, functionTrue, functionFalse)=>(0, $hbF3h.functionWithCondition)(()=>(0, $bi9FK.ff)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("bi9FK", function(module, exports) {
$parcel$export(module.exports, "ff", () => $af7a0b2e539364ac$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $af7a0b2e539364ac$export$757bc67afadef4a0);
$parcel$export(module.exports, "getFeatureFlagValue", () => $af7a0b2e539364ac$export$7064bb599f663d7e);

var $4iJGP = parcelRequire("4iJGP");

var $6eHOp = parcelRequire("6eHOp");

var $9DwQv = parcelRequire("9DwQv");

var $4ajKf = parcelRequire("4ajKf");
function $af7a0b2e539364ac$export$a6dcfcb59016e126(featureFlagName, defaultValue) {
    const client = (0, $4ajKf.getFeatureFlagClient)();
    const flag = client.getFlagEvaluation(featureFlagName, {
        default: defaultValue
    });
    if (!flag) return defaultValue;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return flag.value;
}
const $af7a0b2e539364ac$var$getBooleanFeatureFlagUsingClient = (featureFlagName, defaultValue)=>{
    const client = (0, $4ajKf.getFeatureFlagClient)();
    return client.getBooleanValue(featureFlagName, {
        default: defaultValue,
        shouldTrackExposureEvent: false
    });
};
const $af7a0b2e539364ac$var$getMultivariateFeatureFlagUsingClient = (featureFlagName, defaultValue, possibleValues)=>{
    const client = (0, $4ajKf.getFeatureFlagClient)();
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'T'.
    return client.getVariantValue(featureFlagName, {
        default: defaultValue,
        // @ts-expect-error - TS2322 - Type 'T[]' is not assignable to type 'string[]'.
        oneOf: possibleValues,
        shouldTrackExposureEvent: false
    });
};
/**
 * The feature flag client can be configured to fire automatic exposure events when evaluating
 * feature flag values. For the Track All Changes project, we need all flag evaluations to go
 * through this client so that we can collect these events for all feature flags.
 * See https://hello.atlassian.net/browse/FD-18145 for more information.
 */ const $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations = ()=>(0, $9DwQv.isAutomaticExposureCollectionEnabled)();
const $af7a0b2e539364ac$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$var$getBooleanFeatureFlagUsingClient : (0, $6eHOp.ff);
    const value = impl(featureFlagName, defaultValue);
    (0, $4iJGP.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
};
function $af7a0b2e539364ac$export$757bc67afadef4a0(featureFlagName, defaultValue, possibleValues) {
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$var$getMultivariateFeatureFlagUsingClient : (0, $6eHOp.getMultivariateFeatureFlag);
    const value = impl(featureFlagName, defaultValue, possibleValues);
    (0, $4iJGP.addFeatureFlagAccessed)(featureFlagName, value);
    return value;
}
function $af7a0b2e539364ac$export$7064bb599f663d7e(featureFlagName, defaultValue) {
    const impl = $af7a0b2e539364ac$var$isFeatureFlagClientUsedForAllEvaluations() ? $af7a0b2e539364ac$export$a6dcfcb59016e126 : (0, $6eHOp.getFeatureFlagValue);
    const value = impl(featureFlagName, defaultValue);
    (0, $4iJGP.addFeatureFlagAccessed)(featureFlagName, value);
    return impl(featureFlagName, defaultValue);
}

});
parcelRegister("6eHOp", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlagValue", () => $da6d0b5f6a4027e4$export$7064bb599f663d7e);
$parcel$export(module.exports, "ff", () => $da6d0b5f6a4027e4$export$f59495b1b7502b33);
$parcel$export(module.exports, "getMultivariateFeatureFlag", () => $da6d0b5f6a4027e4$export$757bc67afadef4a0);
function $da6d0b5f6a4027e4$export$7064bb599f663d7e(_featureFlagName, defaultValue) {
    return defaultValue;
}
const $da6d0b5f6a4027e4$export$f59495b1b7502b33 = (featureFlagName, defaultValue = false)=>{
    const flagValue = $da6d0b5f6a4027e4$export$7064bb599f663d7e(featureFlagName, defaultValue);
    const isValid = typeof flagValue === 'boolean';
    return isValid ? flagValue : defaultValue;
};
const $da6d0b5f6a4027e4$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues)=>{
    const flagValue = $da6d0b5f6a4027e4$export$7064bb599f663d7e(featureFlagName, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    defaultValue);
    const isValid = typeof flagValue === 'string' && possibleValues.includes(flagValue);
    return isValid ? flagValue : defaultValue;
};

});

parcelRegister("4ajKf", function(module, exports) {
$parcel$export(module.exports, "getFeatureFlagClient", () => $236e6674104348c2$export$43a6e0552eef5ca9);

var $LFmXM = parcelRequire("LFmXM");
parcelRequire("3HGde");
var $luZJ4 = parcelRequire("luZJ4");

var $j500r = parcelRequire("j500r");

var $2Mqjh = parcelRequire("2Mqjh");
const $236e6674104348c2$var$getAnalyticsClientInstance = ()=>(0, $2Mqjh.getAnalyticsWebClientPromise)().then((analyticsClient)=>analyticsClient.getInstance());
const $236e6674104348c2$var$createFeatureFlagClient = ()=>{
    const client = new (0, $luZJ4.default)({
        analyticsHandler: {
            sendOperationalEvent: async (event)=>{
                if (!false) $236e6674104348c2$var$getAnalyticsClientInstance().then((analyticsClient)=>{
                    // SSR doesn't have an analytics client
                    if (!analyticsClient) return;
                    // customize event data here if needed
                    analyticsClient.sendOperationalEvent(event);
                });
            }
        },
        flags: undefined
    });
    return client;
};
const $236e6674104348c2$var$featureFlagClient = $236e6674104348c2$var$createFeatureFlagClient();
const $236e6674104348c2$var$getFeatureFlags = ()=>{
    const flags = (0, $j500r.default)();
    if (Object.keys(flags).length === 0) {
        if (false) {
            const err = new Error("Feature flags are not available yet. The feature flag client can't be initialized");
            // print out the stack trace for SSR, so we can have better understanding on
            // which module is using the client too early.
            // in SSR, we use bunyan to replace the console.error, so we can use the standard
            // log format for apps.
            // eslint-disable-next-line no-console
            console.error({
                err: err
            });
        } else // eslint-disable-next-line no-console
        console.error("Feature flags are not available yet. The feature flag client can't be initialized");
    }
    return flags;
};
const $236e6674104348c2$var$configureFeatureFlagClient = ()=>{
    const flags = $236e6674104348c2$var$getFeatureFlags();
    // @ts-expect-error - TS2345 - Argument of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/utils/feature-flagging-using-meta/src/common/types").Flags' is not assignable to parameter of type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@atlaskit/feature-flag-client/dist/types/types").Flags'.
    $236e6674104348c2$var$featureFlagClient.setFlags(flags);
    if (!false) $236e6674104348c2$var$featureFlagClient.setIsAutomaticExposuresEnabled(true);
    return $236e6674104348c2$var$featureFlagClient;
};
// NOTE: `memoizeOne` is doing unnecessary checks, what we need in this file is
// a simple local variable implementation, if local variable doesn't exist then
// create it.
const $236e6674104348c2$var$getMemoizedFeatureFlagClient = (0, $LFmXM.default)($236e6674104348c2$var$configureFeatureFlagClient);
let $236e6674104348c2$var$builtFeatureFlagClient;
const $236e6674104348c2$export$43a6e0552eef5ca9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (globalVar.isReorderEarlyScriptsEnabled === true) {
        if (typeof $236e6674104348c2$var$builtFeatureFlagClient === 'undefined' || globalVar.invalidateFeatureFlagsClient_DO_NOT_USE === true) {
            globalVar.invalidateFeatureFlagsClient_DO_NOT_USE = false;
            $236e6674104348c2$var$builtFeatureFlagClient = (0, $LFmXM.default)($236e6674104348c2$var$configureFeatureFlagClient);
        }
        return $236e6674104348c2$var$builtFeatureFlagClient();
    }
    return $236e6674104348c2$var$getMemoizedFeatureFlagClient();
};

});
parcelRegister("3HGde", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("luZJ4")).default);

var $luZJ4 = parcelRequire("luZJ4");

var $l27Vv = parcelRequire("l27Vv");

});
parcelRegister("luZJ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcf7b7e4d681358f$export$2e2bcd8739ae039);

var $l27Vv = parcelRequire("l27Vv");

var $bLeeC = parcelRequire("bLeeC");

var $dfMe6 = parcelRequire("dfMe6");

var $51ACz = parcelRequire("51ACz");
class $bcf7b7e4d681358f$export$2e2bcd8739ae039 {
    constructor(options){
        (0, $bLeeC.enforceAttributes)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
    setFlags(flags) {
        if (!(0, $bLeeC.isObject)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
	 * This method returns the wrapper object for the given flag key.
	 * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
	 * so it is always guaranteed to return an object.
	 */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $51ACz.default)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $dfMe6.default)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $bLeeC.enforceAttributes)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
	 * This method combines both the trackExposure and sendAutomaticExposure flows into
	 * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
	 * is sent.
	 **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $l27Vv.ExposureTriggerReason).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $l27Vv.ExposureTriggerReason).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $l27Vv.ExposureTriggerReason).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $bLeeC.checkForReservedAttributes)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $bLeeC.isObjectEmptyOrUndefined)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $l27Vv.ExposureTriggerReason).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $bLeeC.isObjectEmptyOrUndefined)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $l27Vv.ExposureTriggerReason).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
}

});
parcelRegister("l27Vv", function(module, exports) {
$parcel$export(module.exports, "ExposureTriggerReason", () => $525fe1842dde9869$export$2c20ffeba7dbc068);
var $525fe1842dde9869$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});

});

parcelRegister("bLeeC", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $22c42206e3495b7d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isObjectEmptyOrUndefined", () => $22c42206e3495b7d$export$8ed1df9dbe2e9a7d);
$parcel$export(module.exports, "enforceAttributes", () => $22c42206e3495b7d$export$c7d37910dd25ecbf);
$parcel$export(module.exports, "checkForReservedAttributes", () => $22c42206e3495b7d$export$891630e169ca14a4);
const $22c42206e3495b7d$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $22c42206e3495b7d$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $22c42206e3495b7d$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $22c42206e3495b7d$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $22c42206e3495b7d$var$validateFlag = (flagKey, flag)=>{
    if ($22c42206e3495b7d$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $22c42206e3495b7d$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$22c42206e3495b7d$var$validateFlag(key, flags[key]));
};

});

parcelRegister("dfMe6", function(module, exports) {
$parcel$export(module.exports, "default", () => $97cdc47b760aea4d$export$2e2bcd8739ae039);
const $97cdc47b760aea4d$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $97cdc47b760aea4d$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $97cdc47b760aea4d$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}

});

parcelRegister("51ACz", function(module, exports) {
$parcel$export(module.exports, "default", () => $4565132a6dc98d6b$export$2e2bcd8739ae039);

var $l27Vv = parcelRequire("l27Vv");
class $4565132a6dc98d6b$export$2e2bcd8739ae039 {
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $l27Vv.ExposureTriggerReason).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $l27Vv.ExposureTriggerReason).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
}

});








parcelRegister("jcY6n", function(module, exports) {
$parcel$export(module.exports, "ForgeModalCommands", () => $2b0a5263eeb315f9$export$e809448cf604f95b);

var $eJOHy = parcelRequire("eJOHy");

var $kcLaf = parcelRequire("kcLaf");

var $hf4h9 = parcelRequire("hf4h9");

var $kJnzO = parcelRequire("kJnzO");

var $1Zcfy = parcelRequire("1Zcfy");

var $4cTDP = parcelRequire("4cTDP");

var $7votZ = parcelRequire("7votZ");

var $3y7H4 = parcelRequire("3y7H4");
const $2b0a5263eeb315f9$export$e809448cf604f95b = ({ commands: commands })=>{
    const [modalExtension, setModalExtension] = (0, $eJOHy.useState)(null);
    const commandsWithActions = (0, $eJOHy.useMemo)(()=>$2b0a5263eeb315f9$export$1bd5700c2fc72e18(commands, setModalExtension), [
        commands
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7votZ.RegisterForgeCommands), {
        commands: commandsWithActions
    }), modalExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kJnzO.AsyncCommandPalette), {
        onClose: ()=>{
            setModalExtension(null);
        },
        extension: modalExtension
    }));
};
const $2b0a5263eeb315f9$export$1bd5700c2fc72e18 = (commands, setModalExtension)=>commands.map((extension)=>{
        const { id: id, properties: properties } = extension;
        const { title: title, keywords: keywords, shortcut: shortcut, icon: icon } = properties;
        const LeftIcon = (0, $3y7H4.FORGE_COMMAND_PALETTE_ICON_MAP)[icon];
        const components = LeftIcon ? {
            LeftIcon: LeftIcon
        } : {
            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kcLaf))), {
                    label: "",
                    "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                })
        };
        return {
            id: id,
            title: title,
            icon: icon,
            keywords: keywords?.join(' '),
            section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).forge,
            components: components,
            shortcut: shortcut,
            name: title,
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>{
                    setModalExtension(extension);
                }
            }
        };
    });

});
parcelRegister("kJnzO", function(module, exports) {
$parcel$export(module.exports, "AsyncCommandPalette", () => $1bd5e3ec91cb9aaa$export$2f4d02791542901d);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $fohjD = parcelRequire("fohjD");

var $cF23a = parcelRequire("cF23a");
const $1bd5e3ec91cb9aaa$var$extensionData = {
    type: (0, $fohjD.COMMAND_PALETTE_MODULE)
};
const $1bd5e3ec91cb9aaa$var$extraProps = {
    module: (0, $fohjD.COMMAND_PALETTE_MODULE),
    type: (0, $fohjD.COMMAND_PALETTE_MODULE),
    extensionData: $1bd5e3ec91cb9aaa$var$extensionData,
    contextToken: (0, $fohjD.CONTEXT_TOKEN_TYPE_JIRA)
};
const $1bd5e3ec91cb9aaa$export$2f4d02791542901d = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "command-palette-extension"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cF23a.LazyCommandPaletteRenderer), {
        ...props,
        ...$1bd5e3ec91cb9aaa$var$extraProps
    }));
};

});
parcelRegister("cF23a", function(module, exports) {
$parcel$export(module.exports, "LazyCommandPaletteRenderer", () => $c14efa2662f15831$export$b7c61214514d7cfe);

var $aeOhE = parcelRequire("aeOhE");

var $bQWwW = parcelRequire("bQWwW");

const $c14efa2662f15831$export$b7c61214514d7cfe = (0, $aeOhE.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $bQWwW.lazyForPaint)(()=>(parcelRequire("dqHSj")).then((module)=>module.CommandPalette), {
    ssr: false,
    moduleId: "./src/packages/forge/forge-ui/src/ui/components/command-palette/index.tsx"
}));

});
parcelRegister("dqHSj", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("3yAl4"),
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("3hDWF")
]).then(()=>parcelRequire('4xBNy'));

});





const $f29e7b1e3120b887$export$70d2130cb02f61fa = 'command-palette-integration.ui.container';

parcelRegister("66hHa", function(module, exports) {
$parcel$export(module.exports, "useCloseDotMenu", () => $22ee03bb33c86324$export$64ace3e915332feb);

var $eJOHy = parcelRequire("eJOHy");

var $58ssj = parcelRequire("58ssj");

var $g51Bg = parcelRequire("g51Bg");

var $bHRpp = parcelRequire("bHRpp");
const $22ee03bb33c86324$export$64ace3e915332feb = ()=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }, { setShortcutsDialogVisibility: setShortcutsDialogVisibility }] = (0, $bHRpp.useShortcuts)();
    const [{ isOpen: isOpen }, { open: open }] = (0, $g51Bg.useCommandPaletteIsOpen)();
    (0, $eJOHy.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (isOpen) return ()=>{};
        const handler = (ev)=>{
            const modifier = (0, $58ssj.isMacOs)() ? ev.metaKey : ev.ctrlKey;
            if (modifier && ev.key === 'k') {
                const hasMonolithDotMenu = typeof JIRA !== 'undefined' && typeof JIRA?.Shifter?.dialog?.destroyed === 'function' && !JIRA?.Shifter?.dialog?.destroyed();
                const dotOpen = isShortcutsDialogVisible || hasMonolithDotMenu;
                if (!dotOpen) return;
                if (isShortcutsDialogVisible) setShortcutsDialogVisibility(false);
                if (hasMonolithDotMenu) JIRA.Shifter?.hide?.();
                open();
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handler);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handler);
        };
    }, [
        isOpen,
        isShortcutsDialogVisible,
        open,
        setShortcutsDialogVisibility
    ]);
};

});

parcelRegister("hkBEU", function(module, exports) {
$parcel$export(module.exports, "useCompalBridge", () => $e584802f1301e335$export$9e0258ef367c1984);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");
const $e584802f1301e335$export$9e0258ef367c1984 = ()=>{
    const { open: open } = (0, $g51Bg.useActionsCommandPalette)();
    (0, $eJOHy.useEffect)(()=>{
        if (typeof window !== 'undefined') window.JIRA_COMPAL = {
            open: open
        };
        return ()=>{
            if (typeof window !== 'undefined') window.JIRA_COMPAL = undefined;
        };
    }, [
        open
    ]);
};

});

parcelRegister("hXYvb", function(module, exports) {
$parcel$export(module.exports, "useDisableCompalIfEmbed", () => $ed9c4c8701eb33e9$export$2b4e2f60c6063c36);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");

var $4VWPU = parcelRequire("4VWPU");
const $ed9c4c8701eb33e9$export$2b4e2f60c6063c36 = ()=>{
    const { isEmbed: isEmbed } = (0, $4VWPU.useIsEmbed)();
    const { setIsDisabled: setIsDisabled } = (0, $g51Bg.useActionsCommandPalette)();
    (0, $eJOHy.useEffect)(()=>{
        setIsDisabled(isEmbed);
    }, [
        isEmbed,
        setIsDisabled
    ]);
};

});
parcelRegister("4VWPU", function(module, exports) {
$parcel$export(module.exports, "useIsEmbed", () => $2731095801e428ca$export$ce94463dec1ccebd);

var $gCY1z = parcelRequire("gCY1z");
const $2731095801e428ca$export$ce94463dec1ccebd = ()=>{
    const [{ location: { pathname: pathname } }] = (0, $gCY1z.useRouter)();
    if (pathname.endsWith('/embed')) return {
        isEmbed: true
    };
    return {
        isEmbed: false
    };
};

});


parcelRegister("9QSBF", function(module, exports) {
$parcel$export(module.exports, "useRegisterDismissCommand", () => $bc33f313bb5b52dc$export$ba1bbbf46b23917);

var $eJOHy = parcelRequire("eJOHy");

var $1Zcfy = parcelRequire("1Zcfy");

var $g51Bg = parcelRequire("g51Bg");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $atsoQ = parcelRequire("atsoQ");
const $bc33f313bb5b52dc$export$ba1bbbf46b23917 = ()=>{
    const [{ isOpen: isOpen }, { close: close }] = (0, $g51Bg.useCommandPaletteIsOpen)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isOpen) return ()=>{};
        const dismissCommandPalette = (ev)=>{
            if (!(0, $atsoQ.isCommandPaletteTrigger)(ev)) return;
            (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent((0, $1Zcfy.COMMAND_PALETTE_PRESSED_ANALYTICS)), (0, $1Zcfy.COMMAND_PALETTE_ID), {
                key: 'k',
                isDismissing: true
            });
            ev.preventDefault();
            close();
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('keydown', dismissCommandPalette);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('keydown', dismissCommandPalette);
        };
    }, [
        close,
        createAnalyticsEvent,
        isOpen
    ]);
    return null;
};

});
parcelRegister("atsoQ", function(module, exports) {
$parcel$export(module.exports, "isCommandPaletteTrigger", () => $09458f37063498bc$export$fdcbda728f65a22a);

var $58ssj = parcelRequire("58ssj");
const $09458f37063498bc$export$fdcbda728f65a22a = (ev)=>{
    if (ev.key !== 'k') return false;
    if ((0, $58ssj.isMacOs)()) {
        if (!ev.metaKey) return false;
    } else if (!ev.ctrlKey) return false;
    return true;
};

});


parcelRegister("i1QV6", function(module, exports) {
$parcel$export(module.exports, "useRegisterSections", () => $718afd0cf8ceea80$export$322b8dfd66fee25d);

var $eJOHy = parcelRequire("eJOHy");

var $1Zcfy = parcelRequire("1Zcfy");

var $kSMTP = parcelRequire("kSMTP");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $fGxMc = parcelRequire("fGxMc");
const $718afd0cf8ceea80$export$f32bd31b8d81dbe9 = {
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).containerNavigation]: {
        message: (0, $fGxMc.messages).containerNavigationSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).containerNavigation,
        actionCategory: 'containerNavigation'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation]: {
        message: (0, $fGxMc.messages).siteNavigationSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).siteNavigation,
        actionCategory: 'siteNavigation'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions]: {
        message: (0, $fGxMc.messages).quickActionsSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).quickActions,
        actionCategory: 'quickActions'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).personalSettings]: {
        message: (0, $fGxMc.messages).personalSettingsSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).personalSettings,
        actionCategory: 'personalSettings'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).help]: {
        message: (0, $fGxMc.messages).helpSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).help,
        actionCategory: 'help'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).jiraSettings]: {
        message: (0, $fGxMc.messages).jiraSettingsSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).jiraSettings,
        actionCategory: 'jiraSettings'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).atlassianAdmin]: {
        message: (0, $fGxMc.messages).atlassianAdminSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).atlassianAdmin,
        actionCategory: 'atlassianAdmin'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickSearch]: {
        message: (0, $fGxMc.messages).quickSearchSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).quickSearch,
        actionCategory: 'quickSearch'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).forge]: {
        message: (0, $fGxMc.messages).forgeSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).forge,
        actionCategory: 'forge'
    }
};
const $718afd0cf8ceea80$export$40271ff46d89b4bb = {
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).containerNavigation]: {
        message: (0, $fGxMc.messages).containerNavigationSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).containerNavigation,
        actionCategory: 'containerNavigation'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation]: {
        message: (0, $fGxMc.messages).siteNavigationSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).siteNavigation,
        actionCategory: 'siteNavigation'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions]: {
        message: (0, $fGxMc.messages).quickActionsSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).quickActions,
        actionCategory: 'quickActions'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).personalSettings]: {
        message: (0, $fGxMc.messages).personalSettingsSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).personalSettings,
        actionCategory: 'personalSettings'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).help]: {
        message: (0, $fGxMc.messages).helpSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).help,
        actionCategory: 'help'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).jiraSettings]: {
        message: (0, $fGxMc.messages).jiraSettingsSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).jiraSettings,
        actionCategory: 'jiraSettings'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).atlassianAdmin]: {
        message: (0, $fGxMc.messages).atlassianAdminSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).atlassianAdmin,
        actionCategory: 'atlassianAdmin'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickSearch]: {
        message: (0, $fGxMc.messages).quickSearchSection,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).quickSearch,
        actionCategory: 'quickSearch'
    },
    [(0, $1Zcfy.COMMAND_PALETTE_SECTIONS).forge]: {
        message: (0, $fGxMc.messages).forgeSectionAppify,
        priority: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS_PRIORITY).forge,
        actionCategory: 'forge'
    }
};
const $718afd0cf8ceea80$export$322b8dfd66fee25d = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const initialSections = (0, $4cTDP.fg)('product-terminology-refresh') ? $718afd0cf8ceea80$export$40271ff46d89b4bb : $718afd0cf8ceea80$export$f32bd31b8d81dbe9;
    const sections = (0, $eJOHy.useMemo)(()=>Object.entries(initialSections).reduce((acc, [key, entry])=>{
            acc[key] = {
                name: formatMessage(entry.message),
                priority: entry.priority,
                actionCategory: entry.actionCategory
            };
            return acc;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {}), [
        formatMessage,
        initialSections
    ]);
    (0, $kSMTP.useRegisterCommandSections)(sections);
};

});
parcelRegister("kSMTP", function(module, exports) {
$parcel$export(module.exports, "useRegisterCommandSections", () => $b97ae79f2382e4d1$export$24e75e2bcad1489a);

var $eJOHy = parcelRequire("eJOHy");

var $g51Bg = parcelRequire("g51Bg");
const $b97ae79f2382e4d1$export$24e75e2bcad1489a = (sections, deps = [])=>{
    const { registerSections: registerSections, unregisterSections: unregisterSections } = (0, $g51Bg.useActionsCommandPalette)();
    const ids = Object.keys(sections);
    (0, $eJOHy.useEffect)(()=>{
        registerSections(sections);
        return ()=>{
            unregisterSections(sections);
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ...deps,
        registerSections,
        unregisterSections,
        ids.toString()
    ]);
};

});

parcelRegister("fGxMc", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c8995cbfe5f4d7d6$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $c8995cbfe5f4d7d6$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    containerNavigationSection: {
        "id": "command-palette-integration.controllers.use-register-sections.container-navigation-section",
        "defaultMessage": "Navigation"
    },
    siteNavigationSection: {
        "id": "command-palette-integration.controllers.use-register-sections.site-navigation-section",
        "defaultMessage": "Site navigation"
    },
    quickActionsSection: {
        "id": "command-palette-integration.controllers.use-register-sections.quick-actions-section",
        "defaultMessage": "Quick actions"
    },
    personalSettingsSection: {
        "id": "command-palette-integration.controllers.use-register-sections.personal-settings-section",
        "defaultMessage": "Personal settings"
    },
    helpSection: {
        "id": "command-palette-integration.controllers.use-register-sections.help-section",
        "defaultMessage": "Help"
    },
    jiraSettingsSection: {
        "id": "command-palette-integration.controllers.use-register-sections.jira-settings-section",
        "defaultMessage": "Jira Settings"
    },
    atlassianAdminSection: {
        "id": "command-palette-integration.controllers.use-register-sections.atlassian-admin-section",
        "defaultMessage": "Atlassian admin"
    },
    quickSearchSection: {
        "id": "command-palette-integration.controllers.use-register-sections.quick-search-section",
        "defaultMessage": "Search work"
    },
    forgeSection: {
        "id": "command-palette-integration.controllers.use-register-sections.forge-section",
        "defaultMessage": "Forge Apps"
    },
    forgeSectionAppify: {
        "id": "command-palette-integration.controllers.use-register-sections.forge-section-appify",
        "defaultMessage": "Custom apps"
    }
});

});


parcelRegister("6E71U", function(module, exports) {
$parcel$export(module.exports, "FooterFeedbackContent", () => $f9d2a24580822339$export$63ddf0170f2bf579);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $bQP4O = parcelRequire("bQP4O");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $goZPP = parcelRequire("goZPP");

var $8c712 = parcelRequire("8c712");

var $g51Bg = parcelRequire("g51Bg");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $4cTDP = parcelRequire("4cTDP");

var $g1xxu = parcelRequire("g1xxu");

var $3Lqz8 = parcelRequire("3Lqz8");
const $f9d2a24580822339$export$63ddf0170f2bf579 = ()=>{
    const [openFeedbackCollectorDialog] = (0, $g1xxu.useCommandPaletteFeedbackCollector)();
    const { close: close } = (0, $g51Bg.useActionsCommandPalette)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return (0, $4cTDP.fg)('deliveroo_a11y_enghealth_fixes_oct_25') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $f9d2a24580822339$var$feedbackFormStyles,
        testId: "command-palette-integration.ui.footer-feedback-content.feedback-button",
        onClick: (event, analyticsEvent)=>{
            close();
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'openCommandPaletteFeedbackForm');
            openFeedbackCollectorDialog();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8c712))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.subtle"
    }, formatMessage((0, $3Lqz8.messages).giveFeedbackText))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f9d2a24580822339$var$FeedbackContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f9d2a24580822339$var$TextWrapper, null, " ", formatMessage((0, $3Lqz8.messages).feedbackContentText), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f9d2a24580822339$var$FeedbackButton, {
        appearance: "subtle-link",
        testId: "command-palette-integration.ui.footer-feedback-content.feedback-button",
        onClick: (event, analyticsEvent)=>{
            close();
            (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'openCommandPaletteFeedbackForm');
            openFeedbackCollectorDialog();
        }
    }, formatMessage((0, $3Lqz8.messages).feedbackButtonText)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f9d2a24580822339$var$FeedbackContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _1e0c1txw _2lx2vrvc _4cvr1h6o _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc _syaz1gjq _1bah1y6m _16ai1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f9d2a24580822339$var$TextWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _syaz1gjq _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f9d2a24580822339$var$FeedbackButton = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $goZPP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_11c8dcr7 _4cvr1h6o _k48p1wq8 _18u0v77o _ca0qidpf _u5f3v77o _n3tdidpf _19bvv77o _syazp1wj _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $f9d2a24580822339$var$feedbackFormStyles = (0, $1DXK0.xcss)({
    color: 'color.text.subtle',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 'space.100',
    gap: 'space.075',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus': {
        textDecoration: 'underline'
    }
});

});
parcelRegister("8c712", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0442f8372c8ab0b117b1651de731ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f74e2e78935ad1f$var$_react = $5f74e2e78935ad1f$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $5f74e2e78935ad1f$var$_baseNew = $5f74e2e78935ad1f$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $5f74e2e78935ad1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f74e2e78935ad1f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $5f74e2e78935ad1f$var$_react.default.createElement($5f74e2e78935ad1f$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$5f74e2e78935ad1f$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $5f74e2e78935ad1f$var$_default = module.exports.default = $5f74e2e78935ad1f$var$FeedbackIcon;

});

parcelRegister("g1xxu", function(module, exports) {
$parcel$export(module.exports, "useCommandPaletteFeedbackCollector", () => $cbb8aa6a45ee78ce$export$6db0caae08144d99);

var $eJOHy = parcelRequire("eJOHy");

var $gdeTc = parcelRequire("gdeTc");

var $4Qvpr = parcelRequire("4Qvpr");

var $lRq8t = parcelRequire("lRq8t");

var $3Lqz8 = parcelRequire("3Lqz8");
const $cbb8aa6a45ee78ce$export$6db0caae08144d99 = ()=>{
    const { openFeedbackCollector: openFeedbackCollector, resetFeedbackCollectorState: resetFeedbackCollectorState } = (0, $4Qvpr.useFeedbackCollectorActions)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const openCommandPaletteFeedbackCollector = (0, $eJOHy.useCallback)((props)=>{
        openFeedbackCollector({
            entrypointId: (0, $gdeTc.ENTRYPOINT_ID_JIRA_COMMAND_PALETTE),
            feedbackTitle: formatMessage((0, $3Lqz8.messages).feedbackTitle),
            ...props
        });
    }, [
        formatMessage,
        openFeedbackCollector
    ]);
    return [
        openCommandPaletteFeedbackCollector,
        resetFeedbackCollectorState
    ];
};

});
parcelRegister("3Lqz8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $6e2b187373d81b76$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6e2b187373d81b76$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    feedbackTitle: {
        "id": "command-palette-integration.controllers.use-feedback-collector.feedback-title",
        "defaultMessage": "Share your thoughts"
    },
    feedbackButtonText: {
        "id": "command-palette-integration.controllers.use-feedback-collector.feedback-button-text",
        "defaultMessage": "Let us know"
    },
    feedbackContentText: {
        "id": "command-palette-integration.controllers.use-feedback-collector.feedback-content-text",
        "defaultMessage": "Got feedback?"
    },
    giveFeedbackText: {
        "id": "command-palette-integration.controllers.use-feedback-collector.give-feedback-text",
        "defaultMessage": "Give feedback"
    }
});

});



parcelRegister("1CYyD", function(module, exports) {
$parcel$export(module.exports, "useRegisterInitialCommands", () => $4796de9d66fae1bf$export$c84e12da7f59adc);

var $4cTDP = parcelRequire("4cTDP");

var $eu8sK = parcelRequire("eu8sK");

var $fWwfy = parcelRequire("fWwfy");

var $fGVnv = parcelRequire("fGVnv");

var $7h6Gr = parcelRequire("7h6Gr");

var $5iyF4 = parcelRequire("5iyF4");

var $8Abdz = parcelRequire("8Abdz");
const $4796de9d66fae1bf$export$c84e12da7f59adc = ()=>{
    const copyCommand = (0, $5iyF4.useCopyPageUrlCommand)();
    const navigationCommands = (0, $8Abdz.useNavigationCommands)();
    const { issueNavigatorLink: issueNavigatorLink } = (0, $7h6Gr.useIssueNavigatorLink)();
    // eslint-disable-next-line react-hooks/react-compiler, react-hooks/rules-of-hooks
    const askRovoCommand = (0, $4cTDP.fg)('jjj_ask_rovo_compal_v1') ? (0, $eu8sK.useAskRovoCommand)() : null;
    (0, $fGVnv.useRegisterCommands)((0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).COPY_URL, [
        copyCommand
    ]);
    (0, $fGVnv.useRegisterCommands)((0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).NAVIGATION_COMMANDS, navigationCommands, [
        issueNavigatorLink
    ]);
    const askRovoCommands = askRovoCommand ? [
        askRovoCommand
    ] : [];
    (0, $fGVnv.useRegisterCommands)((0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).ASK_ROVO, askRovoCommands);
};

});
parcelRegister("fGVnv", function(module, exports) {
$parcel$export(module.exports, "useRegisterCommands", () => $e29b438fb88ad88a$export$3f626f8a5dbc29e4);

var $cQKVu = parcelRequire("cQKVu");
const $e29b438fb88ad88a$export$3f626f8a5dbc29e4 = (0, $cQKVu.useRegisterCommandsWithRegistry);

});

parcelRegister("7h6Gr", function(module, exports) {
$parcel$export(module.exports, "useIssueNavigatorLink", () => $f2a84f2455098432$export$3e785a826ba5bd41);

var $FhXEJ = parcelRequire("FhXEJ");

var $3wPiD = parcelRequire("3wPiD");

var $2aY2d = parcelRequire("2aY2d");

var $4cTDP = parcelRequire("4cTDP");

var $1yx8a = parcelRequire("1yx8a");
const $f2a84f2455098432$export$3e785a826ba5bd41 = ()=>{
    const { data: projectContextData } = (0, $2aY2d.useProjectContext)();
    const { data: features } = (0, $3wPiD.useFeatures)();
    if (!projectContextData?.projectType || !projectContextData?.projectKey || typeof projectContextData?.simplified !== 'boolean') return {
        issueNavigatorLink: null
    };
    const issueNavigatorLink = (0, $1yx8a.generateNinBasePath)(projectContextData.projectKey, projectContextData.projectType, projectContextData.simplified);
    // Service Desk and Business Projects have Issue Navigator feature permanently on
    let isIssueNavigatorEnabled = true;
    // Only Jira Software projects have the ability to toggle the Issue Navigator feature
    // TODO JSC-2619 Handled merged list/NIN feature toggles
    if (projectContextData.projectType === (0, $FhXEJ.SOFTWARE_PROJECT)) isIssueNavigatorEnabled = ((0, $4cTDP.fg)('jira_list_nin_merge') ? features?.hasList : features?.hasSIN) ?? false;
    return {
        issueNavigatorLink: isIssueNavigatorEnabled ? issueNavigatorLink : null
    };
};

});
parcelRegister("3wPiD", function(module, exports) {
$parcel$export(module.exports, "useFeatures", () => $429849cdadbc9a3e$export$4a39035bacc4ed76);

var $eJOHy = parcelRequire("eJOHy");

var $dSkLG = parcelRequire("dSkLG");

var $1WzGp = parcelRequire("1WzGp");

var $cZfeH = parcelRequire("cZfeH");

var $fsjYk = parcelRequire("fsjYk");

var $jphFu = parcelRequire("jphFu");
const $429849cdadbc9a3e$export$4a39035bacc4ed76 = ()=>{
    const { data: data, loading: loading, error: error } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const isEligibleForFeatureToggle = (0, $fsjYk.useShouldApplyFeatureToggle)();
    const [sidebarFeatureToggled] = (0, $1WzGp.useSidebarFeatureToggled)();
    const extractedData = (0, $eJOHy.useMemo)(()=>data && (0, $jphFu.extractData)(data), [
        data
    ]);
    // merged feature status before navigation resource gets refreshed
    // if and only if there are features toggled and they are eligible for the feature
    const features = (0, $eJOHy.useMemo)(()=>{
        if (!extractedData || !isEligibleForFeatureToggle || !sidebarFeatureToggled) return extractedData;
        return {
            ...extractedData,
            ...sidebarFeatureToggled
        };
    }, [
        extractedData,
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    (0, $cZfeH.useClearSidebarToggled)();
    return {
        data: features,
        loading: loading,
        error: error
    };
};

});
parcelRegister("1WzGp", function(module, exports) {
$parcel$export(module.exports, "useFeature", () => $2c23860c2dfc0b9e$export$fc97652867e5867e);
$parcel$export(module.exports, "useEnablingFeature", () => $2c23860c2dfc0b9e$export$207b461610a7fca6);
$parcel$export(module.exports, "useSidebarFeatureToggled", () => $2c23860c2dfc0b9e$export$9eef668f94562feb);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $gpE3r = parcelRequire("gpE3r");
const $2c23860c2dfc0b9e$var$initialState = {
    features: [],
    isLoading: false,
    enablingFeatures: [],
    isFetchError: false,
    sidebarFeatureToggled: null
};
const $2c23860c2dfc0b9e$var$store = (0, $GtRbT.createStore)({
    name: 'feature-toggle',
    initialState: $2c23860c2dfc0b9e$var$initialState,
    actions: $gpE3r.actions
});
const $2c23860c2dfc0b9e$export$fc97652867e5867e = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store);
const $2c23860c2dfc0b9e$export$207b461610a7fca6 = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state, { feature: feature })=>state.enablingFeatures.some((f)=>f === feature)
});
const $2c23860c2dfc0b9e$export$e7699ed698eeb9ec = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state, { feature: feature })=>state.features.find((f)=>f.feature === feature)?.state
});
const $2c23860c2dfc0b9e$export$9eef668f94562feb = (0, $iJq0l.createHook)($2c23860c2dfc0b9e$var$store, {
    selector: (state)=>state.sidebarFeatureToggled
});

});
parcelRegister("gpE3r", function(module, exports) {
$parcel$export(module.exports, "actions", () => $e143742cb7786e84$export$e324594224ef24da);

var $9pTd3 = parcelRequire("9pTd3");

var $kRgKj = parcelRequire("kRgKj");

var $2DEdX = parcelRequire("2DEdX");

var $75UwL = parcelRequire("75UwL");

var $dFKLJ = parcelRequire("dFKLJ");

var $5ekEZ = parcelRequire("5ekEZ");
const $e143742cb7786e84$var$clearSiderbarFeatureToggled = ()=>({ setState: setState })=>{
        setState({
            sidebarFeatureToggled: null
        });
    };
const $e143742cb7786e84$var$fetchFeatures = (boardId)=>async ({ getState: getState, setState: setState })=>{
        const { features: features, isLoading: isLoading } = getState();
        if (isLoading) return;
        setState({
            isFetchError: false
        });
        try {
            if (features.length === 0) {
                setState({
                    isLoading: true
                });
                const data = await (0, $dFKLJ.getBoardFeatures)(boardId);
                const filteredFeatures = (0, $75UwL.filterAndSort)(data);
                (0, $75UwL.fireErrorAnalyticsOnUnmatchFeatureKey)(filteredFeatures);
                setState({
                    isLoading: false,
                    features: filteredFeatures
                });
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                isFetchError: true,
                isLoading: false
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    ...(0, $2DEdX.commonErrorAnalyticsMeta),
                    id: 'fetchFeatures'
                },
                error: error
            });
        }
    };
const $e143742cb7786e84$var$syncFeatures = (sidebarFeatureStatus)=>({ getState: getState, setState: setState })=>{
        const { features: features } = getState();
        const featureMap = (0, $2DEdX.getFeatureMap)();
        const synced = features.map((f)=>{
            const id = f.feature;
            if (featureMap[id]) {
                const { statusKey: statusKey } = featureMap[id];
                return {
                    ...f,
                    state: sidebarFeatureStatus[statusKey] ? 'ENABLED' : 'DISABLED'
                };
            }
            return f;
        });
        setState({
            features: synced
        });
    };
const $e143742cb7786e84$var$updateFeature = ({ boardId: boardId, feature: feature, dependentFeature: dependentFeature, analyticsEvent: analyticsEvent, onError: onError, onAfterUpdate: onAfterUpdate })=>async ({ getState: getState, setState: setState })=>{
        const { features: features, enablingFeatures: enablingFeatures, sidebarFeatureToggled: sidebarFeatureToggled } = getState();
        const featureMap = (0, $2DEdX.getFeatureMap)();
        const currentStatus = features.find((f)=>f.feature === feature)?.state;
        const isEnabling = currentStatus === 'DISABLED';
        if (!boardId || feature.length === 0 || !currentStatus) return;
        try {
            // Optimistically update the toggle status before the API call finishes
            // and add feature to the enabling states
            setState({
                features: features.map((0, $75UwL.updateFeatureState)(feature, dependentFeature)),
                sidebarFeatureToggled: {
                    ...sidebarFeatureToggled ?? {},
                    [featureMap[feature].statusKey]: isEnabling,
                    ...dependentFeature && {
                        [featureMap[dependentFeature].statusKey]: isEnabling
                    }
                },
                ...isEnabling && {
                    enablingFeatures: [
                        ...enablingFeatures,
                        feature
                    ]
                }
            });
            await (0, $5ekEZ.updateBoardFeature)({
                boardId: boardId,
                feature: feature,
                enabling: isEnabling
            });
            (0, $kRgKj.fireTrackAnalytics)(analyticsEvent, 'featureStatus updated', {
                featureId: feature,
                newStatus: currentStatus
            });
            onAfterUpdate?.(feature, isEnabling);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            onError?.();
            setState({
                features: features,
                sidebarFeatureToggled: sidebarFeatureToggled
            });
            (0, $9pTd3.fireErrorAnalytics)({
                meta: {
                    ...(0, $2DEdX.commonErrorAnalyticsMeta),
                    id: 'updateFeature'
                },
                error: error
            });
        }
        if (isEnabling) setState({
            // feature has been enabled, remove from enabling state
            enablingFeatures: getState().enablingFeatures.filter((f)=>f !== feature)
        });
    };
const $e143742cb7786e84$export$e324594224ef24da = {
    fetchFeatures: $e143742cb7786e84$var$fetchFeatures,
    updateFeature: $e143742cb7786e84$var$updateFeature,
    syncFeatures: $e143742cb7786e84$var$syncFeatures,
    clearSiderbarFeatureToggled: $e143742cb7786e84$var$clearSiderbarFeatureToggled
};

});
parcelRegister("2DEdX", function(module, exports) {
$parcel$export(module.exports, "commonErrorAnalyticsMeta", () => $5997e650472e24c4$export$47825241dc3c472c);
$parcel$export(module.exports, "MANAGE_FEATURE_MENU_ITEM_TEST_ID", () => $5997e650472e24c4$export$143e1d685830adbe);
$parcel$export(module.exports, "getFeatureMap", () => $5997e650472e24c4$export$6ac50cf33852adb5);
$parcel$export(module.exports, "ERROR_FLAG_ID", () => $5997e650472e24c4$export$f5e4c120ac01b615);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $LFmXM = parcelRequire("LFmXM");

var $jtFRs = parcelRequire("jtFRs");

var $Wdhjx = parcelRequire("Wdhjx");

var $hJIkn = parcelRequire("hJIkn");

var $9AYOJ = parcelRequire("9AYOJ");

var $DtmfJ = parcelRequire("DtmfJ");

var $l5gdO = parcelRequire("l5gdO");
const $5997e650472e24c4$export$47825241dc3c472c = {
    packageName: 'jiraTmpFeatureToggle',
    teamName: 'jlove-makkuro'
};
const $5997e650472e24c4$export$143e1d685830adbe = 'manage-feature-menu-item';
const $5997e650472e24c4$export$a712b1e96d47b856 = {
    'jsw.agility.simple-roadmap': {
        descriptionKey: 'timelineDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l5gdO))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasRoadmap',
        order: 10,
        redirectOn: [
            'software-timeline',
            'software-roadmap'
        ]
    },
    'jsw.agility.backlog': {
        descriptionKey: 'backlogDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jtFRs))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBacklog',
        order: 20,
        redirectOn: [
            'software-backlog'
        ]
    },
    'jsw.agility.board': {
        descriptionKey: 'boardDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasBoard',
        order: 30
    },
    'jsw.agility.issue_navigator': {
        descriptionKey: 'issueNavigatorDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ))), {
            spacing: "spacious",
            label: ""
        }),
        statusKey: 'hasSIN',
        order: 40,
        redirectOn: [
            'software-issue-navigator',
            'issue'
        ]
    },
    'jsw.agility.sprints': {
        descriptionKey: 'releasesDescription',
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
        statusKey: 'hasSprint',
        order: 50,
        isHidden: true
    }
}; // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>
const $5997e650472e24c4$export$6ac50cf33852adb5 = (0, $LFmXM.default)(({ isSimplifyNavExperimentEnabled: isSimplifyNavExperimentEnabled } = {})=>({
        'jsw.agility.simple-roadmap': {
            descriptionKey: 'timelineDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l5gdO))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasRoadmap',
            order: 10,
            redirectOn: [
                'software-timeline',
                'software-roadmap'
            ]
        },
        'jsw.agility.backlog': {
            descriptionKey: 'backlogDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jtFRs))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBacklog',
            order: 20,
            redirectOn: [
                'software-backlog'
            ]
        },
        'jsw.agility.board': {
            descriptionKey: 'boardDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasBoard',
            order: 30
        },
        ...!isSimplifyNavExperimentEnabled && {
            'jsw.agility.issue_navigator': {
                descriptionKey: 'issueNavigatorDescription',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9AYOJ))), {
                    spacing: "spacious",
                    label: ""
                }),
                statusKey: 'hasSIN',
                order: 40,
                redirectOn: [
                    'software-issue-navigator',
                    'issue'
                ]
            }
        },
        'jsw.agility.sprints': {
            descriptionKey: 'releasesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null),
            statusKey: 'hasSprint',
            order: 50,
            isHidden: true
        },
        'jsw.agility.pages': {
            descriptionKey: 'projectPagesDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($DtmfJ))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasPages',
            order: 60,
            redirectOn: [
                'project-pages'
            ]
        },
        'jsw.agility.list_view': {
            descriptionKey: 'listDescription',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hJIkn))), {
                spacing: "spacious",
                label: ""
            }),
            statusKey: 'hasList',
            order: 35,
            redirectOn: [
                'software-list'
            ]
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))); // satisfies Partial<Record<ToggleableFeatureKey, FeatureProperties>>;
const $5997e650472e24c4$export$f5e4c120ac01b615 = 'feature-toggle-error-flag';

});
parcelRegister("jtFRs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::24fd7cabe9c66ca335b5a26e49b2a9b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e2e13280cb3fa5ae$var$_react = $e2e13280cb3fa5ae$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e2e13280cb3fa5ae$var$_baseNew = $e2e13280cb3fa5ae$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e2e13280cb3fa5ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e2e13280cb3fa5ae$var$BacklogIcon = (props)=>/*#__PURE__*/ $e2e13280cb3fa5ae$var$_react.default.createElement($e2e13280cb3fa5ae$var$_baseNew.default, Object.assign({
        name: "BacklogIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$e2e13280cb3fa5ae$var$BacklogIcon.displayName = 'BacklogIcon';
var $e2e13280cb3fa5ae$var$_default = module.exports.default = $e2e13280cb3fa5ae$var$BacklogIcon;

});

parcelRegister("hJIkn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::94ba737f8eb536b5803fd14d2e86416d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce990635ee602485$var$_react = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $ce990635ee602485$var$_baseNew = $ce990635ee602485$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $ce990635ee602485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ce990635ee602485$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $ce990635ee602485$var$_react.default.createElement($ce990635ee602485$var$_baseNew.default, Object.assign({
        name: "ListBulletedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$ce990635ee602485$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $ce990635ee602485$var$_default = module.exports.default = $ce990635ee602485$var$ListBulletedIcon;

});


parcelRegister("75UwL", function(module, exports) {
$parcel$export(module.exports, "filterAndSort", () => $df1cc586f514efec$export$d0e0de50c701304c);
$parcel$export(module.exports, "findDependentFeature", () => $df1cc586f514efec$export$4c8205136225a4e2);
$parcel$export(module.exports, "updateFeatureState", () => $df1cc586f514efec$export$2bdeae30201d513c);
$parcel$export(module.exports, "fireErrorAnalyticsOnUnmatchFeatureKey", () => $df1cc586f514efec$export$5da1e8c5ba5c0dc2);

var $3l9kN = parcelRequire("3l9kN");

var $9pTd3 = parcelRequire("9pTd3");

var $2DEdX = parcelRequire("2DEdX");
const $df1cc586f514efec$export$b70265791d2079d4 = (hasFeature)=>hasFeature ? 'ENABLED' : 'DISABLED';
const $df1cc586f514efec$export$d0e0de50c701304c = (features)=>{
    const featureMap = (0, $2DEdX.getFeatureMap)();
    return features.filter((f)=>Object.keys(featureMap).includes(f.feature)).sort((a, b)=>featureMap[a.feature].order - featureMap[b.feature].order);
};
const $df1cc586f514efec$export$4c8205136225a4e2 = (features, featureId)=>{
    const featureToDisable = features.find((f)=>f.feature === featureId);
    // Will only show the modal when the current status is enabled for both the feature to disable and the dependent feature
    if (featureToDisable?.state !== 'ENABLED') return undefined;
    // For the scope of the feature toggle, we assume there is only one dependency for now
    return features.find((f)=>f.prerequisites.includes(featureId) && f.state === 'ENABLED');
};
const $df1cc586f514efec$export$2bdeae30201d513c = (featureId, dependentFeatureId)=>(feature)=>feature.feature === featureId || dependentFeatureId && feature.feature === dependentFeatureId ? {
            ...feature,
            state: feature.state === 'ENABLED' ? 'DISABLED' : 'ENABLED'
        } : feature;
const $df1cc586f514efec$export$5da1e8c5ba5c0dc2 = (filteredFeatures)=>{
    const featureMap = (0, $2DEdX.getFeatureMap)();
    if (filteredFeatures.length < Object.keys(featureMap).length) {
        const unmatchedFeatureKeys = (0, (/*@__PURE__*/$parcel$interopDefault($3l9kN)))(Object.keys(featureMap), ...filteredFeatures.map((f)=>f.feature));
        (0, $9pTd3.fireErrorAnalytics)({
            error: new Error("Some feature keys don't match . Please check API response"),
            meta: {
                ...(0, $2DEdX.commonErrorAnalyticsMeta),
                id: 'unmatchFeatureKey'
            },
            attributes: {
                unmatchedFeatureKeys: unmatchedFeatureKeys.toString()
            }
        });
    }
};

});
parcelRegister("3l9kN", function(module, exports) {

var $leN9Q = parcelRequire("leN9Q");

var $l76qh = parcelRequire("l76qh");

var $d1ShJ = parcelRequire("d1ShJ");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $26ea92e191963c80$var$without = $l76qh(function(array, values) {
    return $d1ShJ(array) ? $leN9Q(array, values) : [];
});
module.exports = $26ea92e191963c80$var$without;

});


parcelRegister("dFKLJ", function(module, exports) {
$parcel$export(module.exports, "getBoardFeatures", () => $5482b7a0e862d1ce$export$c20100b185d41ab0);

var $3ugTQ = parcelRequire("3ugTQ");

var $8ZH3C = parcelRequire("8ZH3C");
const $5482b7a0e862d1ce$export$c20100b185d41ab0 = async (boardId)=>{
    const data = await (0, $3ugTQ.performGetRequest)((0, $8ZH3C.getBoardFeaturesUrl)(boardId));
    return data.features;
};

});
parcelRegister("8ZH3C", function(module, exports) {
$parcel$export(module.exports, "getBoardFeaturesUrl", () => $a432628e74c040a5$export$3f9939d302766b52);
const $a432628e74c040a5$export$3f9939d302766b52 = (boardId)=>`/rest/agile/latest/board/${boardId}/features`;

});


parcelRegister("5ekEZ", function(module, exports) {
$parcel$export(module.exports, "updateBoardFeature", () => $daf54280ff8482fb$export$61f6bbb745b3a3);

var $3ugTQ = parcelRequire("3ugTQ");

var $8ZH3C = parcelRequire("8ZH3C");
const $daf54280ff8482fb$export$61f6bbb745b3a3 = async (request)=>{
    // it returns the board features array, but we don't use it for optimistic update
    // feature state is used instead to indicate if the updates successful or not
    const data = await (0, $3ugTQ.performPutRequest)((0, $8ZH3C.getBoardFeaturesUrl)(request.boardId), {
        body: JSON.stringify(request)
    });
    const newState = data.features.find((f)=>f.feature === request.feature)?.state;
    return newState ?? (request.enabling ? 'ENABLED' : 'DISABLED');
};

});



parcelRegister("cZfeH", function(module, exports) {
$parcel$export(module.exports, "useClearSidebarToggled", () => $ab83a592c4668936$export$2946f555c6f48127);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $dSkLG = parcelRequire("dSkLG");

var $6d9QY = parcelRequire("6d9QY");

var $1WzGp = parcelRequire("1WzGp");

var $fsjYk = parcelRequire("fsjYk");
const $ab83a592c4668936$export$2946f555c6f48127 = ()=>{
    const { data: data, refresh: refresh } = (0, $dSkLG.useJiraSoftwareProjectNavigation)();
    const [sidebarFeatureToggled, { clearSiderbarFeatureToggled: clearSiderbarFeatureToggled }] = (0, $1WzGp.useSidebarFeatureToggled)();
    const isEligibleForFeatureToggle = (0, $fsjYk.useShouldApplyFeatureToggle)();
    const sidebarHasChanged = (0, $eJOHy.useRef)(false);
    const previousData = (0, $6d9QY.usePreviousWithInitial)(data);
    // if resource data has changed since the last refresh then remove the sidebar toggled data.
    // i.e. whatever that has been toggled is reflected on the latest resource
    const shouldClear = (0, $eJOHy.useMemo)(()=>isEligibleForFeatureToggle && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(previousData, data), [
        isEligibleForFeatureToggle,
        previousData,
        data
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (shouldClear) clearSiderbarFeatureToggled();
    }, [
        shouldClear,
        clearSiderbarFeatureToggled
    ]);
    (0, $eJOHy.useEffect)(()=>{
        sidebarHasChanged.current = isEligibleForFeatureToggle && !!sidebarFeatureToggled;
    }, [
        isEligibleForFeatureToggle,
        sidebarFeatureToggled
    ]);
    // refresh the navigation resource if sidebar has changed
    (0, $eJOHy.useEffect)(()=>()=>{
            if (sidebarHasChanged.current) refresh();
        }, [
        refresh
    ]);
};

});
parcelRegister("fsjYk", function(module, exports) {
$parcel$export(module.exports, "useShouldApplyFeatureToggle", () => $fa56f9341174283f$export$7deca16ba2d9eb74);

var $FhXEJ = parcelRequire("FhXEJ");

var $2aY2d = parcelRequire("2aY2d");

var $bf3Zm = parcelRequire("bf3Zm");
const $fa56f9341174283f$export$7deca16ba2d9eb74 = ()=>{
    const { data: project } = (0, $2aY2d.useProjectContext)();
    const firstActivationDateMs = (0, $bf3Zm.useFirstActivationDateMs)() || 0;
    const isJSW = project?.projectType === (0, $FhXEJ.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isProjectAdmin = !!project?.isProjectAdmin;
    const isNewInstance = new Date(firstActivationDateMs) >= new Date('2023-09-25T15:00:00');
    return isJSW && isTMP && isProjectAdmin && isNewInstance;
};

});
parcelRegister("bf3Zm", function(module, exports) {
$parcel$export(module.exports, "useFirstActivationDateMs", () => $edc1c49564ffc778$export$9df3a539e50a284b);

var $koAZ4 = parcelRequire("koAZ4");
const $edc1c49564ffc778$export$9df3a539e50a284b = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return tenantContext && tenantContext.firstActivationDateMs != null ? tenantContext.firstActivationDateMs : null;
};

});



parcelRegister("jphFu", function(module, exports) {
$parcel$export(module.exports, "extractData", () => $e9a39bce412d9671$export$9df5fa0a366163d2);

var $cxKOj = parcelRequire("cxKOj");
const $e9a39bce412d9671$export$9df5fa0a366163d2 = (navData)=>{
    const { permissionInfo: permissionInfo, hasBacklog: hasBacklog, hasBoard: hasBoard, hasCode: hasCode, hasGoals: hasGoals, hasGetStarted: hasGetStarted, hasSecurity: hasSecurity, hasDeployments: hasDeployments, hasDevelopment: hasDevelopment, hasList: hasList, hasOpsgenieSchedule: hasOpsgenieSchedule, hasPages: hasPages, hasReleases: hasReleases, hasRoadmap: hasRoadmap, hasReports: hasReports, hasRequests: hasRequests, hasIssues: hasIssues, hasSprint: hasSprint, hasIncidents: hasIncidents, hasCalendar: hasCalendar, hasForms: hasForms, hasSummaryPage: hasSummaryPage, hasArchivedIssues: hasArchivedIssues = false } = navData;
    const isProjectOrJiraAdmin = permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    return {
        hasArchivedIssues: hasArchivedIssues,
        hasBacklog: hasBacklog,
        hasBoard: hasBoard,
        hasRoadmap: hasRoadmap,
        hasCode: hasCode,
        hasGoals: hasGoals,
        hasGetStarted: isProjectOrJiraAdmin && hasGetStarted,
        hasSecurity: hasSecurity,
        hasDeployments: hasDeployments,
        hasDevelopment: hasDevelopment,
        hasList: hasList,
        hasReleases: hasReleases,
        hasSIN: hasIssues,
        hasReports: hasReports,
        hasRequests: hasRequests,
        hasPages: hasPages,
        hasOpsgenie: hasOpsgenieSchedule,
        hasShortcutsAdd: isProjectOrJiraAdmin,
        hasSettings: isProjectOrJiraAdmin,
        hasSprint: hasSprint,
        hasIncidents: hasIncidents,
        hasCalendar: hasCalendar,
        hasForms: (0, $cxKOj.expValEquals)('forms_for_jsw_experiment', 'isEnabled', true) && hasForms,
        hasSummaryPage: hasSummaryPage
    };
};

});


parcelRegister("1yx8a", function(module, exports) {
$parcel$export(module.exports, "generateNinBasePath", () => $265aa062a4aa1b0a$export$47d9a807c1277671);

var $FhXEJ = parcelRequire("FhXEJ");

var $4cTDP = parcelRequire("4cTDP");
const $265aa062a4aa1b0a$export$ddaf187654250a8d = '/issues/';
const $265aa062a4aa1b0a$export$47d9a807c1277671 = (projectKey, projectType, isSimplifiedProject)=>{
    const getMainPath = (projectPath, simplified = true)=>`/jira/${projectPath}${!simplified ? '/c' : ''}/projects/${projectKey}/${(0, $4cTDP.fg)('jira_list_nin_merge') ? 'list' : 'issues'}`;
    switch(projectType){
        case 0, $FhXEJ.CORE_PROJECT:
            return getMainPath('core');
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            return getMainPath('servicedesk');
        case 0, $FhXEJ.SOFTWARE_PROJECT:
            return getMainPath('software', isSimplifiedProject);
        default:
            return $265aa062a4aa1b0a$export$ddaf187654250a8d; // Fall back to GIN
    }
};

});


parcelRegister("5iyF4", function(module, exports) {
$parcel$export(module.exports, "useCopyPageUrlCommand", () => $627f2f7634229c2b$export$e4eb2b3d3a5a5045);

var $eJOHy = parcelRequire("eJOHy");

var $lGr6J = parcelRequire("lGr6J");

var $4cTDP = parcelRequire("4cTDP");

var $1Zcfy = parcelRequire("1Zcfy");

var $ii7Oz = parcelRequire("ii7Oz");

var $itdlt = parcelRequire("itdlt");

var $hf4h9 = parcelRequire("hf4h9");

var $9pTd3 = parcelRequire("9pTd3");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $d9IXz = parcelRequire("d9IXz");

var $fCNFc = parcelRequire("fCNFc");
const $627f2f7634229c2b$export$e4eb2b3d3a5a5045 = ()=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const copyToClipboard = async ()=>{
        try {
            await (0, $fCNFc.getNavigator)().clipboard.writeText((0, $fCNFc.getWindow)().location.href);
            showFlag({
                type: 'success',
                title: (0, $d9IXz.messages).successTitleCopiedUrl,
                messageId: 'command-palette-integration.ui.initial-commands.use-copy-page-url.show-flag.success',
                messageType: 'transactional'
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            showFlag({
                type: 'error',
                title: (0, $d9IXz.messages).errorTitleCopiedUrl,
                description: (0, $d9IXz.messages).errorDescriptionCopiedUrl,
                messageId: 'command-palette-integration.ui.initial-commands.use-copy-page-url.show-flag.error',
                messageType: 'transactional'
            });
            (0, $9pTd3.fireErrorAnalytics)({
                error: err,
                meta: {
                    id: 'commandPaletteCopyUrlToClipboard',
                    packageName: 'jiraCommandPaletteIntegration',
                    teamName: 'deliveroo'
                }
            });
        }
    };
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    return {
        id: 'copy-page-url',
        name: formatMessage((0, $d9IXz.messages).commandCommandLabel),
        keywords: getKeywords('copyCurrentPageUrlSynonyms'),
        primaryAction: {
            type: (0, $hf4h9.CommandActionType).PERFORM,
            perform: copyToClipboard
        },
        section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).quickActions,
        priority: (0, $ii7Oz.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).copyUrl,
        components: {
            LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lGr6J))), {
                    spacing: "spacious",
                    label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $d9IXz.messages).commandCommandLabel),
                    "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                })
        },
        analytics: {
            action: 'copyPageURL'
        }
    };
};

});
parcelRegister("d9IXz", function(module, exports) {
$parcel$export(module.exports, "messages", () => $253a428f254ea252$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $253a428f254ea252$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    successTitleCopiedUrl: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.success-title-copied-url",
        "defaultMessage": "Page URL copied to clipboard"
    },
    errorTitleCopiedUrl: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.error-title-copied-url",
        "defaultMessage": "We couldn't copy the page URL"
    },
    errorDescriptionCopiedUrl: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.error-description-copied-url",
        "defaultMessage": "Please check your browser settings."
    },
    commandCommandLabel: {
        "id": "command-palette-integration.initial-commands.use-copy-page-url.command-command-label",
        "defaultMessage": "Copy current page URL"
    }
});

});

parcelRegister("fCNFc", function(module, exports) {
$parcel$export(module.exports, "getWindow", () => $81bc62adc10eaa76$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getNavigator", () => $81bc62adc10eaa76$export$a56241c767c1d89f);
/* istanbul ignore file */ const $81bc62adc10eaa76$export$38b2d434cce3ea22 = ()=>window;
const $81bc62adc10eaa76$export$a56241c767c1d89f = ()=>navigator;

});


parcelRegister("8Abdz", function(module, exports) {
$parcel$export(module.exports, "useNavigationCommands", () => $952e65b6d6de0085$export$997e3c408ba63e3b);

var $eJOHy = parcelRequire("eJOHy");

var $ePxSL = parcelRequire("ePxSL");

var $4F5bb = parcelRequire("4F5bb");

var $cxKOj = parcelRequire("cxKOj");

var $fT8TY = parcelRequire("fT8TY");

var $1Zcfy = parcelRequire("1Zcfy");

var $kQy7N = parcelRequire("kQy7N");

var $itdlt = parcelRequire("itdlt");

var $4cTDP = parcelRequire("4cTDP");

var $lRq8t = parcelRequire("lRq8t");

var $lVMSx = parcelRequire("lVMSx");

var $bxWdr = parcelRequire("bxWdr");

var $SPYRa = parcelRequire("SPYRa");

var $3MbOI = parcelRequire("3MbOI");

var $3Z5Oj = parcelRequire("3Z5Oj");

var $fuV6j = parcelRequire("fuV6j");

var $bxSuo = parcelRequire("bxSuo");

var $fZoD8 = parcelRequire("fZoD8");

var $lWdYg = parcelRequire("lWdYg");

var $4wyu4 = parcelRequire("4wyu4");

var $koAZ4 = parcelRequire("koAZ4");

var $47bQc = parcelRequire("47bQc");

var $7h6Gr = parcelRequire("7h6Gr");


var $6iqtx = parcelRequire("6iqtx");
const $952e65b6d6de0085$export$997e3c408ba63e3b = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const { issueNavigatorLink: issueNavigatorLink } = (0, $7h6Gr.useIssueNavigatorLink)();
    const { hideAndTransformNavigationCommands: hideAndTransformNavigationCommands } = (0, $kQy7N.useTransformNavigationCommands)();
    const { data: data } = (0, $3MbOI.useCurrentUser)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const email = data.user?.emailAddress;
    const accountSettingsLink = (0, $lVMSx.useAtlassianPersonalSettingsLink)(email || undefined);
    const [isPlansVisible] = (0, $SPYRa.useNavigationPlansVisibility)();
    const { isSiteAdmin: isSiteAdmin } = (0, $koAZ4.useTenantContext)();
    let goToIssuesName;
    if ((0, $4cTDP.fg)('jira_list_nin_merge')) goToIssuesName = formatMessage((0, $6iqtx.default).goToList);
    else if ((0, $4cTDP.fg)('jira-issue-terminology-refresh-m3')) goToIssuesName = formatMessage((0, $6iqtx.default).goToIssuesIssueTermRefresh);
    else goToIssuesName = formatMessage((0, $6iqtx.default).goToIssues);
    const commands = hideAndTransformNavigationCommands([
        ...(0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') ? [
            {
                command: {
                    id: (0, $ffa66aa2792c8b51$export$c6ac3c085f5d9f2f),
                    name: formatMessage((0, $6iqtx.default).viewMyOpenIssues),
                    keywords: getKeywords('viewMyOpenIssuesSynonyms'),
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation,
                    priority: (0, $1Zcfy.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewMyIssues,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                                spacing: "spacious",
                                label: "",
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    analytics: {
                        action: 'viewMyOpenIssues'
                    }
                },
                path: `${(0, $47bQc.issueNavigatorGlobalRoute).path}?filter=-1`
            },
            {
                command: {
                    id: (0, $ffa66aa2792c8b51$export$86893b0d65e6a1ba),
                    name: formatMessage((0, $6iqtx.default).viewIssuesReportedByMe),
                    keywords: getKeywords('viewIssuesReportedByMeSynonyms'),
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation,
                    priority: (0, $1Zcfy.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewMyIssues,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                                spacing: "spacious",
                                label: "",
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    analytics: {
                        action: 'viewIssuesReportedByMe'
                    }
                },
                path: `${(0, $47bQc.issueNavigatorGlobalRoute).path}?filter=-2`
            }
        ] : [],
        {
            command: {
                id: (0, $ffa66aa2792c8b51$export$2d4af8d3471f446),
                name: formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $6iqtx.default).viewAllProjectsGalaxia : (0, $6iqtx.default).viewAllProjects),
                keywords: getKeywords('viewAllProjectsSynonyms'),
                section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation,
                priority: (0, $1Zcfy.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToProjects,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                            spacing: "spacious",
                            label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $6iqtx.default).viewAllProjectsGalaxia : (0, $6iqtx.default).viewAllProjects),
                            "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                        })
                },
                analytics: {
                    action: 'viewAllProjects'
                }
            },
            path: (0, $lWdYg.projectsDirectoryRoute)
        },
        {
            command: {
                id: (0, $ffa66aa2792c8b51$export$bfa43d3c5bfbcf35),
                name: formatMessage((0, $6iqtx.default).viewAllFilters),
                keywords: getKeywords('viewAllFiltersSynonyms'),
                section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation,
                priority: (0, $1Zcfy.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToFilters,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                            spacing: "spacious",
                            label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $6iqtx.default).viewAllFilters),
                            "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                        })
                },
                analytics: {
                    action: 'viewAllFilters'
                }
            },
            path: (0, $bxSuo.filtersDirectoryRoute)
        },
        {
            command: {
                id: (0, $ffa66aa2792c8b51$export$538e0daca84e7e29),
                name: formatMessage((0, $6iqtx.default).viewAllDashboards),
                keywords: getKeywords('viewAllDashboardsSynonyms'),
                section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation,
                priority: (0, $1Zcfy.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToDashboards,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                            spacing: "spacious",
                            label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $6iqtx.default).viewAllDashboards),
                            "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                        })
                },
                analytics: {
                    action: 'viewAllDashboards'
                }
            },
            path: (0, $fuV6j.dashboardsDirectoryRoute)
        },
        {
            command: {
                id: (0, $ffa66aa2792c8b51$export$98cbb2f7230db2a1),
                name: formatMessage((0, $6iqtx.default).goToPersonalSettings),
                keywords: getKeywords('goToPersonalSettingsSynonyms'),
                section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).personalSettings,
                priority: (0, $1Zcfy.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).goToPersonalSettings,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
                            spacing: "spacious",
                            label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $6iqtx.default).goToPersonalSettings),
                            "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                        })
                },
                analytics: {
                    action: 'goToPersonalSettings'
                }
            },
            path: (0, $4wyu4.generalPersonalSettingsRoute),
            hideCommandPath: (0, $bxWdr.getGeneralPersonalSettingsPath)()
        },
        {
            command: {
                id: (0, $ffa66aa2792c8b51$export$7e8556985118cd1e),
                name: formatMessage((0, $6iqtx.default).viewAllBoards),
                keywords: getKeywords('viewAllBoardsSynonyms'),
                section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                            spacing: "spacious",
                            label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $6iqtx.default).viewAllBoards),
                            "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                        })
                },
                priority: (0, $1Zcfy.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToBoards,
                analytics: {
                    action: 'viewAllBoards'
                }
            },
            path: (0, $3Z5Oj.boardsDirectoryRoute)
        },
        {
            command: {
                id: (0, $ffa66aa2792c8b51$export$7976f2daa1e8078a),
                name: formatMessage((0, $6iqtx.default).goToAccountSettings),
                keywords: getKeywords('goToAccountSettingsSynonyms'),
                section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).personalSettings,
                components: {
                    LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
                            spacing: "spacious",
                            label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $6iqtx.default).goToAccountSettings),
                            "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                        })
                },
                priority: (0, $1Zcfy.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).goToAccountSettings,
                analytics: {
                    action: 'goToAccountSettings'
                }
            },
            path: accountSettingsLink,
            shouldAlwaysOpenNewTab: true
        },
        ...issueNavigatorLink ? [
            {
                command: {
                    id: (0, $ffa66aa2792c8b51$export$f3211b812cd1a523),
                    name: goToIssuesName,
                    keywords: getKeywords('goToIssuesSynonyms'),
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).containerNavigation,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                                spacing: "spacious",
                                label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : goToIssuesName,
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    priority: (0, $1Zcfy.COMMAND_PALETTE_PROJECT_NAVIGATION_PRIORITY).goToIssues,
                    analytics: {
                        action: 'goToIssues'
                    }
                },
                path: issueNavigatorLink,
                hideCommandPath: (0, $lWdYg.projectsDirectoryRoute).path
            }
        ] : [],
        ...isPlansVisible ? [
            {
                command: {
                    id: (0, $ffa66aa2792c8b51$export$653733b43ae1b993),
                    name: formatMessage((0, $6iqtx.default).viewAllPlans),
                    keywords: getKeywords('viewAllPlansSynonyms'),
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).siteNavigation,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePxSL))), {
                                spacing: "spacious",
                                label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $6iqtx.default).viewAllPlans),
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    priority: (0, $1Zcfy.COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).goToPlans,
                    analytics: {
                        action: 'viewAllPlans'
                    }
                },
                path: (0, $fZoD8.plansDirectoryRoute)
            }
        ] : [],
        ...isSiteAdmin ? [
            {
                command: {
                    id: (0, $ffa66aa2792c8b51$export$9ede11404253696),
                    name: formatMessage((0, $6iqtx.default).goToUserManagement),
                    keywords: getKeywords('goToUserManagementSynonyms'),
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).atlassianAdmin,
                    priority: (0, $1Zcfy.COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY).userManagement,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
                                spacing: "spacious",
                                label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $6iqtx.default).goToUserManagement),
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    analytics: {
                        action: 'goToUserManagement'
                    }
                },
                path: (0, $fT8TY.SITE_ADMIN_SETTINGS_ITEM_HREFS).USER_MANAGEMENT,
                shouldAlwaysOpenNewTab: true
            },
            {
                command: {
                    id: (0, $ffa66aa2792c8b51$export$bf77ae178e5e5984),
                    name: formatMessage((0, $6iqtx.default).goToBilling),
                    section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).atlassianAdmin,
                    priority: (0, $1Zcfy.COMMAND_PALETTE_ATLASSIAN_ADMIN_PRIORITY).billing,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
                                spacing: "spacious",
                                label: (0, $4cTDP.fg)('compal_jifjam_navigation_new_filters') || (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage((0, $6iqtx.default).goToBilling),
                                "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                            })
                    },
                    analytics: {
                        action: 'goToBilling'
                    }
                },
                path: (0, $fT8TY.SITE_ADMIN_SETTINGS_ITEM_HREFS).BILLING,
                shouldAlwaysOpenNewTab: true
            }
        ] : []
    ]);
    return commands;
};

});
parcelRegister("fT8TY", function(module, exports) {
$parcel$export(module.exports, "JIRA_SETTINGS_SECTION_IDS", () => $e9d28b019ab770a1$export$7266225366740ba0);
$parcel$export(module.exports, "ADMIN_SETTINGS_ITEM_IDS", () => $e9d28b019ab770a1$export$4718c8ac53a477e1);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_IDS", () => $e9d28b019ab770a1$export$b23679adb37958a8);
$parcel$export(module.exports, "SITE_ADMIN_SETTINGS_ITEM_HREFS", () => $e9d28b019ab770a1$export$9cc74e3c0b8831f9);
const $e9d28b019ab770a1$export$7266225366740ba0 = {
    SETTINGS_TITLE: 'settings-title',
    SITE_ADMIN: 'site-admin',
    SYSTEM_ADMIN: 'system-admin',
    OPS_ADMIN: 'ops-admin',
    TRUSTED_USER: 'trusted-user',
    PERSONAL: 'personal-settings'
};
const $e9d28b019ab770a1$export$4718c8ac53a477e1 = {
    SYSTEM: 'admin-system-menu',
    APPLICATIONS: 'admin-applications-menu',
    APPLICATIONS_APPIFY: 'admin-applications-menu-appify',
    ISSUES: 'admin-issues-menu',
    WORK: 'admin-issues-menu-issue-term-refresh',
    PLUGINS: 'admin-plugins-menu',
    RECOMMENDATIONS: 'admin-recommendations',
    MANAGE_PROJECTS: 'admin-manage-project-menu'
};
const $e9d28b019ab770a1$export$b23679adb37958a8 = {
    USER_MANAGEMENT: 'user-management-section',
    BILLING: 'admin-billing-section'
};
const $e9d28b019ab770a1$export$9cc74e3c0b8831f9 = {
    USER_MANAGEMENT: '/admin/users?referrerName=JIRA',
    BILLING: '/admin/billing-preview?referrerName=JIRA'
};

});

parcelRegister("lVMSx", function(module, exports) {
$parcel$export(module.exports, "useAtlassianPersonalSettingsLink", () => $77ba1c58fea86490$export$8ac70acdad00754b);
$parcel$export(module.exports, "useSwitchAccountLink", () => $77ba1c58fea86490$export$dce6af3168fb6ced);
$parcel$export(module.exports, "useProfileLink", () => $77ba1c58fea86490$export$b8f25e615dd30d7b);

var $b5RwB = parcelRequire("b5RwB");

var $8RHPx = parcelRequire("8RHPx");

var $dOwXt = parcelRequire("dOwXt");

var $d3wpJ = parcelRequire("d3wpJ");

var $1xlYL = parcelRequire("1xlYL");

var $eWDmv = parcelRequire("eWDmv");

var $lzHTu = parcelRequire("lzHTu");

var $8LnTF = parcelRequire("8LnTF");

var $7MMy7 = parcelRequire("7MMy7");

var $jmzgU = parcelRequire("jmzgU");

var $k7VE6 = parcelRequire("k7VE6");

var $5PY5j = parcelRequire("5PY5j");

var $eULUA = parcelRequire("eULUA");

var $e6YEs = parcelRequire("e6YEs");

var $5RW99 = parcelRequire("5RW99");

const $77ba1c58fea86490$export$ab902790e443b0ec = ()=>`${(0, $8RHPx.getATLContextUrl)('id')}/login`;
const $77ba1c58fea86490$export$8ac70acdad00754b = (destinationAccountEmail)=>{
    const loginLink = $77ba1c58fea86490$export$ab902790e443b0ec();
    const destinationUrl = `${(0, $8RHPx.getATLContextUrl)('id')}/manage-profile/profile-and-visibility`;
    return destinationAccountEmail ? `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        application: 'jira',
        continue: destinationUrl,
        login_hint: destinationAccountEmail,
        prompt: 'none'
    })}` : destinationUrl;
};
const $77ba1c58fea86490$export$dce6af3168fb6ced = ()=>{
    const loginLink = $77ba1c58fea86490$export$ab902790e443b0ec();
    const { href: href } = (0, $dOwXt.default)() || {};
    return `${loginLink}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
        application: 'jira',
        continue: href,
        prompt: 'select_account'
    })}`;
};
const $77ba1c58fea86490$export$b8f25e615dd30d7b = ()=>{
    const accountId = (0, $e6YEs.useAccountId)();
    return `/jira/people/${accountId || ''}`;
};
const $77ba1c58fea86490$export$5b8580d0254a9349 = (favoriteItems)=>favoriteItems && favoriteItems.length > 0 ? {
        id: String(favoriteItems[0].id),
        type: favoriteItems[0].type
    } : {
        id: undefined,
        type: undefined
    };
const $77ba1c58fea86490$export$ff5c49b7852aca68 = (item)=>{
    const { attributes: attributes, attributes: { parentType: parentType }, id: id } = item;
    const boardId = String(id);
    if (parentType === 'project') {
        // @ts-expect-error - TS2339 - Property 'nextgen' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectKey' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'. | TS2339 - Property 'projectType' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { nextgen: nextgen, projectKey: projectKey, projectType: projectType } = attributes;
        if (projectType === 'business') return {
            params: {
                projectKey: projectKey
            },
            query: {},
            route: (0, $1xlYL.jiraBusinessProjectRedirectRoute)
        };
        if (projectType === 'service_desk') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $eWDmv.jsmBoardRoute)
        };
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $jmzgU.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $k7VE6.classicSoftwareBoardRoute)
        };
    }
    if (parentType === 'user') {
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'ProjectBoardItemAttributes | UserBoardItemAttributes'.
        const { userAccountId: accountId } = attributes;
        return {
            params: {
                boardId: boardId,
                accountId: accountId
            },
            query: {},
            route: (0, $5PY5j.userBoardRoute)
        };
    }
    return {
        params: undefined,
        query: undefined,
        route: undefined
    };
};
const $77ba1c58fea86490$export$dd9458ee44edd0c6 = (item)=>{
    const { attributes: { projectType: projectType, boardId: boardId, nextgen: nextgen, projectKey: projectKey } } = item;
    if (projectType === 'business') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $1xlYL.jiraBusinessProjectRedirectRoute)
    };
    if (boardId !== undefined) {
        if (nextgen === 'true') return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $jmzgU.softwareBoardRoute)
        };
        return {
            params: {
                boardId: boardId,
                projectKey: projectKey
            },
            query: {},
            route: (0, $k7VE6.classicSoftwareBoardRoute)
        };
    }
    if (projectType === 'service_desk') return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $lzHTu.projectServiceDeskRoute)
    };
    return {
        params: {
            projectKey: projectKey
        },
        query: {},
        route: (0, $d3wpJ.browseProjectRedirectRoute)
    };
};
const $77ba1c58fea86490$export$b44363840d1b683e = (item)=>{
    const { attributes: { projectKey: projectKey, queuesCategory: queuesCategory }, id: id } = item;
    return {
        params: {
            projectKey: projectKey,
            ...queuesCategory != null && queuesCategory !== '' ? {
                practiceType: (0, $eULUA.toShortFormItsmPractice)(queuesCategory)
            } : {},
            queueId: String(id)
        },
        route: queuesCategory != null && queuesCategory !== '' ? (0, $8LnTF.customPracticeQueueRoute) : (0, $7MMy7.customQueueRoute)
    };
};
const $77ba1c58fea86490$export$286ea82aef1c76e9 = (attributes)=>attributes.parentType === 'user' || attributes.parentType === 'project' && attributes.projectType === 'software' && attributes.nextgen === 'false';
const $77ba1c58fea86490$export$ad0fd737fbd4a083 = (items)=>items.filter((item)=>item.id !== (0, $5RW99.ADDON_ID).DISCOVER);

});
parcelRegister("dOwXt", function(module, exports) {
$parcel$export(module.exports, "default", () => $802e6117e996a19b$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ const $802e6117e996a19b$var$getLocation = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};
var $802e6117e996a19b$export$2e2bcd8739ae039 = $802e6117e996a19b$var$getLocation;

});

parcelRegister("d3wpJ", function(module, exports) {
$parcel$export(module.exports, "browseProjectRedirectRoute", () => $5b577f32c2c2e49a$export$f9cac37753487f39);
const $5b577f32c2c2e49a$export$f9cac37753487f39 = {
    name: 'browse-project-redirect',
    path: "/browse/:projectKey([0-9a-zA-Z_$.+!*']+)",
    exact: true
};

});

parcelRegister("1xlYL", function(module, exports) {
$parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", () => $b8accc242737a0ed$export$73b60789ceb8e1eb);
const $b8accc242737a0ed$export$73b60789ceb8e1eb = {
    name: 'classic-business-redirect',
    path: '/jira/core/projects/:projectKey',
    exact: true
};

});

parcelRegister("eWDmv", function(module, exports) {
$parcel$export(module.exports, "jsmBoardRoute", () => $ef24c8f577828357$export$a192088aab559fa1);
const $ef24c8f577828357$export$a192088aab559fa1 = {
    path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
    name: 'servicedesk-boards',
    exact: true
};

});

parcelRegister("lzHTu", function(module, exports) {
$parcel$export(module.exports, "projectServiceDeskRoute", () => $f2ad8a3da9671eff$export$1cfc858068dd8718);
const $f2ad8a3da9671eff$export$1cfc858068dd8718 = {
    name: 'servicedesk-redirect',
    path: '/jira/servicedesk/projects/:projectKey',
    exact: true
};

});

parcelRegister("8LnTF", function(module, exports) {
$parcel$export(module.exports, "customPracticeQueueRoute", () => $de61ecd99379c904$export$59d0bd42aa07faad);
const $de61ecd99379c904$export$59d0bd42aa07faad = {
    name: 'servicedesk-practice-custom-and-issue',
    path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("7MMy7", function(module, exports) {
$parcel$export(module.exports, "customQueueRoute", () => $8b42a61db1b1071b$export$e1fac82ca0b0d637);
const $8b42a61db1b1071b$export$e1fac82ca0b0d637 = {
    name: 'servicedesk-queues-custom-view',
    path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
    query: [
        'oldIssueView?'
    ],
    exact: true
};

});

parcelRegister("jmzgU", function(module, exports) {
$parcel$export(module.exports, "softwareBoardRoute", () => $082ff7e9e2fdd717$export$9ae2c0a566d4e0f6);
const $082ff7e9e2fdd717$export$9ae2c0a566d4e0f6 = {
    name: 'software-boards',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("k7VE6", function(module, exports) {
$parcel$export(module.exports, "classicSoftwareBoardRoute", () => $a86c112e63e1973c$export$131d51ca54849e97);
const $a86c112e63e1973c$export$131d51ca54849e97 = {
    name: 'rapidboard-board',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId'
};

});

parcelRegister("5PY5j", function(module, exports) {
$parcel$export(module.exports, "userBoardRoute", () => $c671295e8f87ee59$export$57a2a0fe739f16);
const $c671295e8f87ee59$export$57a2a0fe739f16 = {
    name: 'rapidboard-user-board',
    path: '/jira/people/:accountId/boards/:boardId'
};

});

parcelRegister("eULUA", function(module, exports) {
$parcel$export(module.exports, "toShortFormItsmPractice", () => $b467ca1786f529f0$export$db58a56259f511a2);

var $jlJsl = parcelRequire("jlJsl");
const $b467ca1786f529f0$var$longToShortConversionMap = {
    [(0, $jlJsl.CHANGES)]: (0, $jlJsl.SHORT_FORM_CHANGES),
    [(0, $jlJsl.INCIDENTS)]: (0, $jlJsl.SHORT_FORM_INCIDENTS),
    [(0, $jlJsl.PROBLEMS)]: (0, $jlJsl.SHORT_FORM_PROBLEMS),
    [(0, $jlJsl.SERVICE_REQUEST)]: (0, $jlJsl.SHORT_FORM_SERVICE_REQUEST),
    [(0, $jlJsl.POST_INCIDENT_REVIEWS)]: (0, $jlJsl.SHORT_FORM_POST_INCIDENT_REVIEWS),
    [(0, $jlJsl.DEVELOPER_ESCALATION)]: (0, $jlJsl.SHORT_FORM_DEVELOPER_ESCALATION)
};
function $b467ca1786f529f0$var$isLongForm(workCategoryKey) {
    return !!workCategoryKey && workCategoryKey in $b467ca1786f529f0$var$longToShortConversionMap;
}
const $b467ca1786f529f0$export$db58a56259f511a2 = (workCategoryKey)=>{
    if ($b467ca1786f529f0$var$isLongForm(workCategoryKey)) return $b467ca1786f529f0$var$longToShortConversionMap[workCategoryKey];
    return null;
};

});

parcelRegister("5RW99", function(module, exports) {
$parcel$export(module.exports, "ADDON_ID", () => $6707b1635af3be3c$export$6c4866a933650d1d);
$parcel$export(module.exports, "MENU_ID", () => $6707b1635af3be3c$export$d4cd258d01c03112);
$parcel$export(module.exports, "SIDEBAR_ID", () => $6707b1635af3be3c$export$adf978edbdfaf080);
const $6707b1635af3be3c$export$6c4866a933650d1d = {
    DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
};
const $6707b1635af3be3c$export$d4cd258d01c03112 = {
    ADDONS: 'ADDONS',
    APP_SWITCHER: 'APP_SWITCHER',
    COMMUNICATIONS: 'COMMUNICATIONS',
    DASHBOARDS: 'DASHBOARDS',
    FILTERS: 'FILTERS',
    HELP: 'HELP',
    HOME: 'HOME',
    INSIGHT: 'INSIGHT',
    NOTIFICATIONS: 'NOTIFICATIONS',
    PEOPLE: 'PEOPLE',
    PLANS: 'PLANS',
    PROFILE: 'PROFILE',
    PROJECTS: 'PROJECTS',
    ROADMAPS: 'ROADMAPS',
    SEARCH: 'SEARCH',
    SERVICE_HUB: 'SERVICE_HUB',
    SETTINGS: 'SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    STATUS_PAGE_MANAGE: 'STATUS_PAGE_MANAGE',
    WORK_ITEM: 'WORK_ITEM'
};
const $6707b1635af3be3c$export$adf978edbdfaf080 = {
    BOARD_SETTINGS: 'BOARD_SETTINGS',
    CONTENT: 'CONTENT',
    GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
    GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
    GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
    GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
    GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
    HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
    PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
    PLAN_SETTINGS: 'PLAN_SETTINGS',
    PROJECT_SETTINGS: 'PROJECT_SETTINGS',
    OPERATIONS_GENERAL_CONFIGURATION: 'OPERATIONS_GENERAL_CONFIGURATION'
};

});


parcelRegister("3MbOI", function(module, exports) {
$parcel$export(module.exports, "useCurrentUser", () => $cea734a12424bed3$export$3901076af3749fa9);

var $eJOHy = parcelRequire("eJOHy");

var $jbr6p = parcelRequire("jbr6p");

var $koAZ4 = parcelRequire("koAZ4");

var $c9f6v = parcelRequire("c9f6v");
const $cea734a12424bed3$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $jbr6p.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $cea734a12424bed3$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $cea734a12424bed3$var$useCurrentUserBasic();
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $c9f6v.useUserSubscriber)();
    (0, $eJOHy.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $cea734a12424bed3$export$3901076af3749fa9 = ()=>// eslint-disable-next-line react-hooks/react-compiler
    (0, $koAZ4.useTenantContext)().isAnonymous ? $cea734a12424bed3$var$useCurrentUserBasic() : $cea734a12424bed3$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $cea734a12424bed3$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $cea734a12424bed3$export$3901076af3749fa9();
    return children(result);
};

});

parcelRegister("3Z5Oj", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryRoute", () => $ac00b00f7ddabdfe$export$f0fc6f4e8be87e85);
const $ac00b00f7ddabdfe$export$f0fc6f4e8be87e85 = {
    name: 'boards-directory',
    path: '/jira/boards'
};

});

parcelRegister("fuV6j", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryRoute", () => $f8f2a1120a41a941$export$41bba408475cab16);
const $f8f2a1120a41a941$export$41bba408475cab16 = {
    name: 'dashboards-directory',
    path: '/jira/dashboards'
};

});

parcelRegister("bxSuo", function(module, exports) {
$parcel$export(module.exports, "filtersDirectoryRoute", () => $6ecabfb97a89b10c$export$6350f52c8b40042d);
const $6ecabfb97a89b10c$export$6350f52c8b40042d = {
    name: 'filters-directory',
    path: '/jira/filters'
};

});

parcelRegister("fZoD8", function(module, exports) {
$parcel$export(module.exports, "plansDirectoryRoute", () => $5e7673d2f94ce53a$export$143b4a1ef2ffc051);
const $5e7673d2f94ce53a$export$143b4a1ef2ffc051 = {
    name: 'plans-directory',
    path: '/jira/plans'
};

});

parcelRegister("lWdYg", function(module, exports) {
$parcel$export(module.exports, "projectsDirectoryRoute", () => $80e3307949c1173b$export$74114064f06cd71b);
const $80e3307949c1173b$export$74114064f06cd71b = {
    name: 'projects-directory',
    path: '/jira/projects',
    exact: true
};

});

parcelRegister("4wyu4", function(module, exports) {
$parcel$export(module.exports, "generalPersonalSettingsRoute", () => $15328041019aaf7d$export$7a6c9715a86f906b);
const $15328041019aaf7d$export$7a6c9715a86f906b = {
    name: 'personal-settings-general',
    path: '/jira/settings/personal/general'
};

});

parcelRegister("47bQc", function(module, exports) {
$parcel$export(module.exports, "issueNavigatorGlobalRoute", () => $c1bfc0f1ce07a50f$export$928d3577bbe9e124);
const $c1bfc0f1ce07a50f$export$928d3577bbe9e124 = {
    name: 'global-issue-navigator',
    path: '/issues'
};

});

const $ffa66aa2792c8b51$export$2d4af8d3471f446 = 'view-all-projects';
const $ffa66aa2792c8b51$export$bfa43d3c5bfbcf35 = 'view-all-filters';
const $ffa66aa2792c8b51$export$538e0daca84e7e29 = 'view-all-dashboards';
const $ffa66aa2792c8b51$export$c6ac3c085f5d9f2f = 'view-my-open-issues';
const $ffa66aa2792c8b51$export$86893b0d65e6a1ba = 'view-issues-reported-by-me';
const $ffa66aa2792c8b51$export$f3211b812cd1a523 = 'go-to-issues';
const $ffa66aa2792c8b51$export$98cbb2f7230db2a1 = 'go-to-personal-settings';
const $ffa66aa2792c8b51$export$7e8556985118cd1e = 'view-all-boards';
const $ffa66aa2792c8b51$export$7976f2daa1e8078a = 'go-to-account-settings';
const $ffa66aa2792c8b51$export$653733b43ae1b993 = 'view-all-plans';
const $ffa66aa2792c8b51$export$9ede11404253696 = 'site-admin-user-management';
const $ffa66aa2792c8b51$export$bf77ae178e5e5984 = 'site-admin-billing';

parcelRegister("6iqtx", function(module, exports) {
$parcel$export(module.exports, "default", () => $be64ff072ffd61fd$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $be64ff072ffd61fd$var$messages = (0, $7qGN1.defineMessages)({
    viewMyOpenIssues: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-my-open-issues",
        "defaultMessage": "View my open work items"
    },
    viewIssuesReportedByMe: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-issues-reported-by-me",
        "defaultMessage": "View work items reported by me"
    },
    viewAllProjects: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-projects",
        "defaultMessage": "View all projects"
    },
    viewAllFilters: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-filters",
        "defaultMessage": "View all filters"
    },
    viewAllDashboards: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-dashboards",
        "defaultMessage": "View all dashboards"
    },
    goToIssues: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-issues",
        "defaultMessage": "Go to issues"
    },
    goToPersonalSettings: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-personal-settings",
        "defaultMessage": "Go to personal settings"
    },
    viewAllBoards: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-boards",
        "defaultMessage": "View all boards"
    },
    goToAccountSettings: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-account-settings",
        "defaultMessage": "Go to account settings"
    },
    viewAllPlans: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-plans",
        "defaultMessage": "View all plans"
    },
    goToUserManagement: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-user-management",
        "defaultMessage": "Go to user management"
    },
    goToBilling: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-billing",
        "defaultMessage": "Go to billing"
    },
    goToIssuesIssueTermRefresh: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-issues-issue-term-refresh",
        "defaultMessage": "Go to work items"
    },
    goToList: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.go-to-list",
        "defaultMessage": "Go to list"
    },
    viewAllProjectsGalaxia: {
        "id": "command-palette-integration.initial-commands.use-navigation-commands.view-all-projects-galaxia",
        "defaultMessage": "View all spaces"
    }
});
var $be64ff072ffd61fd$export$2e2bcd8739ae039 = $be64ff072ffd61fd$var$messages;

});



parcelRegister("1LqFT", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f1e9bfce8e18ae48$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $f1e9bfce8e18ae48$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    defaultPlaceholder: {
        "id": "command-palette-integration.default-placeholder",
        "defaultMessage": "Search actions, settings, or type \"/\" to search work"
    },
    noResultsFound: {
        "id": "command-palette-integration.no-results-found",
        "defaultMessage": "No commands match your search."
    },
    onErrorFallback: {
        "id": "command-palette-integration.on-error-fallback",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    },
    recommendedSection: {
        "id": "command-palette-integration.recommended-section",
        "defaultMessage": "Recommended"
    },
    defaultSearchInputAriaLabel: {
        "id": "command-palette-integration.default-search-input-aria-label",
        "defaultMessage": "Search actions, settings, or type forward slash to search work"
    }
});

});

parcelRegister("2M8GM", function(module, exports) {
$parcel$export(module.exports, "RegisterDynamicCommands", () => $3e35bdde3bf2b3b6$export$54040e80edbe5eaf);

var $eJOHy = parcelRequire("eJOHy");

var $cimT2 = parcelRequire("cimT2");

var $lAjmi = parcelRequire("lAjmi");

var $6WwI6 = parcelRequire("6WwI6");
const $3e35bdde3bf2b3b6$export$54040e80edbe5eaf = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lAjmi.InitialiseAdminNavCommands), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cimT2.QuickSearchCommands), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6WwI6.ThemeModeCommands), null));

});
parcelRegister("cimT2", function(module, exports) {
$parcel$export(module.exports, "QuickSearchCommands", () => $3d47442a71a8c2ab$export$6e94ce71acbaa493);

var $eJOHy = parcelRequire("eJOHy");

var $fWwfy = parcelRequire("fWwfy");

var $efhOD = parcelRequire("efhOD");

var $lDtQl = parcelRequire("lDtQl");

var $4tw0m = parcelRequire("4tw0m");
const $3d47442a71a8c2ab$var$useQuickSearchCommands = ()=>{
    const subscribe = (0, $efhOD.useSubscribeCommands)();
    const { quickSearchCommand: quickSearchCommand } = (0, $4tw0m.useQuickSearchCommand)({
        keepSearch: false
    });
    (0, $eJOHy.useEffect)(()=>subscribe((0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).QUICK_SEARCH, [
            quickSearchCommand
        ]), [
        quickSearchCommand,
        subscribe
    ]);
    return null;
};
const $3d47442a71a8c2ab$var$QuickSearchCommandsInner = ()=>{
    $3d47442a71a8c2ab$var$useQuickSearchCommands();
    return null;
};
const $3d47442a71a8c2ab$export$6e94ce71acbaa493 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lDtQl.QuickSearchWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3d47442a71a8c2ab$var$QuickSearchCommandsInner, null));

});
parcelRegister("efhOD", function(module, exports) {
$parcel$export(module.exports, "useSubscribeCommands", () => $69e1ecd0b4d95d40$export$c13b008422be19c7);

var $iTb6Y = parcelRequire("iTb6Y");
const $69e1ecd0b4d95d40$export$c13b008422be19c7 = (0, $iTb6Y.useSubscribeCommandsWithRegistry);

});


parcelRegister("lAjmi", function(module, exports) {
$parcel$export(module.exports, "InitialiseAdminNavCommands", () => $e82bc9944d73fcea$export$397d6a5dfe0b6bae);

var $eJOHy = parcelRequire("eJOHy");

var $ervtT = parcelRequire("ervtT");

var $g51Bg = parcelRequire("g51Bg");

var $cBavF = parcelRequire("cBavF");

var $iWvkh = parcelRequire("iWvkh");
const $e82bc9944d73fcea$var$entryPointParams = {};
const $e82bc9944d73fcea$export$397d6a5dfe0b6bae = ()=>{
    const [initialised, setInitialised] = (0, $eJOHy.useState)(false);
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $iWvkh.useEntryPoint)((0, $ervtT.compalAdminNavigationEntrypoint), $e82bc9944d73fcea$var$entryPointParams);
    const [{ isOpen: isOpen }] = (0, $g51Bg.useCommandPaletteIsOpen)();
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
        if (!initialised) return;
        if (isOpen) entryPointActions.load();
        else entryPointActions.unload();
    }, [
        isOpen,
        entryPointActions,
        initialised
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!initialised && isOpen) setInitialised(true);
    }, [
        isOpen,
        initialised
    ]);
    const props = (0, $eJOHy.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "commandPaletteAsyncAdminNavigation",
        packageName: "jiraCommandPaletteIntegration",
        teamName: "deliveroo",
        fallback: null,
        errorFallback: "flag",
        runtimeProps: props
    });
};

});
parcelRegister("ervtT", function(module, exports) {
$parcel$export(module.exports, "compalAdminNavigationEntrypoint", () => $7b3c8a9beb0cde70$export$ec97befbb495acbe);
/* istanbul ignore file */ 
var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $7b3c8a9beb0cde70$export$ec97befbb495acbe = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("hV5dd")).then((module)=>module.AdminNavCommands), {
        moduleId: "1ee8a073",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hV5dd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bzRG7").then(()=>parcelRequire('dFPRW'));

});



parcelRegister("6WwI6", function(module, exports) {
$parcel$export(module.exports, "ThemeModeCommands", () => $a558e4b7bcb59c8e$export$cecc9cf59bb74e7d);

var $eJOHy = parcelRequire("eJOHy");

var $4F5bb = parcelRequire("4F5bb");

var $4cTDP = parcelRequire("4cTDP");

var $1Zcfy = parcelRequire("1Zcfy");

var $itdlt = parcelRequire("itdlt");

var $fWwfy = parcelRequire("fWwfy");

var $fGVnv = parcelRequire("fGVnv");

var $hf4h9 = parcelRequire("hf4h9");

var $lzW9r = parcelRequire("lzW9r");

var $9lqIQ = parcelRequire("9lqIQ");

var $1u4yg = parcelRequire("1u4yg");

var $lRq8t = parcelRequire("lRq8t");

var $cxQGT = parcelRequire("cxQGT");

var $28M5N = parcelRequire("28M5N");
const $a558e4b7bcb59c8e$export$17b41f710dd67667 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { theme: currentTheme = 'light', setTheme: setTheme } = (0, $cxQGT.useThemePreference)();
    const { triggerCustomNavBarColorsFlag: triggerCustomNavBarColorsFlag } = (0, $1u4yg.default)();
    const setThemeWithCustomNavBarFlag = (0, $eJOHy.useCallback)(async (newTheme)=>{
        await setTheme(newTheme);
        triggerCustomNavBarColorsFlag(newTheme);
    }, [
        setTheme,
        triggerCustomNavBarColorsFlag
    ]);
    const { getKeywords: getKeywords } = (0, $itdlt.useCommandKeywords)();
    const createThemeCommand = (0, $eJOHy.useCallback)((theme, message, priority)=>({
            id: `command-palette-integration-change-theme-mode-${theme}`,
            name: formatMessage(message),
            keywords: theme === 'auto' ? getKeywords('matchSystemThemeSynonyms') : getKeywords('switchDarkThemeSynonyms'),
            primaryAction: {
                type: (0, $hf4h9.CommandActionType).PERFORM,
                perform: ()=>setThemeWithCustomNavBarFlag(theme)
            },
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4F5bb))), {
                        spacing: "spacious",
                        label: (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? '' : formatMessage(message),
                        "aria-hidden": (0, $4cTDP.fg)('deliveroo_compal_a11y_fixes') ? true : undefined
                    })
            },
            section: (0, $1Zcfy.COMMAND_PALETTE_SECTIONS).personalSettings,
            priority: priority,
            analytics: {
                action: 'toggleTheme'
            }
        }), [
        formatMessage,
        getKeywords,
        setThemeWithCustomNavBarFlag
    ]);
    const themeModeCommands = (0, $eJOHy.useMemo)(()=>{
        const availableThemesMode = {
            dark: createThemeCommand('dark', (0, $28M5N.messages).commandDarkTheme, (0, $1Zcfy.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToDarkTheme),
            light: createThemeCommand('light', (0, $28M5N.messages).commandLightTheme, (0, $1Zcfy.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToLightTheme),
            auto: createThemeCommand('auto', (0, $28M5N.messages).commandAutoTheme, (0, $1Zcfy.COMMAND_PALETTE_PERSONAL_SETTINGS_PRIORITY).switchToSystemTheme)
        };
        const listOfCommands = [];
        Object.entries(availableThemesMode).forEach(([key, command])=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (key !== currentTheme && (0, $lzW9r.ThemeOptions).includes(key)) listOfCommands.push(command);
        });
        return listOfCommands;
    }, [
        createThemeCommand,
        currentTheme
    ]);
    return themeModeCommands;
};
const $a558e4b7bcb59c8e$export$cecc9cf59bb74e7d = ()=>{
    const [{ flagIsDismissed: flagIsDismissed }] = (0, $9lqIQ.useCustomNavBarColorWarnings)();
    const command = $a558e4b7bcb59c8e$export$17b41f710dd67667();
    const commandIds = command.map(({ id: id })=>id).toString();
    (0, $fGVnv.useRegisterCommands)((0, $fWwfy.COMMAND_PALETTE_REGISTRY_IDS).THEME_MODE, command, [
        commandIds,
        flagIsDismissed
    ]);
    return null;
};

});
parcelRegister("lzW9r", function(module, exports) {
$parcel$export(module.exports, "ThemeOptions", () => $b42648c3d8d982a4$export$abe7936539cefefe);
$parcel$export(module.exports, "DEFAULT_THEME", () => $b42648c3d8d982a4$export$2faeed762aac6741);
// This type inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $b42648c3d8d982a4$export$abe7936539cefefe = [
    'light',
    'dark',
    'auto'
];
const $b42648c3d8d982a4$export$2faeed762aac6741 = 'light';

});

parcelRegister("9lqIQ", function(module, exports) {
$parcel$export(module.exports, "useCustomNavBarColorWarnings", () => $cecba1785555848f$export$c3d02c4eeb80172a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $rU9wX = parcelRequire("rU9wX");
const $cecba1785555848f$var$initialState = {
    isLoading: true,
    isLoadingWithRelay: false
};
const $cecba1785555848f$var$CustomNavBarColorsFlagDismissalStore = (0, $GtRbT.createStore)({
    initialState: $cecba1785555848f$var$initialState,
    actions: $rU9wX.actions,
    name: 'custom-nav-bar-colors-flag-dismissal'
});
const $cecba1785555848f$export$c3d02c4eeb80172a = (0, $iJq0l.createHook)($cecba1785555848f$var$CustomNavBarColorsFlagDismissalStore);

});
parcelRegister("rU9wX", function(module, exports) {
$parcel$export(module.exports, "actions", () => $d549780768b69cab$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $l8Itk = parcelRequire("l8Itk");
const $d549780768b69cab$export$e324594224ef24da = {
    initialFetch: ()=>async ({ setState: setState, getState: getState })=>{
            const { isLoading: isLoading } = getState();
            if (!isLoading) return;
            setState({
                isLoading: false
            });
            const [flagDismissedRes, sectionMessageDismissedRes] = await Promise.allSettled([
                (0, $l8Itk.getCustomNavBarFlagDismissed)(),
                (0, $l8Itk.getCustomNavBarMessageDismissed)()
            ]);
            setState({
                flagIsDismissed: flagDismissedRes.status === 'fulfilled' ? flagDismissedRes.value || false : false,
                sectionMessageIsDismissed: sectionMessageDismissedRes.status === 'fulfilled' ? sectionMessageDismissedRes.value || false : false
            });
        },
    setIsLoadingWithRelay: ()=>({ setState: setState })=>{
            setState({
                isLoadingWithRelay: true,
                isLoading: false
            });
        },
    setFlagIsDismissed: (data = true, setRemote = true)=>({ setState: setState })=>{
            setState({
                flagIsDismissed: data
            });
            if (setRemote) (0, $l8Itk.setCustomNavBarFlagDismissed)(data);
        },
    setMessageIsDismissed: (data = true, setRemote = true)=>({ setState: setState })=>{
            setState({
                sectionMessageIsDismissed: data
            });
            if (setRemote) (0, $l8Itk.setCustomNavBarMessageDismissed)(data);
        }
};

});
parcelRegister("l8Itk", function(module, exports) {
$parcel$export(module.exports, "setCustomNavBarFlagDismissed", () => $9d6b126a5e27a36b$export$96c3ac24c205921e);
$parcel$export(module.exports, "getCustomNavBarFlagDismissed", () => $9d6b126a5e27a36b$export$4875b5188973cc41);
$parcel$export(module.exports, "getCustomNavBarMessageDismissed", () => $9d6b126a5e27a36b$export$234ec7e66f5f0d80);
$parcel$export(module.exports, "setCustomNavBarMessageDismissed", () => $9d6b126a5e27a36b$export$81fcff1db07fc096);

var $9pTd3 = parcelRequire("9pTd3");

var $9DB7T = parcelRequire("9DB7T");

var $6HTqp = parcelRequire("6HTqp");
const $9d6b126a5e27a36b$export$96c3ac24c205921e = async (value)=>{
    try {
        await (0, $9DB7T.userPreferenceAPI).set((0, $6HTqp.CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'setCustomNavBarFlagDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $9d6b126a5e27a36b$export$4875b5188973cc41 = async ()=>{
    try {
        return await (0, $9DB7T.userPreferenceAPI).get((0, $6HTqp.CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode !== 404) (0, $9pTd3.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'getCustomNavBarFlagDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};
const $9d6b126a5e27a36b$export$234ec7e66f5f0d80 = async ()=>{
    try {
        return await (0, $9DB7T.userPreferenceAPI).get((0, $6HTqp.CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // 404 is acceptable as it means user hasn't dismissed it yet
        if (err.statusCode !== 404) (0, $9pTd3.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'getCustomNavBarMessageDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};
const $9d6b126a5e27a36b$export$81fcff1db07fc096 = async (value)=>{
    try {
        await (0, $9DB7T.userPreferenceAPI).set((0, $6HTqp.CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY), value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $9pTd3.fireErrorAnalytics)({
            error: err,
            meta: {
                id: 'setCustomTopNavDarkModeDismissed',
                packageName: 'jiraCustomNavBarColorsFlag'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
};

});
parcelRegister("6HTqp", function(module, exports) {
$parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_FLAG_DISMISSED_KEY", () => $68eaa0fbfe41cb40$export$e322337c75e7fd2e);
$parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_SECTION_MESSAGE_DISMISSED_KEY", () => $68eaa0fbfe41cb40$export$d37f7f5db461e560);
$parcel$export(module.exports, "CUSTOM_NAV_BAR_COLORS_FLAG_ID", () => $68eaa0fbfe41cb40$export$385ef2d36e85217);
$parcel$export(module.exports, "HELP_ARTICLE_ID", () => $68eaa0fbfe41cb40$export$1da9e2242c8f1be7);

var $jn1Cb = parcelRequire("jn1Cb");
const $68eaa0fbfe41cb40$export$e322337c75e7fd2e = 'jira.user.theme.custom-nav-bar-flag.dismissed';
const $68eaa0fbfe41cb40$export$d37f7f5db461e560 = 'jira.user.theme.custom-nav-bar-section-message.dismissed';
const $68eaa0fbfe41cb40$export$385ef2d36e85217 = (0, $jn1Cb.toFlagId)('onThemeChangeCustomColorsFlag');
const $68eaa0fbfe41cb40$export$1da9e2242c8f1be7 = '1QC8AUgw7MAmoVtoYXQDxM';

});




parcelRegister("1u4yg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a6d397c070ba3ec$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $575d2 = parcelRequire("575d2");

var $cSXp8 = parcelRequire("cSXp8");

var $6HTqp = parcelRequire("6HTqp");

var $9lqIQ = parcelRequire("9lqIQ");

var $6TOqr = parcelRequire("6TOqr");
/**
 * Manages the logic for showing a warning about custom navigation bar colors.
 * Determines whether the warning should be displayed based on feature flags, theme settings,
 * and whether the warning has been previously dismissed. Aimed at ensuring users are aware
 * of potential issues with custom color schemes in the navigation bar.
 */ const $1a6d397c070ba3ec$var$useCustomNavBarColorsFlag = ()=>{
    const { hasFlag: hasFlag, showFlag: showFlag, dismissFlag: dismissFlag } = (0, $cSXp8.useFlagsService)();
    const [{ navigationTheme: navigationTheme }] = (0, $575d2.useTheme)();
    const [{ flagIsDismissed: flagIsDismissed, sectionMessageIsDismissed: sectionMessageIsDismissed, isLoading: isLoading, isLoadingWithRelay: isLoadingWithRelay }, { setFlagIsDismissed: setFlagIsDismissed, initialFetch: initialFetch }] = (0, $9lqIQ.useCustomNavBarColorWarnings)();
    (0, $eJOHy.useEffect)(()=>{
        if (isLoadingWithRelay) return;
        initialFetch();
    }, [
        initialFetch,
        isLoadingWithRelay
    ]);
    const handleDismiss = (0, $eJOHy.useCallback)(()=>{
        dismissFlag((0, $6HTqp.CUSTOM_NAV_BAR_COLORS_FLAG_ID));
        setFlagIsDismissed();
    }, [
        dismissFlag,
        setFlagIsDismissed
    ]);
    const shouldShowFlag = (0, $eJOHy.useCallback)((theme)=>!isLoading && !hasFlag?.((0, $6HTqp.CUSTOM_NAV_BAR_COLORS_FLAG_ID)) && (theme === 'dark' || theme === 'auto') && navigationTheme.usesCustomColours && flagIsDismissed === false && sectionMessageIsDismissed === false, [
        hasFlag,
        navigationTheme.usesCustomColours,
        isLoading,
        flagIsDismissed,
        sectionMessageIsDismissed
    ]);
    const triggerCustomNavBarColorsFlag = (0, $eJOHy.useCallback)((newTheme)=>{
        if (shouldShowFlag(newTheme)) showFlag({
            id: (0, $6HTqp.CUSTOM_NAV_BAR_COLORS_FLAG_ID),
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6TOqr.default), {
                    ...props,
                    messageId: "custom-nav-bar-colors-flag.custom-nav-bar-colors-warning-flag",
                    messageType: "transactional",
                    onDismiss: handleDismiss,
                    analyticsAttributes: {
                        backgroundColor: navigationTheme.backgroundColor,
                        highlightColor: navigationTheme.highlightColor
                    }
                })
        });
    }, [
        shouldShowFlag,
        handleDismiss,
        showFlag,
        navigationTheme
    ]);
    return {
        triggerCustomNavBarColorsFlag: triggerCustomNavBarColorsFlag
    };
};
var $1a6d397c070ba3ec$export$2e2bcd8739ae039 = $1a6d397c070ba3ec$var$useCustomNavBarColorsFlag;

});
parcelRegister("575d2", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $68e241df896657e0$export$93d4e7f90805808f);
$parcel$export(module.exports, "ThemeContainer", () => $68e241df896657e0$export$11eb671888ed6e7d);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

var $2evd1 = parcelRequire("2evd1");
const $68e241df896657e0$var$initialState = {
    navigationTheme: {
        shouldShowTitle: false,
        logoUrl: '',
        usesCustomColours: false,
        backgroundColor: '',
        highlightColor: ''
    }
};
const $68e241df896657e0$var$Store = (0, $GtRbT.createStore)({
    name: 'theme',
    initialState: $68e241df896657e0$var$initialState,
    actions: $2evd1
});
const $68e241df896657e0$export$74e6aa5aeff5e82e = (0, $ht3nQ.createSubscriber)($68e241df896657e0$var$Store);
const $68e241df896657e0$export$93d4e7f90805808f = (0, $iJq0l.createHook)($68e241df896657e0$var$Store);
const $68e241df896657e0$export$11eb671888ed6e7d = (0, $6E16M.createContainer)($68e241df896657e0$var$Store, {
    onInit: $2evd1.bootstrap
});

});
parcelRegister("2evd1", function(module, exports) {
$parcel$export(module.exports, "bootstrap", () => $c655e5e5256464c4$export$36aff1fbb4f5dfc6);
$parcel$export(module.exports, "update", () => $c655e5e5256464c4$export$722fbec263ad908a);

const $c655e5e5256464c4$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
        const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
        const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
        // we need to use color code directly here to compare it with hex code in meta tags
        const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $7bb4c1736002a04a$exports).N0 || ajsHighlightColor !== (0, $7bb4c1736002a04a$exports).B400);
        const navigationTheme = {
            shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
            logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
            usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
            backgroundColor: ajsBackgroundColor || "var(--ds-background-inverse-subtle, #00000029)",
            highlightColor: ajsHighlightColor || "var(--ds-text-brand, #0C66E4)"
        };
        if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
        setState({
            navigationTheme: navigationTheme
        });
    };
const $c655e5e5256464c4$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
        const navigationTheme = {
            ...getState().navigationTheme,
            ...item
        };
        setState({
            navigationTheme: navigationTheme
        });
    };

});


parcelRegister("6TOqr", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbade09eb954fb0e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2R0ne = parcelRequire("2R0ne");

var $2pgjF = parcelRequire("2pgjF");

var $ezJEv = parcelRequire("ezJEv");

var $lRq8t = parcelRequire("lRq8t");

var $kRgKj = parcelRequire("kRgKj");

var $6HTqp = parcelRequire("6HTqp");

var $3WAmf = parcelRequire("3WAmf");
const $fbade09eb954fb0e$export$e5995f97d3b9e5eb = 'router-resources.theme-preference.custom-nav-bar-colors-flag';
const $fbade09eb954fb0e$var$CustomNavBarColorsFlag = ({ onDismiss: onDismiss, analyticsAttributes: analyticsAttributes, messageId: messageId, messageType: messageType })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onOpenInProductHelpArticle = (0, $ezJEv.useHelpPanelLink)();
    const onDismissFn = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'customTopNavUserFlagWarningDismissButton', analyticsAttributes);
        onDismiss();
    }, [
        onDismiss,
        analyticsAttributes
    ]);
    return (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2pgjF.InfoFlag), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2R0ne))), {
                spacing: "spacious",
                color: "var(--ds-icon-information, #1D7AFC)",
                label: ""
            }),
            testId: $fbade09eb954fb0e$export$e5995f97d3b9e5eb,
            id: (0, $6HTqp.CUSTOM_NAV_BAR_COLORS_FLAG_ID),
            title: formatMessage((0, $3WAmf.default).title),
            description: formatMessage((0, $3WAmf.default).description),
            onDismissed: onDismissFn,
            messageId: messageId ?? 'custom-nav-bar-colors-flag.ui.info-flag',
            messageType: messageType ?? 'transactional',
            actions: [
                {
                    content: formatMessage((0, $3WAmf.default).learnMoreAction),
                    onClick: (_, analyticsEvent)=>{
                        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'customTopNavUserFlagWarningMoreButton', analyticsAttributes);
                        onOpenInProductHelpArticle((0, $6HTqp.HELP_ARTICLE_ID));
                    }
                },
                {
                    content: formatMessage((0, $3WAmf.default).dismissAction),
                    onClick: onDismissFn
                }
            ]
        }), [
        formatMessage,
        onDismissFn,
        onOpenInProductHelpArticle,
        analyticsAttributes,
        messageId,
        messageType
    ]);
};
var $fbade09eb954fb0e$export$2e2bcd8739ae039 = $fbade09eb954fb0e$var$CustomNavBarColorsFlag;

});
parcelRegister("2pgjF", function(module, exports) {
$parcel$export(module.exports, "CommonFlag", () => $ad78c13b0c88c3ae$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $ad78c13b0c88c3ae$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $ad78c13b0c88c3ae$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $ad78c13b0c88c3ae$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $ad78c13b0c88c3ae$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $ad78c13b0c88c3ae$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $ad78c13b0c88c3ae$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $ad78c13b0c88c3ae$export$a2c3479950310d7d);

var $eJOHy = parcelRequire("eJOHy");

var $xvuCV = parcelRequire("xvuCV");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad78c13b0c88c3ae$var$ForPaintJiraCommonFlag = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("iH5UR")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad78c13b0c88c3ae$var$AfterPaintJiraCommonFlag = (0, $bQWwW.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("iH5UR")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $ad78c13b0c88c3ae$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad78c13b0c88c3ae$var$ForPaintFlagGroup = (0, $bQWwW.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("1yBk6")), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ad78c13b0c88c3ae$var$AfterPaintFlagGroup = (0, $bQWwW.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("1yBk6")), {
    ssr: false,
    moduleId: "./src/packages/platform/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $ad78c13b0c88c3ae$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$ForPaintFlagGroup, props);
const $ad78c13b0c88c3ae$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, props));
const $ad78c13b0c88c3ae$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $ad78c13b0c88c3ae$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $ad78c13b0c88c3ae$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $ad78c13b0c88c3ae$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $ad78c13b0c88c3ae$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $ad78c13b0c88c3ae$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $ad78c13b0c88c3ae$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $xvuCV.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ad78c13b0c88c3ae$var$FlagGroupImpl, props));

});
parcelRegister("xvuCV", function(module, exports) {
$parcel$export(module.exports, "FlagsBoundary", () => $04814a5dcc217132$export$8b4a0fffcddd96f4);

var $eJOHy = parcelRequire("eJOHy");

var $h47gY = parcelRequire("h47gY");

var $2imLM = parcelRequire("2imLM");
const $04814a5dcc217132$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: "flags",
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "flags-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, children));

});

parcelRegister("iH5UR", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("hM1w9")
]).then(()=>parcelRequire('8Q0s6'));

});

parcelRegister("1yBk6", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("1Rz2I").then(()=>parcelRequire('h9uSI'));

});


parcelRegister("ezJEv", function(module, exports) {
$parcel$export(module.exports, "useHelpPanelLink", () => $906804a52fd3782f$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $906804a52fd3782f$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $906804a52fd3782f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");


var $3VPsL = parcelRequire("3VPsL");

var $dfP3D = parcelRequire("dfP3D");

var $cxKOj = parcelRequire("cxKOj");
const $906804a52fd3782f$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $3VPsL.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $60b564818f0d5fed$export$e99efa3985fa3c26), (0, $60b564818f0d5fed$export$23aa6670f346c214), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $906804a52fd3782f$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $906804a52fd3782f$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $hcewu.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $cxKOj.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $906804a52fd3782f$export$2e2bcd8739ae039 = $906804a52fd3782f$export$5a09250ffddd7fd1;
const $906804a52fd3782f$var$buttonWrapperStyles = null;
const $906804a52fd3782f$var$buttonWrapperSubtleStyles = null;

});
const $60b564818f0d5fed$export$c43c7444da662fa1 = '1';
const $60b564818f0d5fed$export$e99efa3985fa3c26 = 'helpPanel';
const $60b564818f0d5fed$export$23aa6670f346c214 = 368;

parcelRegister("3VPsL", function(module, exports) {
$parcel$export(module.exports, "useHelpPanel", () => $39739d0e1c6f9274$export$3fe94d66377a53b8);
$parcel$export(module.exports, "useHelpPanelActions", () => $39739d0e1c6f9274$export$c61f56f4797e22db);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $ht3nQ = parcelRequire("ht3nQ");

var $6wZ6K = parcelRequire("6wZ6K");
const $39739d0e1c6f9274$export$3fe94d66377a53b8 = (0, $iJq0l.createHook)((0, $6wZ6K.default));
const $39739d0e1c6f9274$export$c61f56f4797e22db = (0, $iJq0l.createHook)((0, $6wZ6K.default), {
    selector: null
});
const $39739d0e1c6f9274$export$513717a84f55db1a = (0, $ht3nQ.createSubscriber)((0, $6wZ6K.default), {
    displayName: 'HelpPanelSubscriber'
});
const $39739d0e1c6f9274$export$5f4de38bd79f4446 = (0, $ht3nQ.createSubscriber)((0, $6wZ6K.default), {
    displayName: 'HelpPanelActionsSubscriber',
    selector: null
});

});
parcelRegister("6wZ6K", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0401c126f56172a$export$2e2bcd8739ae039);

var $8tIrO = parcelRequire("8tIrO");

var $GtRbT = parcelRequire("GtRbT");

var $efQxP = parcelRequire("efQxP");
let $e0401c126f56172a$var$iphStorage;
const $e0401c126f56172a$var$createStorage = ()=>{
    if ($e0401c126f56172a$var$iphStorage) return $e0401c126f56172a$var$iphStorage;
    $e0401c126f56172a$var$iphStorage = (0, $8tIrO.createSessionStorageProvider)('iph');
    return $e0401c126f56172a$var$iphStorage;
};
const $e0401c126f56172a$var$initialState = {
    navigationData: {
        articleId: {
            id: '',
            type: 'HELP_ARTICLE'
        },
        // FIXME: initialState breaks SSR
        history: false ? [] : $e0401c126f56172a$var$createStorage().get('navigationData') || []
    },
    releaseNotesNotifications: 100
};
var $e0401c126f56172a$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'help-panel',
    initialState: $e0401c126f56172a$var$initialState,
    actions: $efQxP
});

});
parcelRegister("efQxP", function(module, exports) {
$parcel$export(module.exports, "setNavigationData", () => $b1de94cedbb71714$export$ab1b80f40ca898ed);
$parcel$export(module.exports, "setReleaseNotesNotifications", () => $b1de94cedbb71714$export$cdabe01d01a8da1e);

var $8tIrO = parcelRequire("8tIrO");
const $b1de94cedbb71714$var$iphStorage = (0, $8tIrO.createSessionStorageProvider)('iph');
const $b1de94cedbb71714$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            navigationData: {
                articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                history: navigationData.history ? navigationData.history : currentState.navigationData.history
            }
        });
        $b1de94cedbb71714$var$iphStorage.set('history', []);
    };
const $b1de94cedbb71714$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
        setState({
            releaseNotesNotifications: releaseNotesNotifications
        });
    };

});




parcelRegister("3WAmf", function(module, exports) {
$parcel$export(module.exports, "default", () => $19d79c877f71aa67$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $19d79c877f71aa67$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "custom-nav-bar-colors-flag.title",
        "defaultMessage": "Your top navigation menu has custom colors"
    },
    description: {
        "id": "custom-nav-bar-colors-flag.description",
        "defaultMessage": "If the color of your navigation menu doesn't look right in this theme, notify your Jira admin."
    },
    learnMoreAction: {
        "id": "custom-nav-bar-colors-flag.learn-more-action",
        "defaultMessage": "Learn more"
    },
    dismissAction: {
        "id": "custom-nav-bar-colors-flag.dismiss-action",
        "defaultMessage": "Dismiss"
    }
});
var $19d79c877f71aa67$export$2e2bcd8739ae039 = $19d79c877f71aa67$var$messages;

});



parcelRegister("cxQGT", function(module, exports) {
$parcel$export(module.exports, "themePreferenceResource", () => $5f480f6098caae1f$export$e5a423d1eb1cf1d0);
$parcel$export(module.exports, "useThemePreference", () => $5f480f6098caae1f$export$3416635c8aeb5bab);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $l1VxS = parcelRequire("l1VxS");
var $eJrcF = parcelRequire("eJrcF");

var $fwRwb = parcelRequire("fwRwb");

var $fWIQB = parcelRequire("fWIQB");

var $5nksj = parcelRequire("5nksj");

const $5f480f6098caae1f$var$getDataLoader = ()=>(parcelRequire("utF9E"));
const $5f480f6098caae1f$export$e5a423d1eb1cf1d0 = (0, $l1VxS.createResource)({
    type: 'RESOURCE_THEME_PREFERENCE',
    getKey: ()=>'state',
    getDataLoader: $5f480f6098caae1f$var$getDataLoader,
    maxAge: 300000,
    isCritical: true
});
// TODO (DST): Should be deleted along with shared-user-preferences cleanup
/**
 * Original implementation of useThemePreference (pre shared-user-preferences feature)
 */ const $5f480f6098caae1f$var$useThemePreferenceOld = ()=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $eJrcF.useResource)($5f480f6098caae1f$export$e5a423d1eb1cf1d0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireThemeAnalytics = (0, $eJOHy.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $fwRwb.THEME_PREFERENCES_ANALYTICS_ACTION),
            actionSubject: (0, $fwRwb.THEME_PREFERENCES_ANALYTICS_SUBJECT)
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eJOHy.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $fWIQB.setThemePreference)(theme);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};
const $5f480f6098caae1f$export$3416635c8aeb5bab = ()=>{
    // See https://hello.atlassian.net/wiki/spaces/JFP/pages/5033916021/Jira+Playbook+How+can+I+feature+gate+that#From-a-hook for conditional hooks
    return (0, $4cTDP.fg)('shared-user-preferences') ? (0, $5nksj.useThemePreference)($5f480f6098caae1f$export$e5a423d1eb1cf1d0) : $5f480f6098caae1f$var$useThemePreferenceOld();
};

});
parcelRegister("fwRwb", function(module, exports) {
$parcel$export(module.exports, "THEME_PREFERENCE_KEY", () => $256811ed117b45d8$export$40bd77e1c9f49c27);
$parcel$export(module.exports, "THEME_PREFERENCES_ANALYTICS_SUBJECT", () => $256811ed117b45d8$export$9e2cc65718a61846);
$parcel$export(module.exports, "THEME_PREFERENCES_ANALYTICS_ACTION", () => $256811ed117b45d8$export$89c5cf64ad15c3ea);
$parcel$export(module.exports, "themeColorModes", () => $256811ed117b45d8$export$83993de8eb66733);
$parcel$export(module.exports, "DEFAULT_COLOR_MODE", () => $256811ed117b45d8$export$854b45b62d1eb6d4);
const $256811ed117b45d8$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $256811ed117b45d8$export$9e2cc65718a61846 = 'themePreference';
const $256811ed117b45d8$export$89c5cf64ad15c3ea = 'changed';
const $256811ed117b45d8$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $256811ed117b45d8$export$854b45b62d1eb6d4 = 'auto';

});

parcelRegister("fWIQB", function(module, exports) {
$parcel$export(module.exports, "setThemePreference", () => $43e3efe56f96aef4$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $43e3efe56f96aef4$export$2f7a12048d96237);

var $9pTd3 = parcelRequire("9pTd3");

var $9DB7T = parcelRequire("9DB7T");

var $lzW9r = parcelRequire("lzW9r");

var $fwRwb = parcelRequire("fwRwb");
const $43e3efe56f96aef4$export$a6b84eebd33787e2 = (theme)=>{
    const promise = (0, $9DB7T.userPreferenceAPI).set((0, $fwRwb.THEME_PREFERENCE_KEY), theme);
    promise.catch((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'put',
                errName: String(error.name),
                statusCode: error.statusCode,
                param: `to:${theme}`
            }
        });
    });
    return promise;
};
const $43e3efe56f96aef4$export$2f7a12048d96237 = async ()=>{
    const promise = (0, $9DB7T.userPreferenceAPI).get((0, $fwRwb.THEME_PREFERENCE_KEY));
    promise.catch((error)=>{
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: error,
            attributes: {
                op: 'get',
                errName: String(error.name),
                statusCode: error.statusCode
            }
        });
    });
    promise.then((theme)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (theme && !(0, $lzW9r.ThemeOptions).includes(theme)) // very unlikely but…
        (0, $9pTd3.fireErrorAnalytics)({
            meta: {
                id: 'ThemePreferenceCRUD',
                packageName: 'jiraRouterResourcesThemePreference'
            },
            error: new Error('Unrecognized theme!'),
            attributes: {
                op: 'get',
                theme: theme,
                errName: 'unrecognized value!'
            }
        });
    });
    const theme = await promise;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return theme && (0, $lzW9r.ThemeOptions).includes(theme) ? theme : undefined;
};

});

parcelRegister("5nksj", function(module, exports) {
$parcel$export(module.exports, "useThemePreference", () => $fbca806fbb8d42c9$export$3416635c8aeb5bab);

var $eJOHy = parcelRequire("eJOHy");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $eJrcF = parcelRequire("eJrcF");

var $cHtIB = parcelRequire("cHtIB");

var $f2sjT = parcelRequire("f2sjT");

var $e6YEs = parcelRequire("e6YEs");

var $fwRwb = parcelRequire("fwRwb");

var $a75Xi = parcelRequire("a75Xi");
const $fbca806fbb8d42c9$export$3416635c8aeb5bab = (themePreferenceResource)=>{
    const { data: data, update: updateThemePreferenceResource } = (0, $eJrcF.useResource)(themePreferenceResource);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    // Get tenant context using hooks
    const cloudId = (0, $cHtIB.useCloudId)();
    const activationId = (0, $f2sjT.useActivationId)();
    const accountId = (0, $e6YEs.useAccountId)();
    const fireThemeAnalytics = (0, $eJOHy.useCallback)((current, next)=>{
        const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const analyticsEvent = createAnalyticsEvent({
            action: (0, $fwRwb.THEME_PREFERENCES_ANALYTICS_ACTION),
            actionSubject: (0, $fwRwb.THEME_PREFERENCES_ANALYTICS_SUBJECT)
        });
        (0, $kRgKj.fireUIAnalytics)(analyticsEvent, {
            newPreference: next,
            oldPreference: current,
            OStheme: OStheme
        });
    }, [
        createAnalyticsEvent
    ]);
    const setTheme = (0, $eJOHy.useCallback)(async (theme)=>{
        updateThemePreferenceResource(()=>({
                theme: theme
            }));
        if (data?.theme !== theme) {
            fireThemeAnalytics(data?.theme, theme);
            await (0, $a75Xi.setThemePreference)(theme, cloudId, activationId, accountId);
        }
    }, [
        data?.theme,
        updateThemePreferenceResource,
        fireThemeAnalytics,
        cloudId,
        activationId,
        accountId
    ]);
    return {
        theme: data?.theme,
        setTheme: setTheme
    };
};

});
parcelRegister("a75Xi", function(module, exports) {
$parcel$export(module.exports, "setThemePreference", () => $e094a5fbd794da36$export$a6b84eebd33787e2);
$parcel$export(module.exports, "getThemePreference", () => $e094a5fbd794da36$export$2f7a12048d96237);

var $goBB5 = parcelRequire("goBB5");

var $9pTd3 = parcelRequire("9pTd3");

var $7zZ4w = parcelRequire("7zZ4w");

var $ckJSY = parcelRequire("ckJSY");

var $fwRwb = parcelRequire("fwRwb");
const $e094a5fbd794da36$var$handleThemePreferenceError = (error, operation, additionalAttributes)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const err = error;
    (0, $9pTd3.fireErrorAnalytics)({
        meta: {
            id: 'ThemePreferenceCRUD',
            packageName: 'jiraRouterResourcesThemePreference'
        },
        error: err,
        attributes: {
            op: operation,
            errName: String(err.name),
            statusCode: err.statusCode,
            ...additionalAttributes
        }
    });
};
const $e094a5fbd794da36$export$a6b84eebd33787e2 = async (colorMode, cloudId, activationId, accountId)=>{
    try {
        // Create workspace ARI only when feature flag is enabled
        const workspaceAri = (0, $goBB5.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        if (!accountId) // Shared theming is supported for logged in users only
        return;
        // Use platform package for GraphQL operations
        await (0, $ckJSY.updateWorkspaceThemePreference)((0, $7zZ4w.default)(), workspaceAri, accountId, {
            colorMode: colorMode
        });
    } catch (error) {
        $e094a5fbd794da36$var$handleThemePreferenceError(error, 'put', {
            param: `to:${colorMode}`
        });
        throw error;
    }
};
const $e094a5fbd794da36$export$2f7a12048d96237 = async (cloudId, activationId, accountId)=>{
    if (!cloudId || !activationId || !accountId) // Shared theming is supported for logged in users only. CloudId and ActicationId should be always present but are left nullable to simplify the caller function
    return 0, $fwRwb.DEFAULT_COLOR_MODE;
    try {
        let colorMode;
        // Create workspace ARI only when feature flag is enabled
        const workspaceAri = (0, $goBB5.JiraWorkspaceAri).create({
            siteId: cloudId,
            activationId: activationId
        }).toString();
        // Use platform package for GraphQL operations
        const themeState = await (0, $ckJSY.getWorkspaceThemePreference)((0, $7zZ4w.default)(), workspaceAri, accountId);
        colorMode = themeState?.colorMode;
        // Validate theme value
        if (colorMode && !(0, $fwRwb.themeColorModes).includes(colorMode)) {
            // very unlikely but…
            $e094a5fbd794da36$var$handleThemePreferenceError(new Error('Unrecognized theme!'), 'get', {
                theme: colorMode,
                errName: 'unrecognized value!'
            });
            colorMode = (0, $fwRwb.DEFAULT_COLOR_MODE);
        }
        return colorMode ?? (0, $fwRwb.DEFAULT_COLOR_MODE);
    } catch (error) {
        $e094a5fbd794da36$var$handleThemePreferenceError(error, 'get');
        throw error;
    }
};

});


parcelRegister("utF9E", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("62I9B")
]).then(()=>parcelRequire('fgD68'));

});


parcelRegister("28M5N", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8c045109199c08a0$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $8c045109199c08a0$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    commandLightTheme: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-light-theme",
        "defaultMessage": "Switch to light theme"
    },
    commandDarkTheme: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-dark-theme",
        "defaultMessage": "Switch to dark theme"
    },
    commandAutoTheme: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.command-auto-theme",
        "defaultMessage": "Match system theme"
    },
    themeKeywords: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-no-translate",
        "defaultMessage": "switch to dark theme switch to light theme dark mode light mode change appearance change colors night mode day mode theme dark switch theme light switch theme switch switch theme appearance change colors change"
    },
    themeKeywordsMisspelt: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-misspelt-no-translate",
        "defaultMessage": "lite theme darkmode lightmode nightmode daymode change colours change"
    },
    autoThemeKeywords: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-no-translate",
        "defaultMessage": "match system theme sync to system settings dark mode light mode change appearance change colors night mode day mode system theme match match theme system sync theme to system system theme sync theme dark switch theme light switch theme switch appearance change colors change"
    },
    autoThemeKeywordsMisspelt: {
        "id": "command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-misspelt-no-translate",
        "defaultMessage": "match sistem theme sinc system theme matxh system theme match sytem theme darkmode lightmode nightmode daymode change colours change"
    }
});

});





//# sourceMappingURL=async-command-palette-integration.c5154ceb.js.map
